/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.2.2.0 (NJsonSchema v10.1.4.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

export interface IAccountClient {
    /**
     * Get local access token give a remote one.
     * @param id (optional) 
     * @return OK
     */
    obtainLocalAccessToken(provider: string, externalAccessToken: string, id?: string | null | undefined): Promise<any>;
    /**
     * Resets a users password.
     * @param code The code sent in the reset password email.
     * @param id The is send in the reset password email.
     * @param newPassword The users new password.
     * @return OK
     */
    resetPassword(code: string, id: string, newPassword: string): Promise<boolean>;
    /**
     * Sends an email with a reset password link.
     * @param email The email addresss entered on the form.
     * @param site (optional) site request is from.
     * @return OK
     */
    sendResetPassword(email: string, site?: string | null | undefined): Promise<boolean>;
    /**
     * resends the welcome email to the given email address.
     * @param email email to send to
     * @param site (optional) site request is from
     * @return OK
     */
    resendWelcomeEmail(email: string, site?: string | null | undefined): Promise<boolean>;
    /**
     * Confirms the code is valid for the user.
     * @param id the id of the user
     * @param code the code sent in an email
     * @return OK
     */
    confirmEmail(id: string, code: string): Promise<boolean>;
    /**
     * Register a new user.
     * @return OK
     */
    register(userModel: UserModel): Promise<any>;
    /**
     * Perform the validation of an external login.
     * @param error (optional) 
     * @return OK
     */
    getExternalLogin(provider: string, error?: string | null | undefined): Promise<any>;
    /**
     * logout of session.
     * @return OK
     */
    logout(): Promise<any>;
    /**
     * Register a validated external login in this system
     * @return OK
     */
    registerExternal(model: RegisterExternalBindingModel): Promise<any>;
}

export class AccountClient implements IAccountClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Get local access token give a remote one.
     * @param id (optional) 
     * @return OK
     */
    obtainLocalAccessToken(provider: string, externalAccessToken: string, id?: string | null | undefined): Promise<any> {
        let url_ = this.baseUrl + "/Account/ObtainLocalAccessToken?";
        if (provider === undefined || provider === null)
            throw new Error("The parameter 'provider' must be defined and cannot be null.");
        else
            url_ += "provider=" + encodeURIComponent("" + provider) + "&"; 
        if (externalAccessToken === undefined || externalAccessToken === null)
            throw new Error("The parameter 'externalAccessToken' must be defined and cannot be null.");
        else
            url_ += "externalAccessToken=" + encodeURIComponent("" + externalAccessToken) + "&"; 
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processObtainLocalAccessToken(_response);
        });
    }

    protected processObtainLocalAccessToken(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Resets a users password.
     * @param code The code sent in the reset password email.
     * @param id The is send in the reset password email.
     * @param newPassword The users new password.
     * @return OK
     */
    resetPassword(code: string, id: string, newPassword: string): Promise<boolean> {
        let url_ = this.baseUrl + "/Account/resetpassword?";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined and cannot be null.");
        else
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (newPassword === undefined || newPassword === null)
            throw new Error("The parameter 'newPassword' must be defined and cannot be null.");
        else
            url_ += "newPassword=" + encodeURIComponent("" + newPassword) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * Sends an email with a reset password link.
     * @param email The email addresss entered on the form.
     * @param site (optional) site request is from.
     * @return OK
     */
    sendResetPassword(email: string, site?: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/Account/sendresetpasswordemail?";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined and cannot be null.");
        else
            url_ += "Email=" + encodeURIComponent("" + email) + "&"; 
        if (site !== undefined)
            url_ += "site=" + encodeURIComponent("" + site) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSendResetPassword(_response);
        });
    }

    protected processSendResetPassword(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * resends the welcome email to the given email address.
     * @param email email to send to
     * @param site (optional) site request is from
     * @return OK
     */
    resendWelcomeEmail(email: string, site?: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/Account/resendwelcomeemail?";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined and cannot be null.");
        else
            url_ += "Email=" + encodeURIComponent("" + email) + "&"; 
        if (site !== undefined)
            url_ += "site=" + encodeURIComponent("" + site) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processResendWelcomeEmail(_response);
        });
    }

    protected processResendWelcomeEmail(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * Confirms the code is valid for the user.
     * @param id the id of the user
     * @param code the code sent in an email
     * @return OK
     */
    confirmEmail(id: string, code: string): Promise<boolean> {
        let url_ = this.baseUrl + "/Account/confirmemail?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined and cannot be null.");
        else
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processConfirmEmail(_response);
        });
    }

    protected processConfirmEmail(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * Register a new user.
     * @return OK
     */
    register(userModel: UserModel): Promise<any> {
        let url_ = this.baseUrl + "/Account/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userModel);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRegister(_response);
        });
    }

    protected processRegister(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Perform the validation of an external login.
     * @param error (optional) 
     * @return OK
     */
    getExternalLogin(provider: string, error?: string | null | undefined): Promise<any> {
        let url_ = this.baseUrl + "/Account/ExternalLogin?";
        if (provider === undefined || provider === null)
            throw new Error("The parameter 'provider' must be defined and cannot be null.");
        else
            url_ += "provider=" + encodeURIComponent("" + provider) + "&"; 
        if (error !== undefined)
            url_ += "error=" + encodeURIComponent("" + error) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetExternalLogin(_response);
        });
    }

    protected processGetExternalLogin(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * logout of session.
     * @return OK
     */
    logout(): Promise<any> {
        let url_ = this.baseUrl + "/Account/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processLogout(_response);
        });
    }

    protected processLogout(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Register a validated external login in this system
     * @return OK
     */
    registerExternal(model: RegisterExternalBindingModel): Promise<any> {
        let url_ = this.baseUrl + "/Account/RegisterExternal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRegisterExternal(_response);
        });
    }

    protected processRegisterExternal(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }
}

export interface IAffiliateConfigurationClient {
    /**
     * Get a list of purchases for a given affiliate.
     * @param customerAccountId Owner of the affiliate
     * @param affiliateId AffiliateId to get purchases for
     * @return OK
     */
    getAffiliatePurchases(customerAccountId: number, affiliateId: number): Promise<AffiliatePurchasesDTO[]>;
    /**
     * Get a list of AffiliateConfigurations for the given customer.
     * @param customerAccountId Account to get AffiliateConfiguration for.
     * @return OK
     */
    getAffiliateConfigurations(customerAccountId: number): Promise<AffiliateConfigurationDTO[]>;
    /**
     * Adds a new AffiliateConfiguration to the customer
     * @param affiliateConfiguration AffiliateConfiguration to add.
     * @return OK
     */
    addAffiliateConfiguration(affiliateConfiguration: AffiliateConfigurationDTO): Promise<AffiliateConfigurationDTO>;
    /**
     * update a AffiliateConfiguration.
     * @return OK
     */
    updateAffiliateConfiguration(affiliateConfiguration: AffiliateConfigurationDTO): Promise<AffiliateConfigurationDTO>;
}

export class AffiliateConfigurationClient implements IAffiliateConfigurationClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Get a list of purchases for a given affiliate.
     * @param customerAccountId Owner of the affiliate
     * @param affiliateId AffiliateId to get purchases for
     * @return OK
     */
    getAffiliatePurchases(customerAccountId: number, affiliateId: number): Promise<AffiliatePurchasesDTO[]> {
        let url_ = this.baseUrl + "/affiliateconfiguration/purchases?";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined and cannot be null.");
        else
            url_ += "CustomerAccountId=" + encodeURIComponent("" + customerAccountId) + "&"; 
        if (affiliateId === undefined || affiliateId === null)
            throw new Error("The parameter 'affiliateId' must be defined and cannot be null.");
        else
            url_ += "affiliateId=" + encodeURIComponent("" + affiliateId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAffiliatePurchases(_response);
        });
    }

    protected processGetAffiliatePurchases(response: AxiosResponse): Promise<AffiliatePurchasesDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AffiliatePurchasesDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AffiliatePurchasesDTO[]>(<any>null);
    }

    /**
     * Get a list of AffiliateConfigurations for the given customer.
     * @param customerAccountId Account to get AffiliateConfiguration for.
     * @return OK
     */
    getAffiliateConfigurations(customerAccountId: number): Promise<AffiliateConfigurationDTO[]> {
        let url_ = this.baseUrl + "/affiliateconfiguration?";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined and cannot be null.");
        else
            url_ += "customerAccountId=" + encodeURIComponent("" + customerAccountId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAffiliateConfigurations(_response);
        });
    }

    protected processGetAffiliateConfigurations(response: AxiosResponse): Promise<AffiliateConfigurationDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AffiliateConfigurationDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AffiliateConfigurationDTO[]>(<any>null);
    }

    /**
     * Adds a new AffiliateConfiguration to the customer
     * @param affiliateConfiguration AffiliateConfiguration to add.
     * @return OK
     */
    addAffiliateConfiguration(affiliateConfiguration: AffiliateConfigurationDTO): Promise<AffiliateConfigurationDTO> {
        let url_ = this.baseUrl + "/affiliateconfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(affiliateConfiguration);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAddAffiliateConfiguration(_response);
        });
    }

    protected processAddAffiliateConfiguration(response: AxiosResponse): Promise<AffiliateConfigurationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AffiliateConfigurationDTO.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AffiliateConfigurationDTO>(<any>null);
    }

    /**
     * update a AffiliateConfiguration.
     * @return OK
     */
    updateAffiliateConfiguration(affiliateConfiguration: AffiliateConfigurationDTO): Promise<AffiliateConfigurationDTO> {
        let url_ = this.baseUrl + "/affiliateconfiguration/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(affiliateConfiguration);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateAffiliateConfiguration(_response);
        });
    }

    protected processUpdateAffiliateConfiguration(response: AxiosResponse): Promise<AffiliateConfigurationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AffiliateConfigurationDTO.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AffiliateConfigurationDTO>(<any>null);
    }
}

export interface IAIClient {
    /**
     * Get bubble data for account. Not available now.
     * @return OK
     */
    getBubble(customerAccountId: string): Promise<AIAggregate[]>;
    /**
     * Get aggregrated name entities for account. /nerservice
     * @param customerAccountId account to get aggregrated entities
     * @return OK
     */
    getNameEntitiesAgg(customerAccountId: string): Promise<AIAggregate[]>;
    /**
     * Get name entities for article. /nerservice
     * @param customerAccountId account to use
     * @param articleId article to get entities for
     * @return OK
     */
    getNameEntities(customerAccountId: string, articleId: string): Promise<AIArticleResult[]>;
    /**
     * push all articles for an account to the AI engine. /tagsgenservice
     * @return OK
     */
    pushAccountContentToAIEngine(customerAccountId: string): Promise<any>;
    /**
     * Gets AI auto tags for an article. /tagsgenservice
     * @return OK
     */
    getAutoTag(customerAccountId: string, articleId: string): Promise<AIAutoTag[]>;
}

export class AIClient implements IAIClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Get bubble data for account. Not available now.
     * @return OK
     */
    getBubble(customerAccountId: string): Promise<AIAggregate[]> {
        let url_ = this.baseUrl + "/AI/bubble?";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined and cannot be null.");
        else
            url_ += "customerAccountId=" + encodeURIComponent("" + customerAccountId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetBubble(_response);
        });
    }

    protected processGetBubble(response: AxiosResponse): Promise<AIAggregate[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AIAggregate.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AIAggregate[]>(<any>null);
    }

    /**
     * Get aggregrated name entities for account. /nerservice
     * @param customerAccountId account to get aggregrated entities
     * @return OK
     */
    getNameEntitiesAgg(customerAccountId: string): Promise<AIAggregate[]> {
        let url_ = this.baseUrl + "/AI/nameentitiesagg?";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined and cannot be null.");
        else
            url_ += "customerAccountId=" + encodeURIComponent("" + customerAccountId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetNameEntitiesAgg(_response);
        });
    }

    protected processGetNameEntitiesAgg(response: AxiosResponse): Promise<AIAggregate[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AIAggregate.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AIAggregate[]>(<any>null);
    }

    /**
     * Get name entities for article. /nerservice
     * @param customerAccountId account to use
     * @param articleId article to get entities for
     * @return OK
     */
    getNameEntities(customerAccountId: string, articleId: string): Promise<AIArticleResult[]> {
        let url_ = this.baseUrl + "/AI/nameentities?";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined and cannot be null.");
        else
            url_ += "customerAccountId=" + encodeURIComponent("" + customerAccountId) + "&"; 
        if (articleId === undefined || articleId === null)
            throw new Error("The parameter 'articleId' must be defined and cannot be null.");
        else
            url_ += "articleId=" + encodeURIComponent("" + articleId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetNameEntities(_response);
        });
    }

    protected processGetNameEntities(response: AxiosResponse): Promise<AIArticleResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AIArticleResult.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AIArticleResult[]>(<any>null);
    }

    /**
     * push all articles for an account to the AI engine. /tagsgenservice
     * @return OK
     */
    pushAccountContentToAIEngine(customerAccountId: string): Promise<any> {
        let url_ = this.baseUrl + "/AI/pushtoaiengine?";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined and cannot be null.");
        else
            url_ += "customerAccountId=" + encodeURIComponent("" + customerAccountId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPushAccountContentToAIEngine(_response);
        });
    }

    protected processPushAccountContentToAIEngine(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Gets AI auto tags for an article. /tagsgenservice
     * @return OK
     */
    getAutoTag(customerAccountId: string, articleId: string): Promise<AIAutoTag[]> {
        let url_ = this.baseUrl + "/AI/autotag?";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined and cannot be null.");
        else
            url_ += "customerAccountId=" + encodeURIComponent("" + customerAccountId) + "&"; 
        if (articleId === undefined || articleId === null)
            throw new Error("The parameter 'articleId' must be defined and cannot be null.");
        else
            url_ += "articleId=" + encodeURIComponent("" + articleId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAutoTag(_response);
        });
    }

    protected processGetAutoTag(response: AxiosResponse): Promise<AIAutoTag[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AIAutoTag.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AIAutoTag[]>(<any>null);
    }
}

export interface IAnalyticsClient {
    /**
     * Get the analytics codes for a publication.
     * @return OK
     */
    getPublicationAnalytics(publicationId: number): Promise<PublicationAnalyticsModel>;
    /**
     * Save or Update a publications analytics codes.
     * @return OK
     */
    savePublicationAnalytics(analytics: PublicationAnalyticsModel): Promise<PublicationAnalyticsModel>;
}

export class AnalyticsClient implements IAnalyticsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Get the analytics codes for a publication.
     * @return OK
     */
    getPublicationAnalytics(publicationId: number): Promise<PublicationAnalyticsModel> {
        let url_ = this.baseUrl + "/analytics?";
        if (publicationId === undefined || publicationId === null)
            throw new Error("The parameter 'publicationId' must be defined and cannot be null.");
        else
            url_ += "publicationId=" + encodeURIComponent("" + publicationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPublicationAnalytics(_response);
        });
    }

    protected processGetPublicationAnalytics(response: AxiosResponse): Promise<PublicationAnalyticsModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PublicationAnalyticsModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicationAnalyticsModel>(<any>null);
    }

    /**
     * Save or Update a publications analytics codes.
     * @return OK
     */
    savePublicationAnalytics(analytics: PublicationAnalyticsModel): Promise<PublicationAnalyticsModel> {
        let url_ = this.baseUrl + "/analytics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(analytics);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSavePublicationAnalytics(_response);
        });
    }

    protected processSavePublicationAnalytics(response: AxiosResponse): Promise<PublicationAnalyticsModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PublicationAnalyticsModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicationAnalyticsModel>(<any>null);
    }
}

export interface IArticleLicencingClient {
    /**
     * Get article licencing for account
     * @return OK
     */
    getAccountLicences(accountId: number): Promise<CustomerArticleLicenceDTO[]>;
    /**
     * Save or Update a publications analytics codes.
     * @return OK
     */
    saveAccountLicence(licence: CustomerArticleLicenceDTO): Promise<CustomerArticleLicenceDTO>;
    /**
     * Make a licence the default licence.
     * @return OK
     */
    makeDefault(accountId: number, licenceId: number): Promise<any>;
    /**
     * get all articles in proof.
     * @return OK
     */
    getArticlesInProof(accountId: number): Promise<AccountArticleLicenceDTO[]>;
    /**
     * update article with new licence.
     * @return OK
     */
    updateArticleLicences(accountId: number, articles: number[], licenceId: number): Promise<any>;
}

export class ArticleLicencingClient implements IArticleLicencingClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Get article licencing for account
     * @return OK
     */
    getAccountLicences(accountId: number): Promise<CustomerArticleLicenceDTO[]> {
        let url_ = this.baseUrl + "/articlelicencing?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined and cannot be null.");
        else
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAccountLicences(_response);
        });
    }

    protected processGetAccountLicences(response: AxiosResponse): Promise<CustomerArticleLicenceDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerArticleLicenceDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerArticleLicenceDTO[]>(<any>null);
    }

    /**
     * Save or Update a publications analytics codes.
     * @return OK
     */
    saveAccountLicence(licence: CustomerArticleLicenceDTO): Promise<CustomerArticleLicenceDTO> {
        let url_ = this.baseUrl + "/articlelicencing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(licence);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveAccountLicence(_response);
        });
    }

    protected processSaveAccountLicence(response: AxiosResponse): Promise<CustomerArticleLicenceDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomerArticleLicenceDTO.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerArticleLicenceDTO>(<any>null);
    }

    /**
     * Make a licence the default licence.
     * @return OK
     */
    makeDefault(accountId: number, licenceId: number): Promise<any> {
        let url_ = this.baseUrl + "/articlelicencing/makedefault?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined and cannot be null.");
        else
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&"; 
        if (licenceId === undefined || licenceId === null)
            throw new Error("The parameter 'licenceId' must be defined and cannot be null.");
        else
            url_ += "licenceId=" + encodeURIComponent("" + licenceId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processMakeDefault(_response);
        });
    }

    protected processMakeDefault(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * get all articles in proof.
     * @return OK
     */
    getArticlesInProof(accountId: number): Promise<AccountArticleLicenceDTO[]> {
        let url_ = this.baseUrl + "/articlelicencing/proof?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined and cannot be null.");
        else
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetArticlesInProof(_response);
        });
    }

    protected processGetArticlesInProof(response: AxiosResponse): Promise<AccountArticleLicenceDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccountArticleLicenceDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountArticleLicenceDTO[]>(<any>null);
    }

    /**
     * update article with new licence.
     * @return OK
     */
    updateArticleLicences(accountId: number, articles: number[], licenceId: number): Promise<any> {
        let url_ = this.baseUrl + "/articlelicencing/updatearticlelicence?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined and cannot be null.");
        else
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&"; 
        if (licenceId === undefined || licenceId === null)
            throw new Error("The parameter 'licenceId' must be defined and cannot be null.");
        else
            url_ += "licenceId=" + encodeURIComponent("" + licenceId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(articles);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateArticleLicences(_response);
        });
    }

    protected processUpdateArticleLicences(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }
}

export interface IArticleManagementClient {
    /**
     * Get all the articles, of any type, for an issue.
     * @return OK
     */
    getIssueArticles(issueId: number): Promise<ArticleModel[]>;
    /**
     * Sync all articles, for an issue, from DB to Index.
     * @return OK
     */
    synchronizeArticles(issueId: number, articleType: ArticleType): Promise<ArticleModel[]>;
}

export class ArticleManagementClient implements IArticleManagementClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Get all the articles, of any type, for an issue.
     * @return OK
     */
    getIssueArticles(issueId: number): Promise<ArticleModel[]> {
        let url_ = this.baseUrl + "/articlemanagement?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "IssueId=" + encodeURIComponent("" + issueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetIssueArticles(_response);
        });
    }

    protected processGetIssueArticles(response: AxiosResponse): Promise<ArticleModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ArticleModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ArticleModel[]>(<any>null);
    }

    /**
     * Sync all articles, for an issue, from DB to Index.
     * @return OK
     */
    synchronizeArticles(issueId: number, articleType: ArticleType): Promise<ArticleModel[]> {
        let url_ = this.baseUrl + "/articlemanagement/sync?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "IssueId=" + encodeURIComponent("" + issueId) + "&"; 
        if (articleType === undefined || articleType === null)
            throw new Error("The parameter 'articleType' must be defined and cannot be null.");
        else
            url_ += "articleType=" + encodeURIComponent("" + articleType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSynchronizeArticles(_response);
        });
    }

    protected processSynchronizeArticles(response: AxiosResponse): Promise<ArticleModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ArticleModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ArticleModel[]>(<any>null);
    }
}

export interface IArticleSearchClient {
    /**
     * Search a publication for articles.
     * @return OK
     */
    publicationArticleSearch(publicationId: number, data: ContentSearchDataOfContentSearchHit): Promise<ContentSearchDataOfContentSearchHit>;
    /**
     * search an account for articles
     * @return OK
     */
    accountArticleSearch(accountId: number, data: ContentSearchDataOfContentSearchHit): Promise<ContentSearchDataOfContentSearchHit>;
    /**
     * search an account for metadata
     * @return OK
     */
    globalSearch(data: ContentSearchDataOfContentSearchHit): Promise<ContentSearchDataOfContentSearchHit>;
}

export class ArticleSearchClient implements IArticleSearchClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Search a publication for articles.
     * @return OK
     */
    publicationArticleSearch(publicationId: number, data: ContentSearchDataOfContentSearchHit): Promise<ContentSearchDataOfContentSearchHit> {
        let url_ = this.baseUrl + "/articlesearch/publicationarticles?";
        if (publicationId === undefined || publicationId === null)
            throw new Error("The parameter 'publicationId' must be defined and cannot be null.");
        else
            url_ += "publicationId=" + encodeURIComponent("" + publicationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPublicationArticleSearch(_response);
        });
    }

    protected processPublicationArticleSearch(response: AxiosResponse): Promise<ContentSearchDataOfContentSearchHit> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ContentSearchDataOfContentSearchHit.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContentSearchDataOfContentSearchHit>(<any>null);
    }

    /**
     * search an account for articles
     * @return OK
     */
    accountArticleSearch(accountId: number, data: ContentSearchDataOfContentSearchHit): Promise<ContentSearchDataOfContentSearchHit> {
        let url_ = this.baseUrl + "/articlesearch/accountarticles?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined and cannot be null.");
        else
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAccountArticleSearch(_response);
        });
    }

    protected processAccountArticleSearch(response: AxiosResponse): Promise<ContentSearchDataOfContentSearchHit> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ContentSearchDataOfContentSearchHit.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContentSearchDataOfContentSearchHit>(<any>null);
    }

    /**
     * search an account for metadata
     * @return OK
     */
    globalSearch(data: ContentSearchDataOfContentSearchHit): Promise<ContentSearchDataOfContentSearchHit> {
        let url_ = this.baseUrl + "/articlesearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGlobalSearch(_response);
        });
    }

    protected processGlobalSearch(response: AxiosResponse): Promise<ContentSearchDataOfContentSearchHit> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ContentSearchDataOfContentSearchHit.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContentSearchDataOfContentSearchHit>(<any>null);
    }
}

export interface IArticleStatsClient {
    /**
     * Get all the articles for an issue.
     * @return OK
     */
    getArticleStats(customerAccountId: number): Promise<ArticleStats>;
}

export class ArticleStatsClient implements IArticleStatsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Get all the articles for an issue.
     * @return OK
     */
    getArticleStats(customerAccountId: number): Promise<ArticleStats> {
        let url_ = this.baseUrl + "/articlestats/articles?";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined and cannot be null.");
        else
            url_ += "customerAccountId=" + encodeURIComponent("" + customerAccountId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetArticleStats(_response);
        });
    }

    protected processGetArticleStats(response: AxiosResponse): Promise<ArticleStats> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ArticleStats.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ArticleStats>(<any>null);
    }
}

export interface IAuth0Client {
    /**
     * accept webhooks
     * @return OK
     */
    accept(): Promise<any>;
}

export class Auth0Client implements IAuth0Client {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * accept webhooks
     * @return OK
     */
    accept(): Promise<any> {
        let url_ = this.baseUrl + "/api/auth0";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAccept(_response);
        });
    }

    protected processAccept(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }
}

export interface IAuthProviderClient {
    /**
     * create oAuth clients in Auth0.
     * @return OK
     */
    createAuthClients(details: Auth0CreateDetails): Promise<CustomerAuthConfigModel>;
}

export class AuthProviderClient implements IAuthProviderClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * create oAuth clients in Auth0.
     * @return OK
     */
    createAuthClients(details: Auth0CreateDetails): Promise<CustomerAuthConfigModel> {
        let url_ = this.baseUrl + "/authprovider/auth0";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(details);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateAuthClients(_response);
        });
    }

    protected processCreateAuthClients(response: AxiosResponse): Promise<CustomerAuthConfigModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomerAuthConfigModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerAuthConfigModel>(<any>null);
    }
}

export interface IAuthViewerConfigClient {
    /**
     * create auth viewer config.
     * @return OK
     */
    getAuthViewerConfig(customerUrlId: number): Promise<AuthViewerConfigDTO>;
    /**
     * save auth viewer config
     * @return OK
     */
    saveAuthViewerConfig(config: AuthViewerConfigDTO): Promise<AuthViewerConfigDTO>;
}

export class AuthViewerConfigClient implements IAuthViewerConfigClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * create auth viewer config.
     * @return OK
     */
    getAuthViewerConfig(customerUrlId: number): Promise<AuthViewerConfigDTO> {
        let url_ = this.baseUrl + "/authviewerconfig?";
        if (customerUrlId === undefined || customerUrlId === null)
            throw new Error("The parameter 'customerUrlId' must be defined and cannot be null.");
        else
            url_ += "CustomerUrlId=" + encodeURIComponent("" + customerUrlId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAuthViewerConfig(_response);
        });
    }

    protected processGetAuthViewerConfig(response: AxiosResponse): Promise<AuthViewerConfigDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthViewerConfigDTO.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthViewerConfigDTO>(<any>null);
    }

    /**
     * save auth viewer config
     * @return OK
     */
    saveAuthViewerConfig(config: AuthViewerConfigDTO): Promise<AuthViewerConfigDTO> {
        let url_ = this.baseUrl + "/authviewerconfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(config);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveAuthViewerConfig(_response);
        });
    }

    protected processSaveAuthViewerConfig(response: AxiosResponse): Promise<AuthViewerConfigDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthViewerConfigDTO.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthViewerConfigDTO>(<any>null);
    }
}

export interface IAutologinClient {
    /**
     * save an autologin referer rule.
     * @return OK
     */
    saveAutoLoginReferer(rule: AutologinReferrerDTO): Promise<AutologinReferrerDTO>;
    /**
     * delete an autologin referer rule
     * @return No Content
     */
    deleteAutoLoginReferer(rule: AutologinReferrerDTO): Promise<void>;
    /**
     * save an autologin ip rule.
     * @return OK
     */
    saveAutoLoginIP(rule: AutologinIPAddressDTO): Promise<AutologinIPAddressDTO>;
    /**
     * delete an autologin ip rule
     * @return No Content
     */
    deleteAutoLoginIP(rule: AutologinIPAddressDTO): Promise<void>;
    /**
     * get ip autologins for a given url
     * @param customerUrlId url to get ip autologins
     * @return OK
     */
    getAutoLoginIPs(customerUrlId: number): Promise<AutologinIPAddressDTO[]>;
    /**
     * get referer autologins for a given url
     * @param customerUrlId url to get ip autologins
     * @return OK
     */
    getAutoLoginReferers(customerUrlId: number): Promise<AutologinReferrerDTO[]>;
}

export class AutologinClient implements IAutologinClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * save an autologin referer rule.
     * @return OK
     */
    saveAutoLoginReferer(rule: AutologinReferrerDTO): Promise<AutologinReferrerDTO> {
        let url_ = this.baseUrl + "/autologin/referer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(rule);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveAutoLoginReferer(_response);
        });
    }

    protected processSaveAutoLoginReferer(response: AxiosResponse): Promise<AutologinReferrerDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AutologinReferrerDTO.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AutologinReferrerDTO>(<any>null);
    }

    /**
     * delete an autologin referer rule
     * @return No Content
     */
    deleteAutoLoginReferer(rule: AutologinReferrerDTO): Promise<void> {
        let url_ = this.baseUrl + "/autologin/referer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(rule);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteAutoLoginReferer(_response);
        });
    }

    protected processDeleteAutoLoginReferer(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * save an autologin ip rule.
     * @return OK
     */
    saveAutoLoginIP(rule: AutologinIPAddressDTO): Promise<AutologinIPAddressDTO> {
        let url_ = this.baseUrl + "/autologin/ip";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(rule);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveAutoLoginIP(_response);
        });
    }

    protected processSaveAutoLoginIP(response: AxiosResponse): Promise<AutologinIPAddressDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AutologinIPAddressDTO.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AutologinIPAddressDTO>(<any>null);
    }

    /**
     * delete an autologin ip rule
     * @return No Content
     */
    deleteAutoLoginIP(rule: AutologinIPAddressDTO): Promise<void> {
        let url_ = this.baseUrl + "/autologin/ip";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(rule);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteAutoLoginIP(_response);
        });
    }

    protected processDeleteAutoLoginIP(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * get ip autologins for a given url
     * @param customerUrlId url to get ip autologins
     * @return OK
     */
    getAutoLoginIPs(customerUrlId: number): Promise<AutologinIPAddressDTO[]> {
        let url_ = this.baseUrl + "/autologin/ips?";
        if (customerUrlId === undefined || customerUrlId === null)
            throw new Error("The parameter 'customerUrlId' must be defined and cannot be null.");
        else
            url_ += "CustomerUrlId=" + encodeURIComponent("" + customerUrlId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAutoLoginIPs(_response);
        });
    }

    protected processGetAutoLoginIPs(response: AxiosResponse): Promise<AutologinIPAddressDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AutologinIPAddressDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AutologinIPAddressDTO[]>(<any>null);
    }

    /**
     * get referer autologins for a given url
     * @param customerUrlId url to get ip autologins
     * @return OK
     */
    getAutoLoginReferers(customerUrlId: number): Promise<AutologinReferrerDTO[]> {
        let url_ = this.baseUrl + "/autologin/referers?";
        if (customerUrlId === undefined || customerUrlId === null)
            throw new Error("The parameter 'customerUrlId' must be defined and cannot be null.");
        else
            url_ += "CustomerUrlId=" + encodeURIComponent("" + customerUrlId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAutoLoginReferers(_response);
        });
    }

    protected processGetAutoLoginReferers(response: AxiosResponse): Promise<AutologinReferrerDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AutologinReferrerDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AutologinReferrerDTO[]>(<any>null);
    }
}

export interface IContentStreamClient {
    /**
     * get content streams for account.
     * @return OK
     */
    getContentStreams(customerAccountId: number): Promise<StreamStatsDTO[]>;
    /**
     * get content streams for account.
     * @return OK
     */
    getContentStream(contentStreamId: number): Promise<ContentStreamDTO>;
    /**
     * Save a content Stream
     * @return OK
     */
    saveContentStream(contentStream: ContentStreamDTO): Promise<ContentStreamDTO>;
    /**
     * get content streams level.
     * @return OK
     */
    getContentStreamLevel(contentStreamLevelId: number): Promise<ContentStreamLevelDTO>;
    /**
     * add a content stream level
     * @return OK
     */
    saveContentStreamLevel(contentStreamLevel: ContentStreamLevelDTO): Promise<ContentStreamLevelDTO>;
    /**
     * delete a level from a stream.
     * @return OK
     */
    deleteContentStreamLevel(contentStreamId: number, contentStreamLevelId: number): Promise<any>;
    /**
     * get all streams - administrator only.
     * @return OK
     */
    getAllContentStreams(): Promise<StreamStatsDTO[]>;
    /**
     * get a subscription.
     * @return OK
     */
    getContentStreamSubscription(contentStreamSubscriptionId: number): Promise<ListItemDTO[]>;
    /**
     * list of subscription for content stream
     * @return OK
     */
    getContentStreamSubscriptions(contentStreamId: number): Promise<ContentStreamSubscriberDTO[]>;
    /**
     * Move the content stream to given account.
     * @return OK
     */
    moveContentStream(contentStreamId: number, newCustomerAccountId: number): Promise<any>;
    /**
     * delete the given content stream
     * @return OK
     */
    deleteContentStream(contentStreamId: number): Promise<any>;
}

export class ContentStreamClient implements IContentStreamClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * get content streams for account.
     * @return OK
     */
    getContentStreams(customerAccountId: number): Promise<StreamStatsDTO[]> {
        let url_ = this.baseUrl + "/contentstream/{customerAccountId}";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined.");
        url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetContentStreams(_response);
        });
    }

    protected processGetContentStreams(response: AxiosResponse): Promise<StreamStatsDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StreamStatsDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StreamStatsDTO[]>(<any>null);
    }

    /**
     * get content streams for account.
     * @return OK
     */
    getContentStream(contentStreamId: number): Promise<ContentStreamDTO> {
        let url_ = this.baseUrl + "/contentstream?";
        if (contentStreamId === undefined || contentStreamId === null)
            throw new Error("The parameter 'contentStreamId' must be defined and cannot be null.");
        else
            url_ += "contentStreamId=" + encodeURIComponent("" + contentStreamId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetContentStream(_response);
        });
    }

    protected processGetContentStream(response: AxiosResponse): Promise<ContentStreamDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ContentStreamDTO.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContentStreamDTO>(<any>null);
    }

    /**
     * Save a content Stream
     * @return OK
     */
    saveContentStream(contentStream: ContentStreamDTO): Promise<ContentStreamDTO> {
        let url_ = this.baseUrl + "/contentstream";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(contentStream);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveContentStream(_response);
        });
    }

    protected processSaveContentStream(response: AxiosResponse): Promise<ContentStreamDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ContentStreamDTO.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContentStreamDTO>(<any>null);
    }

    /**
     * get content streams level.
     * @return OK
     */
    getContentStreamLevel(contentStreamLevelId: number): Promise<ContentStreamLevelDTO> {
        let url_ = this.baseUrl + "/contentstream/level?";
        if (contentStreamLevelId === undefined || contentStreamLevelId === null)
            throw new Error("The parameter 'contentStreamLevelId' must be defined and cannot be null.");
        else
            url_ += "contentStreamLevelId=" + encodeURIComponent("" + contentStreamLevelId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetContentStreamLevel(_response);
        });
    }

    protected processGetContentStreamLevel(response: AxiosResponse): Promise<ContentStreamLevelDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ContentStreamLevelDTO.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContentStreamLevelDTO>(<any>null);
    }

    /**
     * add a content stream level
     * @return OK
     */
    saveContentStreamLevel(contentStreamLevel: ContentStreamLevelDTO): Promise<ContentStreamLevelDTO> {
        let url_ = this.baseUrl + "/contentstream/level";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(contentStreamLevel);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveContentStreamLevel(_response);
        });
    }

    protected processSaveContentStreamLevel(response: AxiosResponse): Promise<ContentStreamLevelDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ContentStreamLevelDTO.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContentStreamLevelDTO>(<any>null);
    }

    /**
     * delete a level from a stream.
     * @return OK
     */
    deleteContentStreamLevel(contentStreamId: number, contentStreamLevelId: number): Promise<any> {
        let url_ = this.baseUrl + "/contentstream/level?";
        if (contentStreamId === undefined || contentStreamId === null)
            throw new Error("The parameter 'contentStreamId' must be defined and cannot be null.");
        else
            url_ += "ContentStreamId=" + encodeURIComponent("" + contentStreamId) + "&"; 
        if (contentStreamLevelId === undefined || contentStreamLevelId === null)
            throw new Error("The parameter 'contentStreamLevelId' must be defined and cannot be null.");
        else
            url_ += "ContentStreamLevelId=" + encodeURIComponent("" + contentStreamLevelId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteContentStreamLevel(_response);
        });
    }

    protected processDeleteContentStreamLevel(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * get all streams - administrator only.
     * @return OK
     */
    getAllContentStreams(): Promise<StreamStatsDTO[]> {
        let url_ = this.baseUrl + "/contentstream/streams";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAllContentStreams(_response);
        });
    }

    protected processGetAllContentStreams(response: AxiosResponse): Promise<StreamStatsDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StreamStatsDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StreamStatsDTO[]>(<any>null);
    }

    /**
     * get a subscription.
     * @return OK
     */
    getContentStreamSubscription(contentStreamSubscriptionId: number): Promise<ListItemDTO[]> {
        let url_ = this.baseUrl + "/contentstream/subscription?";
        if (contentStreamSubscriptionId === undefined || contentStreamSubscriptionId === null)
            throw new Error("The parameter 'contentStreamSubscriptionId' must be defined and cannot be null.");
        else
            url_ += "contentStreamSubscriptionId=" + encodeURIComponent("" + contentStreamSubscriptionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetContentStreamSubscription(_response);
        });
    }

    protected processGetContentStreamSubscription(response: AxiosResponse): Promise<ListItemDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ListItemDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListItemDTO[]>(<any>null);
    }

    /**
     * list of subscription for content stream
     * @return OK
     */
    getContentStreamSubscriptions(contentStreamId: number): Promise<ContentStreamSubscriberDTO[]> {
        let url_ = this.baseUrl + "/contentstream/subscriptions?";
        if (contentStreamId === undefined || contentStreamId === null)
            throw new Error("The parameter 'contentStreamId' must be defined and cannot be null.");
        else
            url_ += "contentStreamId=" + encodeURIComponent("" + contentStreamId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetContentStreamSubscriptions(_response);
        });
    }

    protected processGetContentStreamSubscriptions(response: AxiosResponse): Promise<ContentStreamSubscriberDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContentStreamSubscriberDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContentStreamSubscriberDTO[]>(<any>null);
    }

    /**
     * Move the content stream to given account.
     * @return OK
     */
    moveContentStream(contentStreamId: number, newCustomerAccountId: number): Promise<any> {
        let url_ = this.baseUrl + "/api/ContentStream?";
        if (contentStreamId === undefined || contentStreamId === null)
            throw new Error("The parameter 'contentStreamId' must be defined and cannot be null.");
        else
            url_ += "ContentStreamId=" + encodeURIComponent("" + contentStreamId) + "&"; 
        if (newCustomerAccountId === undefined || newCustomerAccountId === null)
            throw new Error("The parameter 'newCustomerAccountId' must be defined and cannot be null.");
        else
            url_ += "NewCustomerAccountId=" + encodeURIComponent("" + newCustomerAccountId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processMoveContentStream(_response);
        });
    }

    protected processMoveContentStream(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * delete the given content stream
     * @return OK
     */
    deleteContentStream(contentStreamId: number): Promise<any> {
        let url_ = this.baseUrl + "/api/ContentStream?";
        if (contentStreamId === undefined || contentStreamId === null)
            throw new Error("The parameter 'contentStreamId' must be defined and cannot be null.");
        else
            url_ += "ContentStreamId=" + encodeURIComponent("" + contentStreamId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteContentStream(_response);
        });
    }

    protected processDeleteContentStream(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }
}

export interface IContentStreamBillingConfigurationClient {
    /**
     * get billing config for stream
     * @return OK
     */
    get(contentStreamId: number): Promise<ContentStreamBillingConfigurationDTO>;
    /**
     * add content stream billing config
     * @return OK
     */
    add(contentStreamBillingConfiguration: ContentStreamBillingConfigurationDTO): Promise<ContentStreamBillingConfigurationDTO>;
    /**
     * updaet content stream billing config
     * @return OK
     */
    update(contentStreamBillingConfiguration: ContentStreamBillingConfigurationDTO): Promise<ContentStreamBillingConfigurationDTO>;
}

export class ContentStreamBillingConfigurationClient implements IContentStreamBillingConfigurationClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * get billing config for stream
     * @return OK
     */
    get(contentStreamId: number): Promise<ContentStreamBillingConfigurationDTO> {
        let url_ = this.baseUrl + "/api/ContentStreamBillingConfiguration?";
        if (contentStreamId === undefined || contentStreamId === null)
            throw new Error("The parameter 'contentStreamId' must be defined and cannot be null.");
        else
            url_ += "ContentStreamId=" + encodeURIComponent("" + contentStreamId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ContentStreamBillingConfigurationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ContentStreamBillingConfigurationDTO.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContentStreamBillingConfigurationDTO>(<any>null);
    }

    /**
     * add content stream billing config
     * @return OK
     */
    add(contentStreamBillingConfiguration: ContentStreamBillingConfigurationDTO): Promise<ContentStreamBillingConfigurationDTO> {
        let url_ = this.baseUrl + "/api/ContentStreamBillingConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(contentStreamBillingConfiguration);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: AxiosResponse): Promise<ContentStreamBillingConfigurationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ContentStreamBillingConfigurationDTO.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContentStreamBillingConfigurationDTO>(<any>null);
    }

    /**
     * updaet content stream billing config
     * @return OK
     */
    update(contentStreamBillingConfiguration: ContentStreamBillingConfigurationDTO): Promise<ContentStreamBillingConfigurationDTO> {
        let url_ = this.baseUrl + "/api/ContentStreamBillingConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(contentStreamBillingConfiguration);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<ContentStreamBillingConfigurationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ContentStreamBillingConfigurationDTO.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContentStreamBillingConfigurationDTO>(<any>null);
    }
}

export interface IContentStreamCurateClient {
    /**
     * get outstanding work for acocunt
     * @return OK
     */
    getOutstandingContentStreamWork(customerAccountId: number): Promise<OutstandingArticlesForCuration[]>;
    /**
     * get an article to display/curate by guid
     * @return OK
     */
    getArticleForCuration(articleGuid: string): Promise<ArticleModel>;
    /**
     * get list of articles for curation.
     * @return OK
     */
    getArticleForCurationAll(articleForCuration: ArticleForCurationDTO): Promise<CurationTodoDTO[]>;
    /**
     * get by id
     * @return OK
     */
    getArticleForCurationById(articleId: number): Promise<ArticleModel>;
    /**
     * get curation data for article.
     * @return OK
     */
    getCurationInfoForArticle(articleId: string): Promise<CurationInfoDTO>;
    /**
     * marks an article as curated after an editor has curated/tailored it.
     * @return OK
     */
    markArticleCurated(articleId: string): Promise<any>;
    /**
     * save an article during the issue creation process.
     * @return OK
     */
    saveSourceArticle(article: ArticleModel): Promise<ArticleModel>;
    /**
     * delete an article waiting for curation.
     * @return OK
     */
    deleteArticle(articleId: string): Promise<any>;
    /**
     * save an article during the curation process.
     * @return OK
     */
    saveCuratingArticle(article: ArticleModel): Promise<ArticleModel>;
}

export class ContentStreamCurateClient implements IContentStreamCurateClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * get outstanding work for acocunt
     * @return OK
     */
    getOutstandingContentStreamWork(customerAccountId: number): Promise<OutstandingArticlesForCuration[]> {
        let url_ = this.baseUrl + "/contentstreamcurate/outstanding?";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined and cannot be null.");
        else
            url_ += "CustomerAccountId=" + encodeURIComponent("" + customerAccountId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetOutstandingContentStreamWork(_response);
        });
    }

    protected processGetOutstandingContentStreamWork(response: AxiosResponse): Promise<OutstandingArticlesForCuration[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OutstandingArticlesForCuration.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OutstandingArticlesForCuration[]>(<any>null);
    }

    /**
     * get an article to display/curate by guid
     * @return OK
     */
    getArticleForCuration(articleGuid: string): Promise<ArticleModel> {
        let url_ = this.baseUrl + "/contentstreamcurate/articleforcuration?";
        if (articleGuid === undefined || articleGuid === null)
            throw new Error("The parameter 'articleGuid' must be defined and cannot be null.");
        else
            url_ += "ArticleGuid=" + encodeURIComponent("" + articleGuid) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetArticleForCuration(_response);
        });
    }

    protected processGetArticleForCuration(response: AxiosResponse): Promise<ArticleModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ArticleModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ArticleModel>(<any>null);
    }

    /**
     * get list of articles for curation.
     * @return OK
     */
    getArticleForCurationAll(articleForCuration: ArticleForCurationDTO): Promise<CurationTodoDTO[]> {
        let url_ = this.baseUrl + "/contentstreamcurate/todo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(articleForCuration);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetArticleForCurationAll(_response);
        });
    }

    protected processGetArticleForCurationAll(response: AxiosResponse): Promise<CurationTodoDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CurationTodoDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CurationTodoDTO[]>(<any>null);
    }

    /**
     * get by id
     * @return OK
     */
    getArticleForCurationById(articleId: number): Promise<ArticleModel> {
        let url_ = this.baseUrl + "/contentstreamcurate/articleforcurationbyid?";
        if (articleId === undefined || articleId === null)
            throw new Error("The parameter 'articleId' must be defined and cannot be null.");
        else
            url_ += "ArticleId=" + encodeURIComponent("" + articleId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetArticleForCurationById(_response);
        });
    }

    protected processGetArticleForCurationById(response: AxiosResponse): Promise<ArticleModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ArticleModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ArticleModel>(<any>null);
    }

    /**
     * get curation data for article.
     * @return OK
     */
    getCurationInfoForArticle(articleId: string): Promise<CurationInfoDTO> {
        let url_ = this.baseUrl + "/contentstreamcurate/curationinfo?";
        if (articleId === undefined || articleId === null)
            throw new Error("The parameter 'articleId' must be defined and cannot be null.");
        else
            url_ += "ArticleId=" + encodeURIComponent("" + articleId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetCurationInfoForArticle(_response);
        });
    }

    protected processGetCurationInfoForArticle(response: AxiosResponse): Promise<CurationInfoDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CurationInfoDTO.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CurationInfoDTO>(<any>null);
    }

    /**
     * marks an article as curated after an editor has curated/tailored it.
     * @return OK
     */
    markArticleCurated(articleId: string): Promise<any> {
        let url_ = this.baseUrl + "/contentstreamcurate/articlecurated?";
        if (articleId === undefined || articleId === null)
            throw new Error("The parameter 'articleId' must be defined and cannot be null.");
        else
            url_ += "ArticleId=" + encodeURIComponent("" + articleId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processMarkArticleCurated(_response);
        });
    }

    protected processMarkArticleCurated(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * save an article during the issue creation process.
     * @return OK
     */
    saveSourceArticle(article: ArticleModel): Promise<ArticleModel> {
        let url_ = this.baseUrl + "/contentstreamcurate/savesourcearticle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(article);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveSourceArticle(_response);
        });
    }

    protected processSaveSourceArticle(response: AxiosResponse): Promise<ArticleModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ArticleModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ArticleModel>(<any>null);
    }

    /**
     * delete an article waiting for curation.
     * @return OK
     */
    deleteArticle(articleId: string): Promise<any> {
        let url_ = this.baseUrl + "/contentstreamcurate/deletearticle?";
        if (articleId === undefined || articleId === null)
            throw new Error("The parameter 'articleId' must be defined and cannot be null.");
        else
            url_ += "articleId=" + encodeURIComponent("" + articleId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteArticle(_response);
        });
    }

    protected processDeleteArticle(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * save an article during the curation process.
     * @return OK
     */
    saveCuratingArticle(article: ArticleModel): Promise<ArticleModel> {
        let url_ = this.baseUrl + "/contentstreamcurate/savecuratingarticle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(article);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveCuratingArticle(_response);
        });
    }

    protected processSaveCuratingArticle(response: AxiosResponse): Promise<ArticleModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ArticleModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ArticleModel>(<any>null);
    }
}

export interface IContentStreamIssueClient {
    /**
     * get issue
     * @return OK
     */
    getIssue(issueId: number): Promise<IssueModel>;
    /**
     * add a new issue to the content stream.
     * @return OK
     */
    saveContentStreamIssue(contentStreamIssue: ContentStreamIssueDTO): Promise<ContentStreamIssueDTO>;
    /**
     * remove an empty content stream issue.
     * @return OK
     */
    deleteIssue(issueId: number): Promise<any>;
    /**
     * get articles for issue
     * @return OK
     */
    getArticlesForIssue(issueId: number): Promise<ArticleModel[]>;
    /**
     * add an article to a content stream issue.
     * @return OK
     */
    addArticleToContentStream(addArticleContentStream: AddArticleContentStreamDTO): Promise<any>;
    /**
     * remove an article from a content stream.
     * @return OK
     */
    removeArticleFromIssue(articleId: string): Promise<any>;
    /**
     * finalize an issue, it will be available for curation in the subscribers account after this.
     * @return OK
     */
    finalizeIssue(contentStreamFinalize: ContentStreamFinalizeDTO): Promise<any>;
}

export class ContentStreamIssueClient implements IContentStreamIssueClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * get issue
     * @return OK
     */
    getIssue(issueId: number): Promise<IssueModel> {
        let url_ = this.baseUrl + "/contentstreamissue/issue?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetIssue(_response);
        });
    }

    protected processGetIssue(response: AxiosResponse): Promise<IssueModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueModel>(<any>null);
    }

    /**
     * add a new issue to the content stream.
     * @return OK
     */
    saveContentStreamIssue(contentStreamIssue: ContentStreamIssueDTO): Promise<ContentStreamIssueDTO> {
        let url_ = this.baseUrl + "/contentstreamissue/issue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(contentStreamIssue);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveContentStreamIssue(_response);
        });
    }

    protected processSaveContentStreamIssue(response: AxiosResponse): Promise<ContentStreamIssueDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ContentStreamIssueDTO.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContentStreamIssueDTO>(<any>null);
    }

    /**
     * remove an empty content stream issue.
     * @return OK
     */
    deleteIssue(issueId: number): Promise<any> {
        let url_ = this.baseUrl + "/contentstreamissue/issue?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteIssue(_response);
        });
    }

    protected processDeleteIssue(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * get articles for issue
     * @return OK
     */
    getArticlesForIssue(issueId: number): Promise<ArticleModel[]> {
        let url_ = this.baseUrl + "/contentstreamissue/issuearticles?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "IssueId=" + encodeURIComponent("" + issueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetArticlesForIssue(_response);
        });
    }

    protected processGetArticlesForIssue(response: AxiosResponse): Promise<ArticleModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ArticleModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ArticleModel[]>(<any>null);
    }

    /**
     * add an article to a content stream issue.
     * @return OK
     */
    addArticleToContentStream(addArticleContentStream: AddArticleContentStreamDTO): Promise<any> {
        let url_ = this.baseUrl + "/contentstreamissue/addarticle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addArticleContentStream);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAddArticleToContentStream(_response);
        });
    }

    protected processAddArticleToContentStream(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * remove an article from a content stream.
     * @return OK
     */
    removeArticleFromIssue(articleId: string): Promise<any> {
        let url_ = this.baseUrl + "/contentstreamissue/removearticlefromissue?";
        if (articleId === undefined || articleId === null)
            throw new Error("The parameter 'articleId' must be defined and cannot be null.");
        else
            url_ += "ArticleId=" + encodeURIComponent("" + articleId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRemoveArticleFromIssue(_response);
        });
    }

    protected processRemoveArticleFromIssue(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * finalize an issue, it will be available for curation in the subscribers account after this.
     * @return OK
     */
    finalizeIssue(contentStreamFinalize: ContentStreamFinalizeDTO): Promise<any> {
        let url_ = this.baseUrl + "/contentstreamissue/finalize";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(contentStreamFinalize);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFinalizeIssue(_response);
        });
    }

    protected processFinalizeIssue(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }
}

export interface IContentStreamStoreClient {
    /**
     * get stream subscriptions for account.
     * @return OK
     */
    getContentStreamSubscriptions(customerAccountId: number): Promise<ContentStreamSubscriptionStoreDTO[]>;
    /**
     * get content stream for given id
     * @return OK
     */
    getContentStream(contentStreamId: string): Promise<ContentStreamStoreDTO>;
    /**
     * Update subscriber information for curation, tailored.
     * @return OK
     */
    updateSubscriptionInfo(contentStreamSubscriberInfo: ContentStreamSubscriberInfoDTO): Promise<any>;
    /**
     * Subscribe to a content stream, this must be performed by subscriber.
     * @param contentStreamSubscriptionData Subscription data
     * @return OK
     */
    subscribeToContentStream(contentStreamSubscriptionData: ContentStreamSubscriptionDataDTO): Promise<any>;
    /**
     * Cancel a stream subscription.
     * @return OK
     */
    cancelSubscription(contentStreamSubscriptionId: number): Promise<any>;
}

export class ContentStreamStoreClient implements IContentStreamStoreClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * get stream subscriptions for account.
     * @return OK
     */
    getContentStreamSubscriptions(customerAccountId: number): Promise<ContentStreamSubscriptionStoreDTO[]> {
        let url_ = this.baseUrl + "/contentstreamstore/subscriptions?";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined and cannot be null.");
        else
            url_ += "CustomerAccountId=" + encodeURIComponent("" + customerAccountId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetContentStreamSubscriptions(_response);
        });
    }

    protected processGetContentStreamSubscriptions(response: AxiosResponse): Promise<ContentStreamSubscriptionStoreDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContentStreamSubscriptionStoreDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContentStreamSubscriptionStoreDTO[]>(<any>null);
    }

    /**
     * get content stream for given id
     * @return OK
     */
    getContentStream(contentStreamId: string): Promise<ContentStreamStoreDTO> {
        let url_ = this.baseUrl + "/contentstreamstore/stream?";
        if (contentStreamId === undefined || contentStreamId === null)
            throw new Error("The parameter 'contentStreamId' must be defined and cannot be null.");
        else
            url_ += "contentStreamId=" + encodeURIComponent("" + contentStreamId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetContentStream(_response);
        });
    }

    protected processGetContentStream(response: AxiosResponse): Promise<ContentStreamStoreDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ContentStreamStoreDTO.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContentStreamStoreDTO>(<any>null);
    }

    /**
     * Update subscriber information for curation, tailored.
     * @return OK
     */
    updateSubscriptionInfo(contentStreamSubscriberInfo: ContentStreamSubscriberInfoDTO): Promise<any> {
        let url_ = this.baseUrl + "/contentstreamstore/updatesubscriberinfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(contentStreamSubscriberInfo);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateSubscriptionInfo(_response);
        });
    }

    protected processUpdateSubscriptionInfo(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Subscribe to a content stream, this must be performed by subscriber.
     * @param contentStreamSubscriptionData Subscription data
     * @return OK
     */
    subscribeToContentStream(contentStreamSubscriptionData: ContentStreamSubscriptionDataDTO): Promise<any> {
        let url_ = this.baseUrl + "/contentstreamstore/subscribe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(contentStreamSubscriptionData);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSubscribeToContentStream(_response);
        });
    }

    protected processSubscribeToContentStream(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Cancel a stream subscription.
     * @return OK
     */
    cancelSubscription(contentStreamSubscriptionId: number): Promise<any> {
        let url_ = this.baseUrl + "/contentstreamstore/cancelsubscription?";
        if (contentStreamSubscriptionId === undefined || contentStreamSubscriptionId === null)
            throw new Error("The parameter 'contentStreamSubscriptionId' must be defined and cannot be null.");
        else
            url_ += "ContentStreamSubscriptionId=" + encodeURIComponent("" + contentStreamSubscriptionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCancelSubscription(_response);
        });
    }

    protected processCancelSubscription(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }
}

export interface IConversionOptionsClient {
    /**
     * GetIssueOptions the conversion options for the give issue.
     * @param issueId The issue id.
     * @return OK
     */
    getIssueOptions(issueId: number): Promise<ConversionOptionsModel>;
    /**
     * Get the conversion options for a publication.
     * @return OK
     */
    getPublicationOptions(publicationId: number): Promise<ConversionOptionsModel>;
    /**
     * Save the processing options for this publication.
     * @return OK
     */
    savePublicationOptions(options: ConversionOptionsModel, publicationId: number): Promise<ConversionOptionsModel>;
    /**
     * Gets the conversion options for a customer.
     * @return OK
     */
    getCustomerOptions(customerId: number): Promise<ConversionOptionsModel>;
    /**
     * Save the processing options for this customer.
     * @return OK
     */
    saveCustomerOptions(options: ConversionOptionsModel, customerId: number): Promise<ConversionOptionsModel>;
    /**
     * Save the processing options for the given issue.
     * @param options updated options object
     * @param issueId issue id
     * @return OK
     */
    saveIssueOptions(options: ConversionOptionsModel, issueId: number): Promise<ConversionOptionsModel>;
}

export class ConversionOptionsClient implements IConversionOptionsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * GetIssueOptions the conversion options for the give issue.
     * @param issueId The issue id.
     * @return OK
     */
    getIssueOptions(issueId: number): Promise<ConversionOptionsModel> {
        let url_ = this.baseUrl + "/conversionoptions/issueoptions?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetIssueOptions(_response);
        });
    }

    protected processGetIssueOptions(response: AxiosResponse): Promise<ConversionOptionsModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ConversionOptionsModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConversionOptionsModel>(<any>null);
    }

    /**
     * Get the conversion options for a publication.
     * @return OK
     */
    getPublicationOptions(publicationId: number): Promise<ConversionOptionsModel> {
        let url_ = this.baseUrl + "/conversionoptions/publicationoptions?";
        if (publicationId === undefined || publicationId === null)
            throw new Error("The parameter 'publicationId' must be defined and cannot be null.");
        else
            url_ += "publicationId=" + encodeURIComponent("" + publicationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPublicationOptions(_response);
        });
    }

    protected processGetPublicationOptions(response: AxiosResponse): Promise<ConversionOptionsModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ConversionOptionsModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConversionOptionsModel>(<any>null);
    }

    /**
     * Save the processing options for this publication.
     * @return OK
     */
    savePublicationOptions(options: ConversionOptionsModel, publicationId: number): Promise<ConversionOptionsModel> {
        let url_ = this.baseUrl + "/conversionoptions/publicationoptions?";
        if (publicationId === undefined || publicationId === null)
            throw new Error("The parameter 'publicationId' must be defined and cannot be null.");
        else
            url_ += "publicationId=" + encodeURIComponent("" + publicationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSavePublicationOptions(_response);
        });
    }

    protected processSavePublicationOptions(response: AxiosResponse): Promise<ConversionOptionsModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ConversionOptionsModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConversionOptionsModel>(<any>null);
    }

    /**
     * Gets the conversion options for a customer.
     * @return OK
     */
    getCustomerOptions(customerId: number): Promise<ConversionOptionsModel> {
        let url_ = this.baseUrl + "/conversionoptions/customeroptions?";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined and cannot be null.");
        else
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetCustomerOptions(_response);
        });
    }

    protected processGetCustomerOptions(response: AxiosResponse): Promise<ConversionOptionsModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ConversionOptionsModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConversionOptionsModel>(<any>null);
    }

    /**
     * Save the processing options for this customer.
     * @return OK
     */
    saveCustomerOptions(options: ConversionOptionsModel, customerId: number): Promise<ConversionOptionsModel> {
        let url_ = this.baseUrl + "/conversionoptions/customeroptions?";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined and cannot be null.");
        else
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveCustomerOptions(_response);
        });
    }

    protected processSaveCustomerOptions(response: AxiosResponse): Promise<ConversionOptionsModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ConversionOptionsModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConversionOptionsModel>(<any>null);
    }

    /**
     * Save the processing options for the given issue.
     * @param options updated options object
     * @param issueId issue id
     * @return OK
     */
    saveIssueOptions(options: ConversionOptionsModel, issueId: number): Promise<ConversionOptionsModel> {
        let url_ = this.baseUrl + "/conversionoptions/options?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveIssueOptions(_response);
        });
    }

    protected processSaveIssueOptions(response: AxiosResponse): Promise<ConversionOptionsModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ConversionOptionsModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConversionOptionsModel>(<any>null);
    }
}

export interface ICorelogicClient {
    /**
     * Checks if an account exists, if not, creates an account in Partica using the details provided.
    Checks if the account has an active subscription to the stream.
    Restricted to tenant owner.
     * @return OK
     */
    createSubscription(userDTO: PartnerSubscriptionDTO): Promise<any>;
    /**
     * Gets all articles for the stream.
     * @return OK
     */
    getArticles(externalId: string, partnerId: string): Promise<any>;
    /**
     * Get all streams for partner.
     * @return OK
     */
    getStreams(partnerId: string): Promise<ContentStreamStoreDTO[]>;
    /**
     * Get subscriptions for user.
     * @return OK
     */
    getSubscriptions(externalId: string, partnerId: string): Promise<any>;
}

export class CorelogicClient implements ICorelogicClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Checks if an account exists, if not, creates an account in Partica using the details provided.
    Checks if the account has an active subscription to the stream.
    Restricted to tenant owner.
     * @return OK
     */
    createSubscription(userDTO: PartnerSubscriptionDTO): Promise<any> {
        let url_ = this.baseUrl + "/partners/corelogic";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateSubscription(_response);
        });
    }

    protected processCreateSubscription(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Gets all articles for the stream.
     * @return OK
     */
    getArticles(externalId: string, partnerId: string): Promise<any> {
        let url_ = this.baseUrl + "/partners/corelogic/articles?";
        if (externalId === undefined || externalId === null)
            throw new Error("The parameter 'externalId' must be defined and cannot be null.");
        else
            url_ += "ExternalId=" + encodeURIComponent("" + externalId) + "&"; 
        if (partnerId === undefined || partnerId === null)
            throw new Error("The parameter 'partnerId' must be defined and cannot be null.");
        else
            url_ += "PartnerId=" + encodeURIComponent("" + partnerId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetArticles(_response);
        });
    }

    protected processGetArticles(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Get all streams for partner.
     * @return OK
     */
    getStreams(partnerId: string): Promise<ContentStreamStoreDTO[]> {
        let url_ = this.baseUrl + "/partners/corelogic/streams?";
        if (partnerId === undefined || partnerId === null)
            throw new Error("The parameter 'partnerId' must be defined and cannot be null.");
        else
            url_ += "PartnerId=" + encodeURIComponent("" + partnerId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetStreams(_response);
        });
    }

    protected processGetStreams(response: AxiosResponse): Promise<ContentStreamStoreDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContentStreamStoreDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContentStreamStoreDTO[]>(<any>null);
    }

    /**
     * Get subscriptions for user.
     * @return OK
     */
    getSubscriptions(externalId: string, partnerId: string): Promise<any> {
        let url_ = this.baseUrl + "/partners/corelogic/subscriptions?";
        if (externalId === undefined || externalId === null)
            throw new Error("The parameter 'externalId' must be defined and cannot be null.");
        else
            url_ += "ExternalId=" + encodeURIComponent("" + externalId) + "&"; 
        if (partnerId === undefined || partnerId === null)
            throw new Error("The parameter 'partnerId' must be defined and cannot be null.");
        else
            url_ += "PartnerId=" + encodeURIComponent("" + partnerId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetSubscriptions(_response);
        });
    }

    protected processGetSubscriptions(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }
}

export interface ICustomerAccountClient {
    /**
     * update account and user details.
     * @return OK
     */
    getAccountDetails(customerAccountId: number): Promise<AccountDetailsUpdateDTO>;
    /**
     * update account and user details.
     * @return OK
     */
    updateAccountDetails(accountDetailsUpdateDTO: AccountDetailsUpdateDTO): Promise<boolean>;
    /**
     * get all users for an account.
     * @param customerAccountId the account you want to get users for.
     * @return OK
     */
    getAccountUsers(customerAccountId: number): Promise<AdminIdentityUserModel[]>;
    /**
     * Rename an account. By default it is created using the email of the owner.
     * @return OK
     */
    rename(customerAccountId: number, newName: string): Promise<any>;
    /**
     * Get the default account for the user.
     * @return OK
     */
    getCustomerAccount(): Promise<CustomerAccountModel>;
    /**
     * get a customers account using its unique name
     * @return OK
     */
    getCustomerAccountByName(customerName: string): Promise<CustomerAccountModel>;
    /**
     * list all account the user has access to.
     * @return OK
     */
    listAllAccounts(): Promise<CustomerAccountModel[]>;
    /**
     * Gets all the customerAccounts/publications/issues the give user has access to. The user is determined by the access token.
     * @param issues Include issues in the returned object structure?
     * @return OK
     */
    getCustomerAccounts(issues: boolean): Promise<CustomerAccountModel[]>;
    /**
     * Find a customer/publication this user has access to. This will match the searchKey string to any part of the name of customer/publication.
     * @param text the text to match
     * @return OK
     */
    find(text: string): Promise<string[]>;
    /**
     * This deletes the customers account.
    Any users associated with the account are not deleted.
    You should delete the users accociated with this account before deleting the account.
     * @param customerAccountId account to delete
     * @return OK
     */
    deleteCustomerAccount(customerAccountId: number): Promise<any>;
    /**
     * Updates the status of customers account.
     * @param customerAccountId account to update
     * @param status new status of account
     * @return OK
     */
    updateCustomerAccountStatus(customerAccountId: number, status: Status): Promise<any>;
}

export class CustomerAccountClient implements ICustomerAccountClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * update account and user details.
     * @return OK
     */
    getAccountDetails(customerAccountId: number): Promise<AccountDetailsUpdateDTO> {
        let url_ = this.baseUrl + "/customeraccount/accountdetails?";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined and cannot be null.");
        else
            url_ += "CustomerAccountId=" + encodeURIComponent("" + customerAccountId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAccountDetails(_response);
        });
    }

    protected processGetAccountDetails(response: AxiosResponse): Promise<AccountDetailsUpdateDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccountDetailsUpdateDTO.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountDetailsUpdateDTO>(<any>null);
    }

    /**
     * update account and user details.
     * @return OK
     */
    updateAccountDetails(accountDetailsUpdateDTO: AccountDetailsUpdateDTO): Promise<boolean> {
        let url_ = this.baseUrl + "/customeraccount/accountdetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(accountDetailsUpdateDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateAccountDetails(_response);
        });
    }

    protected processUpdateAccountDetails(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * get all users for an account.
     * @param customerAccountId the account you want to get users for.
     * @return OK
     */
    getAccountUsers(customerAccountId: number): Promise<AdminIdentityUserModel[]> {
        let url_ = this.baseUrl + "/customeraccount/getaccountusers?";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined and cannot be null.");
        else
            url_ += "customerAccountId=" + encodeURIComponent("" + customerAccountId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAccountUsers(_response);
        });
    }

    protected processGetAccountUsers(response: AxiosResponse): Promise<AdminIdentityUserModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AdminIdentityUserModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AdminIdentityUserModel[]>(<any>null);
    }

    /**
     * Rename an account. By default it is created using the email of the owner.
     * @return OK
     */
    rename(customerAccountId: number, newName: string): Promise<any> {
        let url_ = this.baseUrl + "/customeraccount/rename?";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined and cannot be null.");
        else
            url_ += "customerAccountId=" + encodeURIComponent("" + customerAccountId) + "&"; 
        if (newName === undefined || newName === null)
            throw new Error("The parameter 'newName' must be defined and cannot be null.");
        else
            url_ += "newName=" + encodeURIComponent("" + newName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRename(_response);
        });
    }

    protected processRename(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Get the default account for the user.
     * @return OK
     */
    getCustomerAccount(): Promise<CustomerAccountModel> {
        let url_ = this.baseUrl + "/customeraccount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetCustomerAccount(_response);
        });
    }

    protected processGetCustomerAccount(response: AxiosResponse): Promise<CustomerAccountModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomerAccountModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerAccountModel>(<any>null);
    }

    /**
     * get a customers account using its unique name
     * @return OK
     */
    getCustomerAccountByName(customerName: string): Promise<CustomerAccountModel> {
        let url_ = this.baseUrl + "/customeraccount/byname?";
        if (customerName === undefined || customerName === null)
            throw new Error("The parameter 'customerName' must be defined and cannot be null.");
        else
            url_ += "customerName=" + encodeURIComponent("" + customerName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetCustomerAccountByName(_response);
        });
    }

    protected processGetCustomerAccountByName(response: AxiosResponse): Promise<CustomerAccountModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomerAccountModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerAccountModel>(<any>null);
    }

    /**
     * list all account the user has access to.
     * @return OK
     */
    listAllAccounts(): Promise<CustomerAccountModel[]> {
        let url_ = this.baseUrl + "/customeraccount/listall";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processListAllAccounts(_response);
        });
    }

    protected processListAllAccounts(response: AxiosResponse): Promise<CustomerAccountModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerAccountModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerAccountModel[]>(<any>null);
    }

    /**
     * Gets all the customerAccounts/publications/issues the give user has access to. The user is determined by the access token.
     * @param issues Include issues in the returned object structure?
     * @return OK
     */
    getCustomerAccounts(issues: boolean): Promise<CustomerAccountModel[]> {
        let url_ = this.baseUrl + "/customeraccount/customerAccounts?";
        if (issues === undefined || issues === null)
            throw new Error("The parameter 'issues' must be defined and cannot be null.");
        else
            url_ += "issues=" + encodeURIComponent("" + issues) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetCustomerAccounts(_response);
        });
    }

    protected processGetCustomerAccounts(response: AxiosResponse): Promise<CustomerAccountModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerAccountModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerAccountModel[]>(<any>null);
    }

    /**
     * Find a customer/publication this user has access to. This will match the searchKey string to any part of the name of customer/publication.
     * @param text the text to match
     * @return OK
     */
    find(text: string): Promise<string[]> {
        let url_ = this.baseUrl + "/customeraccount/find?";
        if (text === undefined || text === null)
            throw new Error("The parameter 'text' must be defined and cannot be null.");
        else
            url_ += "text=" + encodeURIComponent("" + text) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFind(_response);
        });
    }

    protected processFind(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(<any>null);
    }

    /**
     * This deletes the customers account.
    Any users associated with the account are not deleted.
    You should delete the users accociated with this account before deleting the account.
     * @param customerAccountId account to delete
     * @return OK
     */
    deleteCustomerAccount(customerAccountId: number): Promise<any> {
        let url_ = this.baseUrl + "/customeraccount/customeraccount?";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined and cannot be null.");
        else
            url_ += "customerAccountId=" + encodeURIComponent("" + customerAccountId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteCustomerAccount(_response);
        });
    }

    protected processDeleteCustomerAccount(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Updates the status of customers account.
     * @param customerAccountId account to update
     * @param status new status of account
     * @return OK
     */
    updateCustomerAccountStatus(customerAccountId: number, status: Status): Promise<any> {
        let url_ = this.baseUrl + "/customeraccount/updatestatus?";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined and cannot be null.");
        else
            url_ += "customerAccountId=" + encodeURIComponent("" + customerAccountId) + "&"; 
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined and cannot be null.");
        else
            url_ += "status=" + encodeURIComponent("" + status) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateCustomerAccountStatus(_response);
        });
    }

    protected processUpdateCustomerAccountStatus(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }
}

export interface ICustomerAccountBillingClient {
    /**
     * Get a list of customerAccountBillings for the given publication.
     * @param customerAccountId Publication to get customerAccountBilling for.
     * @return OK
     */
    getCustomerAccountBillings(customerAccountId: number): Promise<CustomerAccountBillingModel[]>;
    /**
     * Adds a new customerAccountBilling to the publication
     * @param customerAccountBilling customerAccountBilling to add.
     * @return OK
     */
    addCustomerAccountBilling(customerAccountBilling: CustomerAccountBillingModel): Promise<CustomerAccountBillingModel>;
    /**
     * Delete a customerAccountBilling.
     * @param customerAccountId id of the customerAccountBilling to delete.
     * @return OK
     */
    deleteCustomerAccountBilling(customerAccountId: number): Promise<any>;
    /**
     * update a customerAccountBilling.
     * @return OK
     */
    updateCustomerAccountBilling(customerAccountBilling: CustomerAccountBillingModel): Promise<CustomerAccountBillingModel>;
}

export class CustomerAccountBillingClient implements ICustomerAccountBillingClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Get a list of customerAccountBillings for the given publication.
     * @param customerAccountId Publication to get customerAccountBilling for.
     * @return OK
     */
    getCustomerAccountBillings(customerAccountId: number): Promise<CustomerAccountBillingModel[]> {
        let url_ = this.baseUrl + "/customerAccountBilling?";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined and cannot be null.");
        else
            url_ += "customerAccountId=" + encodeURIComponent("" + customerAccountId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetCustomerAccountBillings(_response);
        });
    }

    protected processGetCustomerAccountBillings(response: AxiosResponse): Promise<CustomerAccountBillingModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerAccountBillingModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerAccountBillingModel[]>(<any>null);
    }

    /**
     * Adds a new customerAccountBilling to the publication
     * @param customerAccountBilling customerAccountBilling to add.
     * @return OK
     */
    addCustomerAccountBilling(customerAccountBilling: CustomerAccountBillingModel): Promise<CustomerAccountBillingModel> {
        let url_ = this.baseUrl + "/customerAccountBilling";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customerAccountBilling);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAddCustomerAccountBilling(_response);
        });
    }

    protected processAddCustomerAccountBilling(response: AxiosResponse): Promise<CustomerAccountBillingModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomerAccountBillingModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerAccountBillingModel>(<any>null);
    }

    /**
     * Delete a customerAccountBilling.
     * @param customerAccountId id of the customerAccountBilling to delete.
     * @return OK
     */
    deleteCustomerAccountBilling(customerAccountId: number): Promise<any> {
        let url_ = this.baseUrl + "/customerAccountBilling?";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined and cannot be null.");
        else
            url_ += "CustomerAccountId=" + encodeURIComponent("" + customerAccountId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteCustomerAccountBilling(_response);
        });
    }

    protected processDeleteCustomerAccountBilling(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * update a customerAccountBilling.
     * @return OK
     */
    updateCustomerAccountBilling(customerAccountBilling: CustomerAccountBillingModel): Promise<CustomerAccountBillingModel> {
        let url_ = this.baseUrl + "/customerAccountBilling/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customerAccountBilling);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateCustomerAccountBilling(_response);
        });
    }

    protected processUpdateCustomerAccountBilling(response: AxiosResponse): Promise<CustomerAccountBillingModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomerAccountBillingModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerAccountBillingModel>(<any>null);
    }
}

export interface ICustomerAccountLicenceClient {
    /**
     * get all licences
     * @return OK
     */
    getLicences(): Promise<LicenceDTO[]>;
    /**
     * get active TandC licence
     * @return OK
     */
    getActiveTC(): Promise<LicenceContentDTO>;
    /**
     * add or update a licance.
     * @return OK
     */
    saveLicence(licence: LicenceDTO): Promise<LicenceDTO>;
}

export class CustomerAccountLicenceClient implements ICustomerAccountLicenceClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * get all licences
     * @return OK
     */
    getLicences(): Promise<LicenceDTO[]> {
        let url_ = this.baseUrl + "/licencemanagement/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetLicences(_response);
        });
    }

    protected processGetLicences(response: AxiosResponse): Promise<LicenceDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LicenceDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LicenceDTO[]>(<any>null);
    }

    /**
     * get active TandC licence
     * @return OK
     */
    getActiveTC(): Promise<LicenceContentDTO> {
        let url_ = this.baseUrl + "/licencemanagement/activetc";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetActiveTC(_response);
        });
    }

    protected processGetActiveTC(response: AxiosResponse): Promise<LicenceContentDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LicenceContentDTO.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LicenceContentDTO>(<any>null);
    }

    /**
     * add or update a licance.
     * @return OK
     */
    saveLicence(licence: LicenceDTO): Promise<LicenceDTO> {
        let url_ = this.baseUrl + "/licencemanagement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(licence);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveLicence(_response);
        });
    }

    protected processSaveLicence(response: AxiosResponse): Promise<LicenceDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LicenceDTO.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LicenceDTO>(<any>null);
    }
}

export interface ICustomerAccountUserClient {
    /**
     * Send an invite to the given email address to give them access to this account.
     * @param email email to send the invite to.
     * @param customerAccountId account to invite to.
     * @param tenantId current tenant
     * @return OK
     */
    invite(email: string, customerAccountId: number, tenantId: number): Promise<any>;
    /**
     * Delete a users access to an account. 
    The user is deleted if this is the only account they have access to.
    If the user has access to another account then thier access to this account is removed but the user is not deleted.
    ("If the user is the owner of an account then the account will be deleted." removed - will now not delete account.)
     * @return OK
     */
    deleteUser(user: string, customerAccountId: number): Promise<any>;
    /**
     * Update the owner of an account.
     * @param user the user to change
     * @param customerAccountId the account to change
     * @param owner owner or not
     * @return OK
     */
    updateOwner(user: string, customerAccountId: number, owner: boolean): Promise<any>;
    /**
     * get a list of users for the given account.
     * @return OK
     */
    getUsers(customerAccountId: number): Promise<UserLoginDetails[]>;
    /**
     * update the email of the current user.
     * @param newEmail new email address
     * @return OK
     */
    updateEmailAdddress(newEmail: string): Promise<any>;
    /**
     * update the email of the current user.
     * @param userId the user to update
     * @param newUserName the new username
     * @return OK
     */
    updateUsername(userId: string, newUserName: string): Promise<any>;
    /**
     * Checks if an emailaddress already exists in partica.
     * @return OK
     */
    emailExists(email: string): Promise<any>;
}

export class CustomerAccountUserClient implements ICustomerAccountUserClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Send an invite to the given email address to give them access to this account.
     * @param email email to send the invite to.
     * @param customerAccountId account to invite to.
     * @param tenantId current tenant
     * @return OK
     */
    invite(email: string, customerAccountId: number, tenantId: number): Promise<any> {
        let url_ = this.baseUrl + "/customeraccountuser/invite?";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined and cannot be null.");
        else
            url_ += "email=" + encodeURIComponent("" + email) + "&"; 
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined and cannot be null.");
        else
            url_ += "customerAccountId=" + encodeURIComponent("" + customerAccountId) + "&"; 
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined and cannot be null.");
        else
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processInvite(_response);
        });
    }

    protected processInvite(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Delete a users access to an account. 
    The user is deleted if this is the only account they have access to.
    If the user has access to another account then thier access to this account is removed but the user is not deleted.
    ("If the user is the owner of an account then the account will be deleted." removed - will now not delete account.)
     * @return OK
     */
    deleteUser(user: string, customerAccountId: number): Promise<any> {
        let url_ = this.baseUrl + "/customeraccountuser/user?";
        if (user === undefined || user === null)
            throw new Error("The parameter 'user' must be defined and cannot be null.");
        else
            url_ += "user=" + encodeURIComponent("" + user) + "&"; 
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined and cannot be null.");
        else
            url_ += "customerAccountId=" + encodeURIComponent("" + customerAccountId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteUser(_response);
        });
    }

    protected processDeleteUser(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Update the owner of an account.
     * @param user the user to change
     * @param customerAccountId the account to change
     * @param owner owner or not
     * @return OK
     */
    updateOwner(user: string, customerAccountId: number, owner: boolean): Promise<any> {
        let url_ = this.baseUrl + "/customeraccountuser/updateowner?";
        if (user === undefined || user === null)
            throw new Error("The parameter 'user' must be defined and cannot be null.");
        else
            url_ += "user=" + encodeURIComponent("" + user) + "&"; 
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined and cannot be null.");
        else
            url_ += "customerAccountId=" + encodeURIComponent("" + customerAccountId) + "&"; 
        if (owner === undefined || owner === null)
            throw new Error("The parameter 'owner' must be defined and cannot be null.");
        else
            url_ += "owner=" + encodeURIComponent("" + owner) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateOwner(_response);
        });
    }

    protected processUpdateOwner(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * get a list of users for the given account.
     * @return OK
     */
    getUsers(customerAccountId: number): Promise<UserLoginDetails[]> {
        let url_ = this.baseUrl + "/customeraccountuser/users?";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined and cannot be null.");
        else
            url_ += "customerAccountId=" + encodeURIComponent("" + customerAccountId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetUsers(_response);
        });
    }

    protected processGetUsers(response: AxiosResponse): Promise<UserLoginDetails[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserLoginDetails.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserLoginDetails[]>(<any>null);
    }

    /**
     * update the email of the current user.
     * @param newEmail new email address
     * @return OK
     */
    updateEmailAdddress(newEmail: string): Promise<any> {
        let url_ = this.baseUrl + "/customeraccountuser/updateemail?";
        if (newEmail === undefined || newEmail === null)
            throw new Error("The parameter 'newEmail' must be defined and cannot be null.");
        else
            url_ += "newEmail=" + encodeURIComponent("" + newEmail) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateEmailAdddress(_response);
        });
    }

    protected processUpdateEmailAdddress(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * update the email of the current user.
     * @param userId the user to update
     * @param newUserName the new username
     * @return OK
     */
    updateUsername(userId: string, newUserName: string): Promise<any> {
        let url_ = this.baseUrl + "/customeraccountuser/updateusername?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        if (newUserName === undefined || newUserName === null)
            throw new Error("The parameter 'newUserName' must be defined and cannot be null.");
        else
            url_ += "newUserName=" + encodeURIComponent("" + newUserName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateUsername(_response);
        });
    }

    protected processUpdateUsername(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Checks if an emailaddress already exists in partica.
     * @return OK
     */
    emailExists(email: string): Promise<any> {
        let url_ = this.baseUrl + "/customeraccountuser/emailexists?";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined and cannot be null.");
        else
            url_ += "email=" + encodeURIComponent("" + email) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processEmailExists(_response);
        });
    }

    protected processEmailExists(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }
}

export interface ICustomerPaymentClient {
    /**
     * get a summary of a payment batch give the search options.
     * @return OK
     */
    getBatchDetails(searchOptions: ChargebeeTransactionSearchOptions): Promise<PaymentBatch>;
    /**
     * Get all batches.
     * @return OK
     */
    allBatches(batchId: number): Promise<HyperwalletBatchDTO[]>;
    /**
     * retry a failed batch.
     * @return OK
     */
    retryBatch(batchId: number): Promise<PaymentBatch>;
    /**
     * process a batch of payments to hyperwallet.
     * @return OK
     */
    processBatch(batchDetails: HyperwalletBatchDetailsDTO): Promise<PaymentBatch>;
    /**
     * Get SAML for wallet SSO.
     * @return OK
     */
    getSSO(): Promise<any>;
    /**
     * Does the user have a hyperwallet account.
     * @return OK
     */
    hasAccount(): Promise<boolean>;
}

export class CustomerPaymentClient implements ICustomerPaymentClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * get a summary of a payment batch give the search options.
     * @return OK
     */
    getBatchDetails(searchOptions: ChargebeeTransactionSearchOptions): Promise<PaymentBatch> {
        let url_ = this.baseUrl + "/customerpayment/batchdetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchOptions);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetBatchDetails(_response);
        });
    }

    protected processGetBatchDetails(response: AxiosResponse): Promise<PaymentBatch> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaymentBatch.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaymentBatch>(<any>null);
    }

    /**
     * Get all batches.
     * @return OK
     */
    allBatches(batchId: number): Promise<HyperwalletBatchDTO[]> {
        let url_ = this.baseUrl + "/customerpayment?";
        if (batchId === undefined || batchId === null)
            throw new Error("The parameter 'batchId' must be defined and cannot be null.");
        else
            url_ += "BatchId=" + encodeURIComponent("" + batchId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAllBatches(_response);
        });
    }

    protected processAllBatches(response: AxiosResponse): Promise<HyperwalletBatchDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HyperwalletBatchDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HyperwalletBatchDTO[]>(<any>null);
    }

    /**
     * retry a failed batch.
     * @return OK
     */
    retryBatch(batchId: number): Promise<PaymentBatch> {
        let url_ = this.baseUrl + "/customerpayment/retrybatch?";
        if (batchId === undefined || batchId === null)
            throw new Error("The parameter 'batchId' must be defined and cannot be null.");
        else
            url_ += "BatchId=" + encodeURIComponent("" + batchId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRetryBatch(_response);
        });
    }

    protected processRetryBatch(response: AxiosResponse): Promise<PaymentBatch> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaymentBatch.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaymentBatch>(<any>null);
    }

    /**
     * process a batch of payments to hyperwallet.
     * @return OK
     */
    processBatch(batchDetails: HyperwalletBatchDetailsDTO): Promise<PaymentBatch> {
        let url_ = this.baseUrl + "/customerpayment/processbatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(batchDetails);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processProcessBatch(_response);
        });
    }

    protected processProcessBatch(response: AxiosResponse): Promise<PaymentBatch> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaymentBatch.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaymentBatch>(<any>null);
    }

    /**
     * Get SAML for wallet SSO.
     * @return OK
     */
    getSSO(): Promise<any> {
        let url_ = this.baseUrl + "/customerpayment/sso";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetSSO(_response);
        });
    }

    protected processGetSSO(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Does the user have a hyperwallet account.
     * @return OK
     */
    hasAccount(): Promise<boolean> {
        let url_ = this.baseUrl + "/customerpayment/hasaccount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processHasAccount(_response);
        });
    }

    protected processHasAccount(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export interface IDashboardNavClient {
    /**
     * websites for account.
     * @return OK
     */
    getDomains(customerAccountId: number): Promise<ListItemDTO[]>;
    /**
     * return json menu for Content Stream Dasboard
     * @return OK
     */
    getDashboardMenu(customerAccountId: number): Promise<MenuItemDTO[]>;
    /**
     * Returns all articles for an issue. All types.
     * @return OK
     */
    searchArticlesAll(issueId: number): Promise<ListItemDTO[]>;
    /**
     * @return OK
     */
    searchArticles(query: string): Promise<ListItemDTO[]>;
    /**
     * get issues for a publication
     * @return OK
     */
    getIssuesForPublication(publicationId: number): Promise<PubIssueDTO[]>;
    /**
     * get publication
     * @return OK
     */
    getStreamSubscription(contentStreamSubscriptionId: number): Promise<NavItemDTO>;
    /**
     * get publication
     * @return OK
     */
    getPublication(publicationId: number): Promise<NavItemDTO>;
    /**
     * get Stream
     * @return OK
     */
    getStream(streamId: number): Promise<NavItemDTO>;
    /**
     * get Account
     * @return OK
     */
    getAccount(accountId: number): Promise<NavItemDTO>;
    /**
     * get Issue
     * @return OK
     */
    getIssue(issueId: number): Promise<NavItemDTO>;
    /**
     * get Url
     * @return OK
     */
    getUrl(urlId: number): Promise<NavItemDTO>;
    /**
     * @return OK
     */
    getIssuesForStream(contentStreamId: number): Promise<ListItemDTO[]>;
    /**
     * get pricing levels for content stream
     * @return OK
     */
    getPricingLevelsForStream(contentStreamId: number): Promise<ListItemDTO[]>;
    /**
     * get wordpress plugins for account.
     * @return OK
     */
    getWPPlugins(customerAccountId: number): Promise<ListItemDTO[]>;
    /**
     * get articles (curated, awaiting curation)for a content stream subscription
     * @return OK
     */
    getSubscriptionArticles(contentStreamSubscriptionId: number, curated: boolean): Promise<ListItemDTO[]>;
    /**
     * get dashboard menu for the logged in user.
     * @return OK
     */
    getMe(): Promise<MenuItemDTO[]>;
    /**
     * get all accounts - admin only
     * @return OK
     */
    getAccounts(query: string): Promise<ListItemDTO[]>;
}

export class DashboardNavClient implements IDashboardNavClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * websites for account.
     * @return OK
     */
    getDomains(customerAccountId: number): Promise<ListItemDTO[]> {
        let url_ = this.baseUrl + "/navigation/domains?";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined and cannot be null.");
        else
            url_ += "CustomerAccountId=" + encodeURIComponent("" + customerAccountId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetDomains(_response);
        });
    }

    protected processGetDomains(response: AxiosResponse): Promise<ListItemDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ListItemDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListItemDTO[]>(<any>null);
    }

    /**
     * return json menu for Content Stream Dasboard
     * @return OK
     */
    getDashboardMenu(customerAccountId: number): Promise<MenuItemDTO[]> {
        let url_ = this.baseUrl + "/navigation/menu/contentstreamdashboard?";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined and cannot be null.");
        else
            url_ += "CustomerAccountId=" + encodeURIComponent("" + customerAccountId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetDashboardMenu(_response);
        });
    }

    protected processGetDashboardMenu(response: AxiosResponse): Promise<MenuItemDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MenuItemDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MenuItemDTO[]>(<any>null);
    }

    /**
     * Returns all articles for an issue. All types.
     * @return OK
     */
    searchArticlesAll(issueId: number): Promise<ListItemDTO[]> {
        let url_ = this.baseUrl + "/navigation/issuearticles?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "IssueId=" + encodeURIComponent("" + issueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSearchArticlesAll(_response);
        });
    }

    protected processSearchArticlesAll(response: AxiosResponse): Promise<ListItemDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ListItemDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListItemDTO[]>(<any>null);
    }

    /**
     * @return OK
     */
    searchArticles(query: string): Promise<ListItemDTO[]> {
        let url_ = this.baseUrl + "/navigation/search?";
        if (query === undefined || query === null)
            throw new Error("The parameter 'query' must be defined and cannot be null.");
        else
            url_ += "query=" + encodeURIComponent("" + query) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSearchArticles(_response);
        });
    }

    protected processSearchArticles(response: AxiosResponse): Promise<ListItemDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ListItemDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListItemDTO[]>(<any>null);
    }

    /**
     * get issues for a publication
     * @return OK
     */
    getIssuesForPublication(publicationId: number): Promise<PubIssueDTO[]> {
        let url_ = this.baseUrl + "/navigation/issuesforpublication?";
        if (publicationId === undefined || publicationId === null)
            throw new Error("The parameter 'publicationId' must be defined and cannot be null.");
        else
            url_ += "PublicationId=" + encodeURIComponent("" + publicationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetIssuesForPublication(_response);
        });
    }

    protected processGetIssuesForPublication(response: AxiosResponse): Promise<PubIssueDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PubIssueDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PubIssueDTO[]>(<any>null);
    }

    /**
     * get publication
     * @return OK
     */
    getStreamSubscription(contentStreamSubscriptionId: number): Promise<NavItemDTO> {
        let url_ = this.baseUrl + "/navigation/streamsubscription?";
        if (contentStreamSubscriptionId === undefined || contentStreamSubscriptionId === null)
            throw new Error("The parameter 'contentStreamSubscriptionId' must be defined and cannot be null.");
        else
            url_ += "ContentStreamSubscriptionId=" + encodeURIComponent("" + contentStreamSubscriptionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetStreamSubscription(_response);
        });
    }

    protected processGetStreamSubscription(response: AxiosResponse): Promise<NavItemDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NavItemDTO.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NavItemDTO>(<any>null);
    }

    /**
     * get publication
     * @return OK
     */
    getPublication(publicationId: number): Promise<NavItemDTO> {
        let url_ = this.baseUrl + "/navigation/publication?";
        if (publicationId === undefined || publicationId === null)
            throw new Error("The parameter 'publicationId' must be defined and cannot be null.");
        else
            url_ += "PublicationId=" + encodeURIComponent("" + publicationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPublication(_response);
        });
    }

    protected processGetPublication(response: AxiosResponse): Promise<NavItemDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NavItemDTO.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NavItemDTO>(<any>null);
    }

    /**
     * get Stream
     * @return OK
     */
    getStream(streamId: number): Promise<NavItemDTO> {
        let url_ = this.baseUrl + "/navigation/Stream?";
        if (streamId === undefined || streamId === null)
            throw new Error("The parameter 'streamId' must be defined and cannot be null.");
        else
            url_ += "StreamId=" + encodeURIComponent("" + streamId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetStream(_response);
        });
    }

    protected processGetStream(response: AxiosResponse): Promise<NavItemDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NavItemDTO.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NavItemDTO>(<any>null);
    }

    /**
     * get Account
     * @return OK
     */
    getAccount(accountId: number): Promise<NavItemDTO> {
        let url_ = this.baseUrl + "/navigation/Account?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined and cannot be null.");
        else
            url_ += "AccountId=" + encodeURIComponent("" + accountId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAccount(_response);
        });
    }

    protected processGetAccount(response: AxiosResponse): Promise<NavItemDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NavItemDTO.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NavItemDTO>(<any>null);
    }

    /**
     * get Issue
     * @return OK
     */
    getIssue(issueId: number): Promise<NavItemDTO> {
        let url_ = this.baseUrl + "/navigation/Issue?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "IssueId=" + encodeURIComponent("" + issueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetIssue(_response);
        });
    }

    protected processGetIssue(response: AxiosResponse): Promise<NavItemDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NavItemDTO.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NavItemDTO>(<any>null);
    }

    /**
     * get Url
     * @return OK
     */
    getUrl(urlId: number): Promise<NavItemDTO> {
        let url_ = this.baseUrl + "/navigation/Url?";
        if (urlId === undefined || urlId === null)
            throw new Error("The parameter 'urlId' must be defined and cannot be null.");
        else
            url_ += "UrlId=" + encodeURIComponent("" + urlId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetUrl(_response);
        });
    }

    protected processGetUrl(response: AxiosResponse): Promise<NavItemDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NavItemDTO.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NavItemDTO>(<any>null);
    }

    /**
     * @return OK
     */
    getIssuesForStream(contentStreamId: number): Promise<ListItemDTO[]> {
        let url_ = this.baseUrl + "/navigation/issues?";
        if (contentStreamId === undefined || contentStreamId === null)
            throw new Error("The parameter 'contentStreamId' must be defined and cannot be null.");
        else
            url_ += "ContentStreamId=" + encodeURIComponent("" + contentStreamId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetIssuesForStream(_response);
        });
    }

    protected processGetIssuesForStream(response: AxiosResponse): Promise<ListItemDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ListItemDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListItemDTO[]>(<any>null);
    }

    /**
     * get pricing levels for content stream
     * @return OK
     */
    getPricingLevelsForStream(contentStreamId: number): Promise<ListItemDTO[]> {
        let url_ = this.baseUrl + "/navigation/pricinglevels?";
        if (contentStreamId === undefined || contentStreamId === null)
            throw new Error("The parameter 'contentStreamId' must be defined and cannot be null.");
        else
            url_ += "ContentStreamId=" + encodeURIComponent("" + contentStreamId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPricingLevelsForStream(_response);
        });
    }

    protected processGetPricingLevelsForStream(response: AxiosResponse): Promise<ListItemDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ListItemDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListItemDTO[]>(<any>null);
    }

    /**
     * get wordpress plugins for account.
     * @return OK
     */
    getWPPlugins(customerAccountId: number): Promise<ListItemDTO[]> {
        let url_ = this.baseUrl + "/navigation/wpplugins?";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined and cannot be null.");
        else
            url_ += "customerAccountId=" + encodeURIComponent("" + customerAccountId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetWPPlugins(_response);
        });
    }

    protected processGetWPPlugins(response: AxiosResponse): Promise<ListItemDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ListItemDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListItemDTO[]>(<any>null);
    }

    /**
     * get articles (curated, awaiting curation)for a content stream subscription
     * @return OK
     */
    getSubscriptionArticles(contentStreamSubscriptionId: number, curated: boolean): Promise<ListItemDTO[]> {
        let url_ = this.baseUrl + "/navigation/subarticles?";
        if (contentStreamSubscriptionId === undefined || contentStreamSubscriptionId === null)
            throw new Error("The parameter 'contentStreamSubscriptionId' must be defined and cannot be null.");
        else
            url_ += "ContentStreamSubscriptionId=" + encodeURIComponent("" + contentStreamSubscriptionId) + "&"; 
        if (curated === undefined || curated === null)
            throw new Error("The parameter 'curated' must be defined and cannot be null.");
        else
            url_ += "curated=" + encodeURIComponent("" + curated) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetSubscriptionArticles(_response);
        });
    }

    protected processGetSubscriptionArticles(response: AxiosResponse): Promise<ListItemDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ListItemDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListItemDTO[]>(<any>null);
    }

    /**
     * get dashboard menu for the logged in user.
     * @return OK
     */
    getMe(): Promise<MenuItemDTO[]> {
        let url_ = this.baseUrl + "/navigation/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetMe(_response);
        });
    }

    protected processGetMe(response: AxiosResponse): Promise<MenuItemDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MenuItemDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MenuItemDTO[]>(<any>null);
    }

    /**
     * get all accounts - admin only
     * @return OK
     */
    getAccounts(query: string): Promise<ListItemDTO[]> {
        let url_ = this.baseUrl + "/navigation/accounts?";
        if (query === undefined || query === null)
            throw new Error("The parameter 'query' must be defined and cannot be null.");
        else
            url_ += "query=" + encodeURIComponent("" + query) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAccounts(_response);
        });
    }

    protected processGetAccounts(response: AxiosResponse): Promise<ListItemDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ListItemDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListItemDTO[]>(<any>null);
    }
}

export interface IFilesClient {
    /**
     * Upload a file from your local computer to an issue. 
    This method creates and issue for each pdf uploaded.
     * @return OK
     */
    upload(): Promise<any>;
    /**
     * Upload a file from your local computer to an issue. 
    This method adds each pdf to the issue. you need to call Issue.IssueComplete() to bundle up the pages and process.
    You need to pass { issueName:'', publicationId:0, issueId:0 } as part of the stream.
    If an issueId is not passed then a new issue will be created named issueName
     * @return OK
     */
    uploadPages(): Promise<any>;
}

export class FilesClient implements IFilesClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Upload a file from your local computer to an issue. 
    This method creates and issue for each pdf uploaded.
     * @return OK
     */
    upload(): Promise<any> {
        let url_ = this.baseUrl + "/file/uploadissue";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Upload a file from your local computer to an issue. 
    This method adds each pdf to the issue. you need to call Issue.IssueComplete() to bundle up the pages and process.
    You need to pass { issueName:'', publicationId:0, issueId:0 } as part of the stream.
    If an issueId is not passed then a new issue will be created named issueName
     * @return OK
     */
    uploadPages(): Promise<any> {
        let url_ = this.baseUrl + "/file/uploadpages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUploadPages(_response);
        });
    }

    protected processUploadPages(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }
}

export interface IImageClient {
    /**
     * Save an image to an issue.
     * @return OK
     */
    saveImage(issueId: number, pageNumber: number, base64image: string): Promise<string>;
}

export class ImageClient implements IImageClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Save an image to an issue.
     * @return OK
     */
    saveImage(issueId: number, pageNumber: number, base64image: string): Promise<string> {
        let url_ = this.baseUrl + "/image?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(base64image);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveImage(_response);
        });
    }

    protected processSaveImage(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(<any>null);
    }
}

export interface IImportClient {
    /**
     * Import metadata for replica clients.
     * @return OK
     */
    importMetadata(publicationId: number, metadata: ArticleMetadataDTO[], removeExisting: boolean): Promise<string[]>;
    /**
     * Import metadata from classic.
     * @return OK
     */
    importMetadata2(publicationId: number, metadata: ArticleMetadata2DTO[], removeExisting: boolean): Promise<string[]>;
    /**
     * Import folio for replica clients.
     * @return OK
     */
    importFolio(publicationId: number, foliodata: FolioDTO[]): Promise<string[]>;
    /**
     * Import articles for syndication
     * @param importDescription description of articles, will be used for issue name
     * @return OK
     */
    importArticles(publicationId: number, importDescription: string, articles: ArticleModel[]): Promise<string[]>;
}

export class ImportClient implements IImportClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Import metadata for replica clients.
     * @return OK
     */
    importMetadata(publicationId: number, metadata: ArticleMetadataDTO[], removeExisting: boolean): Promise<string[]> {
        let url_ = this.baseUrl + "/import/metadata?";
        if (publicationId === undefined || publicationId === null)
            throw new Error("The parameter 'publicationId' must be defined and cannot be null.");
        else
            url_ += "publicationId=" + encodeURIComponent("" + publicationId) + "&"; 
        if (removeExisting === undefined || removeExisting === null)
            throw new Error("The parameter 'removeExisting' must be defined and cannot be null.");
        else
            url_ += "removeExisting=" + encodeURIComponent("" + removeExisting) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(metadata);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processImportMetadata(_response);
        });
    }

    protected processImportMetadata(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(<any>null);
    }

    /**
     * Import metadata from classic.
     * @return OK
     */
    importMetadata2(publicationId: number, metadata: ArticleMetadata2DTO[], removeExisting: boolean): Promise<string[]> {
        let url_ = this.baseUrl + "/import/metadata2?";
        if (publicationId === undefined || publicationId === null)
            throw new Error("The parameter 'publicationId' must be defined and cannot be null.");
        else
            url_ += "publicationId=" + encodeURIComponent("" + publicationId) + "&"; 
        if (removeExisting === undefined || removeExisting === null)
            throw new Error("The parameter 'removeExisting' must be defined and cannot be null.");
        else
            url_ += "removeExisting=" + encodeURIComponent("" + removeExisting) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(metadata);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processImportMetadata2(_response);
        });
    }

    protected processImportMetadata2(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(<any>null);
    }

    /**
     * Import folio for replica clients.
     * @return OK
     */
    importFolio(publicationId: number, foliodata: FolioDTO[]): Promise<string[]> {
        let url_ = this.baseUrl + "/import/folio?";
        if (publicationId === undefined || publicationId === null)
            throw new Error("The parameter 'publicationId' must be defined and cannot be null.");
        else
            url_ += "publicationId=" + encodeURIComponent("" + publicationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(foliodata);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processImportFolio(_response);
        });
    }

    protected processImportFolio(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(<any>null);
    }

    /**
     * Import articles for syndication
     * @param importDescription description of articles, will be used for issue name
     * @return OK
     */
    importArticles(publicationId: number, importDescription: string, articles: ArticleModel[]): Promise<string[]> {
        let url_ = this.baseUrl + "/import/article?";
        if (publicationId === undefined || publicationId === null)
            throw new Error("The parameter 'publicationId' must be defined and cannot be null.");
        else
            url_ += "publicationId=" + encodeURIComponent("" + publicationId) + "&"; 
        if (importDescription === undefined || importDescription === null)
            throw new Error("The parameter 'importDescription' must be defined and cannot be null.");
        else
            url_ += "importDescription=" + encodeURIComponent("" + importDescription) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(articles);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processImportArticles(_response);
        });
    }

    protected processImportArticles(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(<any>null);
    }
}

export interface IIssueClient {
    /**
     * updat properties for an issue.
     * @return OK
     */
    updateIssue(issueProperties: IssuePropertiesDTO): Promise<IssueModel>;
    /**
     * Move an issue to a another publication.
     * @param issueId The issue to move.
     * @param publicationId The destination publication.
     * @return OK
     */
    moveIssueToPublication(issueId: number, publicationId: number): Promise<IssueModel>;
    /**
     * Retrieve a list of uploaded files for an issue. This is used to change the sequence when multiple files are uploaded for a single issue.
     * @param issueId The id of the issue to get files for.
     * @return OK
     */
    getIssuePages(issueId: number): Promise<InputPdfModel[]>;
    /**
     * get the sourec pdf for an issue.
     * @return OK
     */
    getIssueSourcePdf(issueId: number): Promise<SourceFileModel[]>;
    /**
     * GetIssueOptions the conversion log for an issue.
     * @param issueId The issue you want to get the log for.
     * @return OK
     */
    getIssueLog(issueId: number): Promise<ConversionLogModel[]>;
    /**
     * Make an issue publicly visible/hidden.
     * @param issueId The issue you want o make live / hide
     * @param state int = 1:visiable, 0:hide
     * @return OK
     */
    publishIssue(issueId: number, state: number): Promise<IssueModel>;
    /**
     * Create an new issue using a URL. The issue name will be pdf file name.
     * @param data issue details
     * @return OK
     */
    createIssue(data: NewIssueFromURLView): Promise<IssueModel>;
    /**
     * get a single issue
     * @param issueId Issue to retrieve.
     * @return OK
     */
    getIssue(issueId: number): Promise<IssueModel>;
    /**
     * Delete an issue from a publication.
     * @param issueId Issue to delete
     * @return OK
     */
    deleteIssue(issueId: number): Promise<any>;
    /**
     * get properties for an issue.
     * @return OK
     */
    getIssueProperties(issueId: number): Promise<IssuePropertiesDTO>;
    /**
     * Gets all the issues for a publication.
     * @param publicationId The publication id.
     * @return OK
     */
    getIssues(publicationId: number): Promise<IssueModel[]>;
    /**
     * Rename an issue.
     * @param issueId The issue to rename.
     * @param newIssueName The new name of the issue.
     * @return OK
     */
    renameIssue(issueId: number, newIssueName: string): Promise<IssueModel>;
    /**
     * Restart processing of an issue.
     * @param issueId The issue to restart.
     * @return OK
     */
    restartIssue(issueId: number): Promise<IssueModel>;
    /**
     * Lets the system know that you are finished uploading multiple pdfs into a single issue.
    It bundles up the pdfs into a single file and submits that pdf for processing.
     * @param issueId The id of the issue to complete and start processing.
     * @return OK
     */
    fileUploadCompleteIssue(issueId: number): Promise<boolean>;
    /**
     * Sets the issue date for an issue.
     * @return OK
     */
    setIssueDate(issueId: number, issueDate: Date): Promise<IssueModel>;
    /**
     * Update the slug for an issue. 
    The change will be publicshed to url.json instantly
     * @return OK
     */
    setIssueSlug(issueId: number, slug: string): Promise<IssueModel>;
    /**
     * Sets the order of the issue in the publication.
     * @return OK
     */
    setIssueOrder(issueId: number, issueOrder: number): Promise<IssueModel>;
    /**
     * Updates the secure flag of the issue.
     * @param secure 0 : free | 1 : secure
     * @return OK
     */
    makeSecure(issueId: number, secure: number): Promise<IssueModel>;
    /**
     * get issue with associated urls.
     * @return OK
     */
    getIssueWithUrls(issueId: number): Promise<string[]>;
    /**
     * add a new issue containing the articles supplied.
     * @return OK
     */
    addIssueWithArticles(data: NewIssueData): Promise<IssueModel>;
}

export class IssueClient implements IIssueClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * updat properties for an issue.
     * @return OK
     */
    updateIssue(issueProperties: IssuePropertiesDTO): Promise<IssueModel> {
        let url_ = this.baseUrl + "/issue/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(issueProperties);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateIssue(_response);
        });
    }

    protected processUpdateIssue(response: AxiosResponse): Promise<IssueModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueModel>(<any>null);
    }

    /**
     * Move an issue to a another publication.
     * @param issueId The issue to move.
     * @param publicationId The destination publication.
     * @return OK
     */
    moveIssueToPublication(issueId: number, publicationId: number): Promise<IssueModel> {
        let url_ = this.baseUrl + "/issue/move?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        if (publicationId === undefined || publicationId === null)
            throw new Error("The parameter 'publicationId' must be defined and cannot be null.");
        else
            url_ += "publicationId=" + encodeURIComponent("" + publicationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processMoveIssueToPublication(_response);
        });
    }

    protected processMoveIssueToPublication(response: AxiosResponse): Promise<IssueModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueModel>(<any>null);
    }

    /**
     * Retrieve a list of uploaded files for an issue. This is used to change the sequence when multiple files are uploaded for a single issue.
     * @param issueId The id of the issue to get files for.
     * @return OK
     */
    getIssuePages(issueId: number): Promise<InputPdfModel[]> {
        let url_ = this.baseUrl + "/issue/pdfs?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetIssuePages(_response);
        });
    }

    protected processGetIssuePages(response: AxiosResponse): Promise<InputPdfModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InputPdfModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InputPdfModel[]>(<any>null);
    }

    /**
     * get the sourec pdf for an issue.
     * @return OK
     */
    getIssueSourcePdf(issueId: number): Promise<SourceFileModel[]> {
        let url_ = this.baseUrl + "/issue/sourcepdfs?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetIssueSourcePdf(_response);
        });
    }

    protected processGetIssueSourcePdf(response: AxiosResponse): Promise<SourceFileModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SourceFileModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SourceFileModel[]>(<any>null);
    }

    /**
     * GetIssueOptions the conversion log for an issue.
     * @param issueId The issue you want to get the log for.
     * @return OK
     */
    getIssueLog(issueId: number): Promise<ConversionLogModel[]> {
        let url_ = this.baseUrl + "/issue/log?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetIssueLog(_response);
        });
    }

    protected processGetIssueLog(response: AxiosResponse): Promise<ConversionLogModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConversionLogModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConversionLogModel[]>(<any>null);
    }

    /**
     * Make an issue publicly visible/hidden.
     * @param issueId The issue you want o make live / hide
     * @param state int = 1:visiable, 0:hide
     * @return OK
     */
    publishIssue(issueId: number, state: number): Promise<IssueModel> {
        let url_ = this.baseUrl + "/issue/publish?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        if (state === undefined || state === null)
            throw new Error("The parameter 'state' must be defined and cannot be null.");
        else
            url_ += "state=" + encodeURIComponent("" + state) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPublishIssue(_response);
        });
    }

    protected processPublishIssue(response: AxiosResponse): Promise<IssueModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueModel>(<any>null);
    }

    /**
     * Create an new issue using a URL. The issue name will be pdf file name.
     * @param data issue details
     * @return OK
     */
    createIssue(data: NewIssueFromURLView): Promise<IssueModel> {
        let url_ = this.baseUrl + "/issue/issue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateIssue(_response);
        });
    }

    protected processCreateIssue(response: AxiosResponse): Promise<IssueModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueModel>(<any>null);
    }

    /**
     * get a single issue
     * @param issueId Issue to retrieve.
     * @return OK
     */
    getIssue(issueId: number): Promise<IssueModel> {
        let url_ = this.baseUrl + "/issue?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetIssue(_response);
        });
    }

    protected processGetIssue(response: AxiosResponse): Promise<IssueModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueModel>(<any>null);
    }

    /**
     * Delete an issue from a publication.
     * @param issueId Issue to delete
     * @return OK
     */
    deleteIssue(issueId: number): Promise<any> {
        let url_ = this.baseUrl + "/issue?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteIssue(_response);
        });
    }

    protected processDeleteIssue(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * get properties for an issue.
     * @return OK
     */
    getIssueProperties(issueId: number): Promise<IssuePropertiesDTO> {
        let url_ = this.baseUrl + "/issue/props?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetIssueProperties(_response);
        });
    }

    protected processGetIssueProperties(response: AxiosResponse): Promise<IssuePropertiesDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssuePropertiesDTO.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssuePropertiesDTO>(<any>null);
    }

    /**
     * Gets all the issues for a publication.
     * @param publicationId The publication id.
     * @return OK
     */
    getIssues(publicationId: number): Promise<IssueModel[]> {
        let url_ = this.baseUrl + "/issue/issues?";
        if (publicationId === undefined || publicationId === null)
            throw new Error("The parameter 'publicationId' must be defined and cannot be null.");
        else
            url_ += "publicationId=" + encodeURIComponent("" + publicationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetIssues(_response);
        });
    }

    protected processGetIssues(response: AxiosResponse): Promise<IssueModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IssueModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueModel[]>(<any>null);
    }

    /**
     * Rename an issue.
     * @param issueId The issue to rename.
     * @param newIssueName The new name of the issue.
     * @return OK
     */
    renameIssue(issueId: number, newIssueName: string): Promise<IssueModel> {
        let url_ = this.baseUrl + "/issue/rename?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        if (newIssueName === undefined || newIssueName === null)
            throw new Error("The parameter 'newIssueName' must be defined and cannot be null.");
        else
            url_ += "newIssueName=" + encodeURIComponent("" + newIssueName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRenameIssue(_response);
        });
    }

    protected processRenameIssue(response: AxiosResponse): Promise<IssueModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueModel>(<any>null);
    }

    /**
     * Restart processing of an issue.
     * @param issueId The issue to restart.
     * @return OK
     */
    restartIssue(issueId: number): Promise<IssueModel> {
        let url_ = this.baseUrl + "/issue/restart?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRestartIssue(_response);
        });
    }

    protected processRestartIssue(response: AxiosResponse): Promise<IssueModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueModel>(<any>null);
    }

    /**
     * Lets the system know that you are finished uploading multiple pdfs into a single issue.
    It bundles up the pdfs into a single file and submits that pdf for processing.
     * @param issueId The id of the issue to complete and start processing.
     * @return OK
     */
    fileUploadCompleteIssue(issueId: number): Promise<boolean> {
        let url_ = this.baseUrl + "/issue/fileuploadcomplete?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFileUploadCompleteIssue(_response);
        });
    }

    protected processFileUploadCompleteIssue(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * Sets the issue date for an issue.
     * @return OK
     */
    setIssueDate(issueId: number, issueDate: Date): Promise<IssueModel> {
        let url_ = this.baseUrl + "/issue/issuedate?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        if (issueDate === undefined || issueDate === null)
            throw new Error("The parameter 'issueDate' must be defined and cannot be null.");
        else
            url_ += "issueDate=" + encodeURIComponent(issueDate ? "" + issueDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSetIssueDate(_response);
        });
    }

    protected processSetIssueDate(response: AxiosResponse): Promise<IssueModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueModel>(<any>null);
    }

    /**
     * Update the slug for an issue. 
    The change will be publicshed to url.json instantly
     * @return OK
     */
    setIssueSlug(issueId: number, slug: string): Promise<IssueModel> {
        let url_ = this.baseUrl + "/issue/slug?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        if (slug === undefined || slug === null)
            throw new Error("The parameter 'slug' must be defined and cannot be null.");
        else
            url_ += "slug=" + encodeURIComponent("" + slug) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSetIssueSlug(_response);
        });
    }

    protected processSetIssueSlug(response: AxiosResponse): Promise<IssueModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueModel>(<any>null);
    }

    /**
     * Sets the order of the issue in the publication.
     * @return OK
     */
    setIssueOrder(issueId: number, issueOrder: number): Promise<IssueModel> {
        let url_ = this.baseUrl + "/issue/issueorder?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        if (issueOrder === undefined || issueOrder === null)
            throw new Error("The parameter 'issueOrder' must be defined and cannot be null.");
        else
            url_ += "issueOrder=" + encodeURIComponent("" + issueOrder) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSetIssueOrder(_response);
        });
    }

    protected processSetIssueOrder(response: AxiosResponse): Promise<IssueModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueModel>(<any>null);
    }

    /**
     * Updates the secure flag of the issue.
     * @param secure 0 : free | 1 : secure
     * @return OK
     */
    makeSecure(issueId: number, secure: number): Promise<IssueModel> {
        let url_ = this.baseUrl + "/issue/makeSecure?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        if (secure === undefined || secure === null)
            throw new Error("The parameter 'secure' must be defined and cannot be null.");
        else
            url_ += "secure=" + encodeURIComponent("" + secure) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processMakeSecure(_response);
        });
    }

    protected processMakeSecure(response: AxiosResponse): Promise<IssueModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueModel>(<any>null);
    }

    /**
     * get issue with associated urls.
     * @return OK
     */
    getIssueWithUrls(issueId: number): Promise<string[]> {
        let url_ = this.baseUrl + "/issue/urls?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetIssueWithUrls(_response);
        });
    }

    protected processGetIssueWithUrls(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(<any>null);
    }

    /**
     * add a new issue containing the articles supplied.
     * @return OK
     */
    addIssueWithArticles(data: NewIssueData): Promise<IssueModel> {
        let url_ = this.baseUrl + "/issue/addissuewitharticles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAddIssueWithArticles(_response);
        });
    }

    protected processAddIssueWithArticles(response: AxiosResponse): Promise<IssueModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueModel>(<any>null);
    }
}

export interface IIssueConversionClient {
    /**
     * Retrieve a list of uploaded files for an issue. This is used to change the sequence when multiple files are uploaded for a single issue.
     * @param issueId The id of the issue to get files for.
     * @return OK
     */
    getIssuePages(issueId: number): Promise<InputPdfModel[]>;
    /**
     * get the sourec pdf for an issue.
     * @return OK
     */
    getIssueSourcePdf(issueId: number): Promise<SourceFileModel[]>;
    /**
     * GetIssueOptions the conversion log for an issue.
     * @param issueId The issue you want to get the log for.
     * @return OK
     */
    getIssueLog(issueId: number): Promise<ConversionLogModel[]>;
    /**
     * admin only - get recent conversions.
     * @return OK
     */
    getRecentConversions(): Promise<PubIssueDTO[]>;
    /**
     * Restart processing of an issue.
     * @param issueId The issue to restart.
     * @return OK
     */
    restartIssue(issueId: number): Promise<IssueModel>;
    /**
     * Lets the system know that you are finished uploading multiple pdfs into a single issue.
    It bundles up the pdfs into a single file and submits that pdf for processing.
     * @param issueId The id of the issue to complete and start processing.
     * @return OK
     */
    fileUploadCompleteIssue(issueId: number): Promise<boolean>;
    /**
     * Get issue source blob
     * @return OK
     */
    getIssueSourceBlob(issueId: number): Promise<BlobReplaceDTO>;
    /**
     * Get issue source blob folder
     * @return OK
     */
    getIssueSourceBlobFile(issueId: number, file: string): Promise<BlobReplaceDTO>;
    /**
     * merges all pdfs uploaded for this issue and converts.
     * @return OK
     */
    processMultiPage(issueId: number, files: string[]): Promise<any>;
}

export class IssueConversionClient implements IIssueConversionClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Retrieve a list of uploaded files for an issue. This is used to change the sequence when multiple files are uploaded for a single issue.
     * @param issueId The id of the issue to get files for.
     * @return OK
     */
    getIssuePages(issueId: number): Promise<InputPdfModel[]> {
        let url_ = this.baseUrl + "/issueconversion/pdfs?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetIssuePages(_response);
        });
    }

    protected processGetIssuePages(response: AxiosResponse): Promise<InputPdfModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InputPdfModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InputPdfModel[]>(<any>null);
    }

    /**
     * get the sourec pdf for an issue.
     * @return OK
     */
    getIssueSourcePdf(issueId: number): Promise<SourceFileModel[]> {
        let url_ = this.baseUrl + "/issueconversion/sourcepdfs?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetIssueSourcePdf(_response);
        });
    }

    protected processGetIssueSourcePdf(response: AxiosResponse): Promise<SourceFileModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SourceFileModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SourceFileModel[]>(<any>null);
    }

    /**
     * GetIssueOptions the conversion log for an issue.
     * @param issueId The issue you want to get the log for.
     * @return OK
     */
    getIssueLog(issueId: number): Promise<ConversionLogModel[]> {
        let url_ = this.baseUrl + "/issueconversion/log?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetIssueLog(_response);
        });
    }

    protected processGetIssueLog(response: AxiosResponse): Promise<ConversionLogModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConversionLogModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConversionLogModel[]>(<any>null);
    }

    /**
     * admin only - get recent conversions.
     * @return OK
     */
    getRecentConversions(): Promise<PubIssueDTO[]> {
        let url_ = this.baseUrl + "/issueconversion/recent";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetRecentConversions(_response);
        });
    }

    protected processGetRecentConversions(response: AxiosResponse): Promise<PubIssueDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PubIssueDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PubIssueDTO[]>(<any>null);
    }

    /**
     * Restart processing of an issue.
     * @param issueId The issue to restart.
     * @return OK
     */
    restartIssue(issueId: number): Promise<IssueModel> {
        let url_ = this.baseUrl + "/issueconversion/restart?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRestartIssue(_response);
        });
    }

    protected processRestartIssue(response: AxiosResponse): Promise<IssueModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueModel>(<any>null);
    }

    /**
     * Lets the system know that you are finished uploading multiple pdfs into a single issue.
    It bundles up the pdfs into a single file and submits that pdf for processing.
     * @param issueId The id of the issue to complete and start processing.
     * @return OK
     */
    fileUploadCompleteIssue(issueId: number): Promise<boolean> {
        let url_ = this.baseUrl + "/issueconversion/fileuploadcomplete?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFileUploadCompleteIssue(_response);
        });
    }

    protected processFileUploadCompleteIssue(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * Get issue source blob
     * @return OK
     */
    getIssueSourceBlob(issueId: number): Promise<BlobReplaceDTO> {
        let url_ = this.baseUrl + "/issueconversion/issueblob?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetIssueSourceBlob(_response);
        });
    }

    protected processGetIssueSourceBlob(response: AxiosResponse): Promise<BlobReplaceDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BlobReplaceDTO.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BlobReplaceDTO>(<any>null);
    }

    /**
     * Get issue source blob folder
     * @return OK
     */
    getIssueSourceBlobFile(issueId: number, file: string): Promise<BlobReplaceDTO> {
        let url_ = this.baseUrl + "/issueconversion/issueblobfile?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        if (file === undefined || file === null)
            throw new Error("The parameter 'file' must be defined and cannot be null.");
        else
            url_ += "file=" + encodeURIComponent("" + file) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetIssueSourceBlobFile(_response);
        });
    }

    protected processGetIssueSourceBlobFile(response: AxiosResponse): Promise<BlobReplaceDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BlobReplaceDTO.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BlobReplaceDTO>(<any>null);
    }

    /**
     * merges all pdfs uploaded for this issue and converts.
     * @return OK
     */
    processMultiPage(issueId: number, files: string[]): Promise<any> {
        let url_ = this.baseUrl + "/issueconversion/processmultipagepdf?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(files);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processProcessMultiPage(_response);
        });
    }

    protected processProcessMultiPage(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }
}

export interface IIssueCSSClient {
    /**
     * Get CSS for a Issue.
     * @return OK
     */
    getIssueCSS(issueId: number): Promise<IssueCSSModel>;
    /**
     * Save CSS for a Issue.
     * @return OK
     */
    saveIssueCSS(cSS: IssueCSSModel): Promise<IssueCSSModel>;
}

export class IssueCSSClient implements IIssueCSSClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Get CSS for a Issue.
     * @return OK
     */
    getIssueCSS(issueId: number): Promise<IssueCSSModel> {
        let url_ = this.baseUrl + "/issuecss?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "IssueId=" + encodeURIComponent("" + issueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetIssueCSS(_response);
        });
    }

    protected processGetIssueCSS(response: AxiosResponse): Promise<IssueCSSModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueCSSModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueCSSModel>(<any>null);
    }

    /**
     * Save CSS for a Issue.
     * @return OK
     */
    saveIssueCSS(cSS: IssueCSSModel): Promise<IssueCSSModel> {
        let url_ = this.baseUrl + "/issuecss";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cSS);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveIssueCSS(_response);
        });
    }

    protected processSaveIssueCSS(response: AxiosResponse): Promise<IssueCSSModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueCSSModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueCSSModel>(<any>null);
    }
}

export interface IIssueFolioClient {
    /**
     * Gets the folio for an issue.
     * @return OK
     */
    getFolioForIssue(issueId: number): Promise<IssueFolioModel>;
    /**
     * Save a folio for an issue.
     * @return OK
     */
    saveIssueFolio(issueId: number, folio: string): Promise<IssueFolioModel>;
    /**
     * Delete the folio for an issue.
     * @return OK
     */
    deletFolio(issueId: number): Promise<any>;
}

export class IssueFolioClient implements IIssueFolioClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Gets the folio for an issue.
     * @return OK
     */
    getFolioForIssue(issueId: number): Promise<IssueFolioModel> {
        let url_ = this.baseUrl + "/issuefolio?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetFolioForIssue(_response);
        });
    }

    protected processGetFolioForIssue(response: AxiosResponse): Promise<IssueFolioModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueFolioModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueFolioModel>(<any>null);
    }

    /**
     * Save a folio for an issue.
     * @return OK
     */
    saveIssueFolio(issueId: number, folio: string): Promise<IssueFolioModel> {
        let url_ = this.baseUrl + "/issuefolio?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(folio);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveIssueFolio(_response);
        });
    }

    protected processSaveIssueFolio(response: AxiosResponse): Promise<IssueFolioModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueFolioModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueFolioModel>(<any>null);
    }

    /**
     * Delete the folio for an issue.
     * @return OK
     */
    deletFolio(issueId: number): Promise<any> {
        let url_ = this.baseUrl + "/issuefolio?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeletFolio(_response);
        });
    }

    protected processDeletFolio(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }
}

export interface IIssueImageClient {
    /**
     * Save a image for the given title.
     * @param issueId The issue to save the image for
     * @param imageType the image type
     * @param base64image base64 string of png icon
     * @return OK
     */
    saveImage(issueId: number, imageType: ImageType, base64image: string): Promise<string[]>;
}

export class IssueImageClient implements IIssueImageClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Save a image for the given title.
     * @param issueId The issue to save the image for
     * @param imageType the image type
     * @param base64image base64 string of png icon
     * @return OK
     */
    saveImage(issueId: number, imageType: ImageType, base64image: string): Promise<string[]> {
        let url_ = this.baseUrl + "/issueimage?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        if (imageType === undefined || imageType === null)
            throw new Error("The parameter 'imageType' must be defined and cannot be null.");
        else
            url_ += "imageType=" + encodeURIComponent("" + imageType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(base64image);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveImage(_response);
        });
    }

    protected processSaveImage(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(<any>null);
    }
}

export interface IIssueStorageClient {
    /**
     * Get Issue Storage details for a given issue.
     * @return OK
     */
    getIssueStorage(issueId: number): Promise<IssueStorageDTO>;
}

export class IssueStorageClient implements IIssueStorageClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Get Issue Storage details for a given issue.
     * @return OK
     */
    getIssueStorage(issueId: number): Promise<IssueStorageDTO> {
        let url_ = this.baseUrl + "/issuestorage?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "IssueId=" + encodeURIComponent("" + issueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetIssueStorage(_response);
        });
    }

    protected processGetIssueStorage(response: AxiosResponse): Promise<IssueStorageDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueStorageDTO.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueStorageDTO>(<any>null);
    }
}

export interface IIssueTokenClient {
    /**
     * Get an issue token to use with the CDN, valid for 30 minutes.
     * @return OK
     */
    getIssueToken(issueId: number): Promise<string>;
}

export class IssueTokenClient implements IIssueTokenClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Get an issue token to use with the CDN, valid for 30 minutes.
     * @return OK
     */
    getIssueToken(issueId: number): Promise<string> {
        let url_ = this.baseUrl + "/issuetoken?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetIssueToken(_response);
        });
    }

    protected processGetIssueToken(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(<any>null);
    }
}

export interface IIssueTrackingClient {
    /**
     * Gets all outstanding work that need to be done.
     * @return OK
     */
    getAllWork(): Promise<IssueWorkModel[]>;
    /**
     * Gets all work finished in the last x number fo days.
     * @param days number of days
     * @return OK
     */
    getFinishedWork(days: number): Promise<IssueWorkModel[]>;
    /**
     * Gets all logs for work done on an issue.
     * @return OK
     */
    getWorkLog(issueId: number): Promise<IssueTrackingLogModel[]>;
    /**
     * Update a task in a job.
     * @return OK
     */
    updateTask(issueId: number, task: Task, status: Status2): Promise<IssueWorkModel>;
    /**
     * adds a work order to the system.
     * @return OK
     */
    addJob(issueWork: IssueWorkModel): Promise<IssueWorkModel>;
    /**
     * update a work order for the system.
     * @return OK
     */
    updateJob(issueWork: IssueWorkUpdateModel): Promise<IssueWorkModel>;
    /**
     * get a job for an issue. null is no job exists.
     * @return OK
     */
    getJob(issueId: number): Promise<IssueWorkModel>;
    /**
     * update the status of a job.
     * @return OK
     */
    updateJobStatus(issueId: number, status: Status3): Promise<any>;
    /**
     * move a job to a new issue.
    all old issue logs will be moved as well.
     * @return OK
     */
    moveJobToIssue(oldIssueId: number, newIssueId: number): Promise<any>;
    /**
     * delete a job from the issue.
     * @return OK
     */
    deleteJob(issueId: number): Promise<any>;
}

export class IssueTrackingClient implements IIssueTrackingClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Gets all outstanding work that need to be done.
     * @return OK
     */
    getAllWork(): Promise<IssueWorkModel[]> {
        let url_ = this.baseUrl + "/issuetracking/getalljobs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAllWork(_response);
        });
    }

    protected processGetAllWork(response: AxiosResponse): Promise<IssueWorkModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IssueWorkModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueWorkModel[]>(<any>null);
    }

    /**
     * Gets all work finished in the last x number fo days.
     * @param days number of days
     * @return OK
     */
    getFinishedWork(days: number): Promise<IssueWorkModel[]> {
        let url_ = this.baseUrl + "/issuetracking/getfinished?";
        if (days === undefined || days === null)
            throw new Error("The parameter 'days' must be defined and cannot be null.");
        else
            url_ += "days=" + encodeURIComponent("" + days) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetFinishedWork(_response);
        });
    }

    protected processGetFinishedWork(response: AxiosResponse): Promise<IssueWorkModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IssueWorkModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueWorkModel[]>(<any>null);
    }

    /**
     * Gets all logs for work done on an issue.
     * @return OK
     */
    getWorkLog(issueId: number): Promise<IssueTrackingLogModel[]> {
        let url_ = this.baseUrl + "/issuetracking/getjoblog?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetWorkLog(_response);
        });
    }

    protected processGetWorkLog(response: AxiosResponse): Promise<IssueTrackingLogModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IssueTrackingLogModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueTrackingLogModel[]>(<any>null);
    }

    /**
     * Update a task in a job.
     * @return OK
     */
    updateTask(issueId: number, task: Task, status: Status2): Promise<IssueWorkModel> {
        let url_ = this.baseUrl + "/issuetracking/updatetask?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        if (task === undefined || task === null)
            throw new Error("The parameter 'task' must be defined and cannot be null.");
        else
            url_ += "task=" + encodeURIComponent("" + task) + "&"; 
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined and cannot be null.");
        else
            url_ += "status=" + encodeURIComponent("" + status) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateTask(_response);
        });
    }

    protected processUpdateTask(response: AxiosResponse): Promise<IssueWorkModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueWorkModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueWorkModel>(<any>null);
    }

    /**
     * adds a work order to the system.
     * @return OK
     */
    addJob(issueWork: IssueWorkModel): Promise<IssueWorkModel> {
        let url_ = this.baseUrl + "/issuetracking/addjob";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(issueWork);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAddJob(_response);
        });
    }

    protected processAddJob(response: AxiosResponse): Promise<IssueWorkModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueWorkModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueWorkModel>(<any>null);
    }

    /**
     * update a work order for the system.
     * @return OK
     */
    updateJob(issueWork: IssueWorkUpdateModel): Promise<IssueWorkModel> {
        let url_ = this.baseUrl + "/issuetracking/updatejob";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(issueWork);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateJob(_response);
        });
    }

    protected processUpdateJob(response: AxiosResponse): Promise<IssueWorkModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueWorkModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueWorkModel>(<any>null);
    }

    /**
     * get a job for an issue. null is no job exists.
     * @return OK
     */
    getJob(issueId: number): Promise<IssueWorkModel> {
        let url_ = this.baseUrl + "/issuetracking/getjob?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetJob(_response);
        });
    }

    protected processGetJob(response: AxiosResponse): Promise<IssueWorkModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueWorkModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueWorkModel>(<any>null);
    }

    /**
     * update the status of a job.
     * @return OK
     */
    updateJobStatus(issueId: number, status: Status3): Promise<any> {
        let url_ = this.baseUrl + "/issuetracking/updatestatus?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined and cannot be null.");
        else
            url_ += "status=" + encodeURIComponent("" + status) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateJobStatus(_response);
        });
    }

    protected processUpdateJobStatus(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * move a job to a new issue.
    all old issue logs will be moved as well.
     * @return OK
     */
    moveJobToIssue(oldIssueId: number, newIssueId: number): Promise<any> {
        let url_ = this.baseUrl + "/issuetracking/movetonewissue?";
        if (oldIssueId === undefined || oldIssueId === null)
            throw new Error("The parameter 'oldIssueId' must be defined and cannot be null.");
        else
            url_ += "oldIssueId=" + encodeURIComponent("" + oldIssueId) + "&"; 
        if (newIssueId === undefined || newIssueId === null)
            throw new Error("The parameter 'newIssueId' must be defined and cannot be null.");
        else
            url_ += "newIssueId=" + encodeURIComponent("" + newIssueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processMoveJobToIssue(_response);
        });
    }

    protected processMoveJobToIssue(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * delete a job from the issue.
     * @return OK
     */
    deleteJob(issueId: number): Promise<any> {
        let url_ = this.baseUrl + "/issuetracking?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteJob(_response);
        });
    }

    protected processDeleteJob(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }
}

export interface IIssueViewerConfigClient {
    /**
     * load issue viewer configuration
     * @return OK
     */
    getIssueViewerConfig(issueId: number): Promise<IssueViewerConfigDTO>;
    /**
     * Save issue viewer configuration
     * @return OK
     */
    saveIssueViererConfig(data: IssueViewerConfigDTO): Promise<IssueViewerConfigDTO>;
}

export class IssueViewerConfigClient implements IIssueViewerConfigClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * load issue viewer configuration
     * @return OK
     */
    getIssueViewerConfig(issueId: number): Promise<IssueViewerConfigDTO> {
        let url_ = this.baseUrl + "/issueviewerconfig?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetIssueViewerConfig(_response);
        });
    }

    protected processGetIssueViewerConfig(response: AxiosResponse): Promise<IssueViewerConfigDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueViewerConfigDTO.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueViewerConfigDTO>(<any>null);
    }

    /**
     * Save issue viewer configuration
     * @return OK
     */
    saveIssueViererConfig(data: IssueViewerConfigDTO): Promise<IssueViewerConfigDTO> {
        let url_ = this.baseUrl + "/issueviewerconfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveIssueViererConfig(_response);
        });
    }

    protected processSaveIssueViererConfig(response: AxiosResponse): Promise<IssueViewerConfigDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueViewerConfigDTO.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueViewerConfigDTO>(<any>null);
    }
}

export interface IMailchimpClient {
    /**
     * Get mailchimp config for a publication.
     * @return OK
     */
    getMailchimpConfiguration(publicationId: number): Promise<MailchimpConfigurationModel>;
    /**
     * Save mailchimp config for a publication.
     * @return OK
     */
    saveMailchimpConfiguration(config: MailchimpConfigurationModel): Promise<MailchimpConfigurationModel>;
    /**
     * creates a default template in Mailchimp.
     * @return OK
     */
    createDefaultTemplate(publicationId: number): Promise<any>;
    /**
     * gets the mailchimp data (lists + templates) for this publications mailchimp account.
     * @return OK
     */
    getMailchimpPublishOptions(publicationId: number): Promise<MailchimpPublishOptions>;
    /**
     * Create and Send a mailchimp campaign.
     * @return OK
     */
    sendCampaign(mailchimpPublishData: MailchimpPublishData): Promise<any>;
}

export class MailchimpClient implements IMailchimpClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Get mailchimp config for a publication.
     * @return OK
     */
    getMailchimpConfiguration(publicationId: number): Promise<MailchimpConfigurationModel> {
        let url_ = this.baseUrl + "/mailchimp/configuration?";
        if (publicationId === undefined || publicationId === null)
            throw new Error("The parameter 'publicationId' must be defined and cannot be null.");
        else
            url_ += "publicationId=" + encodeURIComponent("" + publicationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetMailchimpConfiguration(_response);
        });
    }

    protected processGetMailchimpConfiguration(response: AxiosResponse): Promise<MailchimpConfigurationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MailchimpConfigurationModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MailchimpConfigurationModel>(<any>null);
    }

    /**
     * Save mailchimp config for a publication.
     * @return OK
     */
    saveMailchimpConfiguration(config: MailchimpConfigurationModel): Promise<MailchimpConfigurationModel> {
        let url_ = this.baseUrl + "/mailchimp/configuration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(config);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveMailchimpConfiguration(_response);
        });
    }

    protected processSaveMailchimpConfiguration(response: AxiosResponse): Promise<MailchimpConfigurationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MailchimpConfigurationModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MailchimpConfigurationModel>(<any>null);
    }

    /**
     * creates a default template in Mailchimp.
     * @return OK
     */
    createDefaultTemplate(publicationId: number): Promise<any> {
        let url_ = this.baseUrl + "/mailchimp/createdefault?";
        if (publicationId === undefined || publicationId === null)
            throw new Error("The parameter 'publicationId' must be defined and cannot be null.");
        else
            url_ += "publicationId=" + encodeURIComponent("" + publicationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateDefaultTemplate(_response);
        });
    }

    protected processCreateDefaultTemplate(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * gets the mailchimp data (lists + templates) for this publications mailchimp account.
     * @return OK
     */
    getMailchimpPublishOptions(publicationId: number): Promise<MailchimpPublishOptions> {
        let url_ = this.baseUrl + "/mailchimp/publishoptions?";
        if (publicationId === undefined || publicationId === null)
            throw new Error("The parameter 'publicationId' must be defined and cannot be null.");
        else
            url_ += "publicationId=" + encodeURIComponent("" + publicationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetMailchimpPublishOptions(_response);
        });
    }

    protected processGetMailchimpPublishOptions(response: AxiosResponse): Promise<MailchimpPublishOptions> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MailchimpPublishOptions.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MailchimpPublishOptions>(<any>null);
    }

    /**
     * Create and Send a mailchimp campaign.
     * @return OK
     */
    sendCampaign(mailchimpPublishData: MailchimpPublishData): Promise<any> {
        let url_ = this.baseUrl + "/mailchimp/sendcampaign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(mailchimpPublishData);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSendCampaign(_response);
        });
    }

    protected processSendCampaign(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }
}

export interface IMessageClient {
    /**
     * adds an invite message
     * @return OK
     */
    invite(invite: InviteModel): Promise<any>;
    /**
     * Get messages for account
     * @return OK
     */
    getMessages(customerAccountId: number): Promise<any>;
}

export class MessageClient implements IMessageClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * adds an invite message
     * @return OK
     */
    invite(invite: InviteModel): Promise<any> {
        let url_ = this.baseUrl + "/messages/invite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(invite);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processInvite(_response);
        });
    }

    protected processInvite(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Get messages for account
     * @return OK
     */
    getMessages(customerAccountId: number): Promise<any> {
        let url_ = this.baseUrl + "/messages?";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined and cannot be null.");
        else
            url_ += "customerAccountId=" + encodeURIComponent("" + customerAccountId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetMessages(_response);
        });
    }

    protected processGetMessages(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }
}

export interface IMetadataArticleClient {
    /**
     * Update a metadata article.
     * @return OK
     */
    saveArticle(article: ArticleModel): Promise<ArticleModel>;
    /**
     * Delete a metadata article.
     * @param articleId article guid
     * @return OK
     */
    deleteArticle(articleId: string, issueid: number): Promise<any>;
    /**
     * save a batch of metadata.
     * @return OK
     */
    saveArticles(articles: ArticleModel[]): Promise<any>;
    /**
     * Get a metadata article.
     * @return OK
     */
    getArticle(issueId: number, articleId: string): Promise<ArticleModel>;
    /**
     * Get a metadata articles for issue.
     * @return OK
     */
    getArticleAll(issueId: number): Promise<ArticleModel[]>;
    /**
     * article for an issue grouped by section.
     * @return OK
     */
    getArticlesBySection(issueId: number): Promise<MyGroupingOfArticlePropDTO[]>;
}

export class MetadataArticleClient implements IMetadataArticleClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Update a metadata article.
     * @return OK
     */
    saveArticle(article: ArticleModel): Promise<ArticleModel> {
        let url_ = this.baseUrl + "/metadataarticle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(article);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveArticle(_response);
        });
    }

    protected processSaveArticle(response: AxiosResponse): Promise<ArticleModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ArticleModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ArticleModel>(<any>null);
    }

    /**
     * Delete a metadata article.
     * @param articleId article guid
     * @return OK
     */
    deleteArticle(articleId: string, issueid: number): Promise<any> {
        let url_ = this.baseUrl + "/metadataarticle?";
        if (articleId === undefined || articleId === null)
            throw new Error("The parameter 'articleId' must be defined and cannot be null.");
        else
            url_ += "articleId=" + encodeURIComponent("" + articleId) + "&"; 
        if (issueid === undefined || issueid === null)
            throw new Error("The parameter 'issueid' must be defined and cannot be null.");
        else
            url_ += "issueid=" + encodeURIComponent("" + issueid) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteArticle(_response);
        });
    }

    protected processDeleteArticle(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * save a batch of metadata.
     * @return OK
     */
    saveArticles(articles: ArticleModel[]): Promise<any> {
        let url_ = this.baseUrl + "/metadataarticle/batch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(articles);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveArticles(_response);
        });
    }

    protected processSaveArticles(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Get a metadata article.
     * @return OK
     */
    getArticle(issueId: number, articleId: string): Promise<ArticleModel> {
        let url_ = this.baseUrl + "/metadataarticle/article?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        if (articleId === undefined || articleId === null)
            throw new Error("The parameter 'articleId' must be defined and cannot be null.");
        else
            url_ += "articleId=" + encodeURIComponent("" + articleId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetArticle(_response);
        });
    }

    protected processGetArticle(response: AxiosResponse): Promise<ArticleModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ArticleModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ArticleModel>(<any>null);
    }

    /**
     * Get a metadata articles for issue.
     * @return OK
     */
    getArticleAll(issueId: number): Promise<ArticleModel[]> {
        let url_ = this.baseUrl + "/metadataarticle/articles?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetArticleAll(_response);
        });
    }

    protected processGetArticleAll(response: AxiosResponse): Promise<ArticleModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ArticleModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ArticleModel[]>(<any>null);
    }

    /**
     * article for an issue grouped by section.
     * @return OK
     */
    getArticlesBySection(issueId: number): Promise<MyGroupingOfArticlePropDTO[]> {
        let url_ = this.baseUrl + "/metadataarticle/articlesbysection?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetArticlesBySection(_response);
        });
    }

    protected processGetArticlesBySection(response: AxiosResponse): Promise<MyGroupingOfArticlePropDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MyGroupingOfArticlePropDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MyGroupingOfArticlePropDTO[]>(<any>null);
    }
}

export interface IMobileArticleViewerConfigClient {
    /**
     * Get the mobile article viewer config for a given publication.
     * @return OK
     */
    get(publicationId: number): Promise<MobileArticleViewerConfigModel>;
    /**
     * Save viewer options for this publication.
     * @return OK
     */
    save(config: MobileArticleViewerConfigModel): Promise<MobileArticleViewerConfigModel>;
    /**
     * Publish the mobile article viewer config. Not implemented now.
     * @return OK
     */
    publish(publicationId: number): Promise<boolean>;
}

export class MobileArticleViewerConfigClient implements IMobileArticleViewerConfigClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Get the mobile article viewer config for a given publication.
     * @return OK
     */
    get(publicationId: number): Promise<MobileArticleViewerConfigModel> {
        let url_ = this.baseUrl + "/mobilearticleviewerconfig?";
        if (publicationId === undefined || publicationId === null)
            throw new Error("The parameter 'publicationId' must be defined and cannot be null.");
        else
            url_ += "publicationId=" + encodeURIComponent("" + publicationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<MobileArticleViewerConfigModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MobileArticleViewerConfigModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MobileArticleViewerConfigModel>(<any>null);
    }

    /**
     * Save viewer options for this publication.
     * @return OK
     */
    save(config: MobileArticleViewerConfigModel): Promise<MobileArticleViewerConfigModel> {
        let url_ = this.baseUrl + "/mobilearticleviewerconfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(config);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<MobileArticleViewerConfigModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MobileArticleViewerConfigModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MobileArticleViewerConfigModel>(<any>null);
    }

    /**
     * Publish the mobile article viewer config. Not implemented now.
     * @return OK
     */
    publish(publicationId: number): Promise<boolean> {
        let url_ = this.baseUrl + "/mobilearticleviewerconfig/publish?";
        if (publicationId === undefined || publicationId === null)
            throw new Error("The parameter 'publicationId' must be defined and cannot be null.");
        else
            url_ += "publicationId=" + encodeURIComponent("" + publicationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPublish(_response);
        });
    }

    protected processPublish(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export interface IMoveArticlesClient {
    /**
     * move an article to a new location
     * @return OK
     */
    moveArticles(articleMove: ArticleMoveDTO): Promise<any>;
}

export class MoveArticlesClient implements IMoveArticlesClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * move an article to a new location
     * @return OK
     */
    moveArticles(articleMove: ArticleMoveDTO): Promise<any> {
        let url_ = this.baseUrl + "/movearticle/move";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(articleMove);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processMoveArticles(_response);
        });
    }

    protected processMoveArticles(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }
}

export interface IMyDesignClient {
    /**
     * Checks if an account exists, if not, creates an account in Partica using the details provided.
    Returns the accountId and bearer token for the given user.
    Restricted to tenant owner.
     * @return OK
     */
    getAccessDetails(userDTO: UserDTO): Promise<AccessDetailsDTO>;
}

export class MyDesignClient implements IMyDesignClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Checks if an account exists, if not, creates an account in Partica using the details provided.
    Returns the accountId and bearer token for the given user.
    Restricted to tenant owner.
     * @return OK
     */
    getAccessDetails(userDTO: UserDTO): Promise<AccessDetailsDTO> {
        let url_ = this.baseUrl + "/partners/mydesign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAccessDetails(_response);
        });
    }

    protected processGetAccessDetails(response: AxiosResponse): Promise<AccessDetailsDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccessDetailsDTO.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccessDetailsDTO>(<any>null);
    }
}

export interface IMyPurchasedArticlesClient {
    /**
     * Get all the articles purchased for this account.
     * @return OK
     */
    getArticles(customerAccountId: number): Promise<ArticleModel[]>;
    /**
     * save a purchased article.
     * @return OK
     */
    saveArticle(article: ArticleModel): Promise<ArticleModel>;
}

export class MyPurchasedArticlesClient implements IMyPurchasedArticlesClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Get all the articles purchased for this account.
     * @return OK
     */
    getArticles(customerAccountId: number): Promise<ArticleModel[]> {
        let url_ = this.baseUrl + "/myarticles?";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined and cannot be null.");
        else
            url_ += "customerAccountId=" + encodeURIComponent("" + customerAccountId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetArticles(_response);
        });
    }

    protected processGetArticles(response: AxiosResponse): Promise<ArticleModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ArticleModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ArticleModel[]>(<any>null);
    }

    /**
     * save a purchased article.
     * @return OK
     */
    saveArticle(article: ArticleModel): Promise<ArticleModel> {
        let url_ = this.baseUrl + "/myarticles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(article);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveArticle(_response);
        });
    }

    protected processSaveArticle(response: AxiosResponse): Promise<ArticleModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ArticleModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ArticleModel>(<any>null);
    }
}

export interface IMyWrittenArticlesClient {
    /**
     * Get all the articles written in this account.
     * @return OK
     */
    getArticles(customerAccountId: number): Promise<ArticleModel[]>;
    /**
     * save a client entered article
     * @return OK
     */
    saveArticle(article: ArticleModel, customerAccountId: number): Promise<ArticleModel>;
    /**
     * Delete a written article.
     * @param articleId article guid
     * @return OK
     */
    deleteArticle(articleId: string, issueid: number): Promise<any>;
    /**
     * Get all the articles written in this account.
     * @return OK
     */
    getWrittenArticles(customerAccountId: number): Promise<MyGroupingOfArticlePropDTO[]>;
    /**
     * Get a written article.
     * @return OK
     */
    getWrittenArticle(articleId: string): Promise<ArticleModel>;
    /**
     * Get a written article.
     * @return OK
     */
    getArticle(issueId: number, articleId: string): Promise<ArticleModel>;
    /**
     * add a new issue of type article to the given publication.
     * @return OK
     */
    addWrittenIssue(publicationId: number, name: string): Promise<IssueModel>;
    /**
     * move an article to a new publication(category)
     * @return OK
     */
    moveArticle(articleId: string, publicationId: number): Promise<any>;
    /**
     * save an article to a publication(catgeory)
     * @return OK
     */
    saveWrittenArticle(article: ArticleModel, publicationId: number): Promise<ArticleModel>;
    /**
     * get all publication of type written / article folder.
     * @return OK
     */
    getWrittenArticlePublications(customerAccountId: number): Promise<PublicationModel[]>;
}

export class MyWrittenArticlesClient implements IMyWrittenArticlesClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Get all the articles written in this account.
     * @return OK
     */
    getArticles(customerAccountId: number): Promise<ArticleModel[]> {
        let url_ = this.baseUrl + "/writtenarticles?";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined and cannot be null.");
        else
            url_ += "customerAccountId=" + encodeURIComponent("" + customerAccountId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetArticles(_response);
        });
    }

    protected processGetArticles(response: AxiosResponse): Promise<ArticleModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ArticleModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ArticleModel[]>(<any>null);
    }

    /**
     * save a client entered article
     * @return OK
     */
    saveArticle(article: ArticleModel, customerAccountId: number): Promise<ArticleModel> {
        let url_ = this.baseUrl + "/writtenarticles?";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined and cannot be null.");
        else
            url_ += "customerAccountId=" + encodeURIComponent("" + customerAccountId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(article);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveArticle(_response);
        });
    }

    protected processSaveArticle(response: AxiosResponse): Promise<ArticleModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ArticleModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ArticleModel>(<any>null);
    }

    /**
     * Delete a written article.
     * @param articleId article guid
     * @return OK
     */
    deleteArticle(articleId: string, issueid: number): Promise<any> {
        let url_ = this.baseUrl + "/writtenarticles?";
        if (articleId === undefined || articleId === null)
            throw new Error("The parameter 'articleId' must be defined and cannot be null.");
        else
            url_ += "articleId=" + encodeURIComponent("" + articleId) + "&"; 
        if (issueid === undefined || issueid === null)
            throw new Error("The parameter 'issueid' must be defined and cannot be null.");
        else
            url_ += "issueid=" + encodeURIComponent("" + issueid) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteArticle(_response);
        });
    }

    protected processDeleteArticle(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Get all the articles written in this account.
     * @return OK
     */
    getWrittenArticles(customerAccountId: number): Promise<MyGroupingOfArticlePropDTO[]> {
        let url_ = this.baseUrl + "/writtenarticles/writtenprops?";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined and cannot be null.");
        else
            url_ += "customerAccountId=" + encodeURIComponent("" + customerAccountId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetWrittenArticles(_response);
        });
    }

    protected processGetWrittenArticles(response: AxiosResponse): Promise<MyGroupingOfArticlePropDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MyGroupingOfArticlePropDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MyGroupingOfArticlePropDTO[]>(<any>null);
    }

    /**
     * Get a written article.
     * @return OK
     */
    getWrittenArticle(articleId: string): Promise<ArticleModel> {
        let url_ = this.baseUrl + "/writtenarticles/writtenarticle?";
        if (articleId === undefined || articleId === null)
            throw new Error("The parameter 'articleId' must be defined and cannot be null.");
        else
            url_ += "articleId=" + encodeURIComponent("" + articleId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetWrittenArticle(_response);
        });
    }

    protected processGetWrittenArticle(response: AxiosResponse): Promise<ArticleModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ArticleModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ArticleModel>(<any>null);
    }

    /**
     * Get a written article.
     * @return OK
     */
    getArticle(issueId: number, articleId: string): Promise<ArticleModel> {
        let url_ = this.baseUrl + "/writtenarticles/article?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        if (articleId === undefined || articleId === null)
            throw new Error("The parameter 'articleId' must be defined and cannot be null.");
        else
            url_ += "articleId=" + encodeURIComponent("" + articleId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetArticle(_response);
        });
    }

    protected processGetArticle(response: AxiosResponse): Promise<ArticleModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ArticleModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ArticleModel>(<any>null);
    }

    /**
     * add a new issue of type article to the given publication.
     * @return OK
     */
    addWrittenIssue(publicationId: number, name: string): Promise<IssueModel> {
        let url_ = this.baseUrl + "/writtenarticles/addissue?";
        if (publicationId === undefined || publicationId === null)
            throw new Error("The parameter 'publicationId' must be defined and cannot be null.");
        else
            url_ += "publicationId=" + encodeURIComponent("" + publicationId) + "&"; 
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined and cannot be null.");
        else
            url_ += "Name=" + encodeURIComponent("" + name) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAddWrittenIssue(_response);
        });
    }

    protected processAddWrittenIssue(response: AxiosResponse): Promise<IssueModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueModel>(<any>null);
    }

    /**
     * move an article to a new publication(category)
     * @return OK
     */
    moveArticle(articleId: string, publicationId: number): Promise<any> {
        let url_ = this.baseUrl + "/writtenarticles/move?";
        if (articleId === undefined || articleId === null)
            throw new Error("The parameter 'articleId' must be defined and cannot be null.");
        else
            url_ += "articleId=" + encodeURIComponent("" + articleId) + "&"; 
        if (publicationId === undefined || publicationId === null)
            throw new Error("The parameter 'publicationId' must be defined and cannot be null.");
        else
            url_ += "PublicationId=" + encodeURIComponent("" + publicationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processMoveArticle(_response);
        });
    }

    protected processMoveArticle(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * save an article to a publication(catgeory)
     * @return OK
     */
    saveWrittenArticle(article: ArticleModel, publicationId: number): Promise<ArticleModel> {
        let url_ = this.baseUrl + "/writtenarticles/save?";
        if (publicationId === undefined || publicationId === null)
            throw new Error("The parameter 'publicationId' must be defined and cannot be null.");
        else
            url_ += "PublicationId=" + encodeURIComponent("" + publicationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(article);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveWrittenArticle(_response);
        });
    }

    protected processSaveWrittenArticle(response: AxiosResponse): Promise<ArticleModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ArticleModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ArticleModel>(<any>null);
    }

    /**
     * get all publication of type written / article folder.
     * @return OK
     */
    getWrittenArticlePublications(customerAccountId: number): Promise<PublicationModel[]> {
        let url_ = this.baseUrl + "/writtenarticles/publications?";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined and cannot be null.");
        else
            url_ += "customerAccountId=" + encodeURIComponent("" + customerAccountId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetWrittenArticlePublications(_response);
        });
    }

    protected processGetWrittenArticlePublications(response: AxiosResponse): Promise<PublicationModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PublicationModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicationModel[]>(<any>null);
    }
}

export interface INewsletterClient {
    /**
     * Get a newsletter articles for issue.
     * @return OK
     */
    getArticle(issueId: number): Promise<ArticleModel[]>;
    /**
     * Get a newsletterService by name
     * @return OK
     */
    getNewsletter(newsletterServiceId: number, newsletterName: string): Promise<NewsletterModel>;
    /**
     * adds a newsletterService
     * @return OK
     */
    save(newsletter: NewsletterModel): Promise<NewsletterModel>;
    /**
     * adds a new newsletter to the given newsletter service using the given articles.
     * @return OK
     */
    addNewsletter(data: NewNewsletterData): Promise<NewsletterModel>;
    /**
     * finalise a newsletter. creates issues for all titles subscribed to newsletter service.
     * @return OK
     */
    finalise(newsletterId: number): Promise<any>;
    /**
     * get the usage for a particular newsletter. lists accounts and links after newsletter is finalized.
     * @return OK
     */
    getUsage(newsletterId: number): Promise<NewsletterUsageModel[]>;
    /**
     * Adds an article to a newsletter.
     * @return OK
     */
    addArticleToNewsletter(articleId: string, newsletterId: number, sourceIssueId: number): Promise<ArticleModel>;
    /**
     * Adds an article to a newsletter.
     * @return OK
     */
    removeArticleFromNewsletter(articleId: string, newsletterId: number): Promise<ArticleModel>;
}

export class NewsletterClient implements INewsletterClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Get a newsletter articles for issue.
     * @return OK
     */
    getArticle(issueId: number): Promise<ArticleModel[]> {
        let url_ = this.baseUrl + "/newsletter/articles?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetArticle(_response);
        });
    }

    protected processGetArticle(response: AxiosResponse): Promise<ArticleModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ArticleModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ArticleModel[]>(<any>null);
    }

    /**
     * Get a newsletterService by name
     * @return OK
     */
    getNewsletter(newsletterServiceId: number, newsletterName: string): Promise<NewsletterModel> {
        let url_ = this.baseUrl + "/newsletter?";
        if (newsletterServiceId === undefined || newsletterServiceId === null)
            throw new Error("The parameter 'newsletterServiceId' must be defined and cannot be null.");
        else
            url_ += "NewsletterServiceId=" + encodeURIComponent("" + newsletterServiceId) + "&"; 
        if (newsletterName === undefined || newsletterName === null)
            throw new Error("The parameter 'newsletterName' must be defined and cannot be null.");
        else
            url_ += "newsletterName=" + encodeURIComponent("" + newsletterName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetNewsletter(_response);
        });
    }

    protected processGetNewsletter(response: AxiosResponse): Promise<NewsletterModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NewsletterModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NewsletterModel>(<any>null);
    }

    /**
     * adds a newsletterService
     * @return OK
     */
    save(newsletter: NewsletterModel): Promise<NewsletterModel> {
        let url_ = this.baseUrl + "/newsletter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newsletter);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<NewsletterModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NewsletterModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NewsletterModel>(<any>null);
    }

    /**
     * adds a new newsletter to the given newsletter service using the given articles.
     * @return OK
     */
    addNewsletter(data: NewNewsletterData): Promise<NewsletterModel> {
        let url_ = this.baseUrl + "/newsletter/addnewsletterwitharticles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAddNewsletter(_response);
        });
    }

    protected processAddNewsletter(response: AxiosResponse): Promise<NewsletterModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NewsletterModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NewsletterModel>(<any>null);
    }

    /**
     * finalise a newsletter. creates issues for all titles subscribed to newsletter service.
     * @return OK
     */
    finalise(newsletterId: number): Promise<any> {
        let url_ = this.baseUrl + "/newsletter/finalise?";
        if (newsletterId === undefined || newsletterId === null)
            throw new Error("The parameter 'newsletterId' must be defined and cannot be null.");
        else
            url_ += "newsletterId=" + encodeURIComponent("" + newsletterId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFinalise(_response);
        });
    }

    protected processFinalise(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * get the usage for a particular newsletter. lists accounts and links after newsletter is finalized.
     * @return OK
     */
    getUsage(newsletterId: number): Promise<NewsletterUsageModel[]> {
        let url_ = this.baseUrl + "/newsletter/usage?";
        if (newsletterId === undefined || newsletterId === null)
            throw new Error("The parameter 'newsletterId' must be defined and cannot be null.");
        else
            url_ += "newsletterId=" + encodeURIComponent("" + newsletterId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetUsage(_response);
        });
    }

    protected processGetUsage(response: AxiosResponse): Promise<NewsletterUsageModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NewsletterUsageModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NewsletterUsageModel[]>(<any>null);
    }

    /**
     * Adds an article to a newsletter.
     * @return OK
     */
    addArticleToNewsletter(articleId: string, newsletterId: number, sourceIssueId: number): Promise<ArticleModel> {
        let url_ = this.baseUrl + "/newsletter/addarticletonewsletter?";
        if (articleId === undefined || articleId === null)
            throw new Error("The parameter 'articleId' must be defined and cannot be null.");
        else
            url_ += "articleId=" + encodeURIComponent("" + articleId) + "&"; 
        if (newsletterId === undefined || newsletterId === null)
            throw new Error("The parameter 'newsletterId' must be defined and cannot be null.");
        else
            url_ += "newsletterId=" + encodeURIComponent("" + newsletterId) + "&"; 
        if (sourceIssueId === undefined || sourceIssueId === null)
            throw new Error("The parameter 'sourceIssueId' must be defined and cannot be null.");
        else
            url_ += "sourceIssueId=" + encodeURIComponent("" + sourceIssueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAddArticleToNewsletter(_response);
        });
    }

    protected processAddArticleToNewsletter(response: AxiosResponse): Promise<ArticleModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ArticleModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ArticleModel>(<any>null);
    }

    /**
     * Adds an article to a newsletter.
     * @return OK
     */
    removeArticleFromNewsletter(articleId: string, newsletterId: number): Promise<ArticleModel> {
        let url_ = this.baseUrl + "/newsletter/removearticlefromnewsletter?";
        if (articleId === undefined || articleId === null)
            throw new Error("The parameter 'articleId' must be defined and cannot be null.");
        else
            url_ += "articleId=" + encodeURIComponent("" + articleId) + "&"; 
        if (newsletterId === undefined || newsletterId === null)
            throw new Error("The parameter 'newsletterId' must be defined and cannot be null.");
        else
            url_ += "newsletterId=" + encodeURIComponent("" + newsletterId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRemoveArticleFromNewsletter(_response);
        });
    }

    protected processRemoveArticleFromNewsletter(response: AxiosResponse): Promise<ArticleModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ArticleModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ArticleModel>(<any>null);
    }
}

export interface INewsletterServiceClient {
    /**
     * Get a newsletterService by name
     * @return OK
     */
    getNewsletterService(producerId: number, newsletterServiceName: string): Promise<NewsletterserviceModel>;
    /**
     * adds a newsletterService
     * @return OK
     */
    save(newsletterService: NewsletterserviceModel): Promise<NewsletterserviceModel>;
}

export class NewsletterServiceClient implements INewsletterServiceClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Get a newsletterService by name
     * @return OK
     */
    getNewsletterService(producerId: number, newsletterServiceName: string): Promise<NewsletterserviceModel> {
        let url_ = this.baseUrl + "/newsletterservice?";
        if (producerId === undefined || producerId === null)
            throw new Error("The parameter 'producerId' must be defined and cannot be null.");
        else
            url_ += "ProducerId=" + encodeURIComponent("" + producerId) + "&"; 
        if (newsletterServiceName === undefined || newsletterServiceName === null)
            throw new Error("The parameter 'newsletterServiceName' must be defined and cannot be null.");
        else
            url_ += "newsletterServiceName=" + encodeURIComponent("" + newsletterServiceName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetNewsletterService(_response);
        });
    }

    protected processGetNewsletterService(response: AxiosResponse): Promise<NewsletterserviceModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NewsletterserviceModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NewsletterserviceModel>(<any>null);
    }

    /**
     * adds a newsletterService
     * @return OK
     */
    save(newsletterService: NewsletterserviceModel): Promise<NewsletterserviceModel> {
        let url_ = this.baseUrl + "/newsletterservice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newsletterService);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<NewsletterserviceModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NewsletterserviceModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NewsletterserviceModel>(<any>null);
    }
}

export interface INewsletterSubscriptionClient {
    /**
     * subscribe to a newsletter service.
     * @param details detaisl fo the subscription
     * @return OK
     */
    subscribe(details: NewsletterSubscriptionDetails): Promise<NewsletterSubscriptionModel>;
}

export class NewsletterSubscriptionClient implements INewsletterSubscriptionClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * subscribe to a newsletter service.
     * @param details detaisl fo the subscription
     * @return OK
     */
    subscribe(details: NewsletterSubscriptionDetails): Promise<NewsletterSubscriptionModel> {
        let url_ = this.baseUrl + "/newslettersubscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(details);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSubscribe(_response);
        });
    }

    protected processSubscribe(response: AxiosResponse): Promise<NewsletterSubscriptionModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NewsletterSubscriptionModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NewsletterSubscriptionModel>(<any>null);
    }
}

export interface IParticaStoreClient {
    /**
     * get a purchased article
     * @return OK
     */
    getPurchasedArticle(articleId: string): Promise<ArticleModel>;
    /**
     * get an article from subscription stream.
     * @return OK
     */
    getContentStreamArticle(articleId: string): Promise<ArticleModel>;
    /**
     * Query syndicated articles.
     * @return OK
     */
    searchStore(data: ContentSearchDataOfContentSearchHit): Promise<ContentSearchDataOfContentSearchHit>;
    /**
     * get all purchased articles and articles from content stream subscriptions.
     * @return OK
     */
    getArticles(customerAccountId: number): Promise<{ [key: string]: StoreArticleDTO[]; }>;
    /**
     * gets the licence for an article in the store.
     * @return OK
     */
    getCurrentArticleLicence(articleId: string): Promise<CustomerArticleLicenceDTO>;
    /**
     * gets the licence when the article was purchased / used in stream.
     * @return OK
     */
    getArticleLicence(articleId: string): Promise<CustomerArticleLicenceDTO>;
}

export class ParticaStoreClient implements IParticaStoreClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * get a purchased article
     * @return OK
     */
    getPurchasedArticle(articleId: string): Promise<ArticleModel> {
        let url_ = this.baseUrl + "/particastore/purchasedarticle?";
        if (articleId === undefined || articleId === null)
            throw new Error("The parameter 'articleId' must be defined and cannot be null.");
        else
            url_ += "articleId=" + encodeURIComponent("" + articleId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPurchasedArticle(_response);
        });
    }

    protected processGetPurchasedArticle(response: AxiosResponse): Promise<ArticleModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ArticleModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ArticleModel>(<any>null);
    }

    /**
     * get an article from subscription stream.
     * @return OK
     */
    getContentStreamArticle(articleId: string): Promise<ArticleModel> {
        let url_ = this.baseUrl + "/particastore/streamarticle?";
        if (articleId === undefined || articleId === null)
            throw new Error("The parameter 'articleId' must be defined and cannot be null.");
        else
            url_ += "articleId=" + encodeURIComponent("" + articleId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetContentStreamArticle(_response);
        });
    }

    protected processGetContentStreamArticle(response: AxiosResponse): Promise<ArticleModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ArticleModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ArticleModel>(<any>null);
    }

    /**
     * Query syndicated articles.
     * @return OK
     */
    searchStore(data: ContentSearchDataOfContentSearchHit): Promise<ContentSearchDataOfContentSearchHit> {
        let url_ = this.baseUrl + "/particastore/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSearchStore(_response);
        });
    }

    protected processSearchStore(response: AxiosResponse): Promise<ContentSearchDataOfContentSearchHit> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ContentSearchDataOfContentSearchHit.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContentSearchDataOfContentSearchHit>(<any>null);
    }

    /**
     * get all purchased articles and articles from content stream subscriptions.
     * @return OK
     */
    getArticles(customerAccountId: number): Promise<{ [key: string]: StoreArticleDTO[]; }> {
        let url_ = this.baseUrl + "/particastore/articles?";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined and cannot be null.");
        else
            url_ += "CustomerAccountId=" + encodeURIComponent("" + customerAccountId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetArticles(_response);
        });
    }

    protected processGetArticles(response: AxiosResponse): Promise<{ [key: string]: StoreArticleDTO[]; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200![key] = resultData200[key] ? resultData200[key].map((i: any) => StoreArticleDTO.fromJS(i)) : [];
                }
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: StoreArticleDTO[]; }>(<any>null);
    }

    /**
     * gets the licence for an article in the store.
     * @return OK
     */
    getCurrentArticleLicence(articleId: string): Promise<CustomerArticleLicenceDTO> {
        let url_ = this.baseUrl + "/particastore/currentlicence?";
        if (articleId === undefined || articleId === null)
            throw new Error("The parameter 'articleId' must be defined and cannot be null.");
        else
            url_ += "ArticleId=" + encodeURIComponent("" + articleId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetCurrentArticleLicence(_response);
        });
    }

    protected processGetCurrentArticleLicence(response: AxiosResponse): Promise<CustomerArticleLicenceDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomerArticleLicenceDTO.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerArticleLicenceDTO>(<any>null);
    }

    /**
     * gets the licence when the article was purchased / used in stream.
     * @return OK
     */
    getArticleLicence(articleId: string): Promise<CustomerArticleLicenceDTO> {
        let url_ = this.baseUrl + "/particastore/articlelicence?";
        if (articleId === undefined || articleId === null)
            throw new Error("The parameter 'articleId' must be defined and cannot be null.");
        else
            url_ += "ArticleId=" + encodeURIComponent("" + articleId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetArticleLicence(_response);
        });
    }

    protected processGetArticleLicence(response: AxiosResponse): Promise<CustomerArticleLicenceDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomerArticleLicenceDTO.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerArticleLicenceDTO>(<any>null);
    }
}

export interface IPartnerClient {
    /**
     * Subscribe to a content stream, this must be performed by subscriber.
     * @param subscriptionData Subscription data
     * @return OK
     */
    subscribeToContentStream(subscriptionData: PartnerSubscriptionDTO): Promise<ContentStreamSubscriptionDataDTO>;
    /**
     * Get article feeds for user.
     * @return OK
     */
    getFeeds(partnerId: string, externalId: string): Promise<{ [key: string]: StoreArticleDTO[]; }>;
    /**
     * Get article feed for user.
     * @return OK
     */
    getFeed(partnerId: string, externalId: string, streamSubscriptionId: string): Promise<StoreArticleDTO[]>;
    /**
     * Get subscriptions for the given externalId
     * @return OK
     */
    getSubscriptions(partnerId: string, externalId: string): Promise<ContentStreamSubscriptionStoreDTO[]>;
    /**
     * Gets a stream or purchased artcile for this user.
     * @return OK
     */
    getArticle(partnerId: string, externalId: string, articleId: string): Promise<ArticleModel>;
    /**
     * Get a list of streams owned by the partner.
     * @return OK
     */
    getStreams(partnerId: string): Promise<ContentStreamStoreDTO[]>;
    /**
     * Checks if an account exists, if not, creates an account in Partica using the details provided.
    Returns the accountId and bearer token for the given user.
    Restricted to tenant owner.
     * @return OK
     */
    getAccessDetails(userDTO: UserDTO): Promise<AccessDetailsDTO>;
}

export class PartnerClient implements IPartnerClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Subscribe to a content stream, this must be performed by subscriber.
     * @param subscriptionData Subscription data
     * @return OK
     */
    subscribeToContentStream(subscriptionData: PartnerSubscriptionDTO): Promise<ContentStreamSubscriptionDataDTO> {
        let url_ = this.baseUrl + "/partner/subscribe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(subscriptionData);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSubscribeToContentStream(_response);
        });
    }

    protected processSubscribeToContentStream(response: AxiosResponse): Promise<ContentStreamSubscriptionDataDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ContentStreamSubscriptionDataDTO.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContentStreamSubscriptionDataDTO>(<any>null);
    }

    /**
     * Get article feeds for user.
     * @return OK
     */
    getFeeds(partnerId: string, externalId: string): Promise<{ [key: string]: StoreArticleDTO[]; }> {
        let url_ = this.baseUrl + "/partner/feeds?";
        if (partnerId === undefined || partnerId === null)
            throw new Error("The parameter 'partnerId' must be defined and cannot be null.");
        else
            url_ += "PartnerId=" + encodeURIComponent("" + partnerId) + "&"; 
        if (externalId === undefined || externalId === null)
            throw new Error("The parameter 'externalId' must be defined and cannot be null.");
        else
            url_ += "ExternalId=" + encodeURIComponent("" + externalId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetFeeds(_response);
        });
    }

    protected processGetFeeds(response: AxiosResponse): Promise<{ [key: string]: StoreArticleDTO[]; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200![key] = resultData200[key] ? resultData200[key].map((i: any) => StoreArticleDTO.fromJS(i)) : [];
                }
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: StoreArticleDTO[]; }>(<any>null);
    }

    /**
     * Get article feed for user.
     * @return OK
     */
    getFeed(partnerId: string, externalId: string, streamSubscriptionId: string): Promise<StoreArticleDTO[]> {
        let url_ = this.baseUrl + "/partner/feed?";
        if (partnerId === undefined || partnerId === null)
            throw new Error("The parameter 'partnerId' must be defined and cannot be null.");
        else
            url_ += "PartnerId=" + encodeURIComponent("" + partnerId) + "&"; 
        if (externalId === undefined || externalId === null)
            throw new Error("The parameter 'externalId' must be defined and cannot be null.");
        else
            url_ += "ExternalId=" + encodeURIComponent("" + externalId) + "&"; 
        if (streamSubscriptionId === undefined || streamSubscriptionId === null)
            throw new Error("The parameter 'streamSubscriptionId' must be defined and cannot be null.");
        else
            url_ += "StreamSubscriptionId=" + encodeURIComponent("" + streamSubscriptionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetFeed(_response);
        });
    }

    protected processGetFeed(response: AxiosResponse): Promise<StoreArticleDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StoreArticleDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StoreArticleDTO[]>(<any>null);
    }

    /**
     * Get subscriptions for the given externalId
     * @return OK
     */
    getSubscriptions(partnerId: string, externalId: string): Promise<ContentStreamSubscriptionStoreDTO[]> {
        let url_ = this.baseUrl + "/partner/subscriptions?";
        if (partnerId === undefined || partnerId === null)
            throw new Error("The parameter 'partnerId' must be defined and cannot be null.");
        else
            url_ += "PartnerId=" + encodeURIComponent("" + partnerId) + "&"; 
        if (externalId === undefined || externalId === null)
            throw new Error("The parameter 'externalId' must be defined and cannot be null.");
        else
            url_ += "ExternalId=" + encodeURIComponent("" + externalId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetSubscriptions(_response);
        });
    }

    protected processGetSubscriptions(response: AxiosResponse): Promise<ContentStreamSubscriptionStoreDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContentStreamSubscriptionStoreDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContentStreamSubscriptionStoreDTO[]>(<any>null);
    }

    /**
     * Gets a stream or purchased artcile for this user.
     * @return OK
     */
    getArticle(partnerId: string, externalId: string, articleId: string): Promise<ArticleModel> {
        let url_ = this.baseUrl + "/partner/article?";
        if (partnerId === undefined || partnerId === null)
            throw new Error("The parameter 'partnerId' must be defined and cannot be null.");
        else
            url_ += "PartnerId=" + encodeURIComponent("" + partnerId) + "&"; 
        if (externalId === undefined || externalId === null)
            throw new Error("The parameter 'externalId' must be defined and cannot be null.");
        else
            url_ += "ExternalId=" + encodeURIComponent("" + externalId) + "&"; 
        if (articleId === undefined || articleId === null)
            throw new Error("The parameter 'articleId' must be defined and cannot be null.");
        else
            url_ += "ArticleId=" + encodeURIComponent("" + articleId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetArticle(_response);
        });
    }

    protected processGetArticle(response: AxiosResponse): Promise<ArticleModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ArticleModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ArticleModel>(<any>null);
    }

    /**
     * Get a list of streams owned by the partner.
     * @return OK
     */
    getStreams(partnerId: string): Promise<ContentStreamStoreDTO[]> {
        let url_ = this.baseUrl + "/partner/streams?";
        if (partnerId === undefined || partnerId === null)
            throw new Error("The parameter 'partnerId' must be defined and cannot be null.");
        else
            url_ += "PartnerId=" + encodeURIComponent("" + partnerId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetStreams(_response);
        });
    }

    protected processGetStreams(response: AxiosResponse): Promise<ContentStreamStoreDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContentStreamStoreDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContentStreamStoreDTO[]>(<any>null);
    }

    /**
     * Checks if an account exists, if not, creates an account in Partica using the details provided.
    Returns the accountId and bearer token for the given user.
    Restricted to tenant owner.
     * @return OK
     */
    getAccessDetails(userDTO: UserDTO): Promise<AccessDetailsDTO> {
        let url_ = this.baseUrl + "/partner/user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAccessDetails(_response);
        });
    }

    protected processGetAccessDetails(response: AxiosResponse): Promise<AccessDetailsDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccessDetailsDTO.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccessDetailsDTO>(<any>null);
    }
}

export interface IPaymentClient {
    /**
     * Create a payment source using a one time token.
     * @return OK
     */
    addToken(customerAccountId: number, tokenid: string): Promise<any>;
    /**
     * check if the user has a payment source associated with their account. return null if no payment source.
     * @return OK
     */
    hasPaymentSource(customerAccountId: number): Promise<CustomerInfo>;
    /**
     * get sso token for v3 portal.
     * @return OK
     */
    getSsoToken(customerAccountId: number): Promise<any>;
}

export class PaymentClient implements IPaymentClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Create a payment source using a one time token.
     * @return OK
     */
    addToken(customerAccountId: number, tokenid: string): Promise<any> {
        let url_ = this.baseUrl + "/payment/createsource?";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined and cannot be null.");
        else
            url_ += "CustomerAccountId=" + encodeURIComponent("" + customerAccountId) + "&"; 
        if (tokenid === undefined || tokenid === null)
            throw new Error("The parameter 'tokenid' must be defined and cannot be null.");
        else
            url_ += "tokenid=" + encodeURIComponent("" + tokenid) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAddToken(_response);
        });
    }

    protected processAddToken(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * check if the user has a payment source associated with their account. return null if no payment source.
     * @return OK
     */
    hasPaymentSource(customerAccountId: number): Promise<CustomerInfo> {
        let url_ = this.baseUrl + "/payment/haspaymentsource?";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined and cannot be null.");
        else
            url_ += "customerAccountId=" + encodeURIComponent("" + customerAccountId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processHasPaymentSource(_response);
        });
    }

    protected processHasPaymentSource(response: AxiosResponse): Promise<CustomerInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomerInfo.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerInfo>(<any>null);
    }

    /**
     * get sso token for v3 portal.
     * @return OK
     */
    getSsoToken(customerAccountId: number): Promise<any> {
        let url_ = this.baseUrl + "/payment/ssotoken?";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined and cannot be null.");
        else
            url_ += "customerAccountId=" + encodeURIComponent("" + customerAccountId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetSsoToken(_response);
        });
    }

    protected processGetSsoToken(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }
}

export interface IPdfContentClient {
    /**
     * @return OK
     */
    getPdfInfo(issueId: number): Promise<Pdfinfo>;
    /**
     * extract content with html
     * @return OK
     */
    getPageContentHtml(issueId: number, pageNumber: number): Promise<PageContent>;
    /**
     * extract content for inception
     * @return OK
     */
    getPageContentInception(issueId: number, pageNumber: number): Promise<PageContent>;
    /**
     * demo content for analysis
     * @return OK
     */
    getPageContentDemoHtml(issueId: number, pageNumber: number): Promise<PageContent>;
}

export class PdfContentClient implements IPdfContentClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return OK
     */
    getPdfInfo(issueId: number): Promise<Pdfinfo> {
        let url_ = this.baseUrl + "/pdfinfo?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPdfInfo(_response);
        });
    }

    protected processGetPdfInfo(response: AxiosResponse): Promise<Pdfinfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Pdfinfo.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Pdfinfo>(<any>null);
    }

    /**
     * extract content with html
     * @return OK
     */
    getPageContentHtml(issueId: number, pageNumber: number): Promise<PageContent> {
        let url_ = this.baseUrl + "/content?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPageContentHtml(_response);
        });
    }

    protected processGetPageContentHtml(response: AxiosResponse): Promise<PageContent> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PageContent.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PageContent>(<any>null);
    }

    /**
     * extract content for inception
     * @return OK
     */
    getPageContentInception(issueId: number, pageNumber: number): Promise<PageContent> {
        let url_ = this.baseUrl + "/contentinception?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPageContentInception(_response);
        });
    }

    protected processGetPageContentInception(response: AxiosResponse): Promise<PageContent> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PageContent.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PageContent>(<any>null);
    }

    /**
     * demo content for analysis
     * @return OK
     */
    getPageContentDemoHtml(issueId: number, pageNumber: number): Promise<PageContent> {
        let url_ = this.baseUrl + "/contentdemo?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPageContentDemoHtml(_response);
        });
    }

    protected processGetPageContentDemoHtml(response: AxiosResponse): Promise<PageContent> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PageContent.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PageContent>(<any>null);
    }
}

export interface IPortalClient {
    /**
     * Find articles from your account.
     * @return OK
     */
    findArticles(customerAccountId: number, query: string): Promise<ContentSearchDataOfContentSearchHit>;
    /**
     * search the pdf text in your account
     * @return OK
     */
    searchPageText(customerAccountId: number, query: string): Promise<DashboardPageSearchResults[]>;
    /**
     * Get portal data for logged in account
     * @return OK
     */
    getPortal(): Promise<CustomerAccountModel[]>;
    /**
     * Get portal data for given account
     * @return OK
     */
    getPortalForAccount(accountName: string): Promise<CustomerAccountModel[]>;
}

export class PortalClient implements IPortalClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Find articles from your account.
     * @return OK
     */
    findArticles(customerAccountId: number, query: string): Promise<ContentSearchDataOfContentSearchHit> {
        let url_ = this.baseUrl + "/portal/findarticles?";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined and cannot be null.");
        else
            url_ += "customerAccountId=" + encodeURIComponent("" + customerAccountId) + "&"; 
        if (query === undefined || query === null)
            throw new Error("The parameter 'query' must be defined and cannot be null.");
        else
            url_ += "query=" + encodeURIComponent("" + query) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFindArticles(_response);
        });
    }

    protected processFindArticles(response: AxiosResponse): Promise<ContentSearchDataOfContentSearchHit> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ContentSearchDataOfContentSearchHit.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContentSearchDataOfContentSearchHit>(<any>null);
    }

    /**
     * search the pdf text in your account
     * @return OK
     */
    searchPageText(customerAccountId: number, query: string): Promise<DashboardPageSearchResults[]> {
        let url_ = this.baseUrl + "/portal/searchpagetext?";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined and cannot be null.");
        else
            url_ += "customerAccountId=" + encodeURIComponent("" + customerAccountId) + "&"; 
        if (query === undefined || query === null)
            throw new Error("The parameter 'query' must be defined and cannot be null.");
        else
            url_ += "query=" + encodeURIComponent("" + query) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSearchPageText(_response);
        });
    }

    protected processSearchPageText(response: AxiosResponse): Promise<DashboardPageSearchResults[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DashboardPageSearchResults.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DashboardPageSearchResults[]>(<any>null);
    }

    /**
     * Get portal data for logged in account
     * @return OK
     */
    getPortal(): Promise<CustomerAccountModel[]> {
        let url_ = this.baseUrl + "/portal";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPortal(_response);
        });
    }

    protected processGetPortal(response: AxiosResponse): Promise<CustomerAccountModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerAccountModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerAccountModel[]>(<any>null);
    }

    /**
     * Get portal data for given account
     * @return OK
     */
    getPortalForAccount(accountName: string): Promise<CustomerAccountModel[]> {
        let url_ = this.baseUrl + "/portal/byname?";
        if (accountName === undefined || accountName === null)
            throw new Error("The parameter 'accountName' must be defined and cannot be null.");
        else
            url_ += "accountName=" + encodeURIComponent("" + accountName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPortalForAccount(_response);
        });
    }

    protected processGetPortalForAccount(response: AxiosResponse): Promise<CustomerAccountModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerAccountModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerAccountModel[]>(<any>null);
    }
}

export interface IProducerClient {
    /**
     * Get a producer by name
     * @return OK
     */
    getProducer(producerName: string): Promise<ProducerModel>;
    /**
     * adds a producer
     * @return OK
     */
    save(producer: ProducerModel): Promise<ProducerModel>;
}

export class ProducerClient implements IProducerClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Get a producer by name
     * @return OK
     */
    getProducer(producerName: string): Promise<ProducerModel> {
        let url_ = this.baseUrl + "/producer?";
        if (producerName === undefined || producerName === null)
            throw new Error("The parameter 'producerName' must be defined and cannot be null.");
        else
            url_ += "producerName=" + encodeURIComponent("" + producerName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetProducer(_response);
        });
    }

    protected processGetProducer(response: AxiosResponse): Promise<ProducerModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProducerModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProducerModel>(<any>null);
    }

    /**
     * adds a producer
     * @return OK
     */
    save(producer: ProducerModel): Promise<ProducerModel> {
        let url_ = this.baseUrl + "/producer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(producer);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<ProducerModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProducerModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProducerModel>(<any>null);
    }
}

export interface IPublicationClient {
    /**
     * Check if the title name exists already in the specified account.
     * @return OK
     */
    checkTitleNameExists(customerAccountID: number, titleName: string): Promise<boolean>;
    /**
     * Get the publication.
     * @return OK
     */
    getPublication(publicationId: number): Promise<PublicationModel>;
    /**
     * Renames the given publication.
     * @param publicationId The publication to rename.
     * @param newPublicationName New name of the publication.
     * @return OK
     */
    renamePublication(publicationId: number, newPublicationName: string): Promise<PublicationModel>;
    /**
     * Deletes a publication.
     * @param publicationId The publication to delete.
     * @return OK
     */
    deletePublication(publicationId: number): Promise<any>;
    /**
     * republish all issues in a publication
    does not update url.json
     * @return OK
     */
    republishAllIssues(publicationId: number): Promise<any>;
    /**
     * sets the publication lanagauge for a title
    all articles / page text are updated to reflect the new language. 
    this may be slow for big titles.
    if the new langauage is the same as the current language then nothing will happen.
     * @return OK
     */
    setPublicationLanguage(publicationId: number, language: Language): Promise<any>;
    /**
     * add a new publication to the account.
     * @return OK
     */
    addPublication(customerAccountId: number, publicationType: PublicationType, name: string): Promise<PublicationModel>;
}

export class PublicationClient implements IPublicationClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Check if the title name exists already in the specified account.
     * @return OK
     */
    checkTitleNameExists(customerAccountID: number, titleName: string): Promise<boolean> {
        let url_ = this.baseUrl + "/publication/checkname?";
        if (customerAccountID === undefined || customerAccountID === null)
            throw new Error("The parameter 'customerAccountID' must be defined and cannot be null.");
        else
            url_ += "customerAccountID=" + encodeURIComponent("" + customerAccountID) + "&"; 
        if (titleName === undefined || titleName === null)
            throw new Error("The parameter 'titleName' must be defined and cannot be null.");
        else
            url_ += "titleName=" + encodeURIComponent("" + titleName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCheckTitleNameExists(_response);
        });
    }

    protected processCheckTitleNameExists(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * Get the publication.
     * @return OK
     */
    getPublication(publicationId: number): Promise<PublicationModel> {
        let url_ = this.baseUrl + "/publication?";
        if (publicationId === undefined || publicationId === null)
            throw new Error("The parameter 'publicationId' must be defined and cannot be null.");
        else
            url_ += "publicationId=" + encodeURIComponent("" + publicationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPublication(_response);
        });
    }

    protected processGetPublication(response: AxiosResponse): Promise<PublicationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PublicationModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicationModel>(<any>null);
    }

    /**
     * Renames the given publication.
     * @param publicationId The publication to rename.
     * @param newPublicationName New name of the publication.
     * @return OK
     */
    renamePublication(publicationId: number, newPublicationName: string): Promise<PublicationModel> {
        let url_ = this.baseUrl + "/publication/rename?";
        if (publicationId === undefined || publicationId === null)
            throw new Error("The parameter 'publicationId' must be defined and cannot be null.");
        else
            url_ += "publicationId=" + encodeURIComponent("" + publicationId) + "&"; 
        if (newPublicationName === undefined || newPublicationName === null)
            throw new Error("The parameter 'newPublicationName' must be defined and cannot be null.");
        else
            url_ += "newPublicationName=" + encodeURIComponent("" + newPublicationName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRenamePublication(_response);
        });
    }

    protected processRenamePublication(response: AxiosResponse): Promise<PublicationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PublicationModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicationModel>(<any>null);
    }

    /**
     * Deletes a publication.
     * @param publicationId The publication to delete.
     * @return OK
     */
    deletePublication(publicationId: number): Promise<any> {
        let url_ = this.baseUrl + "/publication/delete?";
        if (publicationId === undefined || publicationId === null)
            throw new Error("The parameter 'publicationId' must be defined and cannot be null.");
        else
            url_ += "publicationId=" + encodeURIComponent("" + publicationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeletePublication(_response);
        });
    }

    protected processDeletePublication(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * republish all issues in a publication
    does not update url.json
     * @return OK
     */
    republishAllIssues(publicationId: number): Promise<any> {
        let url_ = this.baseUrl + "/publication/republishallissues?";
        if (publicationId === undefined || publicationId === null)
            throw new Error("The parameter 'publicationId' must be defined and cannot be null.");
        else
            url_ += "publicationId=" + encodeURIComponent("" + publicationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRepublishAllIssues(_response);
        });
    }

    protected processRepublishAllIssues(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * sets the publication lanagauge for a title
    all articles / page text are updated to reflect the new language. 
    this may be slow for big titles.
    if the new langauage is the same as the current language then nothing will happen.
     * @return OK
     */
    setPublicationLanguage(publicationId: number, language: Language): Promise<any> {
        let url_ = this.baseUrl + "/publication/setlanguage?";
        if (publicationId === undefined || publicationId === null)
            throw new Error("The parameter 'publicationId' must be defined and cannot be null.");
        else
            url_ += "publicationId=" + encodeURIComponent("" + publicationId) + "&"; 
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSetPublicationLanguage(_response);
        });
    }

    protected processSetPublicationLanguage(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * add a new publication to the account.
     * @return OK
     */
    addPublication(customerAccountId: number, publicationType: PublicationType, name: string): Promise<PublicationModel> {
        let url_ = this.baseUrl + "/publication/add?";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined and cannot be null.");
        else
            url_ += "CustomerAccountId=" + encodeURIComponent("" + customerAccountId) + "&"; 
        if (publicationType === undefined || publicationType === null)
            throw new Error("The parameter 'publicationType' must be defined and cannot be null.");
        else
            url_ += "publicationType=" + encodeURIComponent("" + publicationType) + "&"; 
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined and cannot be null.");
        else
            url_ += "Name=" + encodeURIComponent("" + name) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAddPublication(_response);
        });
    }

    protected processAddPublication(response: AxiosResponse): Promise<PublicationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PublicationModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicationModel>(<any>null);
    }
}

export interface IPublicationCSSClient {
    /**
     * Get CSS for a publication.
     * @return OK
     */
    getPublicationCSS(publicationId: number): Promise<PublicationCSSModel>;
    /**
     * Save CSS for a publication.
     * @return OK
     */
    savePublicationCSS(cSS: PublicationCSSModel): Promise<PublicationCSSModel>;
}

export class PublicationCSSClient implements IPublicationCSSClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Get CSS for a publication.
     * @return OK
     */
    getPublicationCSS(publicationId: number): Promise<PublicationCSSModel> {
        let url_ = this.baseUrl + "/publicationcss?";
        if (publicationId === undefined || publicationId === null)
            throw new Error("The parameter 'publicationId' must be defined and cannot be null.");
        else
            url_ += "publicationId=" + encodeURIComponent("" + publicationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPublicationCSS(_response);
        });
    }

    protected processGetPublicationCSS(response: AxiosResponse): Promise<PublicationCSSModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PublicationCSSModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicationCSSModel>(<any>null);
    }

    /**
     * Save CSS for a publication.
     * @return OK
     */
    savePublicationCSS(cSS: PublicationCSSModel): Promise<PublicationCSSModel> {
        let url_ = this.baseUrl + "/publicationcss";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cSS);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSavePublicationCSS(_response);
        });
    }

    protected processSavePublicationCSS(response: AxiosResponse): Promise<PublicationCSSModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PublicationCSSModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicationCSSModel>(<any>null);
    }
}

export interface IPublicationDropboxClient {
    /**
     * Get dropbox config for a publication.
     * @return OK
     */
    getPublicationDropboxConfiguration(publicationId: number): Promise<DropboxConfigurationModel>;
    /**
     * Save dropbox config for a publication.
     * @return OK
     */
    savePublicationDropboxConfiguration(config: DropboxConfigurationModel): Promise<DropboxConfigurationModel>;
    /**
     * return a list of files found using the save dropbox configuration.
     * @return OK
     */
    getPublicationDropboxFiles(publicationId: number): Promise<string[]>;
}

export class PublicationDropboxClient implements IPublicationDropboxClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Get dropbox config for a publication.
     * @return OK
     */
    getPublicationDropboxConfiguration(publicationId: number): Promise<DropboxConfigurationModel> {
        let url_ = this.baseUrl + "/publicationdropbox?";
        if (publicationId === undefined || publicationId === null)
            throw new Error("The parameter 'publicationId' must be defined and cannot be null.");
        else
            url_ += "publicationId=" + encodeURIComponent("" + publicationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPublicationDropboxConfiguration(_response);
        });
    }

    protected processGetPublicationDropboxConfiguration(response: AxiosResponse): Promise<DropboxConfigurationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DropboxConfigurationModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DropboxConfigurationModel>(<any>null);
    }

    /**
     * Save dropbox config for a publication.
     * @return OK
     */
    savePublicationDropboxConfiguration(config: DropboxConfigurationModel): Promise<DropboxConfigurationModel> {
        let url_ = this.baseUrl + "/publicationdropbox";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(config);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSavePublicationDropboxConfiguration(_response);
        });
    }

    protected processSavePublicationDropboxConfiguration(response: AxiosResponse): Promise<DropboxConfigurationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DropboxConfigurationModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DropboxConfigurationModel>(<any>null);
    }

    /**
     * return a list of files found using the save dropbox configuration.
     * @return OK
     */
    getPublicationDropboxFiles(publicationId: number): Promise<string[]> {
        let url_ = this.baseUrl + "/publicationdropbox/files?";
        if (publicationId === undefined || publicationId === null)
            throw new Error("The parameter 'publicationId' must be defined and cannot be null.");
        else
            url_ += "publicationId=" + encodeURIComponent("" + publicationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPublicationDropboxFiles(_response);
        });
    }

    protected processGetPublicationDropboxFiles(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(<any>null);
    }
}

export interface IPublicationFeatureClient {
    /**
     * Update the feature group to or from premium.
     * @param publicationId The publication to update
     * @param featureGroup The feature group to change to.
     * @return OK
     */
    update(publicationId: number, featureGroup: FeatureGroup): Promise<any>;
}

export class PublicationFeatureClient implements IPublicationFeatureClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Update the feature group to or from premium.
     * @param publicationId The publication to update
     * @param featureGroup The feature group to change to.
     * @return OK
     */
    update(publicationId: number, featureGroup: FeatureGroup): Promise<any> {
        let url_ = this.baseUrl + "/api/PublicationFeature?";
        if (publicationId === undefined || publicationId === null)
            throw new Error("The parameter 'publicationId' must be defined and cannot be null.");
        else
            url_ += "publicationId=" + encodeURIComponent("" + publicationId) + "&"; 
        if (featureGroup === undefined || featureGroup === null)
            throw new Error("The parameter 'featureGroup' must be defined and cannot be null.");
        else
            url_ += "featureGroup=" + encodeURIComponent("" + featureGroup) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }
}

export interface IPublicationIconClient {
    /**
     * Save a PNG icon for the given title.
     * @param publicationId The url to save the icon for
     * @param publicationIcon the icon type
     * @param base64image base64 string of png icon
     * @return OK
     */
    saveImage(publicationId: number, publicationIcon: PublicationIcon, base64image: string): Promise<string[]>;
}

export class PublicationIconClient implements IPublicationIconClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Save a PNG icon for the given title.
     * @param publicationId The url to save the icon for
     * @param publicationIcon the icon type
     * @param base64image base64 string of png icon
     * @return OK
     */
    saveImage(publicationId: number, publicationIcon: PublicationIcon, base64image: string): Promise<string[]> {
        let url_ = this.baseUrl + "/publicationicons?";
        if (publicationId === undefined || publicationId === null)
            throw new Error("The parameter 'publicationId' must be defined and cannot be null.");
        else
            url_ += "publicationId=" + encodeURIComponent("" + publicationId) + "&"; 
        if (publicationIcon === undefined || publicationIcon === null)
            throw new Error("The parameter 'publicationIcon' must be defined and cannot be null.");
        else
            url_ += "publicationIcon=" + encodeURIComponent("" + publicationIcon) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(base64image);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveImage(_response);
        });
    }

    protected processSaveImage(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(<any>null);
    }
}

export interface IPublicationImageClient {
    /**
     * Save a image for the given title.
     * @param publicationId The title to save the image for
     * @param imageType the image type
     * @param base64image base64 string of png icon
     * @return OK
     */
    saveImage(publicationId: number, imageType: ImageType2, base64image: string): Promise<string[]>;
}

export class PublicationImageClient implements IPublicationImageClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Save a image for the given title.
     * @param publicationId The title to save the image for
     * @param imageType the image type
     * @param base64image base64 string of png icon
     * @return OK
     */
    saveImage(publicationId: number, imageType: ImageType2, base64image: string): Promise<string[]> {
        let url_ = this.baseUrl + "/publicationimage?";
        if (publicationId === undefined || publicationId === null)
            throw new Error("The parameter 'publicationId' must be defined and cannot be null.");
        else
            url_ += "publicationId=" + encodeURIComponent("" + publicationId) + "&"; 
        if (imageType === undefined || imageType === null)
            throw new Error("The parameter 'imageType' must be defined and cannot be null.");
        else
            url_ += "imageType=" + encodeURIComponent("" + imageType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(base64image);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveImage(_response);
        });
    }

    protected processSaveImage(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(<any>null);
    }
}

export interface IPublicationNotesClient {
    /**
     * Get notes for a publication.
     * @return OK
     */
    getPublicationNotes(publicationId: number): Promise<PublicationNotesModel>;
    /**
     * Save notes for a publication.
     * @return OK
     */
    savePublicationNotes(notes: PublicationNotesModel): Promise<PublicationNotesModel>;
}

export class PublicationNotesClient implements IPublicationNotesClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Get notes for a publication.
     * @return OK
     */
    getPublicationNotes(publicationId: number): Promise<PublicationNotesModel> {
        let url_ = this.baseUrl + "/publicationnotes?";
        if (publicationId === undefined || publicationId === null)
            throw new Error("The parameter 'publicationId' must be defined and cannot be null.");
        else
            url_ += "publicationId=" + encodeURIComponent("" + publicationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPublicationNotes(_response);
        });
    }

    protected processGetPublicationNotes(response: AxiosResponse): Promise<PublicationNotesModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PublicationNotesModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicationNotesModel>(<any>null);
    }

    /**
     * Save notes for a publication.
     * @return OK
     */
    savePublicationNotes(notes: PublicationNotesModel): Promise<PublicationNotesModel> {
        let url_ = this.baseUrl + "/publicationnotes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(notes);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSavePublicationNotes(_response);
        });
    }

    protected processSavePublicationNotes(response: AxiosResponse): Promise<PublicationNotesModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PublicationNotesModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicationNotesModel>(<any>null);
    }
}

export interface IPublicationOptionsClient {
    /**
     * Get Publication Options for a publication.
     * @return OK
     */
    getPublicationOptions(publicationId: number): Promise<PublicationOptionsModel>;
    /**
     * Save Publication OPtions for a publication.
     * @return OK
     */
    savePublicationOptions(publicationId: number, options: PublicationOptionsModel): Promise<PublicationOptionsModel>;
}

export class PublicationOptionsClient implements IPublicationOptionsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Get Publication Options for a publication.
     * @return OK
     */
    getPublicationOptions(publicationId: number): Promise<PublicationOptionsModel> {
        let url_ = this.baseUrl + "/publicationoptions?";
        if (publicationId === undefined || publicationId === null)
            throw new Error("The parameter 'publicationId' must be defined and cannot be null.");
        else
            url_ += "publicationId=" + encodeURIComponent("" + publicationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPublicationOptions(_response);
        });
    }

    protected processGetPublicationOptions(response: AxiosResponse): Promise<PublicationOptionsModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PublicationOptionsModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicationOptionsModel>(<any>null);
    }

    /**
     * Save Publication OPtions for a publication.
     * @return OK
     */
    savePublicationOptions(publicationId: number, options: PublicationOptionsModel): Promise<PublicationOptionsModel> {
        let url_ = this.baseUrl + "/publicationoptions?";
        if (publicationId === undefined || publicationId === null)
            throw new Error("The parameter 'publicationId' must be defined and cannot be null.");
        else
            url_ += "publicationId=" + encodeURIComponent("" + publicationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSavePublicationOptions(_response);
        });
    }

    protected processSavePublicationOptions(response: AxiosResponse): Promise<PublicationOptionsModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PublicationOptionsModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicationOptionsModel>(<any>null);
    }
}

export interface IPublishClient {
    /**
     * publish url.json for the give url.
     * @return OK
     */
    publishUrl(customerUrlId: number): Promise<any>;
    /**
     * publishes article / summary / links and update search index for an issue
    will not update url.json.
    removes content if issue.visibility = 0
     * @return OK
     */
    publishIssueContent(issueId: number): Promise<any>;
    /**
     * Publish/Unpublish all issues for a publication.
     * @return OK
     */
    publishPublicationIssues(publicationId: number, liveStatus: LiveStatus): Promise<any>;
    /**
     * republish content for all issues in this title.
     * @return OK
     */
    republishAllIssues(publicationId: number): Promise<any>;
    /**
     * Publish CSS for a publication.
     * @return OK
     */
    publishPublicationCSS(publicationId: number): Promise<PublicationCSSModel>;
    /**
     * publish the issues CSS for use in viewer.
    It combines the user-editable IssueCss with any article CSS set in extract/manage articles.
     * @return No Content
     */
    publishIssueCSS(issueId: number): Promise<void>;
}

export class PublishClient implements IPublishClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * publish url.json for the give url.
     * @return OK
     */
    publishUrl(customerUrlId: number): Promise<any> {
        let url_ = this.baseUrl + "/publish/url?";
        if (customerUrlId === undefined || customerUrlId === null)
            throw new Error("The parameter 'customerUrlId' must be defined and cannot be null.");
        else
            url_ += "customerUrlId=" + encodeURIComponent("" + customerUrlId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPublishUrl(_response);
        });
    }

    protected processPublishUrl(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * publishes article / summary / links and update search index for an issue
    will not update url.json.
    removes content if issue.visibility = 0
     * @return OK
     */
    publishIssueContent(issueId: number): Promise<any> {
        let url_ = this.baseUrl + "/publish/issuecontent?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPublishIssueContent(_response);
        });
    }

    protected processPublishIssueContent(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Publish/Unpublish all issues for a publication.
     * @return OK
     */
    publishPublicationIssues(publicationId: number, liveStatus: LiveStatus): Promise<any> {
        let url_ = this.baseUrl + "/publish/publishpublicationissues?";
        if (publicationId === undefined || publicationId === null)
            throw new Error("The parameter 'publicationId' must be defined and cannot be null.");
        else
            url_ += "publicationId=" + encodeURIComponent("" + publicationId) + "&"; 
        if (liveStatus === undefined || liveStatus === null)
            throw new Error("The parameter 'liveStatus' must be defined and cannot be null.");
        else
            url_ += "liveStatus=" + encodeURIComponent("" + liveStatus) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPublishPublicationIssues(_response);
        });
    }

    protected processPublishPublicationIssues(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * republish content for all issues in this title.
     * @return OK
     */
    republishAllIssues(publicationId: number): Promise<any> {
        let url_ = this.baseUrl + "/publish/republishallissues?";
        if (publicationId === undefined || publicationId === null)
            throw new Error("The parameter 'publicationId' must be defined and cannot be null.");
        else
            url_ += "publicationId=" + encodeURIComponent("" + publicationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRepublishAllIssues(_response);
        });
    }

    protected processRepublishAllIssues(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Publish CSS for a publication.
     * @return OK
     */
    publishPublicationCSS(publicationId: number): Promise<PublicationCSSModel> {
        let url_ = this.baseUrl + "/publish/publicationcss?";
        if (publicationId === undefined || publicationId === null)
            throw new Error("The parameter 'publicationId' must be defined and cannot be null.");
        else
            url_ += "publicationId=" + encodeURIComponent("" + publicationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPublishPublicationCSS(_response);
        });
    }

    protected processPublishPublicationCSS(response: AxiosResponse): Promise<PublicationCSSModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PublicationCSSModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicationCSSModel>(<any>null);
    }

    /**
     * publish the issues CSS for use in viewer.
    It combines the user-editable IssueCss with any article CSS set in extract/manage articles.
     * @return No Content
     */
    publishIssueCSS(issueId: number): Promise<void> {
        let url_ = this.baseUrl + "/publish/issuecss?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "IssueId=" + encodeURIComponent("" + issueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPublishIssueCSS(_response);
        });
    }

    protected processPublishIssueCSS(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export interface IRedirectUrlClient {
    /**
     * get the redirects for the given url.
     * @return OK
     */
    getRedirectUrl(customerUrlId: number): Promise<RedirectUrlModel[]>;
    /**
     * Add a redirect 301, to the given url.
     * @return OK
     */
    addRedirectUrl(redirect: RedirectUrlModel): Promise<RedirectUrlModel>;
    /**
     * remove a redirect from the system.
     * @return OK
     */
    deleteRedirectUrl(redirect: RedirectUrlModel): Promise<any>;
}

export class RedirectUrlClient implements IRedirectUrlClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * get the redirects for the given url.
     * @return OK
     */
    getRedirectUrl(customerUrlId: number): Promise<RedirectUrlModel[]> {
        let url_ = this.baseUrl + "/api/RedirectUrl?";
        if (customerUrlId === undefined || customerUrlId === null)
            throw new Error("The parameter 'customerUrlId' must be defined and cannot be null.");
        else
            url_ += "customerUrlId=" + encodeURIComponent("" + customerUrlId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetRedirectUrl(_response);
        });
    }

    protected processGetRedirectUrl(response: AxiosResponse): Promise<RedirectUrlModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RedirectUrlModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RedirectUrlModel[]>(<any>null);
    }

    /**
     * Add a redirect 301, to the given url.
     * @return OK
     */
    addRedirectUrl(redirect: RedirectUrlModel): Promise<RedirectUrlModel> {
        let url_ = this.baseUrl + "/api/RedirectUrl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(redirect);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAddRedirectUrl(_response);
        });
    }

    protected processAddRedirectUrl(response: AxiosResponse): Promise<RedirectUrlModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RedirectUrlModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RedirectUrlModel>(<any>null);
    }

    /**
     * remove a redirect from the system.
     * @return OK
     */
    deleteRedirectUrl(redirect: RedirectUrlModel): Promise<any> {
        let url_ = this.baseUrl + "/api/RedirectUrl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(redirect);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteRedirectUrl(_response);
        });
    }

    protected processDeleteRedirectUrl(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }
}

export interface IScheduledLiveTaskClient {
    /**
     * Get tasks for a publication.
     * @return OK
     */
    getScheduledLiveTasks(publicationId: number): Promise<ScheduledLiveTaskDTO[]>;
    /**
     * Save task for a publication.
     * @return OK
     */
    saveScheduledLiveTask(task: ScheduledLiveTaskDTO): Promise<ScheduledLiveTaskDTO>;
    /**
     * delete task for a publication.
     * @return OK
     */
    deleteScheduledLiveTask(scheduledLiveTask: ScheduledLiveTaskDTO): Promise<any>;
}

export class ScheduledLiveTaskClient implements IScheduledLiveTaskClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Get tasks for a publication.
     * @return OK
     */
    getScheduledLiveTasks(publicationId: number): Promise<ScheduledLiveTaskDTO[]> {
        let url_ = this.baseUrl + "/scheduledlivetask?";
        if (publicationId === undefined || publicationId === null)
            throw new Error("The parameter 'publicationId' must be defined and cannot be null.");
        else
            url_ += "publicationId=" + encodeURIComponent("" + publicationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetScheduledLiveTasks(_response);
        });
    }

    protected processGetScheduledLiveTasks(response: AxiosResponse): Promise<ScheduledLiveTaskDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScheduledLiveTaskDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScheduledLiveTaskDTO[]>(<any>null);
    }

    /**
     * Save task for a publication.
     * @return OK
     */
    saveScheduledLiveTask(task: ScheduledLiveTaskDTO): Promise<ScheduledLiveTaskDTO> {
        let url_ = this.baseUrl + "/scheduledlivetask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(task);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveScheduledLiveTask(_response);
        });
    }

    protected processSaveScheduledLiveTask(response: AxiosResponse): Promise<ScheduledLiveTaskDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ScheduledLiveTaskDTO.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScheduledLiveTaskDTO>(<any>null);
    }

    /**
     * delete task for a publication.
     * @return OK
     */
    deleteScheduledLiveTask(scheduledLiveTask: ScheduledLiveTaskDTO): Promise<any> {
        let url_ = this.baseUrl + "/scheduledlivetask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(scheduledLiveTask);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteScheduledLiveTask(_response);
        });
    }

    protected processDeleteScheduledLiveTask(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }
}

export interface ISearchClient {
    /**
     * Seaarch account / url / publication / issues for the given query
     * @return OK
     */
    searchDomain(query: string): Promise<ListItemDTO[]>;
    /**
     * search publications
     * @return OK
     */
    searchPublication(query: string): Promise<ListItemDTO[]>;
    /**
     * search issues.
     * @return OK
     */
    searchIssue(query: string): Promise<ListItemDTO[]>;
}

export class SearchClient implements ISearchClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Seaarch account / url / publication / issues for the given query
     * @return OK
     */
    searchDomain(query: string): Promise<ListItemDTO[]> {
        let url_ = this.baseUrl + "/search/domain?";
        if (query === undefined || query === null)
            throw new Error("The parameter 'query' must be defined and cannot be null.");
        else
            url_ += "query=" + encodeURIComponent("" + query) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSearchDomain(_response);
        });
    }

    protected processSearchDomain(response: AxiosResponse): Promise<ListItemDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ListItemDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListItemDTO[]>(<any>null);
    }

    /**
     * search publications
     * @return OK
     */
    searchPublication(query: string): Promise<ListItemDTO[]> {
        let url_ = this.baseUrl + "/search/publication?";
        if (query === undefined || query === null)
            throw new Error("The parameter 'query' must be defined and cannot be null.");
        else
            url_ += "query=" + encodeURIComponent("" + query) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSearchPublication(_response);
        });
    }

    protected processSearchPublication(response: AxiosResponse): Promise<ListItemDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ListItemDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListItemDTO[]>(<any>null);
    }

    /**
     * search issues.
     * @return OK
     */
    searchIssue(query: string): Promise<ListItemDTO[]> {
        let url_ = this.baseUrl + "/search/issue?";
        if (query === undefined || query === null)
            throw new Error("The parameter 'query' must be defined and cannot be null.");
        else
            url_ += "query=" + encodeURIComponent("" + query) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSearchIssue(_response);
        });
    }

    protected processSearchIssue(response: AxiosResponse): Promise<ListItemDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ListItemDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListItemDTO[]>(<any>null);
    }
}

export interface ISectionClient {
    /**
     * Get a list of sections for the given publication.
     * @param publicationId Publication to get section for.
     * @return OK
     */
    getSectionsForPublication(publicationId: number): Promise<SectionModel[]>;
    /**
     * Adds a new section to the publication
     * @param section section to add.
     * @return OK
     */
    addSection(section: SectionModel): Promise<SectionModel>;
    /**
     * Delete a section.
     * @param id id of the section to delete.
     * @return OK
     */
    deleteSection(id: number): Promise<any>;
    /**
     * rename a section
     * @return OK
     */
    renameSection(sectionId: number, newName: string): Promise<any>;
    /**
     * change the order of a section
     * @return OK
     */
    reorderSection(sectionId: number, order: number): Promise<any>;
    /**
     * change color of section
     * @return OK
     */
    changeSectionColor(sectionId: number, color: string): Promise<any>;
    /**
     * update a section.
     * @return OK
     */
    updateSection(section: SectionModel): Promise<SectionModel>;
}

export class SectionClient implements ISectionClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Get a list of sections for the given publication.
     * @param publicationId Publication to get section for.
     * @return OK
     */
    getSectionsForPublication(publicationId: number): Promise<SectionModel[]> {
        let url_ = this.baseUrl + "/section/sections?";
        if (publicationId === undefined || publicationId === null)
            throw new Error("The parameter 'publicationId' must be defined and cannot be null.");
        else
            url_ += "publicationId=" + encodeURIComponent("" + publicationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetSectionsForPublication(_response);
        });
    }

    protected processGetSectionsForPublication(response: AxiosResponse): Promise<SectionModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SectionModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SectionModel[]>(<any>null);
    }

    /**
     * Adds a new section to the publication
     * @param section section to add.
     * @return OK
     */
    addSection(section: SectionModel): Promise<SectionModel> {
        let url_ = this.baseUrl + "/section";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(section);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAddSection(_response);
        });
    }

    protected processAddSection(response: AxiosResponse): Promise<SectionModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SectionModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SectionModel>(<any>null);
    }

    /**
     * Delete a section.
     * @param id id of the section to delete.
     * @return OK
     */
    deleteSection(id: number): Promise<any> {
        let url_ = this.baseUrl + "/section?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteSection(_response);
        });
    }

    protected processDeleteSection(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * rename a section
     * @return OK
     */
    renameSection(sectionId: number, newName: string): Promise<any> {
        let url_ = this.baseUrl + "/section/rename?";
        if (sectionId === undefined || sectionId === null)
            throw new Error("The parameter 'sectionId' must be defined and cannot be null.");
        else
            url_ += "sectionId=" + encodeURIComponent("" + sectionId) + "&"; 
        if (newName === undefined || newName === null)
            throw new Error("The parameter 'newName' must be defined and cannot be null.");
        else
            url_ += "newName=" + encodeURIComponent("" + newName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRenameSection(_response);
        });
    }

    protected processRenameSection(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * change the order of a section
     * @return OK
     */
    reorderSection(sectionId: number, order: number): Promise<any> {
        let url_ = this.baseUrl + "/section/reorder?";
        if (sectionId === undefined || sectionId === null)
            throw new Error("The parameter 'sectionId' must be defined and cannot be null.");
        else
            url_ += "sectionId=" + encodeURIComponent("" + sectionId) + "&"; 
        if (order === undefined || order === null)
            throw new Error("The parameter 'order' must be defined and cannot be null.");
        else
            url_ += "order=" + encodeURIComponent("" + order) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processReorderSection(_response);
        });
    }

    protected processReorderSection(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * change color of section
     * @return OK
     */
    changeSectionColor(sectionId: number, color: string): Promise<any> {
        let url_ = this.baseUrl + "/section/color?";
        if (sectionId === undefined || sectionId === null)
            throw new Error("The parameter 'sectionId' must be defined and cannot be null.");
        else
            url_ += "sectionId=" + encodeURIComponent("" + sectionId) + "&"; 
        if (color === undefined || color === null)
            throw new Error("The parameter 'color' must be defined and cannot be null.");
        else
            url_ += "color=" + encodeURIComponent("" + color) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processChangeSectionColor(_response);
        });
    }

    protected processChangeSectionColor(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * update a section.
     * @return OK
     */
    updateSection(section: SectionModel): Promise<SectionModel> {
        let url_ = this.baseUrl + "/section/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(section);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateSection(_response);
        });
    }

    protected processUpdateSection(response: AxiosResponse): Promise<SectionModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SectionModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SectionModel>(<any>null);
    }
}

export interface IShoppingCartClient {
    /**
     * Add article to shopping cart.
     * @return OK
     */
    addArticleToCart(customerAccountId: number, articleId: string): Promise<ShoppingCartDTO>;
    /**
     * Remove article from shopping cart.
     * @return OK
     */
    removeArticleFromCart(customerAccountId: number, articleId: string): Promise<ShoppingCartDTO>;
    /**
     * Get the shopping cart.
     * @return OK
     */
    getCart(customerAccountId: number): Promise<ShoppingCartDTO>;
    /**
     * Clear the shopping cart.
     * @return OK
     */
    clearCart(customerAccountId: number): Promise<any>;
    /**
     * get a history of payments for this account.
     * @return OK
     */
    getCarts(customerAccountId: number): Promise<ShoppingCartDTO[]>;
    /**
     * purchase items in cart.
     * @return OK
     */
    checkout(customerAccountId: number): Promise<ChargebeePaymentDTO>;
}

export class ShoppingCartClient implements IShoppingCartClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Add article to shopping cart.
     * @return OK
     */
    addArticleToCart(customerAccountId: number, articleId: string): Promise<ShoppingCartDTO> {
        let url_ = this.baseUrl + "/shoppingcart/item?";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined and cannot be null.");
        else
            url_ += "CustomerAccountId=" + encodeURIComponent("" + customerAccountId) + "&"; 
        if (articleId === undefined || articleId === null)
            throw new Error("The parameter 'articleId' must be defined and cannot be null.");
        else
            url_ += "ArticleId=" + encodeURIComponent("" + articleId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAddArticleToCart(_response);
        });
    }

    protected processAddArticleToCart(response: AxiosResponse): Promise<ShoppingCartDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ShoppingCartDTO.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShoppingCartDTO>(<any>null);
    }

    /**
     * Remove article from shopping cart.
     * @return OK
     */
    removeArticleFromCart(customerAccountId: number, articleId: string): Promise<ShoppingCartDTO> {
        let url_ = this.baseUrl + "/shoppingcart/item?";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined and cannot be null.");
        else
            url_ += "CustomerAccountId=" + encodeURIComponent("" + customerAccountId) + "&"; 
        if (articleId === undefined || articleId === null)
            throw new Error("The parameter 'articleId' must be defined and cannot be null.");
        else
            url_ += "ArticleId=" + encodeURIComponent("" + articleId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRemoveArticleFromCart(_response);
        });
    }

    protected processRemoveArticleFromCart(response: AxiosResponse): Promise<ShoppingCartDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ShoppingCartDTO.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShoppingCartDTO>(<any>null);
    }

    /**
     * Get the shopping cart.
     * @return OK
     */
    getCart(customerAccountId: number): Promise<ShoppingCartDTO> {
        let url_ = this.baseUrl + "/shoppingcart?";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined and cannot be null.");
        else
            url_ += "CustomerAccountId=" + encodeURIComponent("" + customerAccountId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetCart(_response);
        });
    }

    protected processGetCart(response: AxiosResponse): Promise<ShoppingCartDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ShoppingCartDTO.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShoppingCartDTO>(<any>null);
    }

    /**
     * Clear the shopping cart.
     * @return OK
     */
    clearCart(customerAccountId: number): Promise<any> {
        let url_ = this.baseUrl + "/shoppingcart?";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined and cannot be null.");
        else
            url_ += "CustomerAccountId=" + encodeURIComponent("" + customerAccountId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processClearCart(_response);
        });
    }

    protected processClearCart(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * get a history of payments for this account.
     * @return OK
     */
    getCarts(customerAccountId: number): Promise<ShoppingCartDTO[]> {
        let url_ = this.baseUrl + "/shoppingcart/history?";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined and cannot be null.");
        else
            url_ += "CustomerAccountId=" + encodeURIComponent("" + customerAccountId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetCarts(_response);
        });
    }

    protected processGetCarts(response: AxiosResponse): Promise<ShoppingCartDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShoppingCartDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShoppingCartDTO[]>(<any>null);
    }

    /**
     * purchase items in cart.
     * @return OK
     */
    checkout(customerAccountId: number): Promise<ChargebeePaymentDTO> {
        let url_ = this.baseUrl + "/shoppingcart/checkout?";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined and cannot be null.");
        else
            url_ += "CustomerAccountId=" + encodeURIComponent("" + customerAccountId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCheckout(_response);
        });
    }

    protected processCheckout(response: AxiosResponse): Promise<ChargebeePaymentDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChargebeePaymentDTO.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChargebeePaymentDTO>(<any>null);
    }
}

export interface ISocialConfigurationClient {
    /**
     * Get socialConfiguration config for a publication.
     * @return OK
     */
    getSocialConfigurationConfiguration(publicationId: number): Promise<SocialConfigurationModel>;
    /**
     * Save socialConfiguration config for a publication.
     * @return OK
     */
    saveSocialConfigurationConfiguration(config: SocialConfigurationModel): Promise<SocialConfigurationModel>;
}

export class SocialConfigurationClient implements ISocialConfigurationClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Get socialConfiguration config for a publication.
     * @return OK
     */
    getSocialConfigurationConfiguration(publicationId: number): Promise<SocialConfigurationModel> {
        let url_ = this.baseUrl + "/socialconfiguration?";
        if (publicationId === undefined || publicationId === null)
            throw new Error("The parameter 'publicationId' must be defined and cannot be null.");
        else
            url_ += "publicationId=" + encodeURIComponent("" + publicationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetSocialConfigurationConfiguration(_response);
        });
    }

    protected processGetSocialConfigurationConfiguration(response: AxiosResponse): Promise<SocialConfigurationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SocialConfigurationModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SocialConfigurationModel>(<any>null);
    }

    /**
     * Save socialConfiguration config for a publication.
     * @return OK
     */
    saveSocialConfigurationConfiguration(config: SocialConfigurationModel): Promise<SocialConfigurationModel> {
        let url_ = this.baseUrl + "/socialconfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(config);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveSocialConfigurationConfiguration(_response);
        });
    }

    protected processSaveSocialConfigurationConfiguration(response: AxiosResponse): Promise<SocialConfigurationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SocialConfigurationModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SocialConfigurationModel>(<any>null);
    }
}

export interface IStartPageClient {
    /**
     * return data for start page
     * @return OK
     */
    getStartPageData(customerAccountId: number): Promise<StartPageData>;
}

export class StartPageClient implements IStartPageClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * return data for start page
     * @return OK
     */
    getStartPageData(customerAccountId: number): Promise<StartPageData> {
        let url_ = this.baseUrl + "/startpage?";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined and cannot be null.");
        else
            url_ += "customerAccountId=" + encodeURIComponent("" + customerAccountId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetStartPageData(_response);
        });
    }

    protected processGetStartPageData(response: AxiosResponse): Promise<StartPageData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StartPageData.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StartPageData>(<any>null);
    }
}

export interface IStreamOwnerPaymentClient {
    /**
     * get all article owner payments that have not been batched.
     * @return OK
     */
    getOutstanding(): Promise<ArticleOwnerPaymentDTO[]>;
    /**
     * get months with outstanding owner payments
     * @return OK
     */
    getAvailableBatches(): Promise<string[]>;
    /**
     * get all created batches
     * @return OK
     */
    getBatches(): Promise<ContentStreamArticleOwnerBatchDTO[]>;
    /**
     * get details for a given batch
     * @return OK
     */
    getBatch(id: number): Promise<ContentStreamArticleOwnerBatchItemDTO[]>;
    /**
     * pay owners via hyperwallet
     * @return OK
     */
    payBatch(batchId: number): Promise<any>;
    /**
     * Create a payment batch for the given month.
     * @return OK
     */
    createBatch(batchmonth: string): Promise<any>;
    /**
     * get article owner payments for this account.
     * @return OK
     */
    getAccountPayments(customerAccountId: number): Promise<OwnerPaymentDTO[]>;
}

export class StreamOwnerPaymentClient implements IStreamOwnerPaymentClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * get all article owner payments that have not been batched.
     * @return OK
     */
    getOutstanding(): Promise<ArticleOwnerPaymentDTO[]> {
        let url_ = this.baseUrl + "/streamownerpayment/outstanding";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetOutstanding(_response);
        });
    }

    protected processGetOutstanding(response: AxiosResponse): Promise<ArticleOwnerPaymentDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ArticleOwnerPaymentDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ArticleOwnerPaymentDTO[]>(<any>null);
    }

    /**
     * get months with outstanding owner payments
     * @return OK
     */
    getAvailableBatches(): Promise<string[]> {
        let url_ = this.baseUrl + "/streamownerpayment/avaiablebatches";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAvailableBatches(_response);
        });
    }

    protected processGetAvailableBatches(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(<any>null);
    }

    /**
     * get all created batches
     * @return OK
     */
    getBatches(): Promise<ContentStreamArticleOwnerBatchDTO[]> {
        let url_ = this.baseUrl + "/streamownerpayment/batches";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetBatches(_response);
        });
    }

    protected processGetBatches(response: AxiosResponse): Promise<ContentStreamArticleOwnerBatchDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContentStreamArticleOwnerBatchDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContentStreamArticleOwnerBatchDTO[]>(<any>null);
    }

    /**
     * get details for a given batch
     * @return OK
     */
    getBatch(id: number): Promise<ContentStreamArticleOwnerBatchItemDTO[]> {
        let url_ = this.baseUrl + "/streamownerpayment/batch?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetBatch(_response);
        });
    }

    protected processGetBatch(response: AxiosResponse): Promise<ContentStreamArticleOwnerBatchItemDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContentStreamArticleOwnerBatchItemDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContentStreamArticleOwnerBatchItemDTO[]>(<any>null);
    }

    /**
     * pay owners via hyperwallet
     * @return OK
     */
    payBatch(batchId: number): Promise<any> {
        let url_ = this.baseUrl + "/streamownerpayment/paybatch?";
        if (batchId === undefined || batchId === null)
            throw new Error("The parameter 'batchId' must be defined and cannot be null.");
        else
            url_ += "BatchId=" + encodeURIComponent("" + batchId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPayBatch(_response);
        });
    }

    protected processPayBatch(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Create a payment batch for the given month.
     * @return OK
     */
    createBatch(batchmonth: string): Promise<any> {
        let url_ = this.baseUrl + "/streamownerpayment/createbatch?";
        if (batchmonth === undefined || batchmonth === null)
            throw new Error("The parameter 'batchmonth' must be defined and cannot be null.");
        else
            url_ += "batchmonth=" + encodeURIComponent("" + batchmonth) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateBatch(_response);
        });
    }

    protected processCreateBatch(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * get article owner payments for this account.
     * @return OK
     */
    getAccountPayments(customerAccountId: number): Promise<OwnerPaymentDTO[]> {
        let url_ = this.baseUrl + "/streamownerpayment/account?";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined and cannot be null.");
        else
            url_ += "CustomerAccountId=" + encodeURIComponent("" + customerAccountId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAccountPayments(_response);
        });
    }

    protected processGetAccountPayments(response: AxiosResponse): Promise<OwnerPaymentDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OwnerPaymentDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OwnerPaymentDTO[]>(<any>null);
    }
}

export interface IStreamPaymentClient {
    /**
     * get a summary of active issues in streams.
     * @return OK
     */
    getActive(): Promise<StreamIssuePaymentDTO[]>;
    /**
     * get stream payments that are ready to be paid.
     * @return OK
     */
    getReadyForPaymanr(): Promise<StreamIssuePaymentDTO[]>;
    /**
     * @return OK
     */
    processActive(): Promise<StreamIssuePaymentDTO[]>;
    /**
     * send article owner payments that are ready to HW.
     * @return OK
     */
    processOwner(): Promise<number>;
    /**
     * send article owner payments that are ready to HW.
     * @return OK
     */
    processCurator(): Promise<number>;
    /**
     * Get article curation payments that are ready to pay.
     * @return OK
     */
    getCuratorPayments(): Promise<StreamCuratorPaymentDTO[]>;
    /**
     * Get article owner payments that are ready to pay.
     * @return OK
     */
    getOwnerPayments(): Promise<StreamOwnerPaymentDTO[]>;
    /**
     * Get owner payments that are paid.
     * @return OK
     */
    getCompleteOwnerPayments(): Promise<StreamPaymentCompleteDTO[]>;
    /**
     * Get curator payments that are paid.
     * @return OK
     */
    getCompleteCuratorPayments(): Promise<StreamPaymentCompleteDTO[]>;
}

export class StreamPaymentClient implements IStreamPaymentClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * get a summary of active issues in streams.
     * @return OK
     */
    getActive(): Promise<StreamIssuePaymentDTO[]> {
        let url_ = this.baseUrl + "/streampayment/active";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetActive(_response);
        });
    }

    protected processGetActive(response: AxiosResponse): Promise<StreamIssuePaymentDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StreamIssuePaymentDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StreamIssuePaymentDTO[]>(<any>null);
    }

    /**
     * get stream payments that are ready to be paid.
     * @return OK
     */
    getReadyForPaymanr(): Promise<StreamIssuePaymentDTO[]> {
        let url_ = this.baseUrl + "/streampayment/ready";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetReadyForPaymanr(_response);
        });
    }

    protected processGetReadyForPaymanr(response: AxiosResponse): Promise<StreamIssuePaymentDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StreamIssuePaymentDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StreamIssuePaymentDTO[]>(<any>null);
    }

    /**
     * @return OK
     */
    processActive(): Promise<StreamIssuePaymentDTO[]> {
        let url_ = this.baseUrl + "/streampayment/processactive";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processProcessActive(_response);
        });
    }

    protected processProcessActive(response: AxiosResponse): Promise<StreamIssuePaymentDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StreamIssuePaymentDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StreamIssuePaymentDTO[]>(<any>null);
    }

    /**
     * send article owner payments that are ready to HW.
     * @return OK
     */
    processOwner(): Promise<number> {
        let url_ = this.baseUrl + "/streampayment/processowner";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processProcessOwner(_response);
        });
    }

    protected processProcessOwner(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(<any>null);
    }

    /**
     * send article owner payments that are ready to HW.
     * @return OK
     */
    processCurator(): Promise<number> {
        let url_ = this.baseUrl + "/streampayment/processcurator";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processProcessCurator(_response);
        });
    }

    protected processProcessCurator(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(<any>null);
    }

    /**
     * Get article curation payments that are ready to pay.
     * @return OK
     */
    getCuratorPayments(): Promise<StreamCuratorPaymentDTO[]> {
        let url_ = this.baseUrl + "/streampayment/curatorpayments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetCuratorPayments(_response);
        });
    }

    protected processGetCuratorPayments(response: AxiosResponse): Promise<StreamCuratorPaymentDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StreamCuratorPaymentDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StreamCuratorPaymentDTO[]>(<any>null);
    }

    /**
     * Get article owner payments that are ready to pay.
     * @return OK
     */
    getOwnerPayments(): Promise<StreamOwnerPaymentDTO[]> {
        let url_ = this.baseUrl + "/streampayment/ownerpayments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetOwnerPayments(_response);
        });
    }

    protected processGetOwnerPayments(response: AxiosResponse): Promise<StreamOwnerPaymentDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StreamOwnerPaymentDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StreamOwnerPaymentDTO[]>(<any>null);
    }

    /**
     * Get owner payments that are paid.
     * @return OK
     */
    getCompleteOwnerPayments(): Promise<StreamPaymentCompleteDTO[]> {
        let url_ = this.baseUrl + "/streampayment/completeownerpayments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetCompleteOwnerPayments(_response);
        });
    }

    protected processGetCompleteOwnerPayments(response: AxiosResponse): Promise<StreamPaymentCompleteDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StreamPaymentCompleteDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StreamPaymentCompleteDTO[]>(<any>null);
    }

    /**
     * Get curator payments that are paid.
     * @return OK
     */
    getCompleteCuratorPayments(): Promise<StreamPaymentCompleteDTO[]> {
        let url_ = this.baseUrl + "/streampayment/completecuratorpayments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetCompleteCuratorPayments(_response);
        });
    }

    protected processGetCompleteCuratorPayments(response: AxiosResponse): Promise<StreamPaymentCompleteDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StreamPaymentCompleteDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StreamPaymentCompleteDTO[]>(<any>null);
    }
}

export interface IStreamTailorPaymentClient {
    /**
     * get all article owner payments that have not been batched.
     * @return OK
     */
    getOutstanding(): Promise<IssueTailorPaymentDTO[]>;
    /**
     * get months with outstanding owner payments
     * @return OK
     */
    getAvailableBatches(): Promise<string[]>;
    /**
     * create payment batch for given month.
     * @return OK
     */
    createBatch(month: string): Promise<any>;
    /**
     * pay tailors via hyperwallet
     * @return OK
     */
    payBatch(batchId: number): Promise<any>;
    /**
     * get list of all created batches.
     * @return OK
     */
    getBatches(): Promise<ContentStreamIssueTailoringBatchDTO[]>;
    /**
     * get all payments fot the given batch.
     * @return OK
     */
    getBatch(id: number): Promise<ContentStreamIssueTailoringBatchItemDTO[]>;
    /**
     * get account tailoring payments.
     * @return OK
     */
    getAccountPayments(customerAccountId: number): Promise<TailoringPaymentDTO[]>;
}

export class StreamTailorPaymentClient implements IStreamTailorPaymentClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * get all article owner payments that have not been batched.
     * @return OK
     */
    getOutstanding(): Promise<IssueTailorPaymentDTO[]> {
        let url_ = this.baseUrl + "/streamtailorpayment/outstanding";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetOutstanding(_response);
        });
    }

    protected processGetOutstanding(response: AxiosResponse): Promise<IssueTailorPaymentDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IssueTailorPaymentDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueTailorPaymentDTO[]>(<any>null);
    }

    /**
     * get months with outstanding owner payments
     * @return OK
     */
    getAvailableBatches(): Promise<string[]> {
        let url_ = this.baseUrl + "/streamtailorpayment/avaiablebatches";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAvailableBatches(_response);
        });
    }

    protected processGetAvailableBatches(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(<any>null);
    }

    /**
     * create payment batch for given month.
     * @return OK
     */
    createBatch(month: string): Promise<any> {
        let url_ = this.baseUrl + "/streamtailorpayment/createbatch?";
        if (month === undefined || month === null)
            throw new Error("The parameter 'month' must be defined and cannot be null.");
        else
            url_ += "month=" + encodeURIComponent("" + month) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateBatch(_response);
        });
    }

    protected processCreateBatch(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * pay tailors via hyperwallet
     * @return OK
     */
    payBatch(batchId: number): Promise<any> {
        let url_ = this.baseUrl + "/streamtailorpayment/paybatch?";
        if (batchId === undefined || batchId === null)
            throw new Error("The parameter 'batchId' must be defined and cannot be null.");
        else
            url_ += "BatchId=" + encodeURIComponent("" + batchId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPayBatch(_response);
        });
    }

    protected processPayBatch(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * get list of all created batches.
     * @return OK
     */
    getBatches(): Promise<ContentStreamIssueTailoringBatchDTO[]> {
        let url_ = this.baseUrl + "/streamtailorpayment/batches";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetBatches(_response);
        });
    }

    protected processGetBatches(response: AxiosResponse): Promise<ContentStreamIssueTailoringBatchDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContentStreamIssueTailoringBatchDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContentStreamIssueTailoringBatchDTO[]>(<any>null);
    }

    /**
     * get all payments fot the given batch.
     * @return OK
     */
    getBatch(id: number): Promise<ContentStreamIssueTailoringBatchItemDTO[]> {
        let url_ = this.baseUrl + "/streamtailorpayment/batch?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetBatch(_response);
        });
    }

    protected processGetBatch(response: AxiosResponse): Promise<ContentStreamIssueTailoringBatchItemDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContentStreamIssueTailoringBatchItemDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContentStreamIssueTailoringBatchItemDTO[]>(<any>null);
    }

    /**
     * get account tailoring payments.
     * @return OK
     */
    getAccountPayments(customerAccountId: number): Promise<TailoringPaymentDTO[]> {
        let url_ = this.baseUrl + "/streamtailorpayment/account?";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined and cannot be null.");
        else
            url_ += "CustomerAccountId=" + encodeURIComponent("" + customerAccountId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAccountPayments(_response);
        });
    }

    protected processGetAccountPayments(response: AxiosResponse): Promise<TailoringPaymentDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TailoringPaymentDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TailoringPaymentDTO[]>(<any>null);
    }
}

export interface ISyndicationClient {
    /**
     * Move a list of articles to syndication proof. All articles must be of the same language and you must specify that language.
     * @return OK
     */
    moveToProof(articles: SyndicationArticleDto[], language: Language2): Promise<string[]>;
    /**
     * Reject a list of articles during syndication proof. All articles must be of the same language and you must specify that language.
     * @return OK
     */
    reject(articles: SyndicationArticleDto[], language: Language3): Promise<any>;
    /**
     * Move a list of articles to syndication. All articles must be of the same language and you must specify that language.
     * @return OK
     */
    moveToApproved(articles: SyndicationArticleDto[], language: Language4): Promise<string[]>;
}

export class SyndicationClient implements ISyndicationClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Move a list of articles to syndication proof. All articles must be of the same language and you must specify that language.
     * @return OK
     */
    moveToProof(articles: SyndicationArticleDto[], language: Language2): Promise<string[]> {
        let url_ = this.baseUrl + "/syndication/movetoproof?";
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(articles);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processMoveToProof(_response);
        });
    }

    protected processMoveToProof(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(<any>null);
    }

    /**
     * Reject a list of articles during syndication proof. All articles must be of the same language and you must specify that language.
     * @return OK
     */
    reject(articles: SyndicationArticleDto[], language: Language3): Promise<any> {
        let url_ = this.baseUrl + "/syndication/reject?";
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(articles);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processReject(_response);
        });
    }

    protected processReject(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Move a list of articles to syndication. All articles must be of the same language and you must specify that language.
     * @return OK
     */
    moveToApproved(articles: SyndicationArticleDto[], language: Language4): Promise<string[]> {
        let url_ = this.baseUrl + "/syndication/movetoapproved?";
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(articles);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processMoveToApproved(_response);
        });
    }

    protected processMoveToApproved(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(<any>null);
    }
}

export interface ISyndicationAccountConfigClient {
    /**
     * load an accounts syndication config.
     * @return OK
     */
    getSyndicationAccountConfig(accountId: number): Promise<SyndicationAccountConfigModel>;
    /**
     * save an accounts syndication config.
     * @return OK
     */
    saveSyndicationAccountConfig(config: SyndicationAccountConfigModel): Promise<SyndicationAccountConfigModel>;
}

export class SyndicationAccountConfigClient implements ISyndicationAccountConfigClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * load an accounts syndication config.
     * @return OK
     */
    getSyndicationAccountConfig(accountId: number): Promise<SyndicationAccountConfigModel> {
        let url_ = this.baseUrl + "/syndicationaccountconfig?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined and cannot be null.");
        else
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetSyndicationAccountConfig(_response);
        });
    }

    protected processGetSyndicationAccountConfig(response: AxiosResponse): Promise<SyndicationAccountConfigModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SyndicationAccountConfigModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SyndicationAccountConfigModel>(<any>null);
    }

    /**
     * save an accounts syndication config.
     * @return OK
     */
    saveSyndicationAccountConfig(config: SyndicationAccountConfigModel): Promise<SyndicationAccountConfigModel> {
        let url_ = this.baseUrl + "/syndicationaccountconfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(config);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveSyndicationAccountConfig(_response);
        });
    }

    protected processSaveSyndicationAccountConfig(response: AxiosResponse): Promise<SyndicationAccountConfigModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SyndicationAccountConfigModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SyndicationAccountConfigModel>(<any>null);
    }
}

export interface ISyndicationArticleClient {
    /**
     * Get a syndicated article.
     * @return OK
     */
    articleGet(articleId: string): Promise<ArticleModel>;
    /**
     * Update an article in syndication proof.
     * @return OK
     */
    saveArticle(article: ArticleModel): Promise<ArticleModel>;
    /**
     * Delete a syndicated article.
     * @param articleId article guid
     * @param removeFromCart (optional) remove this article from any cart
     * @return OK
     */
    deleteArticle(articleId: string, issueid: number, removeFromCart?: boolean | null | undefined): Promise<any>;
    /**
     * Get a syndicated article.
     * @return OK
     */
    getArticle(issueId: number, articleId: string): Promise<ArticleModel>;
    /**
     * Get a scrambled article for review.
     * @return OK
     */
    getArticleForPreview(issueId: number, articleId: string): Promise<ArticleModel>;
    /**
     * Get a scrambled article for review.
     * @return OK
     */
    getArticleForPreview2(issueId: number, articleId: number): Promise<ArticleModel>;
}

export class SyndicationArticleClient implements ISyndicationArticleClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Get a syndicated article.
     * @return OK
     */
    articleGet(articleId: string): Promise<ArticleModel> {
        let url_ = this.baseUrl + "/syndicationarticle?";
        if (articleId === undefined || articleId === null)
            throw new Error("The parameter 'articleId' must be defined and cannot be null.");
        else
            url_ += "articleId=" + encodeURIComponent("" + articleId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processArticleGet(_response);
        });
    }

    protected processArticleGet(response: AxiosResponse): Promise<ArticleModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ArticleModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ArticleModel>(<any>null);
    }

    /**
     * Update an article in syndication proof.
     * @return OK
     */
    saveArticle(article: ArticleModel): Promise<ArticleModel> {
        let url_ = this.baseUrl + "/syndicationarticle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(article);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveArticle(_response);
        });
    }

    protected processSaveArticle(response: AxiosResponse): Promise<ArticleModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ArticleModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ArticleModel>(<any>null);
    }

    /**
     * Delete a syndicated article.
     * @param articleId article guid
     * @param removeFromCart (optional) remove this article from any cart
     * @return OK
     */
    deleteArticle(articleId: string, issueid: number, removeFromCart?: boolean | null | undefined): Promise<any> {
        let url_ = this.baseUrl + "/syndicationarticle?";
        if (articleId === undefined || articleId === null)
            throw new Error("The parameter 'articleId' must be defined and cannot be null.");
        else
            url_ += "articleId=" + encodeURIComponent("" + articleId) + "&"; 
        if (issueid === undefined || issueid === null)
            throw new Error("The parameter 'issueid' must be defined and cannot be null.");
        else
            url_ += "issueid=" + encodeURIComponent("" + issueid) + "&"; 
        if (removeFromCart !== undefined)
            url_ += "removeFromCart=" + encodeURIComponent("" + removeFromCart) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteArticle(_response);
        });
    }

    protected processDeleteArticle(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Get a syndicated article.
     * @return OK
     */
    getArticle(issueId: number, articleId: string): Promise<ArticleModel> {
        let url_ = this.baseUrl + "/syndicationarticle/article?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        if (articleId === undefined || articleId === null)
            throw new Error("The parameter 'articleId' must be defined and cannot be null.");
        else
            url_ += "articleId=" + encodeURIComponent("" + articleId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetArticle(_response);
        });
    }

    protected processGetArticle(response: AxiosResponse): Promise<ArticleModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ArticleModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ArticleModel>(<any>null);
    }

    /**
     * Get a scrambled article for review.
     * @return OK
     */
    getArticleForPreview(issueId: number, articleId: string): Promise<ArticleModel> {
        let url_ = this.baseUrl + "/syndicationarticle/preview?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        if (articleId === undefined || articleId === null)
            throw new Error("The parameter 'articleId' must be defined and cannot be null.");
        else
            url_ += "articleId=" + encodeURIComponent("" + articleId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetArticleForPreview(_response);
        });
    }

    protected processGetArticleForPreview(response: AxiosResponse): Promise<ArticleModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ArticleModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ArticleModel>(<any>null);
    }

    /**
     * Get a scrambled article for review.
     * @return OK
     */
    getArticleForPreview2(issueId: number, articleId: number): Promise<ArticleModel> {
        let url_ = this.baseUrl + "/syndicationarticle/preview2?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        if (articleId === undefined || articleId === null)
            throw new Error("The parameter 'articleId' must be defined and cannot be null.");
        else
            url_ += "articleId=" + encodeURIComponent("" + articleId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetArticleForPreview2(_response);
        });
    }

    protected processGetArticleForPreview2(response: AxiosResponse): Promise<ArticleModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ArticleModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ArticleModel>(<any>null);
    }
}

export interface ISyndicationTitleConfigClient {
    /**
     * load a titles syndication config.
     * @return OK
     */
    getSyndicationTitleConfig(titleId: number): Promise<SyndicationTitleConfigModel>;
    /**
     * save a titles syndication config.
     * @return OK
     */
    saveSyndicationTitleConfig(config: SyndicationTitleConfigModel): Promise<SyndicationTitleConfigModel>;
}

export class SyndicationTitleConfigClient implements ISyndicationTitleConfigClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * load a titles syndication config.
     * @return OK
     */
    getSyndicationTitleConfig(titleId: number): Promise<SyndicationTitleConfigModel> {
        let url_ = this.baseUrl + "/syndicationtitleconfig?";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined and cannot be null.");
        else
            url_ += "titleId=" + encodeURIComponent("" + titleId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetSyndicationTitleConfig(_response);
        });
    }

    protected processGetSyndicationTitleConfig(response: AxiosResponse): Promise<SyndicationTitleConfigModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SyndicationTitleConfigModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SyndicationTitleConfigModel>(<any>null);
    }

    /**
     * save a titles syndication config.
     * @return OK
     */
    saveSyndicationTitleConfig(config: SyndicationTitleConfigModel): Promise<SyndicationTitleConfigModel> {
        let url_ = this.baseUrl + "/syndicationtitleconfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(config);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveSyndicationTitleConfig(_response);
        });
    }

    protected processSaveSyndicationTitleConfig(response: AxiosResponse): Promise<SyndicationTitleConfigModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SyndicationTitleConfigModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SyndicationTitleConfigModel>(<any>null);
    }
}

export interface ISysClient {
    /**
     * Restart processing of every issues in the system. Carefull!!!
     * @return OK
     */
    restartAllIssues(): Promise<boolean>;
    /**
     * Gets the number of messages in the posion queue.
     * @return OK
     */
    getPoisonSummary(): Promise<PoisonSummary[]>;
    /**
     * Restart messages in the given poison queue
     * @return OK
     */
    restartPosionQueue(posionQueue: PosionQueue): Promise<boolean>;
    /**
     * returns the API activity for a user.
     * @return OK
     */
    getUserAudit(userId: string): Promise<ApiAuditModel[]>;
    /**
     * returns the API activity for this issue.
     * @return OK
     */
    getIssueAudit(issueId: number): Promise<ApiAuditModel[]>;
    /**
     * returns the API activity for this publication
     * @return OK
     */
    getPublicationAudit(publicationId: number): Promise<ApiAuditModel[]>;
    /**
     * Find a user of the system.
     * @return OK
     */
    findUser(user: string): Promise<string[]>;
    /**
     * get version
     * @return OK
     */
    version(): Promise<string>;
    /**
     * get the system history for the last x days
     * @param days number of days of history to get.
     * @return OK
     */
    history(days: number): Promise<ActionHistoryModel[]>;
}

export class SysClient implements ISysClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Restart processing of every issues in the system. Carefull!!!
     * @return OK
     */
    restartAllIssues(): Promise<boolean> {
        let url_ = this.baseUrl + "/sys/restartall";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRestartAllIssues(_response);
        });
    }

    protected processRestartAllIssues(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * Gets the number of messages in the posion queue.
     * @return OK
     */
    getPoisonSummary(): Promise<PoisonSummary[]> {
        let url_ = this.baseUrl + "/sys/posiondetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPoisonSummary(_response);
        });
    }

    protected processGetPoisonSummary(response: AxiosResponse): Promise<PoisonSummary[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PoisonSummary.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PoisonSummary[]>(<any>null);
    }

    /**
     * Restart messages in the given poison queue
     * @return OK
     */
    restartPosionQueue(posionQueue: PosionQueue): Promise<boolean> {
        let url_ = this.baseUrl + "/sys/restartposionmessagequeue?";
        if (posionQueue === undefined || posionQueue === null)
            throw new Error("The parameter 'posionQueue' must be defined and cannot be null.");
        else
            url_ += "posionQueue=" + encodeURIComponent("" + posionQueue) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRestartPosionQueue(_response);
        });
    }

    protected processRestartPosionQueue(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * returns the API activity for a user.
     * @return OK
     */
    getUserAudit(userId: string): Promise<ApiAuditModel[]> {
        let url_ = this.baseUrl + "/sys/useraudit?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetUserAudit(_response);
        });
    }

    protected processGetUserAudit(response: AxiosResponse): Promise<ApiAuditModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiAuditModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiAuditModel[]>(<any>null);
    }

    /**
     * returns the API activity for this issue.
     * @return OK
     */
    getIssueAudit(issueId: number): Promise<ApiAuditModel[]> {
        let url_ = this.baseUrl + "/sys/issueaudit?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetIssueAudit(_response);
        });
    }

    protected processGetIssueAudit(response: AxiosResponse): Promise<ApiAuditModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiAuditModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiAuditModel[]>(<any>null);
    }

    /**
     * returns the API activity for this publication
     * @return OK
     */
    getPublicationAudit(publicationId: number): Promise<ApiAuditModel[]> {
        let url_ = this.baseUrl + "/sys/publicationaudit?";
        if (publicationId === undefined || publicationId === null)
            throw new Error("The parameter 'publicationId' must be defined and cannot be null.");
        else
            url_ += "publicationId=" + encodeURIComponent("" + publicationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPublicationAudit(_response);
        });
    }

    protected processGetPublicationAudit(response: AxiosResponse): Promise<ApiAuditModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiAuditModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiAuditModel[]>(<any>null);
    }

    /**
     * Find a user of the system.
     * @return OK
     */
    findUser(user: string): Promise<string[]> {
        let url_ = this.baseUrl + "/sys/users?";
        if (user === undefined || user === null)
            throw new Error("The parameter 'user' must be defined and cannot be null.");
        else
            url_ += "user=" + encodeURIComponent("" + user) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFindUser(_response);
        });
    }

    protected processFindUser(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(<any>null);
    }

    /**
     * get version
     * @return OK
     */
    version(): Promise<string> {
        let url_ = this.baseUrl + "/sys/version";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVersion(_response);
        });
    }

    protected processVersion(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * get the system history for the last x days
     * @param days number of days of history to get.
     * @return OK
     */
    history(days: number): Promise<ActionHistoryModel[]> {
        let url_ = this.baseUrl + "/sys/history?";
        if (days === undefined || days === null)
            throw new Error("The parameter 'days' must be defined and cannot be null.");
        else
            url_ += "days=" + encodeURIComponent("" + days) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processHistory(_response);
        });
    }

    protected processHistory(response: AxiosResponse): Promise<ActionHistoryModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActionHistoryModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActionHistoryModel[]>(<any>null);
    }
}

export interface ITenantClient {
    /**
     * List all the tenants in the system.
     * @return OK
     */
    getTenants(): Promise<TenantModel[]>;
    /**
     * removes the given tenantowners access.
     * @return No Content
     */
    removeTenantAccess(tenantOwner: TenantOwnerModel): Promise<void>;
    /**
     * makes the given user a tenant owner for the given tenant.
     * @return OK
     */
    addTenant(tenantID: number, userId: string): Promise<TenantOwnerModel>;
    /**
     * Lists all the owners of the given tenant.
     * @return OK
     */
    listOwners(tenantId: number): Promise<TenantOwnerModel[]>;
}

export class TenantClient implements ITenantClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * List all the tenants in the system.
     * @return OK
     */
    getTenants(): Promise<TenantModel[]> {
        let url_ = this.baseUrl + "/tenant";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetTenants(_response);
        });
    }

    protected processGetTenants(response: AxiosResponse): Promise<TenantModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TenantModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TenantModel[]>(<any>null);
    }

    /**
     * removes the given tenantowners access.
     * @return No Content
     */
    removeTenantAccess(tenantOwner: TenantOwnerModel): Promise<void> {
        let url_ = this.baseUrl + "/tenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tenantOwner);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRemoveTenantAccess(_response);
        });
    }

    protected processRemoveTenantAccess(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * makes the given user a tenant owner for the given tenant.
     * @return OK
     */
    addTenant(tenantID: number, userId: string): Promise<TenantOwnerModel> {
        let url_ = this.baseUrl + "/tenant/add?";
        if (tenantID === undefined || tenantID === null)
            throw new Error("The parameter 'tenantID' must be defined and cannot be null.");
        else
            url_ += "tenantID=" + encodeURIComponent("" + tenantID) + "&"; 
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAddTenant(_response);
        });
    }

    protected processAddTenant(response: AxiosResponse): Promise<TenantOwnerModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TenantOwnerModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TenantOwnerModel>(<any>null);
    }

    /**
     * Lists all the owners of the given tenant.
     * @return OK
     */
    listOwners(tenantId: number): Promise<TenantOwnerModel[]> {
        let url_ = this.baseUrl + "/tenant/allowners?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined and cannot be null.");
        else
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processListOwners(_response);
        });
    }

    protected processListOwners(response: AxiosResponse): Promise<TenantOwnerModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TenantOwnerModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TenantOwnerModel[]>(<any>null);
    }
}

export interface IThumbnailClient {
    /**
     * GetIssueOptions the thumbanil for the current issue of the given publication.
     * @param publicationID The issueId you want the thumb for.
     * @return OK
     */
    getPublicationThumbnail(publicationID: number): Promise<string>;
    /**
     * Get a thumbanil for an issue and page number.
     * @return OK
     */
    getImage(issueId: number, pageNumber: number): Promise<any>;
}

export class ThumbnailClient implements IThumbnailClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * GetIssueOptions the thumbanil for the current issue of the given publication.
     * @param publicationID The issueId you want the thumb for.
     * @return OK
     */
    getPublicationThumbnail(publicationID: number): Promise<string> {
        let url_ = this.baseUrl + "/thumbnail/publication?";
        if (publicationID === undefined || publicationID === null)
            throw new Error("The parameter 'publicationID' must be defined and cannot be null.");
        else
            url_ += "publicationID=" + encodeURIComponent("" + publicationID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPublicationThumbnail(_response);
        });
    }

    protected processGetPublicationThumbnail(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * Get a thumbanil for an issue and page number.
     * @return OK
     */
    getImage(issueId: number, pageNumber: number): Promise<any> {
        let url_ = this.baseUrl + "/thumbnail?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetImage(_response);
        });
    }

    protected processGetImage(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }
}

export interface IUrlClient {
    /**
     * Checks if a url is available to use. All urls will be converted to lowercase.
     * @param url Include schema in url, eg http://digital.publication.com
     * @return OK
     */
    urlExists(url: string): Promise<boolean>;
    /**
     * Get token for this url.
     * @return OK
     */
    getUrlAccessToken(customerUrlId: number): Promise<string>;
    /**
     * Gets all urls for a customer.
     * @return OK
     */
    getUrls(customerAccountId: number): Promise<CustomerUrlModel[]>;
    /**
     * Delete a URL from the system.
     * @return OK
     */
    deleteUrl(customerUrlId: number): Promise<any>;
    /**
     * Remove a publication from a given url.
    If removed, the publication will not be visible on the url.
     * @param customerUrlId the url to remove the publication from
     * @param publicationId the publication to remove.
     * @return OK
     */
    removePublicationFromUrl(customerUrlId: number, publicationId: number): Promise<CustomerUrlModel>;
    /**
     * add a website and title.
     * @return OK
     */
    addWebsite(customerAccountId: number, url: string, titleName: string, slug: string): Promise<CustomerUrlModel>;
    /**
     * add a website and title.
     * @return OK
     */
    addWebsite2(newWebsite: NewWebsiteDTO): Promise<CustomerUrlModel>;
    /**
     * Update the url. Admin only.
     * @return OK
     */
    updateURL(customerUrlId: number, newUrl: string): Promise<CustomerUrlModel>;
    /**
     * Get the url
     * @return OK
     */
    getURL(customerUrlId: number): Promise<CustomerUrlModel>;
    /**
     * Create a custom url for a customer. All urls will be converted to lowercase.
     * @param customerAccountId The customer identifier.
     * @param url The url to create. It will be converted to lowercase.
     * @return OK
     */
    addUrl(customerAccountId: number, url: string): Promise<CustomerUrlModel>;
    /**
     * Allow a publication to be viewed on a given url.
    The publication will be available at http://the.url/#/the.path
     * @param customerUrlId The url identifier
     * @param publicationId The publication identifier
     * @param slug the path where the publication will be available
     * @param displayPreference how the title will display on this url
     * @return OK
     */
    addPublicationToUrl(customerUrlId: number, publicationId: number, slug: string, displayPreference: DisplayPreference): Promise<CustomerUrlModel>;
    /**
     * Update the publicatins slug for a url.
     * @return OK
     */
    updatePublicationSlug(customerUrlId: number, publicationId: number, slug: string): Promise<CustomerUrlModel>;
    /**
     * Change the security of a url.
     * @return OK
     */
    setUrlSecure(customerUrlId: number, secure: Secure): Promise<CustomerUrlModel>;
    /**
     * update security type for domain.
     * @return OK
     */
    setSecurityType(customerUrlId: number, securityType: SecurityType): Promise<CustomerUrlModel>;
    /**
     * gets all issue publish data for the given url
     * @return OK
     */
    getIssuePublishData(customerUrlId: number): Promise<IssuePublishDataModel[]>;
    /**
     * update the display preference for the given title on the given url.
     * @return OK
     */
    updateDisplayPreference(customerUrlId: number, publicationId: number, displayPreference: DisplayPreference2): Promise<CustomerUrlModel>;
    /**
     * update the order of the title in the url.
     * @return OK
     */
    updateDisplayOrder(customerUrlId: number, publicationId: number, displayOrder: number): Promise<CustomerUrlModel>;
    /**
     * enable or disable indexing of the site by robots.
     * @return OK
     */
    updateSEOForUrl(customerUrlId: number, seosetting: number): Promise<CustomerUrlModel>;
}

export class UrlClient implements IUrlClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Checks if a url is available to use. All urls will be converted to lowercase.
     * @param url Include schema in url, eg http://digital.publication.com
     * @return OK
     */
    urlExists(url: string): Promise<boolean> {
        let url_ = this.baseUrl + "/url/exists?";
        if (url === undefined || url === null)
            throw new Error("The parameter 'url' must be defined and cannot be null.");
        else
            url_ += "url=" + encodeURIComponent("" + url) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUrlExists(_response);
        });
    }

    protected processUrlExists(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * Get token for this url.
     * @return OK
     */
    getUrlAccessToken(customerUrlId: number): Promise<string> {
        let url_ = this.baseUrl + "/url/logintoken?";
        if (customerUrlId === undefined || customerUrlId === null)
            throw new Error("The parameter 'customerUrlId' must be defined and cannot be null.");
        else
            url_ += "customerUrlId=" + encodeURIComponent("" + customerUrlId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetUrlAccessToken(_response);
        });
    }

    protected processGetUrlAccessToken(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * Gets all urls for a customer.
     * @return OK
     */
    getUrls(customerAccountId: number): Promise<CustomerUrlModel[]> {
        let url_ = this.baseUrl + "/url?";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined and cannot be null.");
        else
            url_ += "customerAccountId=" + encodeURIComponent("" + customerAccountId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetUrls(_response);
        });
    }

    protected processGetUrls(response: AxiosResponse): Promise<CustomerUrlModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerUrlModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerUrlModel[]>(<any>null);
    }

    /**
     * Delete a URL from the system.
     * @return OK
     */
    deleteUrl(customerUrlId: number): Promise<any> {
        let url_ = this.baseUrl + "/url?";
        if (customerUrlId === undefined || customerUrlId === null)
            throw new Error("The parameter 'customerUrlId' must be defined and cannot be null.");
        else
            url_ += "customerUrlId=" + encodeURIComponent("" + customerUrlId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteUrl(_response);
        });
    }

    protected processDeleteUrl(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Remove a publication from a given url.
    If removed, the publication will not be visible on the url.
     * @param customerUrlId the url to remove the publication from
     * @param publicationId the publication to remove.
     * @return OK
     */
    removePublicationFromUrl(customerUrlId: number, publicationId: number): Promise<CustomerUrlModel> {
        let url_ = this.baseUrl + "/url/removepublicationfromurl?";
        if (customerUrlId === undefined || customerUrlId === null)
            throw new Error("The parameter 'customerUrlId' must be defined and cannot be null.");
        else
            url_ += "customerUrlId=" + encodeURIComponent("" + customerUrlId) + "&"; 
        if (publicationId === undefined || publicationId === null)
            throw new Error("The parameter 'publicationId' must be defined and cannot be null.");
        else
            url_ += "publicationId=" + encodeURIComponent("" + publicationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRemovePublicationFromUrl(_response);
        });
    }

    protected processRemovePublicationFromUrl(response: AxiosResponse): Promise<CustomerUrlModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomerUrlModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerUrlModel>(<any>null);
    }

    /**
     * add a website and title.
     * @return OK
     */
    addWebsite(customerAccountId: number, url: string, titleName: string, slug: string): Promise<CustomerUrlModel> {
        let url_ = this.baseUrl + "/url/addwebsite?";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined and cannot be null.");
        else
            url_ += "customerAccountId=" + encodeURIComponent("" + customerAccountId) + "&"; 
        if (url === undefined || url === null)
            throw new Error("The parameter 'url' must be defined and cannot be null.");
        else
            url_ += "url=" + encodeURIComponent("" + url) + "&"; 
        if (titleName === undefined || titleName === null)
            throw new Error("The parameter 'titleName' must be defined and cannot be null.");
        else
            url_ += "titleName=" + encodeURIComponent("" + titleName) + "&"; 
        if (slug === undefined || slug === null)
            throw new Error("The parameter 'slug' must be defined and cannot be null.");
        else
            url_ += "slug=" + encodeURIComponent("" + slug) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAddWebsite(_response);
        });
    }

    protected processAddWebsite(response: AxiosResponse): Promise<CustomerUrlModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomerUrlModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerUrlModel>(<any>null);
    }

    /**
     * add a website and title.
     * @return OK
     */
    addWebsite2(newWebsite: NewWebsiteDTO): Promise<CustomerUrlModel> {
        let url_ = this.baseUrl + "/url/addwebsite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newWebsite);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAddWebsite2(_response);
        });
    }

    protected processAddWebsite2(response: AxiosResponse): Promise<CustomerUrlModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomerUrlModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerUrlModel>(<any>null);
    }

    /**
     * Update the url. Admin only.
     * @return OK
     */
    updateURL(customerUrlId: number, newUrl: string): Promise<CustomerUrlModel> {
        let url_ = this.baseUrl + "/url/updateurl?";
        if (customerUrlId === undefined || customerUrlId === null)
            throw new Error("The parameter 'customerUrlId' must be defined and cannot be null.");
        else
            url_ += "customerUrlId=" + encodeURIComponent("" + customerUrlId) + "&"; 
        if (newUrl === undefined || newUrl === null)
            throw new Error("The parameter 'newUrl' must be defined and cannot be null.");
        else
            url_ += "newUrl=" + encodeURIComponent("" + newUrl) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateURL(_response);
        });
    }

    protected processUpdateURL(response: AxiosResponse): Promise<CustomerUrlModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomerUrlModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerUrlModel>(<any>null);
    }

    /**
     * Get the url
     * @return OK
     */
    getURL(customerUrlId: number): Promise<CustomerUrlModel> {
        let url_ = this.baseUrl + "/url/url?";
        if (customerUrlId === undefined || customerUrlId === null)
            throw new Error("The parameter 'customerUrlId' must be defined and cannot be null.");
        else
            url_ += "customerUrlId=" + encodeURIComponent("" + customerUrlId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetURL(_response);
        });
    }

    protected processGetURL(response: AxiosResponse): Promise<CustomerUrlModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomerUrlModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerUrlModel>(<any>null);
    }

    /**
     * Create a custom url for a customer. All urls will be converted to lowercase.
     * @param customerAccountId The customer identifier.
     * @param url The url to create. It will be converted to lowercase.
     * @return OK
     */
    addUrl(customerAccountId: number, url: string): Promise<CustomerUrlModel> {
        let url_ = this.baseUrl + "/url/add?";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined and cannot be null.");
        else
            url_ += "customerAccountId=" + encodeURIComponent("" + customerAccountId) + "&"; 
        if (url === undefined || url === null)
            throw new Error("The parameter 'url' must be defined and cannot be null.");
        else
            url_ += "url=" + encodeURIComponent("" + url) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAddUrl(_response);
        });
    }

    protected processAddUrl(response: AxiosResponse): Promise<CustomerUrlModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomerUrlModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerUrlModel>(<any>null);
    }

    /**
     * Allow a publication to be viewed on a given url.
    The publication will be available at http://the.url/#/the.path
     * @param customerUrlId The url identifier
     * @param publicationId The publication identifier
     * @param slug the path where the publication will be available
     * @param displayPreference how the title will display on this url
     * @return OK
     */
    addPublicationToUrl(customerUrlId: number, publicationId: number, slug: string, displayPreference: DisplayPreference): Promise<CustomerUrlModel> {
        let url_ = this.baseUrl + "/url/addpublicationtourl?";
        if (customerUrlId === undefined || customerUrlId === null)
            throw new Error("The parameter 'customerUrlId' must be defined and cannot be null.");
        else
            url_ += "customerUrlId=" + encodeURIComponent("" + customerUrlId) + "&"; 
        if (publicationId === undefined || publicationId === null)
            throw new Error("The parameter 'publicationId' must be defined and cannot be null.");
        else
            url_ += "publicationId=" + encodeURIComponent("" + publicationId) + "&"; 
        if (slug === undefined || slug === null)
            throw new Error("The parameter 'slug' must be defined and cannot be null.");
        else
            url_ += "slug=" + encodeURIComponent("" + slug) + "&"; 
        if (displayPreference === undefined || displayPreference === null)
            throw new Error("The parameter 'displayPreference' must be defined and cannot be null.");
        else
            url_ += "displayPreference=" + encodeURIComponent("" + displayPreference) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAddPublicationToUrl(_response);
        });
    }

    protected processAddPublicationToUrl(response: AxiosResponse): Promise<CustomerUrlModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomerUrlModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerUrlModel>(<any>null);
    }

    /**
     * Update the publicatins slug for a url.
     * @return OK
     */
    updatePublicationSlug(customerUrlId: number, publicationId: number, slug: string): Promise<CustomerUrlModel> {
        let url_ = this.baseUrl + "/url/updatepublicationslug?";
        if (customerUrlId === undefined || customerUrlId === null)
            throw new Error("The parameter 'customerUrlId' must be defined and cannot be null.");
        else
            url_ += "customerUrlId=" + encodeURIComponent("" + customerUrlId) + "&"; 
        if (publicationId === undefined || publicationId === null)
            throw new Error("The parameter 'publicationId' must be defined and cannot be null.");
        else
            url_ += "publicationId=" + encodeURIComponent("" + publicationId) + "&"; 
        if (slug === undefined || slug === null)
            throw new Error("The parameter 'slug' must be defined and cannot be null.");
        else
            url_ += "slug=" + encodeURIComponent("" + slug) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdatePublicationSlug(_response);
        });
    }

    protected processUpdatePublicationSlug(response: AxiosResponse): Promise<CustomerUrlModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomerUrlModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerUrlModel>(<any>null);
    }

    /**
     * Change the security of a url.
     * @return OK
     */
    setUrlSecure(customerUrlId: number, secure: Secure): Promise<CustomerUrlModel> {
        let url_ = this.baseUrl + "/url/secure?";
        if (customerUrlId === undefined || customerUrlId === null)
            throw new Error("The parameter 'customerUrlId' must be defined and cannot be null.");
        else
            url_ += "customerUrlId=" + encodeURIComponent("" + customerUrlId) + "&"; 
        if (secure === undefined || secure === null)
            throw new Error("The parameter 'secure' must be defined and cannot be null.");
        else
            url_ += "secure=" + encodeURIComponent("" + secure) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSetUrlSecure(_response);
        });
    }

    protected processSetUrlSecure(response: AxiosResponse): Promise<CustomerUrlModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomerUrlModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerUrlModel>(<any>null);
    }

    /**
     * update security type for domain.
     * @return OK
     */
    setSecurityType(customerUrlId: number, securityType: SecurityType): Promise<CustomerUrlModel> {
        let url_ = this.baseUrl + "/url/securitytype?";
        if (customerUrlId === undefined || customerUrlId === null)
            throw new Error("The parameter 'customerUrlId' must be defined and cannot be null.");
        else
            url_ += "customerUrlId=" + encodeURIComponent("" + customerUrlId) + "&"; 
        if (securityType === undefined || securityType === null)
            throw new Error("The parameter 'securityType' must be defined and cannot be null.");
        else
            url_ += "securityType=" + encodeURIComponent("" + securityType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSetSecurityType(_response);
        });
    }

    protected processSetSecurityType(response: AxiosResponse): Promise<CustomerUrlModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomerUrlModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerUrlModel>(<any>null);
    }

    /**
     * gets all issue publish data for the given url
     * @return OK
     */
    getIssuePublishData(customerUrlId: number): Promise<IssuePublishDataModel[]> {
        let url_ = this.baseUrl + "/url/issuepublishdata?";
        if (customerUrlId === undefined || customerUrlId === null)
            throw new Error("The parameter 'customerUrlId' must be defined and cannot be null.");
        else
            url_ += "customerUrlId=" + encodeURIComponent("" + customerUrlId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetIssuePublishData(_response);
        });
    }

    protected processGetIssuePublishData(response: AxiosResponse): Promise<IssuePublishDataModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IssuePublishDataModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssuePublishDataModel[]>(<any>null);
    }

    /**
     * update the display preference for the given title on the given url.
     * @return OK
     */
    updateDisplayPreference(customerUrlId: number, publicationId: number, displayPreference: DisplayPreference2): Promise<CustomerUrlModel> {
        let url_ = this.baseUrl + "/url/updatedisplaypreference?";
        if (customerUrlId === undefined || customerUrlId === null)
            throw new Error("The parameter 'customerUrlId' must be defined and cannot be null.");
        else
            url_ += "customerUrlId=" + encodeURIComponent("" + customerUrlId) + "&"; 
        if (publicationId === undefined || publicationId === null)
            throw new Error("The parameter 'publicationId' must be defined and cannot be null.");
        else
            url_ += "publicationId=" + encodeURIComponent("" + publicationId) + "&"; 
        if (displayPreference === undefined || displayPreference === null)
            throw new Error("The parameter 'displayPreference' must be defined and cannot be null.");
        else
            url_ += "displayPreference=" + encodeURIComponent("" + displayPreference) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateDisplayPreference(_response);
        });
    }

    protected processUpdateDisplayPreference(response: AxiosResponse): Promise<CustomerUrlModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomerUrlModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerUrlModel>(<any>null);
    }

    /**
     * update the order of the title in the url.
     * @return OK
     */
    updateDisplayOrder(customerUrlId: number, publicationId: number, displayOrder: number): Promise<CustomerUrlModel> {
        let url_ = this.baseUrl + "/url/updatedisplayorder?";
        if (customerUrlId === undefined || customerUrlId === null)
            throw new Error("The parameter 'customerUrlId' must be defined and cannot be null.");
        else
            url_ += "customerUrlId=" + encodeURIComponent("" + customerUrlId) + "&"; 
        if (publicationId === undefined || publicationId === null)
            throw new Error("The parameter 'publicationId' must be defined and cannot be null.");
        else
            url_ += "publicationId=" + encodeURIComponent("" + publicationId) + "&"; 
        if (displayOrder === undefined || displayOrder === null)
            throw new Error("The parameter 'displayOrder' must be defined and cannot be null.");
        else
            url_ += "displayOrder=" + encodeURIComponent("" + displayOrder) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateDisplayOrder(_response);
        });
    }

    protected processUpdateDisplayOrder(response: AxiosResponse): Promise<CustomerUrlModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomerUrlModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerUrlModel>(<any>null);
    }

    /**
     * enable or disable indexing of the site by robots.
     * @return OK
     */
    updateSEOForUrl(customerUrlId: number, seosetting: number): Promise<CustomerUrlModel> {
        let url_ = this.baseUrl + "/url/updateseo?";
        if (customerUrlId === undefined || customerUrlId === null)
            throw new Error("The parameter 'customerUrlId' must be defined and cannot be null.");
        else
            url_ += "customerUrlId=" + encodeURIComponent("" + customerUrlId) + "&"; 
        if (seosetting === undefined || seosetting === null)
            throw new Error("The parameter 'seosetting' must be defined and cannot be null.");
        else
            url_ += "seosetting=" + encodeURIComponent("" + seosetting) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateSEOForUrl(_response);
        });
    }

    protected processUpdateSEOForUrl(response: AxiosResponse): Promise<CustomerUrlModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomerUrlModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerUrlModel>(<any>null);
    }
}

export interface IUrlAuthConfigClient {
    /**
     * test the saved API key for auth config.
     * @return OK
     */
    testAuthConfigForUrl(customerUrlId: number): Promise<boolean>;
    /**
     * Get an auth config for a customer url.
    The secret propery returned will always be empty.
     * @return OK
     */
    getAuthConfigForUrl(customerUrlId: number): Promise<CustomerAuthConfigModel>;
    /**
     * Save an auth config for a customer url.
    Set the secret value to update it, an empty value will leave the existing stored value.
    The secret is always returned as empty.
     * @return OK
     */
    saveAuthConfigForUrl(urlAuthConfig: CustomerAuthConfigModel): Promise<CustomerAuthConfigModel>;
}

export class UrlAuthConfigClient implements IUrlAuthConfigClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * test the saved API key for auth config.
     * @return OK
     */
    testAuthConfigForUrl(customerUrlId: number): Promise<boolean> {
        let url_ = this.baseUrl + "/urlauth/testauthconfig?";
        if (customerUrlId === undefined || customerUrlId === null)
            throw new Error("The parameter 'customerUrlId' must be defined and cannot be null.");
        else
            url_ += "customerUrlId=" + encodeURIComponent("" + customerUrlId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processTestAuthConfigForUrl(_response);
        });
    }

    protected processTestAuthConfigForUrl(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * Get an auth config for a customer url.
    The secret propery returned will always be empty.
     * @return OK
     */
    getAuthConfigForUrl(customerUrlId: number): Promise<CustomerAuthConfigModel> {
        let url_ = this.baseUrl + "/urlauth/auth?";
        if (customerUrlId === undefined || customerUrlId === null)
            throw new Error("The parameter 'customerUrlId' must be defined and cannot be null.");
        else
            url_ += "customerUrlId=" + encodeURIComponent("" + customerUrlId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAuthConfigForUrl(_response);
        });
    }

    protected processGetAuthConfigForUrl(response: AxiosResponse): Promise<CustomerAuthConfigModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomerAuthConfigModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerAuthConfigModel>(<any>null);
    }

    /**
     * Save an auth config for a customer url.
    Set the secret value to update it, an empty value will leave the existing stored value.
    The secret is always returned as empty.
     * @return OK
     */
    saveAuthConfigForUrl(urlAuthConfig: CustomerAuthConfigModel): Promise<CustomerAuthConfigModel> {
        let url_ = this.baseUrl + "/urlauth/auth";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(urlAuthConfig);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveAuthConfigForUrl(_response);
        });
    }

    protected processSaveAuthConfigForUrl(response: AxiosResponse): Promise<CustomerAuthConfigModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomerAuthConfigModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerAuthConfigModel>(<any>null);
    }
}

export interface IUrlCustomAuthConfigClient {
    /**
     * Get the custom auth config for a customer url.
    The secret propery returned will always be empty.
     * @return OK
     */
    getAuthConfigForUrl(customerUrlId: number): Promise<CustomAuthConfigDTO>;
    /**
     * Save an auth config for a customer url.
    Set the secret value to update it, an empty value will leave the existing stored value.
    The secret is always returned as empty.
     * @return OK
     */
    saveAuthConfigForUrl(urlAuthConfig: CustomAuthConfigDTO): Promise<CustomAuthConfigDTO>;
}

export class UrlCustomAuthConfigClient implements IUrlCustomAuthConfigClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Get the custom auth config for a customer url.
    The secret propery returned will always be empty.
     * @return OK
     */
    getAuthConfigForUrl(customerUrlId: number): Promise<CustomAuthConfigDTO> {
        let url_ = this.baseUrl + "/customauth?";
        if (customerUrlId === undefined || customerUrlId === null)
            throw new Error("The parameter 'customerUrlId' must be defined and cannot be null.");
        else
            url_ += "customerUrlId=" + encodeURIComponent("" + customerUrlId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAuthConfigForUrl(_response);
        });
    }

    protected processGetAuthConfigForUrl(response: AxiosResponse): Promise<CustomAuthConfigDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomAuthConfigDTO.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomAuthConfigDTO>(<any>null);
    }

    /**
     * Save an auth config for a customer url.
    Set the secret value to update it, an empty value will leave the existing stored value.
    The secret is always returned as empty.
     * @return OK
     */
    saveAuthConfigForUrl(urlAuthConfig: CustomAuthConfigDTO): Promise<CustomAuthConfigDTO> {
        let url_ = this.baseUrl + "/customauth";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(urlAuthConfig);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveAuthConfigForUrl(_response);
        });
    }

    protected processSaveAuthConfigForUrl(response: AxiosResponse): Promise<CustomAuthConfigDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomAuthConfigDTO.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomAuthConfigDTO>(<any>null);
    }
}

export interface IUrlCustomerManagmentClient {
    /**
     * gets the customers login history of a partica domain
     * @return OK
     */
    getUserActivity(customerUrlId: number, id: string): Promise<UserDetails>;
    /**
     * gets a subscriber with their metadata
     * @return OK
     */
    get(user: AuthUser): Promise<SubscriberDetailsDTO>;
    /**
     * fins a subscriber.
     * @return OK
     */
    findSubscriber(searchSubscriber: SearchSubscriberDTO): Promise<AuthUser[]>;
    /**
     * update a subscriber
     * @return OK
     */
    updateSubscriber(subscriberDetails: SubscriberDetailsDTO): Promise<any>;
    /**
     * Create a user in Auth0 for the domain specified.
     * @return OK
     */
    createSubscriber(userDetails: Auth0UserDTO): Promise<any>;
    /**
     * Get connections associated with this domain.
     * @return OK
     */
    getConnections(domainId: number): Promise<string[]>;
}

export class UrlCustomerManagmentClient implements IUrlCustomerManagmentClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * gets the customers login history of a partica domain
     * @return OK
     */
    getUserActivity(customerUrlId: number, id: string): Promise<UserDetails> {
        let url_ = this.baseUrl + "/subscriber/history?";
        if (customerUrlId === undefined || customerUrlId === null)
            throw new Error("The parameter 'customerUrlId' must be defined and cannot be null.");
        else
            url_ += "customerUrlId=" + encodeURIComponent("" + customerUrlId) + "&"; 
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetUserActivity(_response);
        });
    }

    protected processGetUserActivity(response: AxiosResponse): Promise<UserDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserDetails.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDetails>(<any>null);
    }

    /**
     * gets a subscriber with their metadata
     * @return OK
     */
    get(user: AuthUser): Promise<SubscriberDetailsDTO> {
        let url_ = this.baseUrl + "/subscriber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<SubscriberDetailsDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SubscriberDetailsDTO.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubscriberDetailsDTO>(<any>null);
    }

    /**
     * fins a subscriber.
     * @return OK
     */
    findSubscriber(searchSubscriber: SearchSubscriberDTO): Promise<AuthUser[]> {
        let url_ = this.baseUrl + "/subscriber/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchSubscriber);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFindSubscriber(_response);
        });
    }

    protected processFindSubscriber(response: AxiosResponse): Promise<AuthUser[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AuthUser.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthUser[]>(<any>null);
    }

    /**
     * update a subscriber
     * @return OK
     */
    updateSubscriber(subscriberDetails: SubscriberDetailsDTO): Promise<any> {
        let url_ = this.baseUrl + "/subscriber/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(subscriberDetails);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateSubscriber(_response);
        });
    }

    protected processUpdateSubscriber(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Create a user in Auth0 for the domain specified.
     * @return OK
     */
    createSubscriber(userDetails: Auth0UserDTO): Promise<any> {
        let url_ = this.baseUrl + "/subscriber/user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userDetails);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateSubscriber(_response);
        });
    }

    protected processCreateSubscriber(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Get connections associated with this domain.
     * @return OK
     */
    getConnections(domainId: number): Promise<string[]> {
        let url_ = this.baseUrl + "/subscriber/connections?";
        if (domainId === undefined || domainId === null)
            throw new Error("The parameter 'domainId' must be defined and cannot be null.");
        else
            url_ += "DomainId=" + encodeURIComponent("" + domainId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetConnections(_response);
        });
    }

    protected processGetConnections(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(<any>null);
    }
}

export interface IUrlIconClient {
    /**
     * Save a PNG icon for the given url.
     * @param customerUrlId The url to save the icon for
     * @param urlIcon the icon type
     * @param base64image base64 string of png icon
     * @return OK
     */
    saveImage(customerUrlId: number, urlIcon: UrlIcon, base64image: string): Promise<string>;
}

export class UrlIconClient implements IUrlIconClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Save a PNG icon for the given url.
     * @param customerUrlId The url to save the icon for
     * @param urlIcon the icon type
     * @param base64image base64 string of png icon
     * @return OK
     */
    saveImage(customerUrlId: number, urlIcon: UrlIcon, base64image: string): Promise<string> {
        let url_ = this.baseUrl + "/urlicons?";
        if (customerUrlId === undefined || customerUrlId === null)
            throw new Error("The parameter 'customerUrlId' must be defined and cannot be null.");
        else
            url_ += "customerUrlId=" + encodeURIComponent("" + customerUrlId) + "&"; 
        if (urlIcon === undefined || urlIcon === null)
            throw new Error("The parameter 'urlIcon' must be defined and cannot be null.");
        else
            url_ += "urlIcon=" + encodeURIComponent("" + urlIcon) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(base64image);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveImage(_response);
        });
    }

    protected processSaveImage(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(<any>null);
    }
}

export interface IViewerArticleClient {
    /**
     * Add a new or update an existing article.
     * @return OK
     */
    saveArticle(article: ArticleModel): Promise<ArticleModel>;
    /**
     * Save an array of articles.
     * @return OK
     */
    save(articles: ArticleModel[]): Promise<ArticleModel[]>;
    /**
     * Delete an article.
     * @param articles article guid
     * @return OK
     */
    deleteArticles(articles: ArticleModel[]): Promise<any>;
    /**
     * Delete an article.
     * @param articleId article guid
     * @return OK
     */
    deleteArticle(articleId: string, issueid: number): Promise<any>;
    /**
     * Get all the articles for an issue.
     * @return OK
     */
    getArticles(issueId: number): Promise<ArticleModel[]>;
    /**
     * article for an issue grouped by section.
     * @return OK
     */
    getArticlesBySection(issueId: number): Promise<MyGroupingOfArticlePropDTO[]>;
    /**
     * Get an article.
     * @return OK
     */
    getArticle(issueId: number, articleId: string): Promise<ArticleModel>;
    /**
     * Get all the articles for an issue.
     * @return OK
     */
    getLastExtractedArticles(customerAccountId: number, number: number): Promise<ArticleModel[]>;
    /**
     * copy articles from a one issue to another.
     * @param sourceIssueId source issue for articles.
     * @param destinationIssueId issue to copy articles to.
     * @return OK
     */
    copyArticlesToIssues(sourceIssueId: number, destinationIssueId: number): Promise<any>;
    /**
     * Get the usage for all articles in the given issue.
     * @return OK
     */
    getArticleUsageForIssue(issueId: number): Promise<any>;
}

export class ViewerArticleClient implements IViewerArticleClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Add a new or update an existing article.
     * @return OK
     */
    saveArticle(article: ArticleModel): Promise<ArticleModel> {
        let url_ = this.baseUrl + "/viewerarticle/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(article);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveArticle(_response);
        });
    }

    protected processSaveArticle(response: AxiosResponse): Promise<ArticleModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ArticleModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ArticleModel>(<any>null);
    }

    /**
     * Save an array of articles.
     * @return OK
     */
    save(articles: ArticleModel[]): Promise<ArticleModel[]> {
        let url_ = this.baseUrl + "/viewerarticle/savemany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(articles);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<ArticleModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ArticleModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ArticleModel[]>(<any>null);
    }

    /**
     * Delete an article.
     * @param articles article guid
     * @return OK
     */
    deleteArticles(articles: ArticleModel[]): Promise<any> {
        let url_ = this.baseUrl + "/viewerarticle/many";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(articles);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteArticles(_response);
        });
    }

    protected processDeleteArticles(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Delete an article.
     * @param articleId article guid
     * @return OK
     */
    deleteArticle(articleId: string, issueid: number): Promise<any> {
        let url_ = this.baseUrl + "/viewerarticle?";
        if (articleId === undefined || articleId === null)
            throw new Error("The parameter 'articleId' must be defined and cannot be null.");
        else
            url_ += "articleId=" + encodeURIComponent("" + articleId) + "&"; 
        if (issueid === undefined || issueid === null)
            throw new Error("The parameter 'issueid' must be defined and cannot be null.");
        else
            url_ += "issueid=" + encodeURIComponent("" + issueid) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteArticle(_response);
        });
    }

    protected processDeleteArticle(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Get all the articles for an issue.
     * @return OK
     */
    getArticles(issueId: number): Promise<ArticleModel[]> {
        let url_ = this.baseUrl + "/viewerarticle/articles?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetArticles(_response);
        });
    }

    protected processGetArticles(response: AxiosResponse): Promise<ArticleModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ArticleModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ArticleModel[]>(<any>null);
    }

    /**
     * article for an issue grouped by section.
     * @return OK
     */
    getArticlesBySection(issueId: number): Promise<MyGroupingOfArticlePropDTO[]> {
        let url_ = this.baseUrl + "/viewerarticle/articlesbysection?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetArticlesBySection(_response);
        });
    }

    protected processGetArticlesBySection(response: AxiosResponse): Promise<MyGroupingOfArticlePropDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MyGroupingOfArticlePropDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MyGroupingOfArticlePropDTO[]>(<any>null);
    }

    /**
     * Get an article.
     * @return OK
     */
    getArticle(issueId: number, articleId: string): Promise<ArticleModel> {
        let url_ = this.baseUrl + "/viewerarticle/article?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        if (articleId === undefined || articleId === null)
            throw new Error("The parameter 'articleId' must be defined and cannot be null.");
        else
            url_ += "articleId=" + encodeURIComponent("" + articleId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetArticle(_response);
        });
    }

    protected processGetArticle(response: AxiosResponse): Promise<ArticleModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ArticleModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ArticleModel>(<any>null);
    }

    /**
     * Get all the articles for an issue.
     * @return OK
     */
    getLastExtractedArticles(customerAccountId: number, number: number): Promise<ArticleModel[]> {
        let url_ = this.baseUrl + "/viewerarticle/lastextracted?";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined and cannot be null.");
        else
            url_ += "customerAccountId=" + encodeURIComponent("" + customerAccountId) + "&"; 
        if (number === undefined || number === null)
            throw new Error("The parameter 'number' must be defined and cannot be null.");
        else
            url_ += "number=" + encodeURIComponent("" + number) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetLastExtractedArticles(_response);
        });
    }

    protected processGetLastExtractedArticles(response: AxiosResponse): Promise<ArticleModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ArticleModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ArticleModel[]>(<any>null);
    }

    /**
     * copy articles from a one issue to another.
     * @param sourceIssueId source issue for articles.
     * @param destinationIssueId issue to copy articles to.
     * @return OK
     */
    copyArticlesToIssues(sourceIssueId: number, destinationIssueId: number): Promise<any> {
        let url_ = this.baseUrl + "/viewerarticle/copytoissue?";
        if (sourceIssueId === undefined || sourceIssueId === null)
            throw new Error("The parameter 'sourceIssueId' must be defined and cannot be null.");
        else
            url_ += "sourceIssueId=" + encodeURIComponent("" + sourceIssueId) + "&"; 
        if (destinationIssueId === undefined || destinationIssueId === null)
            throw new Error("The parameter 'destinationIssueId' must be defined and cannot be null.");
        else
            url_ += "destinationIssueId=" + encodeURIComponent("" + destinationIssueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCopyArticlesToIssues(_response);
        });
    }

    protected processCopyArticlesToIssues(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Get the usage for all articles in the given issue.
     * @return OK
     */
    getArticleUsageForIssue(issueId: number): Promise<any> {
        let url_ = this.baseUrl + "/viewerarticle/usageforissue?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetArticleUsageForIssue(_response);
        });
    }

    protected processGetArticleUsageForIssue(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }
}

export interface IViewerContentClient {
    /**
     * Get ViewerContents for the given url.
     * @param customerUrlId Url to get ViewerContent for.
     * @param viewerContentType type of content to load
     * @param viewerContentVersion version of content to load
     * @return OK
     */
    getViewerContent(customerUrlId: number, viewerContentType: ViewerContentType, viewerContentVersion: ViewerContentVersion): Promise<ViewerContentDTO>;
    /**
     * Adds a new ViewerContent to the url
     * @param viewerContent ViewerContent to add.
     * @return OK
     */
    saveViewerContent(viewerContent: ViewerContentDTO): Promise<ViewerContentDTO>;
    /**
     * delete ViewerContent.
     * @return OK
     */
    deleteViewerContent(viewerContentId: number): Promise<any>;
    /**
     * swap live/preview ViewerContent.
     * @return OK
     */
    swapViewerContent(customerUrlId: number, viewerContentType: ViewerContentType2): Promise<any>;
}

export class ViewerContentClient implements IViewerContentClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Get ViewerContents for the given url.
     * @param customerUrlId Url to get ViewerContent for.
     * @param viewerContentType type of content to load
     * @param viewerContentVersion version of content to load
     * @return OK
     */
    getViewerContent(customerUrlId: number, viewerContentType: ViewerContentType, viewerContentVersion: ViewerContentVersion): Promise<ViewerContentDTO> {
        let url_ = this.baseUrl + "/viewercontent?";
        if (customerUrlId === undefined || customerUrlId === null)
            throw new Error("The parameter 'customerUrlId' must be defined and cannot be null.");
        else
            url_ += "customerUrlId=" + encodeURIComponent("" + customerUrlId) + "&"; 
        if (viewerContentType === undefined || viewerContentType === null)
            throw new Error("The parameter 'viewerContentType' must be defined and cannot be null.");
        else
            url_ += "viewerContentType=" + encodeURIComponent("" + viewerContentType) + "&"; 
        if (viewerContentVersion === undefined || viewerContentVersion === null)
            throw new Error("The parameter 'viewerContentVersion' must be defined and cannot be null.");
        else
            url_ += "viewerContentVersion=" + encodeURIComponent("" + viewerContentVersion) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetViewerContent(_response);
        });
    }

    protected processGetViewerContent(response: AxiosResponse): Promise<ViewerContentDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ViewerContentDTO.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ViewerContentDTO>(<any>null);
    }

    /**
     * Adds a new ViewerContent to the url
     * @param viewerContent ViewerContent to add.
     * @return OK
     */
    saveViewerContent(viewerContent: ViewerContentDTO): Promise<ViewerContentDTO> {
        let url_ = this.baseUrl + "/viewercontent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewerContent);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveViewerContent(_response);
        });
    }

    protected processSaveViewerContent(response: AxiosResponse): Promise<ViewerContentDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ViewerContentDTO.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ViewerContentDTO>(<any>null);
    }

    /**
     * delete ViewerContent.
     * @return OK
     */
    deleteViewerContent(viewerContentId: number): Promise<any> {
        let url_ = this.baseUrl + "/viewercontent?";
        if (viewerContentId === undefined || viewerContentId === null)
            throw new Error("The parameter 'viewerContentId' must be defined and cannot be null.");
        else
            url_ += "ViewerContentId=" + encodeURIComponent("" + viewerContentId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteViewerContent(_response);
        });
    }

    protected processDeleteViewerContent(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * swap live/preview ViewerContent.
     * @return OK
     */
    swapViewerContent(customerUrlId: number, viewerContentType: ViewerContentType2): Promise<any> {
        let url_ = this.baseUrl + "/viewercontent/swap?";
        if (customerUrlId === undefined || customerUrlId === null)
            throw new Error("The parameter 'customerUrlId' must be defined and cannot be null.");
        else
            url_ += "CustomerUrlId=" + encodeURIComponent("" + customerUrlId) + "&"; 
        if (viewerContentType === undefined || viewerContentType === null)
            throw new Error("The parameter 'viewerContentType' must be defined and cannot be null.");
        else
            url_ += "viewerContentType=" + encodeURIComponent("" + viewerContentType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSwapViewerContent(_response);
        });
    }

    protected processSwapViewerContent(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }
}

export interface IViewerOptionsClient {
    /**
     * get vieweroptions for publication.
     * @return OK
     */
    get(publicationId: number): Promise<ViewerOptionsModel>;
    /**
     * save viewer options for a publication
     * @return OK
     */
    save(publicationId: number, options: ViewerOptionsModel): Promise<ViewerOptionsModel>;
    /**
     * Publish the options so they are available to the viewer.
     * @return OK
     */
    publishOptions(publicationId: number): Promise<any>;
}

export class ViewerOptionsClient implements IViewerOptionsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * get vieweroptions for publication.
     * @return OK
     */
    get(publicationId: number): Promise<ViewerOptionsModel> {
        let url_ = this.baseUrl + "/vieweroptions?";
        if (publicationId === undefined || publicationId === null)
            throw new Error("The parameter 'publicationId' must be defined and cannot be null.");
        else
            url_ += "publicationId=" + encodeURIComponent("" + publicationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ViewerOptionsModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ViewerOptionsModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ViewerOptionsModel>(<any>null);
    }

    /**
     * save viewer options for a publication
     * @return OK
     */
    save(publicationId: number, options: ViewerOptionsModel): Promise<ViewerOptionsModel> {
        let url_ = this.baseUrl + "/vieweroptions?";
        if (publicationId === undefined || publicationId === null)
            throw new Error("The parameter 'publicationId' must be defined and cannot be null.");
        else
            url_ += "publicationId=" + encodeURIComponent("" + publicationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<ViewerOptionsModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ViewerOptionsModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ViewerOptionsModel>(<any>null);
    }

    /**
     * Publish the options so they are available to the viewer.
     * @return OK
     */
    publishOptions(publicationId: number): Promise<any> {
        let url_ = this.baseUrl + "/vieweroptions/publish?";
        if (publicationId === undefined || publicationId === null)
            throw new Error("The parameter 'publicationId' must be defined and cannot be null.");
        else
            url_ += "publicationId=" + encodeURIComponent("" + publicationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPublishOptions(_response);
        });
    }

    protected processPublishOptions(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }
}

export interface IWordpressClient {
    /**
     * Get a publications Wordpress configuration.
     * @return OK
     */
    getWordpressConfiguration(publicationId: number): Promise<WordpressConfigurationModel>;
    /**
     * Save or Update a publications Wordpress configuration..
     * @return OK
     */
    savePublicationAnalytics(config: WordpressConfigurationModel): Promise<WordpressConfigurationModel>;
    /**
     * Publish an issue to Wordpress.
     * @return OK
     */
    publishWordpress(issueId: number): Promise<any>;
}

export class WordpressClient implements IWordpressClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Get a publications Wordpress configuration.
     * @return OK
     */
    getWordpressConfiguration(publicationId: number): Promise<WordpressConfigurationModel> {
        let url_ = this.baseUrl + "/wordpress?";
        if (publicationId === undefined || publicationId === null)
            throw new Error("The parameter 'publicationId' must be defined and cannot be null.");
        else
            url_ += "publicationId=" + encodeURIComponent("" + publicationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetWordpressConfiguration(_response);
        });
    }

    protected processGetWordpressConfiguration(response: AxiosResponse): Promise<WordpressConfigurationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WordpressConfigurationModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WordpressConfigurationModel>(<any>null);
    }

    /**
     * Save or Update a publications Wordpress configuration..
     * @return OK
     */
    savePublicationAnalytics(config: WordpressConfigurationModel): Promise<WordpressConfigurationModel> {
        let url_ = this.baseUrl + "/wordpress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(config);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSavePublicationAnalytics(_response);
        });
    }

    protected processSavePublicationAnalytics(response: AxiosResponse): Promise<WordpressConfigurationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WordpressConfigurationModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WordpressConfigurationModel>(<any>null);
    }

    /**
     * Publish an issue to Wordpress.
     * @return OK
     */
    publishWordpress(issueId: number): Promise<any> {
        let url_ = this.baseUrl + "/wordpress/publish?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPublishWordpress(_response);
        });
    }

    protected processPublishWordpress(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }
}

export interface IWordpressPluginClient {
    /**
     * get wordpress plugin
     * @return OK
     */
    getWordpressPlugin(id: number): Promise<WordpressPluginDTO>;
    /**
     * Save a wordpress plugin.
     * @return OK
     */
    saveWordpressPlugin(wordpressPlugin: WordpressPluginDTO): Promise<WordpressPluginDTO>;
    /**
     * delete wordpress plugin.
     * @return OK
     */
    deleteWordpressPlugins(id: number): Promise<any>;
    /**
     * test the given WP plugin.
     * @return OK
     */
    testWordpressPlugin(id: number): Promise<boolean>;
    /**
     * get all wordpress plugins for account.
     * @return OK
     */
    getWordpressPlugins(customerAccountId: number): Promise<WordpressPluginDTO[]>;
    /**
     * publish an artice to a wordpress plugin.
     * @return OK
     */
    publishToWordpress(articles: WordpressPublishDTO[]): Promise<WordpressPluginDTO>;
}

export class WordpressPluginClient implements IWordpressPluginClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * get wordpress plugin
     * @return OK
     */
    getWordpressPlugin(id: number): Promise<WordpressPluginDTO> {
        let url_ = this.baseUrl + "/plugins/wordpress?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetWordpressPlugin(_response);
        });
    }

    protected processGetWordpressPlugin(response: AxiosResponse): Promise<WordpressPluginDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WordpressPluginDTO.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WordpressPluginDTO>(<any>null);
    }

    /**
     * Save a wordpress plugin.
     * @return OK
     */
    saveWordpressPlugin(wordpressPlugin: WordpressPluginDTO): Promise<WordpressPluginDTO> {
        let url_ = this.baseUrl + "/plugins/wordpress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(wordpressPlugin);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveWordpressPlugin(_response);
        });
    }

    protected processSaveWordpressPlugin(response: AxiosResponse): Promise<WordpressPluginDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WordpressPluginDTO.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WordpressPluginDTO>(<any>null);
    }

    /**
     * delete wordpress plugin.
     * @return OK
     */
    deleteWordpressPlugins(id: number): Promise<any> {
        let url_ = this.baseUrl + "/plugins/wordpress?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteWordpressPlugins(_response);
        });
    }

    protected processDeleteWordpressPlugins(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * test the given WP plugin.
     * @return OK
     */
    testWordpressPlugin(id: number): Promise<boolean> {
        let url_ = this.baseUrl + "/plugins/wordpress/test?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processTestWordpressPlugin(_response);
        });
    }

    protected processTestWordpressPlugin(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * get all wordpress plugins for account.
     * @return OK
     */
    getWordpressPlugins(customerAccountId: number): Promise<WordpressPluginDTO[]> {
        let url_ = this.baseUrl + "/plugins/wordpress/all?";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined and cannot be null.");
        else
            url_ += "CustomerAccountId=" + encodeURIComponent("" + customerAccountId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetWordpressPlugins(_response);
        });
    }

    protected processGetWordpressPlugins(response: AxiosResponse): Promise<WordpressPluginDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WordpressPluginDTO.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WordpressPluginDTO[]>(<any>null);
    }

    /**
     * publish an artice to a wordpress plugin.
     * @return OK
     */
    publishToWordpress(articles: WordpressPublishDTO[]): Promise<WordpressPluginDTO> {
        let url_ = this.baseUrl + "/plugins/wordpress/publisharticles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(articles);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPublishToWordpress(_response);
        });
    }

    protected processPublishToWordpress(response: AxiosResponse): Promise<WordpressPluginDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WordpressPluginDTO.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WordpressPluginDTO>(<any>null);
    }
}

export interface IWordsmartClient {
    /**
     * Get links created during wordsmart for an issue.
     * @return OK
     */
    getLinksForIssue(issueId: number): Promise<IssueLinkModel[]>;
    /**
     * Save an array on links for an issue.
     * @return OK
     */
    saveLinks(links: IssueLinkModel[]): Promise<IssueLinkModel[]>;
    /**
     * Delete links from an issue.
     * @return OK
     */
    deleteLink(links: IssueLinkModel[]): Promise<any>;
    /**
     * Copy interactivity links between issues.
     * @param sourceIssueId The issue you want to copy links from.
     * @param destinationIssueID The issue you want to copy link to.
     * @param interactivitySource What links to copy
     * @return OK
     */
    copyLinksToIssue(sourceIssueId: number, destinationIssueID: number, interactivitySource: InteractivitySource): Promise<any>;
    /**
     * Publish Links
     * @return OK
     */
    publishLinksForIssue(issueId: number): Promise<any>;
    /**
     * run wordsmart expression on a page
     * @return OK
     */
    wordsmartPage(customRegEx: WordsmartCustomRegexDTO): Promise<any>;
}

export class WordsmartClient implements IWordsmartClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Get links created during wordsmart for an issue.
     * @return OK
     */
    getLinksForIssue(issueId: number): Promise<IssueLinkModel[]> {
        let url_ = this.baseUrl + "/wordsmart?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetLinksForIssue(_response);
        });
    }

    protected processGetLinksForIssue(response: AxiosResponse): Promise<IssueLinkModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IssueLinkModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueLinkModel[]>(<any>null);
    }

    /**
     * Save an array on links for an issue.
     * @return OK
     */
    saveLinks(links: IssueLinkModel[]): Promise<IssueLinkModel[]> {
        let url_ = this.baseUrl + "/wordsmart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(links);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveLinks(_response);
        });
    }

    protected processSaveLinks(response: AxiosResponse): Promise<IssueLinkModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IssueLinkModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueLinkModel[]>(<any>null);
    }

    /**
     * Delete links from an issue.
     * @return OK
     */
    deleteLink(links: IssueLinkModel[]): Promise<any> {
        let url_ = this.baseUrl + "/wordsmart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(links);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteLink(_response);
        });
    }

    protected processDeleteLink(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Copy interactivity links between issues.
     * @param sourceIssueId The issue you want to copy links from.
     * @param destinationIssueID The issue you want to copy link to.
     * @param interactivitySource What links to copy
     * @return OK
     */
    copyLinksToIssue(sourceIssueId: number, destinationIssueID: number, interactivitySource: InteractivitySource): Promise<any> {
        let url_ = this.baseUrl + "/wordsmart/copy?";
        if (sourceIssueId === undefined || sourceIssueId === null)
            throw new Error("The parameter 'sourceIssueId' must be defined and cannot be null.");
        else
            url_ += "SourceIssueId=" + encodeURIComponent("" + sourceIssueId) + "&"; 
        if (destinationIssueID === undefined || destinationIssueID === null)
            throw new Error("The parameter 'destinationIssueID' must be defined and cannot be null.");
        else
            url_ += "DestinationIssueID=" + encodeURIComponent("" + destinationIssueID) + "&"; 
        if (interactivitySource === undefined || interactivitySource === null)
            throw new Error("The parameter 'interactivitySource' must be defined and cannot be null.");
        else
            url_ += "InteractivitySource=" + encodeURIComponent("" + interactivitySource) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCopyLinksToIssue(_response);
        });
    }

    protected processCopyLinksToIssue(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * Publish Links
     * @return OK
     */
    publishLinksForIssue(issueId: number): Promise<any> {
        let url_ = this.baseUrl + "/wordsmart/publish?";
        if (issueId === undefined || issueId === null)
            throw new Error("The parameter 'issueId' must be defined and cannot be null.");
        else
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPublishLinksForIssue(_response);
        });
    }

    protected processPublishLinksForIssue(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * run wordsmart expression on a page
     * @return OK
     */
    wordsmartPage(customRegEx: WordsmartCustomRegexDTO): Promise<any> {
        let url_ = this.baseUrl + "/wordsmart/page";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customRegEx);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWordsmartPage(_response);
        });
    }

    protected processWordsmartPage(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }
}

export class UserModel implements IUserModel {
    email!: string;
    password!: string;
    confirmPassword!: string | undefined;
    tenantId!: number;
    site!: string | undefined;
    affiliateToken!: string | undefined;
    invitecode!: string | undefined;
    createDefaultWebsite!: boolean | undefined;

    constructor(data?: IUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
            this.confirmPassword = _data["confirmPassword"];
            this.tenantId = _data["tenantId"];
            this.site = _data["site"];
            this.affiliateToken = _data["affiliateToken"];
            this.invitecode = _data["invitecode"];
            this.createDefaultWebsite = _data["createDefaultWebsite"];
        }
    }

    static fromJS(data: any): UserModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        data["confirmPassword"] = this.confirmPassword;
        data["tenantId"] = this.tenantId;
        data["site"] = this.site;
        data["affiliateToken"] = this.affiliateToken;
        data["invitecode"] = this.invitecode;
        data["createDefaultWebsite"] = this.createDefaultWebsite;
        return data; 
    }
}

export interface IUserModel {
    email: string;
    password: string;
    confirmPassword: string | undefined;
    tenantId: number;
    site: string | undefined;
    affiliateToken: string | undefined;
    invitecode: string | undefined;
    createDefaultWebsite: boolean | undefined;
}

export class RegisterExternalBindingModel implements IRegisterExternalBindingModel {
    userName!: string;
    provider!: string;
    externalAccessToken!: string;
    email!: string;
    id!: string;
    affiliateToken!: string | undefined;
    invitecode!: string | undefined;
    givenname!: string | undefined;
    surname!: string | undefined;
    tenantId!: number | undefined;
    createDefaultWebsite!: boolean | undefined;

    constructor(data?: IRegisterExternalBindingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.provider = _data["provider"];
            this.externalAccessToken = _data["externalAccessToken"];
            this.email = _data["email"];
            this.id = _data["id"];
            this.affiliateToken = _data["affiliateToken"];
            this.invitecode = _data["invitecode"];
            this.givenname = _data["givenname"];
            this.surname = _data["surname"];
            this.tenantId = _data["tenantId"];
            this.createDefaultWebsite = _data["createDefaultWebsite"];
        }
    }

    static fromJS(data: any): RegisterExternalBindingModel {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterExternalBindingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["provider"] = this.provider;
        data["externalAccessToken"] = this.externalAccessToken;
        data["email"] = this.email;
        data["id"] = this.id;
        data["affiliateToken"] = this.affiliateToken;
        data["invitecode"] = this.invitecode;
        data["givenname"] = this.givenname;
        data["surname"] = this.surname;
        data["tenantId"] = this.tenantId;
        data["createDefaultWebsite"] = this.createDefaultWebsite;
        return data; 
    }
}

export interface IRegisterExternalBindingModel {
    userName: string;
    provider: string;
    externalAccessToken: string;
    email: string;
    id: string;
    affiliateToken: string | undefined;
    invitecode: string | undefined;
    givenname: string | undefined;
    surname: string | undefined;
    tenantId: number | undefined;
    createDefaultWebsite: boolean | undefined;
}

export class AffiliatePurchasesDTO implements IAffiliatePurchasesDTO {
    title!: string | undefined;
    purchaseDate!: Date | undefined;
    price!: number | undefined;

    constructor(data?: IAffiliatePurchasesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.purchaseDate = _data["purchaseDate"] ? new Date(_data["purchaseDate"].toString()) : <any>undefined;
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): AffiliatePurchasesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AffiliatePurchasesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["purchaseDate"] = this.purchaseDate ? this.purchaseDate.toISOString() : <any>undefined;
        data["price"] = this.price;
        return data; 
    }
}

export interface IAffiliatePurchasesDTO {
    title: string | undefined;
    purchaseDate: Date | undefined;
    price: number | undefined;
}

export class AffiliateConfigurationDTO implements IAffiliateConfigurationDTO {
    id!: number | undefined;
    customerAccountId!: number;
    token!: string | undefined;
    daysActive!: number;
    created!: Date | undefined;
    percent!: number;
    status!: AffiliateConfigurationDTOStatus;
    activated!: number | undefined;

    constructor(data?: IAffiliateConfigurationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerAccountId = _data["customerAccountId"];
            this.token = _data["token"];
            this.daysActive = _data["daysActive"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.percent = _data["percent"];
            this.status = _data["status"];
            this.activated = _data["activated"];
        }
    }

    static fromJS(data: any): AffiliateConfigurationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AffiliateConfigurationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerAccountId"] = this.customerAccountId;
        data["token"] = this.token;
        data["daysActive"] = this.daysActive;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["percent"] = this.percent;
        data["status"] = this.status;
        data["activated"] = this.activated;
        return data; 
    }
}

export interface IAffiliateConfigurationDTO {
    id: number | undefined;
    customerAccountId: number;
    token: string | undefined;
    daysActive: number;
    created: Date | undefined;
    percent: number;
    status: AffiliateConfigurationDTOStatus;
    activated: number | undefined;
}

export class AIAggregate implements IAIAggregate {
    entityname!: string | undefined;
    tags!: any | undefined;

    constructor(data?: IAIAggregate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityname = _data["entityname"];
            this.tags = _data["tags"];
        }
    }

    static fromJS(data: any): AIAggregate {
        data = typeof data === 'object' ? data : {};
        let result = new AIAggregate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityname"] = this.entityname;
        data["tags"] = this.tags;
        return data; 
    }
}

export interface IAIAggregate {
    entityname: string | undefined;
    tags: any | undefined;
}

export class AIArticleResult implements IAIArticleResult {
    result!: AINameEntityModel[] | undefined;
    status!: string | undefined;
    decs!: string | undefined;

    constructor(data?: IAIArticleResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(AINameEntityModel.fromJS(item));
            }
            this.status = _data["status"];
            this.decs = _data["decs"];
        }
    }

    static fromJS(data: any): AIArticleResult {
        data = typeof data === 'object' ? data : {};
        let result = new AIArticleResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["decs"] = this.decs;
        return data; 
    }
}

export interface IAIArticleResult {
    result: AINameEntityModel[] | undefined;
    status: string | undefined;
    decs: string | undefined;
}

export class AINameEntityModel implements IAINameEntityModel {
    _id!: string | undefined;
    _source!: AISource | undefined;

    constructor(data?: IAINameEntityModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._id = _data["_id"];
            this._source = _data["_source"] ? AISource.fromJS(_data["_source"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AINameEntityModel {
        data = typeof data === 'object' ? data : {};
        let result = new AINameEntityModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_id"] = this._id;
        data["_source"] = this._source ? this._source.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAINameEntityModel {
    _id: string | undefined;
    _source: AISource | undefined;
}

export class AISource implements IAISource {
    articleid!: string | undefined;
    nnp!: string[] | undefined;
    entity!: AIEntity[] | undefined;

    constructor(data?: IAISource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleid = _data["articleid"];
            if (Array.isArray(_data["nnp"])) {
                this.nnp = [] as any;
                for (let item of _data["nnp"])
                    this.nnp!.push(item);
            }
            if (Array.isArray(_data["entity"])) {
                this.entity = [] as any;
                for (let item of _data["entity"])
                    this.entity!.push(AIEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AISource {
        data = typeof data === 'object' ? data : {};
        let result = new AISource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleid"] = this.articleid;
        if (Array.isArray(this.nnp)) {
            data["nnp"] = [];
            for (let item of this.nnp)
                data["nnp"].push(item);
        }
        if (Array.isArray(this.entity)) {
            data["entity"] = [];
            for (let item of this.entity)
                data["entity"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAISource {
    articleid: string | undefined;
    nnp: string[] | undefined;
    entity: AIEntity[] | undefined;
}

export class AIEntity implements IAIEntity {
    entityname!: string | undefined;
    tags!: string[] | undefined;

    constructor(data?: IAIEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityname = _data["entityname"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
        }
    }

    static fromJS(data: any): AIEntity {
        data = typeof data === 'object' ? data : {};
        let result = new AIEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityname"] = this.entityname;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        return data; 
    }
}

export interface IAIEntity {
    entityname: string | undefined;
    tags: string[] | undefined;
}

export class AIAutoTag implements IAIAutoTag {
    status!: string | undefined;
    tags!: string[] | undefined;
    desc!: string | undefined;

    constructor(data?: IAIAutoTag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.desc = _data["desc"];
        }
    }

    static fromJS(data: any): AIAutoTag {
        data = typeof data === 'object' ? data : {};
        let result = new AIAutoTag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["desc"] = this.desc;
        return data; 
    }
}

export interface IAIAutoTag {
    status: string | undefined;
    tags: string[] | undefined;
    desc: string | undefined;
}

/** publication notes. */
export class PublicationAnalyticsModel implements IPublicationAnalyticsModel {
    /** Publication identifier. */
    publicationId!: number | undefined;
    /** Goolgle UA-Code */
    uaCode!: string | undefined;

    constructor(data?: IPublicationAnalyticsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.publicationId = _data["publicationId"];
            this.uaCode = _data["uaCode"];
        }
    }

    static fromJS(data: any): PublicationAnalyticsModel {
        data = typeof data === 'object' ? data : {};
        let result = new PublicationAnalyticsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["publicationId"] = this.publicationId;
        data["uaCode"] = this.uaCode;
        return data; 
    }
}

/** publication notes. */
export interface IPublicationAnalyticsModel {
    /** Publication identifier. */
    publicationId: number | undefined;
    /** Goolgle UA-Code */
    uaCode: string | undefined;
}

export class CustomerArticleLicenceDTO implements ICustomerArticleLicenceDTO {
    customerArticleLicenceId!: number | undefined;
    customerAccountId!: number;
    name!: string;
    description!: string;
    body!: string;
    timestamp!: Date;
    default!: boolean;
    customerArticleLicenceHistories!: CustomerArticleLicenceHistoryDTO[] | undefined;

    constructor(data?: ICustomerArticleLicenceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerArticleLicenceId = _data["customerArticleLicenceId"];
            this.customerAccountId = _data["customerAccountId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.body = _data["body"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.default = _data["default"];
            if (Array.isArray(_data["customerArticleLicenceHistories"])) {
                this.customerArticleLicenceHistories = [] as any;
                for (let item of _data["customerArticleLicenceHistories"])
                    this.customerArticleLicenceHistories!.push(CustomerArticleLicenceHistoryDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerArticleLicenceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerArticleLicenceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerArticleLicenceId"] = this.customerArticleLicenceId;
        data["customerAccountId"] = this.customerAccountId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["body"] = this.body;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["default"] = this.default;
        if (Array.isArray(this.customerArticleLicenceHistories)) {
            data["customerArticleLicenceHistories"] = [];
            for (let item of this.customerArticleLicenceHistories)
                data["customerArticleLicenceHistories"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICustomerArticleLicenceDTO {
    customerArticleLicenceId: number | undefined;
    customerAccountId: number;
    name: string;
    description: string;
    body: string;
    timestamp: Date;
    default: boolean;
    customerArticleLicenceHistories: CustomerArticleLicenceHistoryDTO[] | undefined;
}

export class CustomerArticleLicenceHistoryDTO implements ICustomerArticleLicenceHistoryDTO {
    customerArticleLicenceHistoryId!: number | undefined;
    customerArticleLicenceId!: number | undefined;
    body!: string;
    timestamp!: Date;

    constructor(data?: ICustomerArticleLicenceHistoryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerArticleLicenceHistoryId = _data["customerArticleLicenceHistoryId"];
            this.customerArticleLicenceId = _data["customerArticleLicenceId"];
            this.body = _data["body"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomerArticleLicenceHistoryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerArticleLicenceHistoryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerArticleLicenceHistoryId"] = this.customerArticleLicenceHistoryId;
        data["customerArticleLicenceId"] = this.customerArticleLicenceId;
        data["body"] = this.body;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        return data; 
    }
}

export interface ICustomerArticleLicenceHistoryDTO {
    customerArticleLicenceHistoryId: number | undefined;
    customerArticleLicenceId: number | undefined;
    body: string;
    timestamp: Date;
}

export class AccountArticleLicenceDTO implements IAccountArticleLicenceDTO {
    articleId!: number | undefined;
    publication!: string | undefined;
    title!: string | undefined;
    timestamp!: Date | undefined;
    licenceName!: string | undefined;
    selected!: boolean | undefined;
    licenceId!: number | undefined;

    constructor(data?: IAccountArticleLicenceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"];
            this.publication = _data["publication"];
            this.title = _data["title"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.licenceName = _data["licenceName"];
            this.selected = _data["selected"];
            this.licenceId = _data["licenceId"];
        }
    }

    static fromJS(data: any): AccountArticleLicenceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AccountArticleLicenceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId;
        data["publication"] = this.publication;
        data["title"] = this.title;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["licenceName"] = this.licenceName;
        data["selected"] = this.selected;
        data["licenceId"] = this.licenceId;
        return data; 
    }
}

export interface IAccountArticleLicenceDTO {
    articleId: number | undefined;
    publication: string | undefined;
    title: string | undefined;
    timestamp: Date | undefined;
    licenceName: string | undefined;
    selected: boolean | undefined;
    licenceId: number | undefined;
}

export class ArticleModel implements IArticleModel {
    id!: number | undefined;
    sectionId!: number | undefined;
    issueId!: number | undefined;
    parentArticleId!: string | undefined;
    articleType!: ArticleModelArticleType | undefined;
    articleId!: string | undefined;
    articleAccess!: number | undefined;
    slug!: string | undefined;
    abstract!: string | undefined;
    pageNumber!: number | undefined;
    subheading!: string | undefined;
    title!: string | undefined;
    text!: string | undefined;
    css!: string | undefined;
    order!: number | undefined;
    coordinates!: string | undefined;
    hash!: string | undefined;
    created!: Date | undefined;
    modified!: Date | undefined;
    articleDate!: Date | undefined;
    price!: number | undefined;
    themes!: ArticleThemeModel[] | undefined;
    contributors!: ArticleContributorModel[] | undefined;
    images!: ArticleImageModel[] | undefined;
    keywords!: ArticleKeywordModel[] | undefined;
    section!: SectionModel | undefined;
    issue!: IssueModel | undefined;
    articleSocials!: ArticleSocialsDTO | undefined;
    locations!: ArticleLocationModel[] | undefined;

    constructor(data?: IArticleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sectionId = _data["sectionId"];
            this.issueId = _data["issueId"];
            this.parentArticleId = _data["parentArticleId"];
            this.articleType = _data["articleType"];
            this.articleId = _data["articleId"];
            this.articleAccess = _data["articleAccess"];
            this.slug = _data["slug"];
            this.abstract = _data["abstract"];
            this.pageNumber = _data["pageNumber"];
            this.subheading = _data["subheading"];
            this.title = _data["title"];
            this.text = _data["text"];
            this.css = _data["css"];
            this.order = _data["order"];
            this.coordinates = _data["coordinates"];
            this.hash = _data["hash"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.articleDate = _data["articleDate"] ? new Date(_data["articleDate"].toString()) : <any>undefined;
            this.price = _data["price"];
            if (Array.isArray(_data["themes"])) {
                this.themes = [] as any;
                for (let item of _data["themes"])
                    this.themes!.push(ArticleThemeModel.fromJS(item));
            }
            if (Array.isArray(_data["contributors"])) {
                this.contributors = [] as any;
                for (let item of _data["contributors"])
                    this.contributors!.push(ArticleContributorModel.fromJS(item));
            }
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(ArticleImageModel.fromJS(item));
            }
            if (Array.isArray(_data["keywords"])) {
                this.keywords = [] as any;
                for (let item of _data["keywords"])
                    this.keywords!.push(ArticleKeywordModel.fromJS(item));
            }
            this.section = _data["section"] ? SectionModel.fromJS(_data["section"]) : <any>undefined;
            this.issue = _data["issue"] ? IssueModel.fromJS(_data["issue"]) : <any>undefined;
            this.articleSocials = _data["articleSocials"] ? ArticleSocialsDTO.fromJS(_data["articleSocials"]) : <any>undefined;
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(ArticleLocationModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ArticleModel {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sectionId"] = this.sectionId;
        data["issueId"] = this.issueId;
        data["parentArticleId"] = this.parentArticleId;
        data["articleType"] = this.articleType;
        data["articleId"] = this.articleId;
        data["articleAccess"] = this.articleAccess;
        data["slug"] = this.slug;
        data["abstract"] = this.abstract;
        data["pageNumber"] = this.pageNumber;
        data["subheading"] = this.subheading;
        data["title"] = this.title;
        data["text"] = this.text;
        data["css"] = this.css;
        data["order"] = this.order;
        data["coordinates"] = this.coordinates;
        data["hash"] = this.hash;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["articleDate"] = this.articleDate ? this.articleDate.toISOString() : <any>undefined;
        data["price"] = this.price;
        if (Array.isArray(this.themes)) {
            data["themes"] = [];
            for (let item of this.themes)
                data["themes"].push(item.toJSON());
        }
        if (Array.isArray(this.contributors)) {
            data["contributors"] = [];
            for (let item of this.contributors)
                data["contributors"].push(item.toJSON());
        }
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        if (Array.isArray(this.keywords)) {
            data["keywords"] = [];
            for (let item of this.keywords)
                data["keywords"].push(item.toJSON());
        }
        data["section"] = this.section ? this.section.toJSON() : <any>undefined;
        data["issue"] = this.issue ? this.issue.toJSON() : <any>undefined;
        data["articleSocials"] = this.articleSocials ? this.articleSocials.toJSON() : <any>undefined;
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IArticleModel {
    id: number | undefined;
    sectionId: number | undefined;
    issueId: number | undefined;
    parentArticleId: string | undefined;
    articleType: ArticleModelArticleType | undefined;
    articleId: string | undefined;
    articleAccess: number | undefined;
    slug: string | undefined;
    abstract: string | undefined;
    pageNumber: number | undefined;
    subheading: string | undefined;
    title: string | undefined;
    text: string | undefined;
    css: string | undefined;
    order: number | undefined;
    coordinates: string | undefined;
    hash: string | undefined;
    created: Date | undefined;
    modified: Date | undefined;
    articleDate: Date | undefined;
    price: number | undefined;
    themes: ArticleThemeModel[] | undefined;
    contributors: ArticleContributorModel[] | undefined;
    images: ArticleImageModel[] | undefined;
    keywords: ArticleKeywordModel[] | undefined;
    section: SectionModel | undefined;
    issue: IssueModel | undefined;
    articleSocials: ArticleSocialsDTO | undefined;
    locations: ArticleLocationModel[] | undefined;
}

export class ArticleThemeModel implements IArticleThemeModel {
    id!: number | undefined;
    articleId!: number | undefined;
    theme!: string | undefined;

    constructor(data?: IArticleThemeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.articleId = _data["articleId"];
            this.theme = _data["theme"];
        }
    }

    static fromJS(data: any): ArticleThemeModel {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleThemeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["articleId"] = this.articleId;
        data["theme"] = this.theme;
        return data; 
    }
}

export interface IArticleThemeModel {
    id: number | undefined;
    articleId: number | undefined;
    theme: string | undefined;
}

export class ArticleContributorModel implements IArticleContributorModel {
    id!: number | undefined;
    articleId!: number | undefined;
    contributor!: string | undefined;

    constructor(data?: IArticleContributorModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.articleId = _data["articleId"];
            this.contributor = _data["contributor"];
        }
    }

    static fromJS(data: any): ArticleContributorModel {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleContributorModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["articleId"] = this.articleId;
        data["contributor"] = this.contributor;
        return data; 
    }
}

export interface IArticleContributorModel {
    id: number | undefined;
    articleId: number | undefined;
    contributor: string | undefined;
}

export class ArticleImageModel implements IArticleImageModel {
    id!: number | undefined;
    articleId!: number | undefined;
    aiType!: string | undefined;
    backgroundPosition!: string | undefined;
    caption!: string | undefined;
    contributor!: string | undefined;
    isFeatured!: boolean | undefined;
    isFirst!: boolean | undefined;
    src!: string | undefined;
    uid!: string | undefined;

    constructor(data?: IArticleImageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.articleId = _data["articleId"];
            this.aiType = _data["aiType"];
            this.backgroundPosition = _data["backgroundPosition"];
            this.caption = _data["caption"];
            this.contributor = _data["contributor"];
            this.isFeatured = _data["isFeatured"];
            this.isFirst = _data["isFirst"];
            this.src = _data["src"];
            this.uid = _data["uid"];
        }
    }

    static fromJS(data: any): ArticleImageModel {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleImageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["articleId"] = this.articleId;
        data["aiType"] = this.aiType;
        data["backgroundPosition"] = this.backgroundPosition;
        data["caption"] = this.caption;
        data["contributor"] = this.contributor;
        data["isFeatured"] = this.isFeatured;
        data["isFirst"] = this.isFirst;
        data["src"] = this.src;
        data["uid"] = this.uid;
        return data; 
    }
}

export interface IArticleImageModel {
    id: number | undefined;
    articleId: number | undefined;
    aiType: string | undefined;
    backgroundPosition: string | undefined;
    caption: string | undefined;
    contributor: string | undefined;
    isFeatured: boolean | undefined;
    isFirst: boolean | undefined;
    src: string | undefined;
    uid: string | undefined;
}

export class ArticleKeywordModel implements IArticleKeywordModel {
    id!: number | undefined;
    articleId!: number | undefined;
    keyword!: string | undefined;

    constructor(data?: IArticleKeywordModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.articleId = _data["articleId"];
            this.keyword = _data["keyword"];
        }
    }

    static fromJS(data: any): ArticleKeywordModel {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleKeywordModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["articleId"] = this.articleId;
        data["keyword"] = this.keyword;
        return data; 
    }
}

export interface IArticleKeywordModel {
    id: number | undefined;
    articleId: number | undefined;
    keyword: string | undefined;
}

/** section class for mobile app */
export class SectionModel implements ISectionModel {
    /** Name of the section. */
    name!: string;
    /** Section identifier. */
    id!: number | undefined;
    /** Publication identifier */
    publicationId!: number | undefined;
    /** section status. */
    status!: number | undefined;
    color!: string | undefined;
    order!: number | undefined;

    constructor(data?: ISectionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
            this.publicationId = _data["publicationId"];
            this.status = _data["status"];
            this.color = _data["color"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): SectionModel {
        data = typeof data === 'object' ? data : {};
        let result = new SectionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        data["publicationId"] = this.publicationId;
        data["status"] = this.status;
        data["color"] = this.color;
        data["order"] = this.order;
        return data; 
    }
}

/** section class for mobile app */
export interface ISectionModel {
    /** Name of the section. */
    name: string;
    /** Section identifier. */
    id: number | undefined;
    /** Publication identifier */
    publicationId: number | undefined;
    /** section status. */
    status: number | undefined;
    color: string | undefined;
    order: number | undefined;
}

export class IssueModel implements IIssueModel {
    id!: number | undefined;
    name!: string | undefined;
    created!: Date | undefined;
    status!: number | undefined;
    visibility!: number | undefined;
    guid!: string | undefined;
    version!: number | undefined;
    sequence!: number | undefined;
    numberPages!: number | undefined;
    urlFragment!: string | undefined;
    issueDate!: Date | undefined;
    issueOrder!: number | undefined;
    secure!: number | undefined;
    publicationId!: number | undefined;
    issueType!: IssueModelIssueType | undefined;
    publication!: IssuePublicationModel | undefined;

    constructor(data?: IIssueModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.visibility = _data["visibility"];
            this.guid = _data["guid"];
            this.version = _data["version"];
            this.sequence = _data["sequence"];
            this.numberPages = _data["numberPages"];
            this.urlFragment = _data["urlFragment"];
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : <any>undefined;
            this.issueOrder = _data["issueOrder"];
            this.secure = _data["secure"];
            this.publicationId = _data["publicationId"];
            this.issueType = _data["issueType"];
            this.publication = _data["publication"] ? IssuePublicationModel.fromJS(_data["publication"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IssueModel {
        data = typeof data === 'object' ? data : {};
        let result = new IssueModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["visibility"] = this.visibility;
        data["guid"] = this.guid;
        data["version"] = this.version;
        data["sequence"] = this.sequence;
        data["numberPages"] = this.numberPages;
        data["urlFragment"] = this.urlFragment;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>undefined;
        data["issueOrder"] = this.issueOrder;
        data["secure"] = this.secure;
        data["publicationId"] = this.publicationId;
        data["issueType"] = this.issueType;
        data["publication"] = this.publication ? this.publication.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IIssueModel {
    id: number | undefined;
    name: string | undefined;
    created: Date | undefined;
    status: number | undefined;
    visibility: number | undefined;
    guid: string | undefined;
    version: number | undefined;
    sequence: number | undefined;
    numberPages: number | undefined;
    urlFragment: string | undefined;
    issueDate: Date | undefined;
    issueOrder: number | undefined;
    secure: number | undefined;
    publicationId: number | undefined;
    issueType: IssueModelIssueType | undefined;
    publication: IssuePublicationModel | undefined;
}

export class ArticleSocialsDTO implements IArticleSocialsDTO {
    articleSocialId!: number;
    linkedin!: string | undefined;
    facebook!: string | undefined;
    instagram!: string | undefined;

    constructor(data?: IArticleSocialsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleSocialId = _data["articleSocialId"];
            this.linkedin = _data["linkedin"];
            this.facebook = _data["facebook"];
            this.instagram = _data["instagram"];
        }
    }

    static fromJS(data: any): ArticleSocialsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleSocialsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleSocialId"] = this.articleSocialId;
        data["linkedin"] = this.linkedin;
        data["facebook"] = this.facebook;
        data["instagram"] = this.instagram;
        return data; 
    }
}

export interface IArticleSocialsDTO {
    articleSocialId: number;
    linkedin: string | undefined;
    facebook: string | undefined;
    instagram: string | undefined;
}

export class ArticleLocationModel implements IArticleLocationModel {
    id!: number | undefined;
    articleId!: number | undefined;
    locationId!: number | undefined;
    location!: string | undefined;

    constructor(data?: IArticleLocationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.articleId = _data["articleId"];
            this.locationId = _data["locationId"];
            this.location = _data["location"];
        }
    }

    static fromJS(data: any): ArticleLocationModel {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleLocationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["articleId"] = this.articleId;
        data["locationId"] = this.locationId;
        data["location"] = this.location;
        return data; 
    }
}

export interface IArticleLocationModel {
    id: number | undefined;
    articleId: number | undefined;
    locationId: number | undefined;
    location: string | undefined;
}

export class IssuePublicationModel implements IIssuePublicationModel {
    name!: string | undefined;
    customerAccountId!: number | undefined;
    langauage!: number | undefined;

    constructor(data?: IIssuePublicationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.customerAccountId = _data["customerAccountId"];
            this.langauage = _data["langauage"];
        }
    }

    static fromJS(data: any): IssuePublicationModel {
        data = typeof data === 'object' ? data : {};
        let result = new IssuePublicationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["customerAccountId"] = this.customerAccountId;
        data["langauage"] = this.langauage;
        return data; 
    }
}

export interface IIssuePublicationModel {
    name: string | undefined;
    customerAccountId: number | undefined;
    langauage: number | undefined;
}

export class ContentSearchDataOfContentSearchHit implements IContentSearchDataOfContentSearchHit {
    /** The restriction (account or title id) */
    id!: string | undefined;
    /** filter to limit breadth of search e.g. issue eq 'testissue' */
    filters!: { [key: string]: string; } | undefined;
    /** results of the search */
    results!: ContentSearchResultsOfContentSearchHit | undefined;
    /** facets results for search */
    facetResults!: FacetInfo[] | undefined;
    /** search query */
    query!: string | undefined;
    /** number of hits to return */
    top!: number | undefined;
    /** page umber of hits to return */
    page!: number | undefined;
    /** specify the facets you want to include in the results. */
    facets!: string[] | undefined;
    orderby!: string[] | undefined;
    message!: string | undefined;

    constructor(data?: IContentSearchDataOfContentSearchHit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (_data["filters"]) {
                this.filters = {} as any;
                for (let key in _data["filters"]) {
                    if (_data["filters"].hasOwnProperty(key))
                        this.filters![key] = _data["filters"][key];
                }
            }
            this.results = _data["results"] ? ContentSearchResultsOfContentSearchHit.fromJS(_data["results"]) : <any>undefined;
            if (Array.isArray(_data["facetResults"])) {
                this.facetResults = [] as any;
                for (let item of _data["facetResults"])
                    this.facetResults!.push(FacetInfo.fromJS(item));
            }
            this.query = _data["query"];
            this.top = _data["top"];
            this.page = _data["page"];
            if (Array.isArray(_data["facets"])) {
                this.facets = [] as any;
                for (let item of _data["facets"])
                    this.facets!.push(item);
            }
            if (Array.isArray(_data["orderby"])) {
                this.orderby = [] as any;
                for (let item of _data["orderby"])
                    this.orderby!.push(item);
            }
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ContentSearchDataOfContentSearchHit {
        data = typeof data === 'object' ? data : {};
        let result = new ContentSearchDataOfContentSearchHit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.filters) {
            data["filters"] = {};
            for (let key in this.filters) {
                if (this.filters.hasOwnProperty(key))
                    data["filters"][key] = this.filters[key];
            }
        }
        data["results"] = this.results ? this.results.toJSON() : <any>undefined;
        if (Array.isArray(this.facetResults)) {
            data["facetResults"] = [];
            for (let item of this.facetResults)
                data["facetResults"].push(item.toJSON());
        }
        data["query"] = this.query;
        data["top"] = this.top;
        data["page"] = this.page;
        if (Array.isArray(this.facets)) {
            data["facets"] = [];
            for (let item of this.facets)
                data["facets"].push(item);
        }
        if (Array.isArray(this.orderby)) {
            data["orderby"] = [];
            for (let item of this.orderby)
                data["orderby"].push(item);
        }
        data["message"] = this.message;
        return data; 
    }
}

export interface IContentSearchDataOfContentSearchHit {
    /** The restriction (account or title id) */
    id: string | undefined;
    /** filter to limit breadth of search e.g. issue eq 'testissue' */
    filters: { [key: string]: string; } | undefined;
    /** results of the search */
    results: ContentSearchResultsOfContentSearchHit | undefined;
    /** facets results for search */
    facetResults: FacetInfo[] | undefined;
    /** search query */
    query: string | undefined;
    /** number of hits to return */
    top: number | undefined;
    /** page umber of hits to return */
    page: number | undefined;
    /** specify the facets you want to include in the results. */
    facets: string[] | undefined;
    orderby: string[] | undefined;
    message: string | undefined;
}

export class ContentSearchResultsOfContentSearchHit implements IContentSearchResultsOfContentSearchHit {
    hits!: ContentSearchHit[] | undefined;
    total_hits!: number | undefined;

    constructor(data?: IContentSearchResultsOfContentSearchHit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["hits"])) {
                this.hits = [] as any;
                for (let item of _data["hits"])
                    this.hits!.push(ContentSearchHit.fromJS(item));
            }
            this.total_hits = _data["total_hits"];
        }
    }

    static fromJS(data: any): ContentSearchResultsOfContentSearchHit {
        data = typeof data === 'object' ? data : {};
        let result = new ContentSearchResultsOfContentSearchHit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.hits)) {
            data["hits"] = [];
            for (let item of this.hits)
                data["hits"].push(item.toJSON());
        }
        data["total_hits"] = this.total_hits;
        return data; 
    }
}

export interface IContentSearchResultsOfContentSearchHit {
    hits: ContentSearchHit[] | undefined;
    total_hits: number | undefined;
}

export class FacetInfo implements IFacetInfo {
    facetName!: string | undefined;
    facets!: { [key: string]: number; } | undefined;

    constructor(data?: IFacetInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.facetName = _data["facetName"];
            if (_data["facets"]) {
                this.facets = {} as any;
                for (let key in _data["facets"]) {
                    if (_data["facets"].hasOwnProperty(key))
                        this.facets![key] = _data["facets"][key];
                }
            }
        }
    }

    static fromJS(data: any): FacetInfo {
        data = typeof data === 'object' ? data : {};
        let result = new FacetInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facetName"] = this.facetName;
        if (this.facets) {
            data["facets"] = {};
            for (let key in this.facets) {
                if (this.facets.hasOwnProperty(key))
                    data["facets"][key] = this.facets[key];
            }
        }
        return data; 
    }
}

export interface IFacetInfo {
    facetName: string | undefined;
    facets: { [key: string]: number; } | undefined;
}

export class ContentSearchHit implements IContentSearchHit {
    issueSlug!: string | undefined;
    issueId!: number | undefined;
    pageNumber!: number | undefined;
    slug!: string | undefined;
    hits!: string[] | undefined;
    body_hits!: string[] | undefined;
    title_hits!: string[] | undefined;
    keywords_hits!: string[] | undefined;
    themes_hits!: string[] | undefined;
    description_hits!: string[] | undefined;
    section!: string | undefined;
    title!: string | undefined;
    featuredImage!: string | undefined;
    abstract!: string | undefined;
    issue!: string | undefined;
    publication!: string | undefined;
    issueGuid!: string | undefined;
    articleType!: number | undefined;
    articleId!: string | undefined;
    accountName!: string | undefined;
    price!: number | undefined;
    wordCount!: number | undefined;

    constructor(data?: IContentSearchHit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueSlug = _data["issueSlug"];
            this.issueId = _data["issueId"];
            this.pageNumber = _data["pageNumber"];
            this.slug = _data["slug"];
            if (Array.isArray(_data["hits"])) {
                this.hits = [] as any;
                for (let item of _data["hits"])
                    this.hits!.push(item);
            }
            if (Array.isArray(_data["body_hits"])) {
                this.body_hits = [] as any;
                for (let item of _data["body_hits"])
                    this.body_hits!.push(item);
            }
            if (Array.isArray(_data["title_hits"])) {
                this.title_hits = [] as any;
                for (let item of _data["title_hits"])
                    this.title_hits!.push(item);
            }
            if (Array.isArray(_data["keywords_hits"])) {
                this.keywords_hits = [] as any;
                for (let item of _data["keywords_hits"])
                    this.keywords_hits!.push(item);
            }
            if (Array.isArray(_data["themes_hits"])) {
                this.themes_hits = [] as any;
                for (let item of _data["themes_hits"])
                    this.themes_hits!.push(item);
            }
            if (Array.isArray(_data["description_hits"])) {
                this.description_hits = [] as any;
                for (let item of _data["description_hits"])
                    this.description_hits!.push(item);
            }
            this.section = _data["section"];
            this.title = _data["title"];
            this.featuredImage = _data["featuredImage"];
            this.abstract = _data["abstract"];
            this.issue = _data["issue"];
            this.publication = _data["publication"];
            this.issueGuid = _data["issueGuid"];
            this.articleType = _data["articleType"];
            this.articleId = _data["articleId"];
            this.accountName = _data["accountName"];
            this.price = _data["price"];
            this.wordCount = _data["wordCount"];
        }
    }

    static fromJS(data: any): ContentSearchHit {
        data = typeof data === 'object' ? data : {};
        let result = new ContentSearchHit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueSlug"] = this.issueSlug;
        data["issueId"] = this.issueId;
        data["pageNumber"] = this.pageNumber;
        data["slug"] = this.slug;
        if (Array.isArray(this.hits)) {
            data["hits"] = [];
            for (let item of this.hits)
                data["hits"].push(item);
        }
        if (Array.isArray(this.body_hits)) {
            data["body_hits"] = [];
            for (let item of this.body_hits)
                data["body_hits"].push(item);
        }
        if (Array.isArray(this.title_hits)) {
            data["title_hits"] = [];
            for (let item of this.title_hits)
                data["title_hits"].push(item);
        }
        if (Array.isArray(this.keywords_hits)) {
            data["keywords_hits"] = [];
            for (let item of this.keywords_hits)
                data["keywords_hits"].push(item);
        }
        if (Array.isArray(this.themes_hits)) {
            data["themes_hits"] = [];
            for (let item of this.themes_hits)
                data["themes_hits"].push(item);
        }
        if (Array.isArray(this.description_hits)) {
            data["description_hits"] = [];
            for (let item of this.description_hits)
                data["description_hits"].push(item);
        }
        data["section"] = this.section;
        data["title"] = this.title;
        data["featuredImage"] = this.featuredImage;
        data["abstract"] = this.abstract;
        data["issue"] = this.issue;
        data["publication"] = this.publication;
        data["issueGuid"] = this.issueGuid;
        data["articleType"] = this.articleType;
        data["articleId"] = this.articleId;
        data["accountName"] = this.accountName;
        data["price"] = this.price;
        data["wordCount"] = this.wordCount;
        return data; 
    }
}

export interface IContentSearchHit {
    issueSlug: string | undefined;
    issueId: number | undefined;
    pageNumber: number | undefined;
    slug: string | undefined;
    hits: string[] | undefined;
    body_hits: string[] | undefined;
    title_hits: string[] | undefined;
    keywords_hits: string[] | undefined;
    themes_hits: string[] | undefined;
    description_hits: string[] | undefined;
    section: string | undefined;
    title: string | undefined;
    featuredImage: string | undefined;
    abstract: string | undefined;
    issue: string | undefined;
    publication: string | undefined;
    issueGuid: string | undefined;
    articleType: number | undefined;
    articleId: string | undefined;
    accountName: string | undefined;
    price: number | undefined;
    wordCount: number | undefined;
}

export class ArticleStats implements IArticleStats {
    name!: string | undefined;
    numberArticles!: number | undefined;
    titles!: ArticleTitleStats[] | undefined;

    constructor(data?: IArticleStats) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.numberArticles = _data["numberArticles"];
            if (Array.isArray(_data["titles"])) {
                this.titles = [] as any;
                for (let item of _data["titles"])
                    this.titles!.push(ArticleTitleStats.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ArticleStats {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["numberArticles"] = this.numberArticles;
        if (Array.isArray(this.titles)) {
            data["titles"] = [];
            for (let item of this.titles)
                data["titles"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IArticleStats {
    name: string | undefined;
    numberArticles: number | undefined;
    titles: ArticleTitleStats[] | undefined;
}

export class ArticleTitleStats implements IArticleTitleStats {
    titleId!: number | undefined;
    name!: string | undefined;
    numberArticles!: number | undefined;
    issues!: ArticleIssueStats[] | undefined;

    constructor(data?: IArticleTitleStats) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"];
            this.name = _data["name"];
            this.numberArticles = _data["numberArticles"];
            if (Array.isArray(_data["issues"])) {
                this.issues = [] as any;
                for (let item of _data["issues"])
                    this.issues!.push(ArticleIssueStats.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ArticleTitleStats {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleTitleStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId;
        data["name"] = this.name;
        data["numberArticles"] = this.numberArticles;
        if (Array.isArray(this.issues)) {
            data["issues"] = [];
            for (let item of this.issues)
                data["issues"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IArticleTitleStats {
    titleId: number | undefined;
    name: string | undefined;
    numberArticles: number | undefined;
    issues: ArticleIssueStats[] | undefined;
}

export class ArticleIssueStats implements IArticleIssueStats {
    issueId!: number | undefined;
    name!: string | undefined;
    numberArticles!: number | undefined;
    issueDate!: Date | undefined;
    publicationId!: number | undefined;

    constructor(data?: IArticleIssueStats) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueId = _data["issueId"];
            this.name = _data["name"];
            this.numberArticles = _data["numberArticles"];
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : <any>undefined;
            this.publicationId = _data["publicationId"];
        }
    }

    static fromJS(data: any): ArticleIssueStats {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleIssueStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueId"] = this.issueId;
        data["name"] = this.name;
        data["numberArticles"] = this.numberArticles;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>undefined;
        data["publicationId"] = this.publicationId;
        return data; 
    }
}

export interface IArticleIssueStats {
    issueId: number | undefined;
    name: string | undefined;
    numberArticles: number | undefined;
    issueDate: Date | undefined;
    publicationId: number | undefined;
}

/** auth0 and paritca data needed to create Auth0 OAuth clients */
export class Auth0CreateDetails implements IAuth0CreateDetails {
    /** Auth0 domain. */
    auth0domain!: string | undefined;
    /** Auth0 token */
    auth0token!: string | undefined;
    /** Partica urlID */
    customerUrlId!: number | undefined;

    constructor(data?: IAuth0CreateDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.auth0domain = _data["auth0domain"];
            this.auth0token = _data["auth0token"];
            this.customerUrlId = _data["customerUrlId"];
        }
    }

    static fromJS(data: any): Auth0CreateDetails {
        data = typeof data === 'object' ? data : {};
        let result = new Auth0CreateDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["auth0domain"] = this.auth0domain;
        data["auth0token"] = this.auth0token;
        data["customerUrlId"] = this.customerUrlId;
        return data; 
    }
}

/** auth0 and paritca data needed to create Auth0 OAuth clients */
export interface IAuth0CreateDetails {
    /** Auth0 domain. */
    auth0domain: string | undefined;
    /** Auth0 token */
    auth0token: string | undefined;
    /** Partica urlID */
    customerUrlId: number | undefined;
}

export class CustomerAuthConfigModel implements ICustomerAuthConfigModel {
    logoutUrl!: string | undefined;
    logoutText!: string | undefined;
    customerUrlId!: number | undefined;
    authDomain!: string | undefined;
    loginUrl!: string | undefined;
    loginText!: string | undefined;
    signupUrl!: string | undefined;
    signupText!: string | undefined;
    readmoreUrl!: string | undefined;
    readmoreText!: string | undefined;
    secret!: string | undefined;
    clientId!: string | undefined;
    widgetOptions!: string | undefined;
    apiClientId!: string | undefined;
    apiClientSecret!: string | undefined;
    authProvider!: number | undefined;
    scope!: string | undefined;

    constructor(data?: ICustomerAuthConfigModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logoutUrl = _data["logoutUrl"];
            this.logoutText = _data["logoutText"];
            this.customerUrlId = _data["customerUrlId"];
            this.authDomain = _data["authDomain"];
            this.loginUrl = _data["loginUrl"];
            this.loginText = _data["loginText"];
            this.signupUrl = _data["signupUrl"];
            this.signupText = _data["signupText"];
            this.readmoreUrl = _data["readmoreUrl"];
            this.readmoreText = _data["readmoreText"];
            this.secret = _data["secret"];
            this.clientId = _data["clientId"];
            this.widgetOptions = _data["widgetOptions"];
            this.apiClientId = _data["apiClientId"];
            this.apiClientSecret = _data["apiClientSecret"];
            this.authProvider = _data["authProvider"];
            this.scope = _data["scope"];
        }
    }

    static fromJS(data: any): CustomerAuthConfigModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAuthConfigModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logoutUrl"] = this.logoutUrl;
        data["logoutText"] = this.logoutText;
        data["customerUrlId"] = this.customerUrlId;
        data["authDomain"] = this.authDomain;
        data["loginUrl"] = this.loginUrl;
        data["loginText"] = this.loginText;
        data["signupUrl"] = this.signupUrl;
        data["signupText"] = this.signupText;
        data["readmoreUrl"] = this.readmoreUrl;
        data["readmoreText"] = this.readmoreText;
        data["secret"] = this.secret;
        data["clientId"] = this.clientId;
        data["widgetOptions"] = this.widgetOptions;
        data["apiClientId"] = this.apiClientId;
        data["apiClientSecret"] = this.apiClientSecret;
        data["authProvider"] = this.authProvider;
        data["scope"] = this.scope;
        return data; 
    }
}

export interface ICustomerAuthConfigModel {
    logoutUrl: string | undefined;
    logoutText: string | undefined;
    customerUrlId: number | undefined;
    authDomain: string | undefined;
    loginUrl: string | undefined;
    loginText: string | undefined;
    signupUrl: string | undefined;
    signupText: string | undefined;
    readmoreUrl: string | undefined;
    readmoreText: string | undefined;
    secret: string | undefined;
    clientId: string | undefined;
    widgetOptions: string | undefined;
    apiClientId: string | undefined;
    apiClientSecret: string | undefined;
    authProvider: number | undefined;
    scope: string | undefined;
}

export class AuthViewerConfigDTO implements IAuthViewerConfigDTO {
    customerUrlId!: number;
    logoutUrl!: string;
    logoutText!: string;
    loginUrl!: string;
    loginText!: string;
    signupUrl!: string;
    signupText!: string;
    readmoreUrl!: string;
    readmoreText!: string;

    constructor(data?: IAuthViewerConfigDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerUrlId = _data["customerUrlId"];
            this.logoutUrl = _data["logoutUrl"];
            this.logoutText = _data["logoutText"];
            this.loginUrl = _data["loginUrl"];
            this.loginText = _data["loginText"];
            this.signupUrl = _data["signupUrl"];
            this.signupText = _data["signupText"];
            this.readmoreUrl = _data["readmoreUrl"];
            this.readmoreText = _data["readmoreText"];
        }
    }

    static fromJS(data: any): AuthViewerConfigDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AuthViewerConfigDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerUrlId"] = this.customerUrlId;
        data["logoutUrl"] = this.logoutUrl;
        data["logoutText"] = this.logoutText;
        data["loginUrl"] = this.loginUrl;
        data["loginText"] = this.loginText;
        data["signupUrl"] = this.signupUrl;
        data["signupText"] = this.signupText;
        data["readmoreUrl"] = this.readmoreUrl;
        data["readmoreText"] = this.readmoreText;
        return data; 
    }
}

export interface IAuthViewerConfigDTO {
    customerUrlId: number;
    logoutUrl: string;
    logoutText: string;
    loginUrl: string;
    loginText: string;
    signupUrl: string;
    signupText: string;
    readmoreUrl: string;
    readmoreText: string;
}

export class AutologinReferrerDTO implements IAutologinReferrerDTO {
    id!: number | undefined;
    customerUrlId!: number | undefined;
    refererMatch!: string;
    status!: number | undefined;
    expiry!: Date | undefined;
    name!: string;

    constructor(data?: IAutologinReferrerDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerUrlId = _data["customerUrlId"];
            this.refererMatch = _data["refererMatch"];
            this.status = _data["status"];
            this.expiry = _data["expiry"] ? new Date(_data["expiry"].toString()) : <any>undefined;
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AutologinReferrerDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AutologinReferrerDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerUrlId"] = this.customerUrlId;
        data["refererMatch"] = this.refererMatch;
        data["status"] = this.status;
        data["expiry"] = this.expiry ? this.expiry.toISOString() : <any>undefined;
        data["name"] = this.name;
        return data; 
    }
}

export interface IAutologinReferrerDTO {
    id: number | undefined;
    customerUrlId: number | undefined;
    refererMatch: string;
    status: number | undefined;
    expiry: Date | undefined;
    name: string;
}

export class AutologinIPAddressDTO implements IAutologinIPAddressDTO {
    id!: number | undefined;
    customerUrlId!: number | undefined;
    ipRangeStart!: string;
    ipRangeEnd!: string;
    status!: number | undefined;
    expiry!: Date | undefined;
    name!: string;

    constructor(data?: IAutologinIPAddressDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerUrlId = _data["customerUrlId"];
            this.ipRangeStart = _data["ipRangeStart"];
            this.ipRangeEnd = _data["ipRangeEnd"];
            this.status = _data["status"];
            this.expiry = _data["expiry"] ? new Date(_data["expiry"].toString()) : <any>undefined;
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AutologinIPAddressDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AutologinIPAddressDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerUrlId"] = this.customerUrlId;
        data["ipRangeStart"] = this.ipRangeStart;
        data["ipRangeEnd"] = this.ipRangeEnd;
        data["status"] = this.status;
        data["expiry"] = this.expiry ? this.expiry.toISOString() : <any>undefined;
        data["name"] = this.name;
        return data; 
    }
}

export interface IAutologinIPAddressDTO {
    id: number | undefined;
    customerUrlId: number | undefined;
    ipRangeStart: string;
    ipRangeEnd: string;
    status: number | undefined;
    expiry: Date | undefined;
    name: string;
}

export class StreamStatsDTO implements IStreamStatsDTO {
    customerAccountId!: number | undefined;
    streamId!: number | undefined;
    lastIssue!: string | undefined;
    nextIssueDate!: Date | undefined;
    billingDay!: number | undefined;
    lastIssueDate!: Date | undefined;
    status!: StreamStatsDTOStatus | undefined;
    visibility!: StreamStatsDTOVisibility | undefined;
    issueCount!: number | undefined;
    name!: string | undefined;
    subscribers!: number | undefined;
    owner!: string | undefined;

    constructor(data?: IStreamStatsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerAccountId = _data["customerAccountId"];
            this.streamId = _data["streamId"];
            this.lastIssue = _data["lastIssue"];
            this.nextIssueDate = _data["nextIssueDate"] ? new Date(_data["nextIssueDate"].toString()) : <any>undefined;
            this.billingDay = _data["billingDay"];
            this.lastIssueDate = _data["lastIssueDate"] ? new Date(_data["lastIssueDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.visibility = _data["visibility"];
            this.issueCount = _data["issueCount"];
            this.name = _data["name"];
            this.subscribers = _data["subscribers"];
            this.owner = _data["owner"];
        }
    }

    static fromJS(data: any): StreamStatsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StreamStatsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerAccountId"] = this.customerAccountId;
        data["streamId"] = this.streamId;
        data["lastIssue"] = this.lastIssue;
        data["nextIssueDate"] = this.nextIssueDate ? this.nextIssueDate.toISOString() : <any>undefined;
        data["billingDay"] = this.billingDay;
        data["lastIssueDate"] = this.lastIssueDate ? this.lastIssueDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["visibility"] = this.visibility;
        data["issueCount"] = this.issueCount;
        data["name"] = this.name;
        data["subscribers"] = this.subscribers;
        data["owner"] = this.owner;
        return data; 
    }
}

export interface IStreamStatsDTO {
    customerAccountId: number | undefined;
    streamId: number | undefined;
    lastIssue: string | undefined;
    nextIssueDate: Date | undefined;
    billingDay: number | undefined;
    lastIssueDate: Date | undefined;
    status: StreamStatsDTOStatus | undefined;
    visibility: StreamStatsDTOVisibility | undefined;
    issueCount: number | undefined;
    name: string | undefined;
    subscribers: number | undefined;
    owner: string | undefined;
}

export class ContentStreamDTO implements IContentStreamDTO {
    id!: number;
    customerAccountId!: number;
    name!: string;
    description!: string;
    status!: ContentStreamDTOStatus;
    visibility!: ContentStreamDTOVisibility;
    publicationId!: number;
    publication!: PublicationModel | undefined;
    contentStreamLevels!: ContentStreamLevelDTO[];
    contentStreamBillingConfigurations!: ContentStreamBillingConfigurationDTO[];
    guid!: string | undefined;
    owner!: ContentStreamDTOOwner;
    category!: ContentStreamDTOCategory;
    copyIssueOnSubscribe!: ContentStreamDTOCopyIssueOnSubscribe;

    constructor(data?: IContentStreamDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.id = 0;
            this.customerAccountId = 0;
            this.name = "";
            this.description = "";
            this.status = ContentStreamDTOStatus.Inactive;
            this.visibility = ContentStreamDTOVisibility.PrivateChargebeeBilledStream;
            this.publicationId = 0;
            this.contentStreamLevels = [];
            this.contentStreamBillingConfigurations = [];
            this.owner = ContentStreamDTOOwner.Partica;
            this.category = ContentStreamDTOCategory.RealEstate;
            this.copyIssueOnSubscribe = ContentStreamDTOCopyIssueOnSubscribe.None;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : 0;
            this.customerAccountId = _data["customerAccountId"] !== undefined ? _data["customerAccountId"] : 0;
            this.name = _data["name"] !== undefined ? _data["name"] : "";
            this.description = _data["description"] !== undefined ? _data["description"] : "";
            this.status = _data["status"] !== undefined ? _data["status"] : ContentStreamDTOStatus.Inactive;
            this.visibility = _data["visibility"] !== undefined ? _data["visibility"] : ContentStreamDTOVisibility.PrivateChargebeeBilledStream;
            this.publicationId = _data["publicationId"] !== undefined ? _data["publicationId"] : 0;
            this.publication = _data["publication"] ? PublicationModel.fromJS(_data["publication"]) : <any>undefined;
            if (Array.isArray(_data["contentStreamLevels"])) {
                this.contentStreamLevels = [] as any;
                for (let item of _data["contentStreamLevels"])
                    this.contentStreamLevels!.push(ContentStreamLevelDTO.fromJS(item));
            }
            if (Array.isArray(_data["contentStreamBillingConfigurations"])) {
                this.contentStreamBillingConfigurations = [] as any;
                for (let item of _data["contentStreamBillingConfigurations"])
                    this.contentStreamBillingConfigurations!.push(ContentStreamBillingConfigurationDTO.fromJS(item));
            }
            this.guid = _data["guid"];
            this.owner = _data["owner"] !== undefined ? _data["owner"] : ContentStreamDTOOwner.Partica;
            this.category = _data["category"] !== undefined ? _data["category"] : ContentStreamDTOCategory.RealEstate;
            this.copyIssueOnSubscribe = _data["copyIssueOnSubscribe"] !== undefined ? _data["copyIssueOnSubscribe"] : ContentStreamDTOCopyIssueOnSubscribe.None;
        }
    }

    static fromJS(data: any): ContentStreamDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ContentStreamDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerAccountId"] = this.customerAccountId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["status"] = this.status;
        data["visibility"] = this.visibility;
        data["publicationId"] = this.publicationId;
        data["publication"] = this.publication ? this.publication.toJSON() : <any>undefined;
        if (Array.isArray(this.contentStreamLevels)) {
            data["contentStreamLevels"] = [];
            for (let item of this.contentStreamLevels)
                data["contentStreamLevels"].push(item.toJSON());
        }
        if (Array.isArray(this.contentStreamBillingConfigurations)) {
            data["contentStreamBillingConfigurations"] = [];
            for (let item of this.contentStreamBillingConfigurations)
                data["contentStreamBillingConfigurations"].push(item.toJSON());
        }
        data["guid"] = this.guid;
        data["owner"] = this.owner;
        data["category"] = this.category;
        data["copyIssueOnSubscribe"] = this.copyIssueOnSubscribe;
        return data; 
    }
}

export interface IContentStreamDTO {
    id: number;
    customerAccountId: number;
    name: string;
    description: string;
    status: ContentStreamDTOStatus;
    visibility: ContentStreamDTOVisibility;
    publicationId: number;
    publication: PublicationModel | undefined;
    contentStreamLevels: ContentStreamLevelDTO[];
    contentStreamBillingConfigurations: ContentStreamBillingConfigurationDTO[];
    guid: string | undefined;
    owner: ContentStreamDTOOwner;
    category: ContentStreamDTOCategory;
    copyIssueOnSubscribe: ContentStreamDTOCopyIssueOnSubscribe;
}

/** Publication model. */
export class PublicationModel implements IPublicationModel {
    sections!: SectionModel[] | undefined;
    premium!: boolean | undefined;
    plus!: boolean | undefined;
    example!: boolean | undefined;
    /** name of publication. unique to account */
    name!: string;
    /** identifier */
    id!: number | undefined;
    /** uniqure string for viewer to access content */
    uniqueId!: string | undefined;
    /** list of issue for publication */
    issues!: IssueModel[] | undefined;
    /** is this the defauly publication for the account */
    default!: boolean | undefined;
    /** unique guid for publication. */
    guid!: string | undefined;
    /** Langauge for this title. */
    language!: PublicationModelLanguage | undefined;
    publicationType!: PublicationModelPublicationType | undefined;
    scheduledLiveTasks!: ScheduledLiveTaskDTO[] | undefined;

    constructor(data?: IPublicationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(SectionModel.fromJS(item));
            }
            this.premium = _data["premium"];
            this.plus = _data["plus"];
            this.example = _data["example"];
            this.name = _data["name"];
            this.id = _data["id"];
            this.uniqueId = _data["uniqueId"];
            if (Array.isArray(_data["issues"])) {
                this.issues = [] as any;
                for (let item of _data["issues"])
                    this.issues!.push(IssueModel.fromJS(item));
            }
            this.default = _data["default"];
            this.guid = _data["guid"];
            this.language = _data["language"];
            this.publicationType = _data["publicationType"];
            if (Array.isArray(_data["scheduledLiveTasks"])) {
                this.scheduledLiveTasks = [] as any;
                for (let item of _data["scheduledLiveTasks"])
                    this.scheduledLiveTasks!.push(ScheduledLiveTaskDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PublicationModel {
        data = typeof data === 'object' ? data : {};
        let result = new PublicationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item.toJSON());
        }
        data["premium"] = this.premium;
        data["plus"] = this.plus;
        data["example"] = this.example;
        data["name"] = this.name;
        data["id"] = this.id;
        data["uniqueId"] = this.uniqueId;
        if (Array.isArray(this.issues)) {
            data["issues"] = [];
            for (let item of this.issues)
                data["issues"].push(item.toJSON());
        }
        data["default"] = this.default;
        data["guid"] = this.guid;
        data["language"] = this.language;
        data["publicationType"] = this.publicationType;
        if (Array.isArray(this.scheduledLiveTasks)) {
            data["scheduledLiveTasks"] = [];
            for (let item of this.scheduledLiveTasks)
                data["scheduledLiveTasks"].push(item.toJSON());
        }
        return data; 
    }
}

/** Publication model. */
export interface IPublicationModel {
    sections: SectionModel[] | undefined;
    premium: boolean | undefined;
    plus: boolean | undefined;
    example: boolean | undefined;
    /** name of publication. unique to account */
    name: string;
    /** identifier */
    id: number | undefined;
    /** uniqure string for viewer to access content */
    uniqueId: string | undefined;
    /** list of issue for publication */
    issues: IssueModel[] | undefined;
    /** is this the defauly publication for the account */
    default: boolean | undefined;
    /** unique guid for publication. */
    guid: string | undefined;
    /** Langauge for this title. */
    language: PublicationModelLanguage | undefined;
    publicationType: PublicationModelPublicationType | undefined;
    scheduledLiveTasks: ScheduledLiveTaskDTO[] | undefined;
}

export class ContentStreamLevelDTO implements IContentStreamLevelDTO {
    id!: number | undefined;
    contentStreamId!: number | undefined;
    price!: number;
    name!: string;
    description!: string;
    chargeBeePlanId!: string | undefined;
    requiresCuration!: ContentStreamLevelDTORequiresCuration;
    additionalInfo!: string;
    articleCurationCost!: number;
    guid!: string | undefined;

    constructor(data?: IContentStreamLevelDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.id = 0;
            this.contentStreamId = 0;
            this.price = 0;
            this.name = "";
            this.description = "";
            this.chargeBeePlanId = "NA";
            this.requiresCuration = ContentStreamLevelDTORequiresCuration.Notrequired;
            this.additionalInfo = "What client information is required?";
            this.articleCurationCost = 40;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : 0;
            this.contentStreamId = _data["contentStreamId"] !== undefined ? _data["contentStreamId"] : 0;
            this.price = _data["price"] !== undefined ? _data["price"] : 0;
            this.name = _data["name"] !== undefined ? _data["name"] : "";
            this.description = _data["description"] !== undefined ? _data["description"] : "";
            this.chargeBeePlanId = _data["chargeBeePlanId"] !== undefined ? _data["chargeBeePlanId"] : "NA";
            this.requiresCuration = _data["requiresCuration"] !== undefined ? _data["requiresCuration"] : ContentStreamLevelDTORequiresCuration.Notrequired;
            this.additionalInfo = _data["additionalInfo"] !== undefined ? _data["additionalInfo"] : "What client information is required?";
            this.articleCurationCost = _data["articleCurationCost"] !== undefined ? _data["articleCurationCost"] : 40;
            this.guid = _data["guid"];
        }
    }

    static fromJS(data: any): ContentStreamLevelDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ContentStreamLevelDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contentStreamId"] = this.contentStreamId;
        data["price"] = this.price;
        data["name"] = this.name;
        data["description"] = this.description;
        data["chargeBeePlanId"] = this.chargeBeePlanId;
        data["requiresCuration"] = this.requiresCuration;
        data["additionalInfo"] = this.additionalInfo;
        data["articleCurationCost"] = this.articleCurationCost;
        data["guid"] = this.guid;
        return data; 
    }
}

export interface IContentStreamLevelDTO {
    id: number | undefined;
    contentStreamId: number | undefined;
    price: number;
    name: string;
    description: string;
    chargeBeePlanId: string | undefined;
    requiresCuration: ContentStreamLevelDTORequiresCuration;
    additionalInfo: string;
    articleCurationCost: number;
    guid: string | undefined;
}

export class ContentStreamBillingConfigurationDTO implements IContentStreamBillingConfigurationDTO {
    id!: number | undefined;
    contentStreamId!: number | undefined;
    numberArticles!: number;
    maximumValueContent!: number;
    contentCharge!: number;
    billingDay!: number;
    ownerPercentageContentCharge!: number;
    contentOwnerContribution!: number;
    preFinaliseIssueEditingFee!: number;
    serviceFee!: number;

    constructor(data?: IContentStreamBillingConfigurationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.id = 0;
            this.contentStreamId = 0;
            this.numberArticles = 4;
            this.maximumValueContent = 200;
            this.contentCharge = 150;
            this.billingDay = 15;
            this.ownerPercentageContentCharge = 25;
            this.contentOwnerContribution = 0;
            this.preFinaliseIssueEditingFee = 0;
            this.serviceFee = 0;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : 0;
            this.contentStreamId = _data["contentStreamId"] !== undefined ? _data["contentStreamId"] : 0;
            this.numberArticles = _data["numberArticles"] !== undefined ? _data["numberArticles"] : 4;
            this.maximumValueContent = _data["maximumValueContent"] !== undefined ? _data["maximumValueContent"] : 200;
            this.contentCharge = _data["contentCharge"] !== undefined ? _data["contentCharge"] : 150;
            this.billingDay = _data["billingDay"] !== undefined ? _data["billingDay"] : 15;
            this.ownerPercentageContentCharge = _data["ownerPercentageContentCharge"] !== undefined ? _data["ownerPercentageContentCharge"] : 25;
            this.contentOwnerContribution = _data["contentOwnerContribution"] !== undefined ? _data["contentOwnerContribution"] : 0;
            this.preFinaliseIssueEditingFee = _data["preFinaliseIssueEditingFee"] !== undefined ? _data["preFinaliseIssueEditingFee"] : 0;
            this.serviceFee = _data["serviceFee"] !== undefined ? _data["serviceFee"] : 0;
        }
    }

    static fromJS(data: any): ContentStreamBillingConfigurationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ContentStreamBillingConfigurationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contentStreamId"] = this.contentStreamId;
        data["numberArticles"] = this.numberArticles;
        data["maximumValueContent"] = this.maximumValueContent;
        data["contentCharge"] = this.contentCharge;
        data["billingDay"] = this.billingDay;
        data["ownerPercentageContentCharge"] = this.ownerPercentageContentCharge;
        data["contentOwnerContribution"] = this.contentOwnerContribution;
        data["preFinaliseIssueEditingFee"] = this.preFinaliseIssueEditingFee;
        data["serviceFee"] = this.serviceFee;
        return data; 
    }
}

export interface IContentStreamBillingConfigurationDTO {
    id: number | undefined;
    contentStreamId: number | undefined;
    numberArticles: number;
    maximumValueContent: number;
    contentCharge: number;
    billingDay: number;
    ownerPercentageContentCharge: number;
    contentOwnerContribution: number;
    preFinaliseIssueEditingFee: number;
    serviceFee: number;
}

export class ScheduledLiveTaskDTO implements IScheduledLiveTaskDTO {
    id!: number | undefined;
    publicationId!: number;
    time!: string;
    status!: number | undefined;
    scheduledLiveTaskHistories!: ScheduledLiveTaskHistoryDTO[] | undefined;

    constructor(data?: IScheduledLiveTaskDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.publicationId = _data["publicationId"];
            this.time = _data["time"];
            this.status = _data["status"];
            if (Array.isArray(_data["scheduledLiveTaskHistories"])) {
                this.scheduledLiveTaskHistories = [] as any;
                for (let item of _data["scheduledLiveTaskHistories"])
                    this.scheduledLiveTaskHistories!.push(ScheduledLiveTaskHistoryDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScheduledLiveTaskDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduledLiveTaskDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["publicationId"] = this.publicationId;
        data["time"] = this.time;
        data["status"] = this.status;
        if (Array.isArray(this.scheduledLiveTaskHistories)) {
            data["scheduledLiveTaskHistories"] = [];
            for (let item of this.scheduledLiveTaskHistories)
                data["scheduledLiveTaskHistories"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IScheduledLiveTaskDTO {
    id: number | undefined;
    publicationId: number;
    time: string;
    status: number | undefined;
    scheduledLiveTaskHistories: ScheduledLiveTaskHistoryDTO[] | undefined;
}

export class ScheduledLiveTaskHistoryDTO implements IScheduledLiveTaskHistoryDTO {
    id!: number | undefined;
    scheduledLiveTaskId!: number | undefined;
    actionTime!: Date;
    message!: string;

    constructor(data?: IScheduledLiveTaskHistoryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.scheduledLiveTaskId = _data["scheduledLiveTaskId"];
            this.actionTime = _data["actionTime"] ? new Date(_data["actionTime"].toString()) : <any>undefined;
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ScheduledLiveTaskHistoryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduledLiveTaskHistoryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["scheduledLiveTaskId"] = this.scheduledLiveTaskId;
        data["actionTime"] = this.actionTime ? this.actionTime.toISOString() : <any>undefined;
        data["message"] = this.message;
        return data; 
    }
}

export interface IScheduledLiveTaskHistoryDTO {
    id: number | undefined;
    scheduledLiveTaskId: number | undefined;
    actionTime: Date;
    message: string;
}

export class ListItemDTO implements IListItemDTO {
    id!: string | undefined;
    label!: string | undefined;

    constructor(data?: IListItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): ListItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ListItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        return data; 
    }
}

export interface IListItemDTO {
    id: string | undefined;
    label: string | undefined;
}

export class ContentStreamSubscriberDTO implements IContentStreamSubscriberDTO {
    contentStreamId!: number | undefined;
    contentStreamSubscriptionId!: number | undefined;
    level!: string | undefined;
    cbStatus!: CBSubscriptionStatus | undefined;
    subscriber!: string | undefined;
    requiresCuration!: ContentStreamSubscriberDTORequiresCuration | undefined;
    customerAccountId!: number | undefined;
    status!: ContentStreamSubscriberDTOStatus | undefined;

    constructor(data?: IContentStreamSubscriberDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contentStreamId = _data["contentStreamId"];
            this.contentStreamSubscriptionId = _data["contentStreamSubscriptionId"];
            this.level = _data["level"];
            this.cbStatus = _data["cbStatus"] ? CBSubscriptionStatus.fromJS(_data["cbStatus"]) : <any>undefined;
            this.subscriber = _data["subscriber"];
            this.requiresCuration = _data["requiresCuration"];
            this.customerAccountId = _data["customerAccountId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ContentStreamSubscriberDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ContentStreamSubscriberDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contentStreamId"] = this.contentStreamId;
        data["contentStreamSubscriptionId"] = this.contentStreamSubscriptionId;
        data["level"] = this.level;
        data["cbStatus"] = this.cbStatus ? this.cbStatus.toJSON() : <any>undefined;
        data["subscriber"] = this.subscriber;
        data["requiresCuration"] = this.requiresCuration;
        data["customerAccountId"] = this.customerAccountId;
        data["status"] = this.status;
        return data; 
    }
}

export interface IContentStreamSubscriberDTO {
    contentStreamId: number | undefined;
    contentStreamSubscriptionId: number | undefined;
    level: string | undefined;
    cbStatus: CBSubscriptionStatus | undefined;
    subscriber: string | undefined;
    requiresCuration: ContentStreamSubscriberDTORequiresCuration | undefined;
    customerAccountId: number | undefined;
    status: ContentStreamSubscriberDTOStatus | undefined;
}

export class CBSubscriptionStatus implements ICBSubscriptionStatus {
    eStatus!: number | undefined;
    status!: string | undefined;
    id!: string | undefined;
    readonly ok!: boolean | undefined;

    constructor(data?: ICBSubscriptionStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eStatus = _data["eStatus"];
            this.status = _data["status"];
            this.id = _data["id"];
            (<any>this).ok = _data["ok"];
        }
    }

    static fromJS(data: any): CBSubscriptionStatus {
        data = typeof data === 'object' ? data : {};
        let result = new CBSubscriptionStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eStatus"] = this.eStatus;
        data["status"] = this.status;
        data["id"] = this.id;
        data["ok"] = this.ok;
        return data; 
    }
}

export interface ICBSubscriptionStatus {
    eStatus: number | undefined;
    status: string | undefined;
    id: string | undefined;
    ok: boolean | undefined;
}

export class OutstandingArticlesForCuration implements IOutstandingArticlesForCuration {
    stream!: string | undefined;
    contentStreamId!: number | undefined;
    numberArticles!: number | undefined;
    price!: number | undefined;
    level!: string | undefined;

    constructor(data?: IOutstandingArticlesForCuration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stream = _data["stream"];
            this.contentStreamId = _data["contentStreamId"];
            this.numberArticles = _data["numberArticles"];
            this.price = _data["price"];
            this.level = _data["level"];
        }
    }

    static fromJS(data: any): OutstandingArticlesForCuration {
        data = typeof data === 'object' ? data : {};
        let result = new OutstandingArticlesForCuration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stream"] = this.stream;
        data["contentStreamId"] = this.contentStreamId;
        data["numberArticles"] = this.numberArticles;
        data["price"] = this.price;
        data["level"] = this.level;
        return data; 
    }
}

export interface IOutstandingArticlesForCuration {
    stream: string | undefined;
    contentStreamId: number | undefined;
    numberArticles: number | undefined;
    price: number | undefined;
    level: string | undefined;
}

export class ArticleForCurationDTO implements IArticleForCurationDTO {
    customerAccountId!: number | undefined;
    contentStreamId!: number | undefined;

    constructor(data?: IArticleForCurationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerAccountId = _data["customerAccountId"];
            this.contentStreamId = _data["contentStreamId"];
        }
    }

    static fromJS(data: any): ArticleForCurationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleForCurationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerAccountId"] = this.customerAccountId;
        data["contentStreamId"] = this.contentStreamId;
        return data; 
    }
}

export interface IArticleForCurationDTO {
    customerAccountId: number | undefined;
    contentStreamId: number | undefined;
}

export class CurationTodoDTO implements ICurationTodoDTO {
    articleId!: string | undefined;
    title!: string | undefined;
    issue!: string | undefined;
    stream!: string | undefined;
    subscriber!: string | undefined;
    level!: string | undefined;
    finalizedTime!: Date | undefined;

    constructor(data?: ICurationTodoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"];
            this.title = _data["title"];
            this.issue = _data["issue"];
            this.stream = _data["stream"];
            this.subscriber = _data["subscriber"];
            this.level = _data["level"];
            this.finalizedTime = _data["finalizedTime"] ? new Date(_data["finalizedTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CurationTodoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CurationTodoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId;
        data["title"] = this.title;
        data["issue"] = this.issue;
        data["stream"] = this.stream;
        data["subscriber"] = this.subscriber;
        data["level"] = this.level;
        data["finalizedTime"] = this.finalizedTime ? this.finalizedTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface ICurationTodoDTO {
    articleId: string | undefined;
    title: string | undefined;
    issue: string | undefined;
    stream: string | undefined;
    subscriber: string | undefined;
    level: string | undefined;
    finalizedTime: Date | undefined;
}

export class CurationInfoDTO implements ICurationInfoDTO {
    clientInfo!: string | undefined;
    level!: ContentStreamLevelDTO | undefined;
    client!: string | undefined;
    subId!: string | undefined;
    subscriptionStatus!: CBSubscriptionStatus | undefined;

    constructor(data?: ICurationInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientInfo = _data["clientInfo"];
            this.level = _data["level"] ? ContentStreamLevelDTO.fromJS(_data["level"]) : <any>undefined;
            this.client = _data["client"];
            this.subId = _data["subId"];
            this.subscriptionStatus = _data["subscriptionStatus"] ? CBSubscriptionStatus.fromJS(_data["subscriptionStatus"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CurationInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CurationInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientInfo"] = this.clientInfo;
        data["level"] = this.level ? this.level.toJSON() : <any>undefined;
        data["client"] = this.client;
        data["subId"] = this.subId;
        data["subscriptionStatus"] = this.subscriptionStatus ? this.subscriptionStatus.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICurationInfoDTO {
    clientInfo: string | undefined;
    level: ContentStreamLevelDTO | undefined;
    client: string | undefined;
    subId: string | undefined;
    subscriptionStatus: CBSubscriptionStatus | undefined;
}

export class ContentStreamIssueDTO implements IContentStreamIssueDTO {
    id!: number | undefined;
    contentStreamId!: number | undefined;
    name!: string;

    constructor(data?: IContentStreamIssueDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.id = 0;
            this.contentStreamId = 0;
            this.name = "";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : 0;
            this.contentStreamId = _data["contentStreamId"] !== undefined ? _data["contentStreamId"] : 0;
            this.name = _data["name"] !== undefined ? _data["name"] : "";
        }
    }

    static fromJS(data: any): ContentStreamIssueDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ContentStreamIssueDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contentStreamId"] = this.contentStreamId;
        data["name"] = this.name;
        return data; 
    }
}

export interface IContentStreamIssueDTO {
    id: number | undefined;
    contentStreamId: number | undefined;
    name: string;
}

export class AddArticleContentStreamDTO implements IAddArticleContentStreamDTO {
    articleId!: string | undefined;
    contentStreamIssueId!: number | undefined;

    constructor(data?: IAddArticleContentStreamDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"];
            this.contentStreamIssueId = _data["contentStreamIssueId"];
        }
    }

    static fromJS(data: any): AddArticleContentStreamDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AddArticleContentStreamDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId;
        data["contentStreamIssueId"] = this.contentStreamIssueId;
        return data; 
    }
}

export interface IAddArticleContentStreamDTO {
    articleId: string | undefined;
    contentStreamIssueId: number | undefined;
}

export class ContentStreamFinalizeDTO implements IContentStreamFinalizeDTO {
    contentStreamIssueId!: number | undefined;

    constructor(data?: IContentStreamFinalizeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contentStreamIssueId = _data["contentStreamIssueId"];
        }
    }

    static fromJS(data: any): ContentStreamFinalizeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ContentStreamFinalizeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contentStreamIssueId"] = this.contentStreamIssueId;
        return data; 
    }
}

export interface IContentStreamFinalizeDTO {
    contentStreamIssueId: number | undefined;
}

export class ContentStreamSubscriptionStoreDTO implements IContentStreamSubscriptionStoreDTO {
    id!: number | undefined;
    contentStreamId!: number | undefined;
    contentStreamLevelId!: number | undefined;
    name!: string | undefined;
    billingDay!: number | undefined;
    created!: Date | undefined;
    contentStreamLevel!: ContentStreamLevelStoreDTO | undefined;
    subscriberInformation!: string | undefined;
    subscriptionStatus!: CBSubscriptionStatus | undefined;
    guid!: string | undefined;

    constructor(data?: IContentStreamSubscriptionStoreDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contentStreamId = _data["contentStreamId"];
            this.contentStreamLevelId = _data["contentStreamLevelId"];
            this.name = _data["name"];
            this.billingDay = _data["billingDay"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.contentStreamLevel = _data["contentStreamLevel"] ? ContentStreamLevelStoreDTO.fromJS(_data["contentStreamLevel"]) : <any>undefined;
            this.subscriberInformation = _data["subscriberInformation"];
            this.subscriptionStatus = _data["subscriptionStatus"] ? CBSubscriptionStatus.fromJS(_data["subscriptionStatus"]) : <any>undefined;
            this.guid = _data["guid"];
        }
    }

    static fromJS(data: any): ContentStreamSubscriptionStoreDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ContentStreamSubscriptionStoreDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contentStreamId"] = this.contentStreamId;
        data["contentStreamLevelId"] = this.contentStreamLevelId;
        data["name"] = this.name;
        data["billingDay"] = this.billingDay;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["contentStreamLevel"] = this.contentStreamLevel ? this.contentStreamLevel.toJSON() : <any>undefined;
        data["subscriberInformation"] = this.subscriberInformation;
        data["subscriptionStatus"] = this.subscriptionStatus ? this.subscriptionStatus.toJSON() : <any>undefined;
        data["guid"] = this.guid;
        return data; 
    }
}

export interface IContentStreamSubscriptionStoreDTO {
    id: number | undefined;
    contentStreamId: number | undefined;
    contentStreamLevelId: number | undefined;
    name: string | undefined;
    billingDay: number | undefined;
    created: Date | undefined;
    contentStreamLevel: ContentStreamLevelStoreDTO | undefined;
    subscriberInformation: string | undefined;
    subscriptionStatus: CBSubscriptionStatus | undefined;
    guid: string | undefined;
}

export class ContentStreamLevelStoreDTO implements IContentStreamLevelStoreDTO {
    id!: number | undefined;
    price!: number | undefined;
    name!: string | undefined;
    description!: string | undefined;
    requiresCuration!: ContentStreamLevelStoreDTORequiresCuration | undefined;
    additionalInfo!: string | undefined;
    guid!: string | undefined;

    constructor(data?: IContentStreamLevelStoreDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.price = _data["price"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.requiresCuration = _data["requiresCuration"];
            this.additionalInfo = _data["additionalInfo"];
            this.guid = _data["guid"];
        }
    }

    static fromJS(data: any): ContentStreamLevelStoreDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ContentStreamLevelStoreDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["price"] = this.price;
        data["name"] = this.name;
        data["description"] = this.description;
        data["requiresCuration"] = this.requiresCuration;
        data["additionalInfo"] = this.additionalInfo;
        data["guid"] = this.guid;
        return data; 
    }
}

export interface IContentStreamLevelStoreDTO {
    id: number | undefined;
    price: number | undefined;
    name: string | undefined;
    description: string | undefined;
    requiresCuration: ContentStreamLevelStoreDTORequiresCuration | undefined;
    additionalInfo: string | undefined;
    guid: string | undefined;
}

export class ContentStreamStoreDTO implements IContentStreamStoreDTO {
    id!: number | undefined;
    name!: string;
    description!: string;
    billingDay!: number | undefined;
    contentStreamLevels!: ContentStreamStoreLevelDTO[] | undefined;
    copyIssueOnSubscribe!: ContentStreamStoreDTOCopyIssueOnSubscribe | undefined;

    constructor(data?: IContentStreamStoreDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.billingDay = _data["billingDay"];
            if (Array.isArray(_data["contentStreamLevels"])) {
                this.contentStreamLevels = [] as any;
                for (let item of _data["contentStreamLevels"])
                    this.contentStreamLevels!.push(ContentStreamStoreLevelDTO.fromJS(item));
            }
            this.copyIssueOnSubscribe = _data["copyIssueOnSubscribe"];
        }
    }

    static fromJS(data: any): ContentStreamStoreDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ContentStreamStoreDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["billingDay"] = this.billingDay;
        if (Array.isArray(this.contentStreamLevels)) {
            data["contentStreamLevels"] = [];
            for (let item of this.contentStreamLevels)
                data["contentStreamLevels"].push(item.toJSON());
        }
        data["copyIssueOnSubscribe"] = this.copyIssueOnSubscribe;
        return data; 
    }
}

export interface IContentStreamStoreDTO {
    id: number | undefined;
    name: string;
    description: string;
    billingDay: number | undefined;
    contentStreamLevels: ContentStreamStoreLevelDTO[] | undefined;
    copyIssueOnSubscribe: ContentStreamStoreDTOCopyIssueOnSubscribe | undefined;
}

export class ContentStreamStoreLevelDTO implements IContentStreamStoreLevelDTO {
    price!: number;
    name!: string;
    description!: string;
    requiresCuration!: ContentStreamStoreLevelDTORequiresCuration;
    additionalInfo!: string;
    guid!: string | undefined;

    constructor(data?: IContentStreamStoreLevelDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.price = 0;
            this.name = "";
            this.description = "";
            this.requiresCuration = ContentStreamStoreLevelDTORequiresCuration.Notrequired;
            this.additionalInfo = "What client information is required?";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.price = _data["price"] !== undefined ? _data["price"] : 0;
            this.name = _data["name"] !== undefined ? _data["name"] : "";
            this.description = _data["description"] !== undefined ? _data["description"] : "";
            this.requiresCuration = _data["requiresCuration"] !== undefined ? _data["requiresCuration"] : ContentStreamStoreLevelDTORequiresCuration.Notrequired;
            this.additionalInfo = _data["additionalInfo"] !== undefined ? _data["additionalInfo"] : "What client information is required?";
            this.guid = _data["guid"];
        }
    }

    static fromJS(data: any): ContentStreamStoreLevelDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ContentStreamStoreLevelDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["price"] = this.price;
        data["name"] = this.name;
        data["description"] = this.description;
        data["requiresCuration"] = this.requiresCuration;
        data["additionalInfo"] = this.additionalInfo;
        data["guid"] = this.guid;
        return data; 
    }
}

export interface IContentStreamStoreLevelDTO {
    price: number;
    name: string;
    description: string;
    requiresCuration: ContentStreamStoreLevelDTORequiresCuration;
    additionalInfo: string;
    guid: string | undefined;
}

export class ContentStreamSubscriberInfoDTO implements IContentStreamSubscriberInfoDTO {
    contentStreamSubscriptionId!: number;
    subscriberInformation!: string;

    constructor(data?: IContentStreamSubscriberInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.contentStreamSubscriptionId = 0;
            this.subscriberInformation = "";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contentStreamSubscriptionId = _data["contentStreamSubscriptionId"] !== undefined ? _data["contentStreamSubscriptionId"] : 0;
            this.subscriberInformation = _data["subscriberInformation"] !== undefined ? _data["subscriberInformation"] : "";
        }
    }

    static fromJS(data: any): ContentStreamSubscriberInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ContentStreamSubscriberInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contentStreamSubscriptionId"] = this.contentStreamSubscriptionId;
        data["subscriberInformation"] = this.subscriberInformation;
        return data; 
    }
}

export interface IContentStreamSubscriberInfoDTO {
    contentStreamSubscriptionId: number;
    subscriberInformation: string;
}

export class ContentStreamSubscriptionDataDTO implements IContentStreamSubscriptionDataDTO {
    customerAccountId!: number;
    contentStreamId!: string;
    contentStreamLevelId!: string;
    guid!: string | undefined;

    constructor(data?: IContentStreamSubscriptionDataDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.customerAccountId = 0;
            this.contentStreamId = "0";
            this.contentStreamLevelId = "0";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerAccountId = _data["customerAccountId"] !== undefined ? _data["customerAccountId"] : 0;
            this.contentStreamId = _data["contentStreamId"] !== undefined ? _data["contentStreamId"] : "0";
            this.contentStreamLevelId = _data["contentStreamLevelId"] !== undefined ? _data["contentStreamLevelId"] : "0";
            this.guid = _data["guid"];
        }
    }

    static fromJS(data: any): ContentStreamSubscriptionDataDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ContentStreamSubscriptionDataDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerAccountId"] = this.customerAccountId;
        data["contentStreamId"] = this.contentStreamId;
        data["contentStreamLevelId"] = this.contentStreamLevelId;
        data["guid"] = this.guid;
        return data; 
    }
}

export interface IContentStreamSubscriptionDataDTO {
    customerAccountId: number;
    contentStreamId: string;
    contentStreamLevelId: string;
    guid: string | undefined;
}

/** options to use when converting pdfs */
export class ConversionOptionsModel implements IConversionOptionsModel {
    cropX1!: number | undefined;
    cropX2!: number | undefined;
    cropY1!: number | undefined;
    cropY2!: number | undefined;
    analyzeWords!: boolean | undefined;
    /** pdftron flatten threshold */
    flattenThresholdFlag!: ConversionOptionsModelFlattenThresholdFlag | undefined;
    /** jpeg quality of rasterized images */
    jpgQuality!: number | undefined;
    /** dpi of any vector-&gt;raster conversion */
    dpiConvertedElement!: number | undefined;
    /** thicken the liens */
    thickenLines!: boolean | undefined;
    /** generate urls in the xod */
    generateURLLinks!: boolean | undefined;
    /** biggest size of raster images */
    maxImagePixels!: number | undefined;
    /** flatten elements */
    flatten!: ConversionOptionsModelFlatten | undefined;
    /** configure amount of space between letters that a space will be inserted. */
    spacePercent!: number | undefined;

    constructor(data?: IConversionOptionsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cropX1 = _data["cropX1"];
            this.cropX2 = _data["cropX2"];
            this.cropY1 = _data["cropY1"];
            this.cropY2 = _data["cropY2"];
            this.analyzeWords = _data["analyzeWords"];
            this.flattenThresholdFlag = _data["flattenThresholdFlag"];
            this.jpgQuality = _data["jpgQuality"];
            this.dpiConvertedElement = _data["dpiConvertedElement"];
            this.thickenLines = _data["thickenLines"];
            this.generateURLLinks = _data["generateURLLinks"];
            this.maxImagePixels = _data["maxImagePixels"];
            this.flatten = _data["flatten"];
            this.spacePercent = _data["spacePercent"];
        }
    }

    static fromJS(data: any): ConversionOptionsModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConversionOptionsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cropX1"] = this.cropX1;
        data["cropX2"] = this.cropX2;
        data["cropY1"] = this.cropY1;
        data["cropY2"] = this.cropY2;
        data["analyzeWords"] = this.analyzeWords;
        data["flattenThresholdFlag"] = this.flattenThresholdFlag;
        data["jpgQuality"] = this.jpgQuality;
        data["dpiConvertedElement"] = this.dpiConvertedElement;
        data["thickenLines"] = this.thickenLines;
        data["generateURLLinks"] = this.generateURLLinks;
        data["maxImagePixels"] = this.maxImagePixels;
        data["flatten"] = this.flatten;
        data["spacePercent"] = this.spacePercent;
        return data; 
    }
}

/** options to use when converting pdfs */
export interface IConversionOptionsModel {
    cropX1: number | undefined;
    cropX2: number | undefined;
    cropY1: number | undefined;
    cropY2: number | undefined;
    analyzeWords: boolean | undefined;
    /** pdftron flatten threshold */
    flattenThresholdFlag: ConversionOptionsModelFlattenThresholdFlag | undefined;
    /** jpeg quality of rasterized images */
    jpgQuality: number | undefined;
    /** dpi of any vector-&gt;raster conversion */
    dpiConvertedElement: number | undefined;
    /** thicken the liens */
    thickenLines: boolean | undefined;
    /** generate urls in the xod */
    generateURLLinks: boolean | undefined;
    /** biggest size of raster images */
    maxImagePixels: number | undefined;
    /** flatten elements */
    flatten: ConversionOptionsModelFlatten | undefined;
    /** configure amount of space between letters that a space will be inserted. */
    spacePercent: number | undefined;
}

export class PartnerSubscriptionDTO implements IPartnerSubscriptionDTO {
    /** Identifier to reference user. */
    externalId!: string;
    /** Partner Identifier supplied by partica */
    partnerId!: string;
    /** Partner Identifier supplied by partica */
    streamId!: string;
    /** Emailaddress of partners user. */
    emailAddress!: string;

    constructor(data?: IPartnerSubscriptionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"];
            this.partnerId = _data["partnerId"];
            this.streamId = _data["streamId"];
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): PartnerSubscriptionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerSubscriptionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId;
        data["partnerId"] = this.partnerId;
        data["streamId"] = this.streamId;
        data["emailAddress"] = this.emailAddress;
        return data; 
    }
}

export interface IPartnerSubscriptionDTO {
    /** Identifier to reference user. */
    externalId: string;
    /** Partner Identifier supplied by partica */
    partnerId: string;
    /** Partner Identifier supplied by partica */
    streamId: string;
    /** Emailaddress of partners user. */
    emailAddress: string;
}

export class AccountDetailsUpdateDTO implements IAccountDetailsUpdateDTO {
    id!: number;
    company!: string | undefined;
    firstName!: string;
    surname!: string;
    country!: AccountDetailsUpdateDTOCountry;
    aspNetUserId!: string | undefined;
    phoneNumber!: string | undefined;

    constructor(data?: IAccountDetailsUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.company = _data["company"];
            this.firstName = _data["firstName"];
            this.surname = _data["surname"];
            this.country = _data["country"];
            this.aspNetUserId = _data["aspNetUserId"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): AccountDetailsUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AccountDetailsUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["company"] = this.company;
        data["firstName"] = this.firstName;
        data["surname"] = this.surname;
        data["country"] = this.country;
        data["aspNetUserId"] = this.aspNetUserId;
        data["phoneNumber"] = this.phoneNumber;
        return data; 
    }
}

export interface IAccountDetailsUpdateDTO {
    id: number;
    company: string | undefined;
    firstName: string;
    surname: string;
    country: AccountDetailsUpdateDTOCountry;
    aspNetUserId: string | undefined;
    phoneNumber: string | undefined;
}

export class AdminIdentityUserModel implements IAdminIdentityUserModel {
    firstName!: string | undefined;
    surname!: string | undefined;
    email!: string | undefined;
    owner!: string | undefined;
    userName!: string | undefined;
    id!: string | undefined;

    constructor(data?: IAdminIdentityUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.surname = _data["surname"];
            this.email = _data["email"];
            this.owner = _data["owner"];
            this.userName = _data["userName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AdminIdentityUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new AdminIdentityUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["surname"] = this.surname;
        data["email"] = this.email;
        data["owner"] = this.owner;
        data["userName"] = this.userName;
        data["id"] = this.id;
        return data; 
    }
}

export interface IAdminIdentityUserModel {
    firstName: string | undefined;
    surname: string | undefined;
    email: string | undefined;
    owner: string | undefined;
    userName: string | undefined;
    id: string | undefined;
}

/** customwer account */
export class CustomerAccountModel implements ICustomerAccountModel {
    /** Identifier */
    id!: number | undefined;
    /** name of customer */
    name!: string | undefined;
    guid!: string | undefined;
    freeTrial!: boolean | undefined;
    customBilling!: boolean | undefined;
    status!: number | undefined;
    tenantId!: number | undefined;
    country!: CustomerAccountModelCountry;
    company!: string | undefined;
    /** only returned on portal calls. */
    hasPdf!: boolean | undefined;
    /** publication for the customer. */
    publications!: PublicationModel[] | undefined;
    customerUrls!: CustomerUrlModel[] | undefined;
    producers!: ProducerModel[] | undefined;
    messages!: MessageModel[] | undefined;
    newsletterSubscriptions!: NewsletterSubscriptionModel[] | undefined;
    customerAccountBillings!: CustomerAccountBillingModel[] | undefined;

    constructor(data?: ICustomerAccountModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.guid = _data["guid"];
            this.freeTrial = _data["freeTrial"];
            this.customBilling = _data["customBilling"];
            this.status = _data["status"];
            this.tenantId = _data["tenantId"];
            this.country = _data["country"];
            this.company = _data["company"];
            this.hasPdf = _data["hasPdf"];
            if (Array.isArray(_data["publications"])) {
                this.publications = [] as any;
                for (let item of _data["publications"])
                    this.publications!.push(PublicationModel.fromJS(item));
            }
            if (Array.isArray(_data["customerUrls"])) {
                this.customerUrls = [] as any;
                for (let item of _data["customerUrls"])
                    this.customerUrls!.push(CustomerUrlModel.fromJS(item));
            }
            if (Array.isArray(_data["producers"])) {
                this.producers = [] as any;
                for (let item of _data["producers"])
                    this.producers!.push(ProducerModel.fromJS(item));
            }
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(MessageModel.fromJS(item));
            }
            if (Array.isArray(_data["newsletterSubscriptions"])) {
                this.newsletterSubscriptions = [] as any;
                for (let item of _data["newsletterSubscriptions"])
                    this.newsletterSubscriptions!.push(NewsletterSubscriptionModel.fromJS(item));
            }
            if (Array.isArray(_data["customerAccountBillings"])) {
                this.customerAccountBillings = [] as any;
                for (let item of _data["customerAccountBillings"])
                    this.customerAccountBillings!.push(CustomerAccountBillingModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerAccountModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAccountModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["guid"] = this.guid;
        data["freeTrial"] = this.freeTrial;
        data["customBilling"] = this.customBilling;
        data["status"] = this.status;
        data["tenantId"] = this.tenantId;
        data["country"] = this.country;
        data["company"] = this.company;
        data["hasPdf"] = this.hasPdf;
        if (Array.isArray(this.publications)) {
            data["publications"] = [];
            for (let item of this.publications)
                data["publications"].push(item.toJSON());
        }
        if (Array.isArray(this.customerUrls)) {
            data["customerUrls"] = [];
            for (let item of this.customerUrls)
                data["customerUrls"].push(item.toJSON());
        }
        if (Array.isArray(this.producers)) {
            data["producers"] = [];
            for (let item of this.producers)
                data["producers"].push(item.toJSON());
        }
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        if (Array.isArray(this.newsletterSubscriptions)) {
            data["newsletterSubscriptions"] = [];
            for (let item of this.newsletterSubscriptions)
                data["newsletterSubscriptions"].push(item.toJSON());
        }
        if (Array.isArray(this.customerAccountBillings)) {
            data["customerAccountBillings"] = [];
            for (let item of this.customerAccountBillings)
                data["customerAccountBillings"].push(item.toJSON());
        }
        return data; 
    }
}

/** customwer account */
export interface ICustomerAccountModel {
    /** Identifier */
    id: number | undefined;
    /** name of customer */
    name: string | undefined;
    guid: string | undefined;
    freeTrial: boolean | undefined;
    customBilling: boolean | undefined;
    status: number | undefined;
    tenantId: number | undefined;
    country: CustomerAccountModelCountry;
    company: string | undefined;
    /** only returned on portal calls. */
    hasPdf: boolean | undefined;
    /** publication for the customer. */
    publications: PublicationModel[] | undefined;
    customerUrls: CustomerUrlModel[] | undefined;
    producers: ProducerModel[] | undefined;
    messages: MessageModel[] | undefined;
    newsletterSubscriptions: NewsletterSubscriptionModel[] | undefined;
    customerAccountBillings: CustomerAccountBillingModel[] | undefined;
}

/** Customer Url model. */
export class CustomerUrlModel implements ICustomerUrlModel {
    /** Url identifier. */
    id!: number | undefined;
    /** custom url for this customer. */
    url!: string | undefined;
    /** elvel of secutiry on url */
    secure!: CustomerUrlModelSecure | undefined;
    /** list of publications available on this url */
    publicationCustomerUrls!: CustomerUrlPublicationModel[] | undefined;
    /** is seo allowed for this site */
    searchEngineIndexed!: number | undefined;
    securityType!: CustomerUrlModelSecurityType | undefined;

    constructor(data?: ICustomerUrlModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.url = _data["url"];
            this.secure = _data["secure"];
            if (Array.isArray(_data["publicationCustomerUrls"])) {
                this.publicationCustomerUrls = [] as any;
                for (let item of _data["publicationCustomerUrls"])
                    this.publicationCustomerUrls!.push(CustomerUrlPublicationModel.fromJS(item));
            }
            this.searchEngineIndexed = _data["searchEngineIndexed"];
            this.securityType = _data["securityType"];
        }
    }

    static fromJS(data: any): CustomerUrlModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerUrlModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["url"] = this.url;
        data["secure"] = this.secure;
        if (Array.isArray(this.publicationCustomerUrls)) {
            data["publicationCustomerUrls"] = [];
            for (let item of this.publicationCustomerUrls)
                data["publicationCustomerUrls"].push(item.toJSON());
        }
        data["searchEngineIndexed"] = this.searchEngineIndexed;
        data["securityType"] = this.securityType;
        return data; 
    }
}

/** Customer Url model. */
export interface ICustomerUrlModel {
    /** Url identifier. */
    id: number | undefined;
    /** custom url for this customer. */
    url: string | undefined;
    /** elvel of secutiry on url */
    secure: CustomerUrlModelSecure | undefined;
    /** list of publications available on this url */
    publicationCustomerUrls: CustomerUrlPublicationModel[] | undefined;
    /** is seo allowed for this site */
    searchEngineIndexed: number | undefined;
    securityType: CustomerUrlModelSecurityType | undefined;
}

export class ProducerModel implements IProducerModel {
    id!: number | undefined;
    customerAccountId!: number | undefined;
    name!: string | undefined;
    tags!: string | undefined;
    description!: string | undefined;
    status!: number | undefined;
    visibility!: number | undefined;
    newsletterServices!: NewsletterserviceModel[] | undefined;

    constructor(data?: IProducerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerAccountId = _data["customerAccountId"];
            this.name = _data["name"];
            this.tags = _data["tags"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.visibility = _data["visibility"];
            if (Array.isArray(_data["newsletterServices"])) {
                this.newsletterServices = [] as any;
                for (let item of _data["newsletterServices"])
                    this.newsletterServices!.push(NewsletterserviceModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProducerModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProducerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerAccountId"] = this.customerAccountId;
        data["name"] = this.name;
        data["tags"] = this.tags;
        data["description"] = this.description;
        data["status"] = this.status;
        data["visibility"] = this.visibility;
        if (Array.isArray(this.newsletterServices)) {
            data["newsletterServices"] = [];
            for (let item of this.newsletterServices)
                data["newsletterServices"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IProducerModel {
    id: number | undefined;
    customerAccountId: number | undefined;
    name: string | undefined;
    tags: string | undefined;
    description: string | undefined;
    status: number | undefined;
    visibility: number | undefined;
    newsletterServices: NewsletterserviceModel[] | undefined;
}

export class MessageModel implements IMessageModel {
    id!: number | undefined;
    customerAccountId!: number | undefined;
    title!: string | undefined;
    body!: string | undefined;
    from!: string | undefined;
    messageType!: MessageModelMessageType | undefined;
    messageParameters!: string | undefined;
    isNew!: boolean | undefined;
    created!: Date | undefined;

    constructor(data?: IMessageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerAccountId = _data["customerAccountId"];
            this.title = _data["title"];
            this.body = _data["body"];
            this.from = _data["from"];
            this.messageType = _data["messageType"];
            this.messageParameters = _data["messageParameters"];
            this.isNew = _data["isNew"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MessageModel {
        data = typeof data === 'object' ? data : {};
        let result = new MessageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerAccountId"] = this.customerAccountId;
        data["title"] = this.title;
        data["body"] = this.body;
        data["from"] = this.from;
        data["messageType"] = this.messageType;
        data["messageParameters"] = this.messageParameters;
        data["isNew"] = this.isNew;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IMessageModel {
    id: number | undefined;
    customerAccountId: number | undefined;
    title: string | undefined;
    body: string | undefined;
    from: string | undefined;
    messageType: MessageModelMessageType | undefined;
    messageParameters: string | undefined;
    isNew: boolean | undefined;
    created: Date | undefined;
}

export class NewsletterSubscriptionModel implements INewsletterSubscriptionModel {
    id!: number | undefined;
    newsletterServiceId!: number | undefined;
    customerAccountId!: number | undefined;
    publicationId!: number | undefined;
    status!: number | undefined;
    publication!: PublicationModel | undefined;
    newsletterService!: NewsletterserviceModel | undefined;

    constructor(data?: INewsletterSubscriptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.newsletterServiceId = _data["newsletterServiceId"];
            this.customerAccountId = _data["customerAccountId"];
            this.publicationId = _data["publicationId"];
            this.status = _data["status"];
            this.publication = _data["publication"] ? PublicationModel.fromJS(_data["publication"]) : <any>undefined;
            this.newsletterService = _data["newsletterService"] ? NewsletterserviceModel.fromJS(_data["newsletterService"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NewsletterSubscriptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewsletterSubscriptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["newsletterServiceId"] = this.newsletterServiceId;
        data["customerAccountId"] = this.customerAccountId;
        data["publicationId"] = this.publicationId;
        data["status"] = this.status;
        data["publication"] = this.publication ? this.publication.toJSON() : <any>undefined;
        data["newsletterService"] = this.newsletterService ? this.newsletterService.toJSON() : <any>undefined;
        return data; 
    }
}

export interface INewsletterSubscriptionModel {
    id: number | undefined;
    newsletterServiceId: number | undefined;
    customerAccountId: number | undefined;
    publicationId: number | undefined;
    status: number | undefined;
    publication: PublicationModel | undefined;
    newsletterService: NewsletterserviceModel | undefined;
}

export class CustomerAccountBillingModel implements ICustomerAccountBillingModel {
    id!: number | undefined;
    customerAccountId!: number | undefined;
    notes!: string | undefined;
    perPage!: number | undefined;
    monthly!: number | undefined;

    constructor(data?: ICustomerAccountBillingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerAccountId = _data["customerAccountId"];
            this.notes = _data["notes"];
            this.perPage = _data["perPage"];
            this.monthly = _data["monthly"];
        }
    }

    static fromJS(data: any): CustomerAccountBillingModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAccountBillingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerAccountId"] = this.customerAccountId;
        data["notes"] = this.notes;
        data["perPage"] = this.perPage;
        data["monthly"] = this.monthly;
        return data; 
    }
}

export interface ICustomerAccountBillingModel {
    id: number | undefined;
    customerAccountId: number | undefined;
    notes: string | undefined;
    perPage: number | undefined;
    monthly: number | undefined;
}

/** Allows access to a given publictaion from the given url. */
export class CustomerUrlPublicationModel implements ICustomerUrlPublicationModel {
    /** Url identifier */
    customerUrlId!: number | undefined;
    /** Publication identifier */
    publicationId!: number | undefined;
    /** path for the publication on the url (www.digitial.com/#/urlpath) */
    slug!: string | undefined;
    /** what can we display in viewer / initial display */
    displayConfiguration!: CustomerUrlPublicationModelDisplayConfiguration | undefined;
    /** order to display is viewer. */
    displayOrder!: number | undefined;
    /** publication linked. */
    publication!: PublicationModel | undefined;

    constructor(data?: ICustomerUrlPublicationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerUrlId = _data["customerUrlId"];
            this.publicationId = _data["publicationId"];
            this.slug = _data["slug"];
            this.displayConfiguration = _data["displayConfiguration"];
            this.displayOrder = _data["displayOrder"];
            this.publication = _data["publication"] ? PublicationModel.fromJS(_data["publication"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomerUrlPublicationModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerUrlPublicationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerUrlId"] = this.customerUrlId;
        data["publicationId"] = this.publicationId;
        data["slug"] = this.slug;
        data["displayConfiguration"] = this.displayConfiguration;
        data["displayOrder"] = this.displayOrder;
        data["publication"] = this.publication ? this.publication.toJSON() : <any>undefined;
        return data; 
    }
}

/** Allows access to a given publictaion from the given url. */
export interface ICustomerUrlPublicationModel {
    /** Url identifier */
    customerUrlId: number | undefined;
    /** Publication identifier */
    publicationId: number | undefined;
    /** path for the publication on the url (www.digitial.com/#/urlpath) */
    slug: string | undefined;
    /** what can we display in viewer / initial display */
    displayConfiguration: CustomerUrlPublicationModelDisplayConfiguration | undefined;
    /** order to display is viewer. */
    displayOrder: number | undefined;
    /** publication linked. */
    publication: PublicationModel | undefined;
}

export class NewsletterserviceModel implements INewsletterserviceModel {
    id!: number | undefined;
    producerId!: number | undefined;
    name!: string | undefined;
    tags!: string | undefined;
    description!: string | undefined;
    status!: number | undefined;
    visibility!: number | undefined;
    publicationId!: number | undefined;
    schedule!: string | undefined;
    price!: number | undefined;
    newsletters!: NewsletterModel[] | undefined;

    constructor(data?: INewsletterserviceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.producerId = _data["producerId"];
            this.name = _data["name"];
            this.tags = _data["tags"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.visibility = _data["visibility"];
            this.publicationId = _data["publicationId"];
            this.schedule = _data["schedule"];
            this.price = _data["price"];
            if (Array.isArray(_data["newsletters"])) {
                this.newsletters = [] as any;
                for (let item of _data["newsletters"])
                    this.newsletters!.push(NewsletterModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NewsletterserviceModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewsletterserviceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["producerId"] = this.producerId;
        data["name"] = this.name;
        data["tags"] = this.tags;
        data["description"] = this.description;
        data["status"] = this.status;
        data["visibility"] = this.visibility;
        data["publicationId"] = this.publicationId;
        data["schedule"] = this.schedule;
        data["price"] = this.price;
        if (Array.isArray(this.newsletters)) {
            data["newsletters"] = [];
            for (let item of this.newsletters)
                data["newsletters"].push(item.toJSON());
        }
        return data; 
    }
}

export interface INewsletterserviceModel {
    id: number | undefined;
    producerId: number | undefined;
    name: string | undefined;
    tags: string | undefined;
    description: string | undefined;
    status: number | undefined;
    visibility: number | undefined;
    publicationId: number | undefined;
    schedule: string | undefined;
    price: number | undefined;
    newsletters: NewsletterModel[] | undefined;
}

export class NewsletterModel implements INewsletterModel {
    id!: number | undefined;
    newsletterServiceId!: number | undefined;
    name!: string | undefined;
    description!: string | undefined;
    tags!: string | undefined;
    guid!: string | undefined;
    issueId!: number | undefined;
    status!: number | undefined;
    issue!: IssueModel | undefined;

    constructor(data?: INewsletterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.newsletterServiceId = _data["newsletterServiceId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.tags = _data["tags"];
            this.guid = _data["guid"];
            this.issueId = _data["issueId"];
            this.status = _data["status"];
            this.issue = _data["issue"] ? IssueModel.fromJS(_data["issue"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NewsletterModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewsletterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["newsletterServiceId"] = this.newsletterServiceId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["tags"] = this.tags;
        data["guid"] = this.guid;
        data["issueId"] = this.issueId;
        data["status"] = this.status;
        data["issue"] = this.issue ? this.issue.toJSON() : <any>undefined;
        return data; 
    }
}

export interface INewsletterModel {
    id: number | undefined;
    newsletterServiceId: number | undefined;
    name: string | undefined;
    description: string | undefined;
    tags: string | undefined;
    guid: string | undefined;
    issueId: number | undefined;
    status: number | undefined;
    issue: IssueModel | undefined;
}

export class LicenceDTO implements ILicenceDTO {
    id!: number | undefined;
    version!: number | undefined;
    type!: LicenceDTOType | undefined;
    content!: string | undefined;
    description!: string | undefined;
    created!: Date | undefined;
    modified!: Date | undefined;
    createdBy!: string | undefined;
    status!: LicenceDTOStatus | undefined;

    constructor(data?: ILicenceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.version = _data["version"];
            this.type = _data["type"];
            this.content = _data["content"];
            this.description = _data["description"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): LicenceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LicenceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["version"] = this.version;
        data["type"] = this.type;
        data["content"] = this.content;
        data["description"] = this.description;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["status"] = this.status;
        return data; 
    }
}

export interface ILicenceDTO {
    id: number | undefined;
    version: number | undefined;
    type: LicenceDTOType | undefined;
    content: string | undefined;
    description: string | undefined;
    created: Date | undefined;
    modified: Date | undefined;
    createdBy: string | undefined;
    status: LicenceDTOStatus | undefined;
}

export class LicenceContentDTO implements ILicenceContentDTO {
    id!: number | undefined;
    content!: string | undefined;

    constructor(data?: ILicenceContentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): LicenceContentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LicenceContentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["content"] = this.content;
        return data; 
    }
}

export interface ILicenceContentDTO {
    id: number | undefined;
    content: string | undefined;
}

export class UserLoginDetails implements IUserLoginDetails {
    id!: string | undefined;
    email!: string | undefined;
    provider!: string | undefined;

    constructor(data?: IUserLoginDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.provider = _data["provider"];
        }
    }

    static fromJS(data: any): UserLoginDetails {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["provider"] = this.provider;
        return data; 
    }
}

export interface IUserLoginDetails {
    id: string | undefined;
    email: string | undefined;
    provider: string | undefined;
}

export class ChargebeeTransactionSearchOptions implements IChargebeeTransactionSearchOptions {
    startDate!: Date | undefined;
    endDate!: Date;

    constructor(data?: IChargebeeTransactionSearchOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ChargebeeTransactionSearchOptions {
        data = typeof data === 'object' ? data : {};
        let result = new ChargebeeTransactionSearchOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IChargebeeTransactionSearchOptions {
    startDate: Date | undefined;
    endDate: Date;
}

export class PaymentBatch implements IPaymentBatch {
    customers!: PaymentBatchCustomer[] | undefined;
    affiliates!: PaymentBatchAffiliate[] | undefined;
    totalPurchases!: number | undefined;
    totalContributorPayments!: number | undefined;
    totalAffiliatePayments!: number | undefined;

    constructor(data?: IPaymentBatch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["customers"])) {
                this.customers = [] as any;
                for (let item of _data["customers"])
                    this.customers!.push(PaymentBatchCustomer.fromJS(item));
            }
            if (Array.isArray(_data["affiliates"])) {
                this.affiliates = [] as any;
                for (let item of _data["affiliates"])
                    this.affiliates!.push(PaymentBatchAffiliate.fromJS(item));
            }
            this.totalPurchases = _data["totalPurchases"];
            this.totalContributorPayments = _data["totalContributorPayments"];
            this.totalAffiliatePayments = _data["totalAffiliatePayments"];
        }
    }

    static fromJS(data: any): PaymentBatch {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentBatch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.customers)) {
            data["customers"] = [];
            for (let item of this.customers)
                data["customers"].push(item.toJSON());
        }
        if (Array.isArray(this.affiliates)) {
            data["affiliates"] = [];
            for (let item of this.affiliates)
                data["affiliates"].push(item.toJSON());
        }
        data["totalPurchases"] = this.totalPurchases;
        data["totalContributorPayments"] = this.totalContributorPayments;
        data["totalAffiliatePayments"] = this.totalAffiliatePayments;
        return data; 
    }
}

export interface IPaymentBatch {
    customers: PaymentBatchCustomer[] | undefined;
    affiliates: PaymentBatchAffiliate[] | undefined;
    totalPurchases: number | undefined;
    totalContributorPayments: number | undefined;
    totalAffiliatePayments: number | undefined;
}

export class PaymentBatchCustomer implements IPaymentBatchCustomer {
    items!: PaymentBatchItem[] | undefined;
    customerToken!: string | undefined;
    id!: number | undefined;
    name!: string | undefined;
    total!: number | undefined;

    constructor(data?: IPaymentBatchCustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PaymentBatchItem.fromJS(item));
            }
            this.customerToken = _data["customerToken"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): PaymentBatchCustomer {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentBatchCustomer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["customerToken"] = this.customerToken;
        data["id"] = this.id;
        data["name"] = this.name;
        data["total"] = this.total;
        return data; 
    }
}

export interface IPaymentBatchCustomer {
    items: PaymentBatchItem[] | undefined;
    customerToken: string | undefined;
    id: number | undefined;
    name: string | undefined;
    total: number | undefined;
}

export class PaymentBatchAffiliate implements IPaymentBatchAffiliate {
    items!: PaymentBatchItem[] | undefined;
    customerAccountId!: number | undefined;
    id!: number | undefined;
    account!: string | undefined;
    token!: string | undefined;
    total!: number | undefined;
    percent!: number | undefined;
    customerToken!: string | undefined;

    constructor(data?: IPaymentBatchAffiliate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PaymentBatchItem.fromJS(item));
            }
            this.customerAccountId = _data["customerAccountId"];
            this.id = _data["id"];
            this.account = _data["account"];
            this.token = _data["token"];
            this.total = _data["total"];
            this.percent = _data["percent"];
            this.customerToken = _data["customerToken"];
        }
    }

    static fromJS(data: any): PaymentBatchAffiliate {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentBatchAffiliate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["customerAccountId"] = this.customerAccountId;
        data["id"] = this.id;
        data["account"] = this.account;
        data["token"] = this.token;
        data["total"] = this.total;
        data["percent"] = this.percent;
        data["customerToken"] = this.customerToken;
        return data; 
    }
}

export interface IPaymentBatchAffiliate {
    items: PaymentBatchItem[] | undefined;
    customerAccountId: number | undefined;
    id: number | undefined;
    account: string | undefined;
    token: string | undefined;
    total: number | undefined;
    percent: number | undefined;
    customerToken: string | undefined;
}

export class PaymentBatchItem implements IPaymentBatchItem {
    id!: number | undefined;
    title!: string | undefined;
    amount!: number | undefined;
    batchitem!: any | undefined;
    purchaser!: string | undefined;
    customerAccountId!: number | undefined;

    constructor(data?: IPaymentBatchItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.amount = _data["amount"];
            this.batchitem = _data["batchitem"];
            this.purchaser = _data["purchaser"];
            this.customerAccountId = _data["customerAccountId"];
        }
    }

    static fromJS(data: any): PaymentBatchItem {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentBatchItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["amount"] = this.amount;
        data["batchitem"] = this.batchitem;
        data["purchaser"] = this.purchaser;
        data["customerAccountId"] = this.customerAccountId;
        return data; 
    }
}

export interface IPaymentBatchItem {
    id: number | undefined;
    title: string | undefined;
    amount: number | undefined;
    batchitem: any | undefined;
    purchaser: string | undefined;
    customerAccountId: number | undefined;
}

/** hyperwallet batch */
export class HyperwalletBatchDTO implements IHyperwalletBatchDTO {
    id!: number | undefined;
    sequence!: number;
    start!: Date;
    end!: Date;
    status!: number | undefined;
    created!: Date | undefined;
    description!: string;

    constructor(data?: IHyperwalletBatchDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sequence = _data["sequence"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): HyperwalletBatchDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HyperwalletBatchDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sequence"] = this.sequence;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["description"] = this.description;
        return data; 
    }
}

/** hyperwallet batch */
export interface IHyperwalletBatchDTO {
    id: number | undefined;
    sequence: number;
    start: Date;
    end: Date;
    status: number | undefined;
    created: Date | undefined;
    description: string;
}

export class HyperwalletBatchDetailsDTO implements IHyperwalletBatchDetailsDTO {
    endDate!: Date;
    description!: string;
    releaseOn!: Date;

    constructor(data?: IHyperwalletBatchDetailsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.releaseOn = _data["releaseOn"] ? new Date(_data["releaseOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): HyperwalletBatchDetailsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HyperwalletBatchDetailsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["releaseOn"] = this.releaseOn ? this.releaseOn.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IHyperwalletBatchDetailsDTO {
    endDate: Date;
    description: string;
    releaseOn: Date;
}

export class MenuItemDTO implements IMenuItemDTO {
    id!: string | undefined;
    link!: string | undefined;
    icon!: string | undefined;
    name!: string | undefined;
    children!: MenuItemDTO[] | undefined;

    constructor(data?: IMenuItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.link = _data["link"];
            this.icon = _data["icon"];
            this.name = _data["name"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(MenuItemDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MenuItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MenuItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["link"] = this.link;
        data["icon"] = this.icon;
        data["name"] = this.name;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IMenuItemDTO {
    id: string | undefined;
    link: string | undefined;
    icon: string | undefined;
    name: string | undefined;
    children: MenuItemDTO[] | undefined;
}

export class PubIssueDTO implements IPubIssueDTO {
    isssueId!: number | undefined;
    name!: string | undefined;
    live!: number | undefined;
    issueDate!: Date | undefined;
    issueStatus!: number | undefined;

    constructor(data?: IPubIssueDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isssueId = _data["isssueId"];
            this.name = _data["name"];
            this.live = _data["live"];
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : <any>undefined;
            this.issueStatus = _data["issueStatus"];
        }
    }

    static fromJS(data: any): PubIssueDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PubIssueDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isssueId"] = this.isssueId;
        data["name"] = this.name;
        data["live"] = this.live;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>undefined;
        data["issueStatus"] = this.issueStatus;
        return data; 
    }
}

export interface IPubIssueDTO {
    isssueId: number | undefined;
    name: string | undefined;
    live: number | undefined;
    issueDate: Date | undefined;
    issueStatus: number | undefined;
}

export class NavItemDTO implements INavItemDTO {
    id!: number | undefined;
    name!: string | undefined;
    guid!: string | undefined;
    parentId!: number | undefined;
    parentName!: string | undefined;
    accountId!: number | undefined;

    constructor(data?: INavItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.guid = _data["guid"];
            this.parentId = _data["parentId"];
            this.parentName = _data["parentName"];
            this.accountId = _data["accountId"];
        }
    }

    static fromJS(data: any): NavItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NavItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["guid"] = this.guid;
        data["parentId"] = this.parentId;
        data["parentName"] = this.parentName;
        data["accountId"] = this.accountId;
        return data; 
    }
}

export interface INavItemDTO {
    id: number | undefined;
    name: string | undefined;
    guid: string | undefined;
    parentId: number | undefined;
    parentName: string | undefined;
    accountId: number | undefined;
}

export class ArticleMetadataDTO implements IArticleMetadataDTO {
    contributor!: string | undefined;
    title!: string;
    description!: string | undefined;
    folio!: string;
    issuename!: string;
    keywords!: string | undefined;
    section!: string | undefined;
    theme!: string | undefined;
    issueid!: number;

    constructor(data?: IArticleMetadataDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contributor = _data["contributor"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.folio = _data["folio"];
            this.issuename = _data["issuename"];
            this.keywords = _data["keywords"];
            this.section = _data["section"];
            this.theme = _data["theme"];
            this.issueid = _data["issueid"];
        }
    }

    static fromJS(data: any): ArticleMetadataDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleMetadataDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contributor"] = this.contributor;
        data["title"] = this.title;
        data["description"] = this.description;
        data["folio"] = this.folio;
        data["issuename"] = this.issuename;
        data["keywords"] = this.keywords;
        data["section"] = this.section;
        data["theme"] = this.theme;
        data["issueid"] = this.issueid;
        return data; 
    }
}

export interface IArticleMetadataDTO {
    contributor: string | undefined;
    title: string;
    description: string | undefined;
    folio: string;
    issuename: string;
    keywords: string | undefined;
    section: string | undefined;
    theme: string | undefined;
    issueid: number;
}

export class ArticleMetadata2DTO implements IArticleMetadata2DTO {
    contributors!: string[] | undefined;
    title!: string;
    description!: string | undefined;
    folio!: string;
    keywords!: string[] | undefined;
    section!: string;
    theme!: string[] | undefined;
    issueid!: number;
    locations!: string[] | undefined;

    constructor(data?: IArticleMetadata2DTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["contributors"])) {
                this.contributors = [] as any;
                for (let item of _data["contributors"])
                    this.contributors!.push(item);
            }
            this.title = _data["title"];
            this.description = _data["description"];
            this.folio = _data["folio"];
            if (Array.isArray(_data["keywords"])) {
                this.keywords = [] as any;
                for (let item of _data["keywords"])
                    this.keywords!.push(item);
            }
            this.section = _data["section"];
            if (Array.isArray(_data["theme"])) {
                this.theme = [] as any;
                for (let item of _data["theme"])
                    this.theme!.push(item);
            }
            this.issueid = _data["issueid"];
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(item);
            }
        }
    }

    static fromJS(data: any): ArticleMetadata2DTO {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleMetadata2DTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contributors)) {
            data["contributors"] = [];
            for (let item of this.contributors)
                data["contributors"].push(item);
        }
        data["title"] = this.title;
        data["description"] = this.description;
        data["folio"] = this.folio;
        if (Array.isArray(this.keywords)) {
            data["keywords"] = [];
            for (let item of this.keywords)
                data["keywords"].push(item);
        }
        data["section"] = this.section;
        if (Array.isArray(this.theme)) {
            data["theme"] = [];
            for (let item of this.theme)
                data["theme"].push(item);
        }
        data["issueid"] = this.issueid;
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item);
        }
        return data; 
    }
}

export interface IArticleMetadata2DTO {
    contributors: string[] | undefined;
    title: string;
    description: string | undefined;
    folio: string;
    keywords: string[] | undefined;
    section: string;
    theme: string[] | undefined;
    issueid: number;
    locations: string[] | undefined;
}

export class FolioDTO implements IFolioDTO {
    firstpagenumber!: number | undefined;
    firstpagenumberoffset!: number | undefined;
    lastnumberedpageoffset!: number | undefined;
    unnumberedoffsets!: string | undefined;
    issuename!: string | undefined;
    issueid!: number | undefined;

    constructor(data?: IFolioDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstpagenumber = _data["firstpagenumber"];
            this.firstpagenumberoffset = _data["firstpagenumberoffset"];
            this.lastnumberedpageoffset = _data["lastnumberedpageoffset"];
            this.unnumberedoffsets = _data["unnumberedoffsets"];
            this.issuename = _data["issuename"];
            this.issueid = _data["issueid"];
        }
    }

    static fromJS(data: any): FolioDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FolioDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstpagenumber"] = this.firstpagenumber;
        data["firstpagenumberoffset"] = this.firstpagenumberoffset;
        data["lastnumberedpageoffset"] = this.lastnumberedpageoffset;
        data["unnumberedoffsets"] = this.unnumberedoffsets;
        data["issuename"] = this.issuename;
        data["issueid"] = this.issueid;
        return data; 
    }
}

export interface IFolioDTO {
    firstpagenumber: number | undefined;
    firstpagenumberoffset: number | undefined;
    lastnumberedpageoffset: number | undefined;
    unnumberedoffsets: string | undefined;
    issuename: string | undefined;
    issueid: number | undefined;
}

export class IssuePropertiesDTO implements IIssuePropertiesDTO {
    id!: number | undefined;
    name!: string;
    issueDate!: Date;
    visibility!: IssuePropertiesDTOVisibility;
    secure!: IssuePropertiesDTOSecure;
    status!: IssuePropertiesDTOStatus;
    urlFragment!: string;

    constructor(data?: IIssuePropertiesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : <any>undefined;
            this.visibility = _data["visibility"];
            this.secure = _data["secure"];
            this.status = _data["status"];
            this.urlFragment = _data["urlFragment"];
        }
    }

    static fromJS(data: any): IssuePropertiesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IssuePropertiesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>undefined;
        data["visibility"] = this.visibility;
        data["secure"] = this.secure;
        data["status"] = this.status;
        data["urlFragment"] = this.urlFragment;
        return data; 
    }
}

export interface IIssuePropertiesDTO {
    id: number | undefined;
    name: string;
    issueDate: Date;
    visibility: IssuePropertiesDTOVisibility;
    secure: IssuePropertiesDTOSecure;
    status: IssuePropertiesDTOStatus;
    urlFragment: string;
}

/** class for managing pdfs */
export class InputPdfModel implements IInputPdfModel {
    id!: number | undefined;
    fileName!: string | undefined;
    sequence!: number | undefined;

    constructor(data?: IInputPdfModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.sequence = _data["sequence"];
        }
    }

    static fromJS(data: any): InputPdfModel {
        data = typeof data === 'object' ? data : {};
        let result = new InputPdfModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["sequence"] = this.sequence;
        return data; 
    }
}

/** class for managing pdfs */
export interface IInputPdfModel {
    id: number | undefined;
    fileName: string | undefined;
    sequence: number | undefined;
}

export class SourceFileModel implements ISourceFileModel {
    guid!: string | undefined;
    url!: string | undefined;
    created!: Date | undefined;
    status!: number | undefined;
    issue!: IssueModel | undefined;

    constructor(data?: ISourceFileModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.url = _data["url"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.issue = _data["issue"] ? IssueModel.fromJS(_data["issue"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SourceFileModel {
        data = typeof data === 'object' ? data : {};
        let result = new SourceFileModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["url"] = this.url;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["issue"] = this.issue ? this.issue.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ISourceFileModel {
    guid: string | undefined;
    url: string | undefined;
    created: Date | undefined;
    status: number | undefined;
    issue: IssueModel | undefined;
}

/** log for conversions */
export class ConversionLogModel implements IConversionLogModel {
    /** start of conversion */
    start!: Date | undefined;
    /** end of conversion */
    end!: Date | undefined;
    /** issue identifier */
    issueId!: number | undefined;
    /** ms xod task executed time. */
    xod!: number | undefined;
    /** ms thumbnail task executed time. */
    thumbnail!: number | undefined;
    /** ms download task executed time. */
    download!: number | undefined;
    /** ms preflight task executed time. */
    preflight!: number | undefined;
    /** ms extract content task executed time. */
    extract!: number | undefined;
    /** ms taken to perform wordsmart */
    wordsmart!: number | undefined;
    /** ms merge task executed time. */
    merge!: number | undefined;
    /** number of pages in the input pdf */
    pages!: number | undefined;
    /** size in bytes of the created xod */
    xodsize!: number | undefined;
    /** size in bytes of the inputted pdf */
    pdfsize!: number | undefined;
    /** error messages generated during conversion */
    message!: string | undefined;
    /** rowkey for table. */
    rowKey!: string | undefined;

    constructor(data?: IConversionLogModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.issueId = _data["issueId"];
            this.xod = _data["xod"];
            this.thumbnail = _data["thumbnail"];
            this.download = _data["download"];
            this.preflight = _data["preflight"];
            this.extract = _data["extract"];
            this.wordsmart = _data["wordsmart"];
            this.merge = _data["merge"];
            this.pages = _data["pages"];
            this.xodsize = _data["xodsize"];
            this.pdfsize = _data["pdfsize"];
            this.message = _data["message"];
            this.rowKey = _data["rowKey"];
        }
    }

    static fromJS(data: any): ConversionLogModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConversionLogModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["issueId"] = this.issueId;
        data["xod"] = this.xod;
        data["thumbnail"] = this.thumbnail;
        data["download"] = this.download;
        data["preflight"] = this.preflight;
        data["extract"] = this.extract;
        data["wordsmart"] = this.wordsmart;
        data["merge"] = this.merge;
        data["pages"] = this.pages;
        data["xodsize"] = this.xodsize;
        data["pdfsize"] = this.pdfsize;
        data["message"] = this.message;
        data["rowKey"] = this.rowKey;
        return data; 
    }
}

/** log for conversions */
export interface IConversionLogModel {
    /** start of conversion */
    start: Date | undefined;
    /** end of conversion */
    end: Date | undefined;
    /** issue identifier */
    issueId: number | undefined;
    /** ms xod task executed time. */
    xod: number | undefined;
    /** ms thumbnail task executed time. */
    thumbnail: number | undefined;
    /** ms download task executed time. */
    download: number | undefined;
    /** ms preflight task executed time. */
    preflight: number | undefined;
    /** ms extract content task executed time. */
    extract: number | undefined;
    /** ms taken to perform wordsmart */
    wordsmart: number | undefined;
    /** ms merge task executed time. */
    merge: number | undefined;
    /** number of pages in the input pdf */
    pages: number | undefined;
    /** size in bytes of the created xod */
    xodsize: number | undefined;
    /** size in bytes of the inputted pdf */
    pdfsize: number | undefined;
    /** error messages generated during conversion */
    message: string | undefined;
    /** rowkey for table. */
    rowKey: string | undefined;
}

/** Details for a new issue. */
export class NewIssueFromURLView implements INewIssueFromURLView {
    publicationId!: number | undefined;
    url!: string | undefined;
    guid!: string | undefined;

    constructor(data?: INewIssueFromURLView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.publicationId = _data["publicationId"];
            this.url = _data["url"];
            this.guid = _data["guid"];
        }
    }

    static fromJS(data: any): NewIssueFromURLView {
        data = typeof data === 'object' ? data : {};
        let result = new NewIssueFromURLView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["publicationId"] = this.publicationId;
        data["url"] = this.url;
        data["guid"] = this.guid;
        return data; 
    }
}

/** Details for a new issue. */
export interface INewIssueFromURLView {
    publicationId: number | undefined;
    url: string | undefined;
    guid: string | undefined;
}

export class NewIssueData implements INewIssueData {
    publicationId!: number | undefined;
    issueName!: string | undefined;
    articles!: ArticleModel[] | undefined;

    constructor(data?: INewIssueData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.publicationId = _data["publicationId"];
            this.issueName = _data["issueName"];
            if (Array.isArray(_data["articles"])) {
                this.articles = [] as any;
                for (let item of _data["articles"])
                    this.articles!.push(ArticleModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NewIssueData {
        data = typeof data === 'object' ? data : {};
        let result = new NewIssueData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["publicationId"] = this.publicationId;
        data["issueName"] = this.issueName;
        if (Array.isArray(this.articles)) {
            data["articles"] = [];
            for (let item of this.articles)
                data["articles"].push(item.toJSON());
        }
        return data; 
    }
}

export interface INewIssueData {
    publicationId: number | undefined;
    issueName: string | undefined;
    articles: ArticleModel[] | undefined;
}

export class BlobReplaceDTO implements IBlobReplaceDTO {
    sas!: string | undefined;
    blob!: string | undefined;

    constructor(data?: IBlobReplaceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sas = _data["sas"];
            this.blob = _data["blob"];
        }
    }

    static fromJS(data: any): BlobReplaceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BlobReplaceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sas"] = this.sas;
        data["blob"] = this.blob;
        return data; 
    }
}

export interface IBlobReplaceDTO {
    sas: string | undefined;
    blob: string | undefined;
}

/** Issue CSS. */
export class IssueCSSModel implements IIssueCSSModel {
    publicationID!: number | undefined;
    /** Issue identifier. */
    issueId!: number | undefined;
    /** CSS for this Issue */
    css!: string | undefined;

    constructor(data?: IIssueCSSModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.publicationID = _data["publicationID"];
            this.issueId = _data["issueId"];
            this.css = _data["css"];
        }
    }

    static fromJS(data: any): IssueCSSModel {
        data = typeof data === 'object' ? data : {};
        let result = new IssueCSSModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["publicationID"] = this.publicationID;
        data["issueId"] = this.issueId;
        data["css"] = this.css;
        return data; 
    }
}

/** Issue CSS. */
export interface IIssueCSSModel {
    publicationID: number | undefined;
    /** Issue identifier. */
    issueId: number | undefined;
    /** CSS for this Issue */
    css: string | undefined;
}

/** folio */
export class IssueFolioModel implements IIssueFolioModel {
    /** the issue the folio is for. */
    issueid!: number | undefined;
    /** folio for the issue */
    folio!: string | undefined;

    constructor(data?: IIssueFolioModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueid = _data["issueid"];
            this.folio = _data["folio"];
        }
    }

    static fromJS(data: any): IssueFolioModel {
        data = typeof data === 'object' ? data : {};
        let result = new IssueFolioModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueid"] = this.issueid;
        data["folio"] = this.folio;
        return data; 
    }
}

/** folio */
export interface IIssueFolioModel {
    /** the issue the folio is for. */
    issueid: number | undefined;
    /** folio for the issue */
    folio: string | undefined;
}

export class IssueStorageDTO implements IIssueStorageDTO {
    status!: IssueStorageDTOStatus | undefined;
    created!: Date | undefined;
    modified!: Date | undefined;
    history!: IssueStorageHistoryDTO[] | undefined;

    constructor(data?: IIssueStorageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            if (Array.isArray(_data["history"])) {
                this.history = [] as any;
                for (let item of _data["history"])
                    this.history!.push(IssueStorageHistoryDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IssueStorageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IssueStorageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        if (Array.isArray(this.history)) {
            data["history"] = [];
            for (let item of this.history)
                data["history"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IIssueStorageDTO {
    status: IssueStorageDTOStatus | undefined;
    created: Date | undefined;
    modified: Date | undefined;
    history: IssueStorageHistoryDTO[] | undefined;
}

export class IssueStorageHistoryDTO implements IIssueStorageHistoryDTO {
    status!: IssueStorageHistoryDTOStatus | undefined;
    user!: string | undefined;
    timestamp!: Date | undefined;

    constructor(data?: IIssueStorageHistoryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.user = _data["user"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): IssueStorageHistoryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IssueStorageHistoryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["user"] = this.user;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IIssueStorageHistoryDTO {
    status: IssueStorageHistoryDTOStatus | undefined;
    user: string | undefined;
    timestamp: Date | undefined;
}

export class IssueWorkModel implements IIssueWorkModel {
    slug!: string | undefined;
    id!: number | undefined;
    issueId!: number | undefined;
    po!: string | undefined;
    notes!: string | undefined;
    requestedBy!: string | undefined;
    qaStatus!: IssueWorkModelQaStatus | undefined;
    qaStart!: Date | undefined;
    qaEnd!: Date | undefined;
    preExtractionStatus!: IssueWorkModelPreExtractionStatus | undefined;
    preExtractionStart!: Date | undefined;
    preExtractionEnd!: Date | undefined;
    extractionStatus!: IssueWorkModelExtractionStatus | undefined;
    extractionStart!: Date | undefined;
    extractionEnd!: Date | undefined;
    conversionStatus!: IssueWorkModelConversionStatus | undefined;
    conversionEnd!: Date | undefined;
    live!: boolean | undefined;
    liveTime!: Date | undefined;
    complete!: boolean | undefined;
    completed!: Date | undefined;
    created!: Date | undefined;
    enhancementStatus!: IssueWorkModelEnhancementStatus | undefined;
    enhancementStart!: Date | undefined;
    enhancementEnd!: Date | undefined;
    currentlyAssigned!: string | undefined;
    customerReference!: string | undefined;
    due!: Date | undefined;
    jobStatus!: IssueWorkModelJobStatus | undefined;
    postExtractionStatus!: IssueWorkModelPostExtractionStatus | undefined;
    postExtractionStart!: Date | undefined;
    postExtractionEnd!: Date | undefined;
    syndicationProof!: IssueWorkModelSyndicationProof | undefined;
    syndicationProofStart!: Date | undefined;
    syndicationProofEnd!: Date | undefined;

    constructor(data?: IIssueWorkModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.slug = _data["slug"];
            this.id = _data["id"];
            this.issueId = _data["issueId"];
            this.po = _data["po"];
            this.notes = _data["notes"];
            this.requestedBy = _data["requestedBy"];
            this.qaStatus = _data["qaStatus"];
            this.qaStart = _data["qaStart"] ? new Date(_data["qaStart"].toString()) : <any>undefined;
            this.qaEnd = _data["qaEnd"] ? new Date(_data["qaEnd"].toString()) : <any>undefined;
            this.preExtractionStatus = _data["preExtractionStatus"];
            this.preExtractionStart = _data["preExtractionStart"] ? new Date(_data["preExtractionStart"].toString()) : <any>undefined;
            this.preExtractionEnd = _data["preExtractionEnd"] ? new Date(_data["preExtractionEnd"].toString()) : <any>undefined;
            this.extractionStatus = _data["extractionStatus"];
            this.extractionStart = _data["extractionStart"] ? new Date(_data["extractionStart"].toString()) : <any>undefined;
            this.extractionEnd = _data["extractionEnd"] ? new Date(_data["extractionEnd"].toString()) : <any>undefined;
            this.conversionStatus = _data["conversionStatus"];
            this.conversionEnd = _data["conversionEnd"] ? new Date(_data["conversionEnd"].toString()) : <any>undefined;
            this.live = _data["live"];
            this.liveTime = _data["liveTime"] ? new Date(_data["liveTime"].toString()) : <any>undefined;
            this.complete = _data["complete"];
            this.completed = _data["completed"] ? new Date(_data["completed"].toString()) : <any>undefined;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.enhancementStatus = _data["enhancementStatus"];
            this.enhancementStart = _data["enhancementStart"] ? new Date(_data["enhancementStart"].toString()) : <any>undefined;
            this.enhancementEnd = _data["enhancementEnd"] ? new Date(_data["enhancementEnd"].toString()) : <any>undefined;
            this.currentlyAssigned = _data["currentlyAssigned"];
            this.customerReference = _data["customerReference"];
            this.due = _data["due"] ? new Date(_data["due"].toString()) : <any>undefined;
            this.jobStatus = _data["jobStatus"];
            this.postExtractionStatus = _data["postExtractionStatus"];
            this.postExtractionStart = _data["postExtractionStart"] ? new Date(_data["postExtractionStart"].toString()) : <any>undefined;
            this.postExtractionEnd = _data["postExtractionEnd"] ? new Date(_data["postExtractionEnd"].toString()) : <any>undefined;
            this.syndicationProof = _data["syndicationProof"];
            this.syndicationProofStart = _data["syndicationProofStart"] ? new Date(_data["syndicationProofStart"].toString()) : <any>undefined;
            this.syndicationProofEnd = _data["syndicationProofEnd"] ? new Date(_data["syndicationProofEnd"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): IssueWorkModel {
        data = typeof data === 'object' ? data : {};
        let result = new IssueWorkModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["slug"] = this.slug;
        data["id"] = this.id;
        data["issueId"] = this.issueId;
        data["po"] = this.po;
        data["notes"] = this.notes;
        data["requestedBy"] = this.requestedBy;
        data["qaStatus"] = this.qaStatus;
        data["qaStart"] = this.qaStart ? this.qaStart.toISOString() : <any>undefined;
        data["qaEnd"] = this.qaEnd ? this.qaEnd.toISOString() : <any>undefined;
        data["preExtractionStatus"] = this.preExtractionStatus;
        data["preExtractionStart"] = this.preExtractionStart ? this.preExtractionStart.toISOString() : <any>undefined;
        data["preExtractionEnd"] = this.preExtractionEnd ? this.preExtractionEnd.toISOString() : <any>undefined;
        data["extractionStatus"] = this.extractionStatus;
        data["extractionStart"] = this.extractionStart ? this.extractionStart.toISOString() : <any>undefined;
        data["extractionEnd"] = this.extractionEnd ? this.extractionEnd.toISOString() : <any>undefined;
        data["conversionStatus"] = this.conversionStatus;
        data["conversionEnd"] = this.conversionEnd ? this.conversionEnd.toISOString() : <any>undefined;
        data["live"] = this.live;
        data["liveTime"] = this.liveTime ? this.liveTime.toISOString() : <any>undefined;
        data["complete"] = this.complete;
        data["completed"] = this.completed ? this.completed.toISOString() : <any>undefined;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["enhancementStatus"] = this.enhancementStatus;
        data["enhancementStart"] = this.enhancementStart ? this.enhancementStart.toISOString() : <any>undefined;
        data["enhancementEnd"] = this.enhancementEnd ? this.enhancementEnd.toISOString() : <any>undefined;
        data["currentlyAssigned"] = this.currentlyAssigned;
        data["customerReference"] = this.customerReference;
        data["due"] = this.due ? this.due.toISOString() : <any>undefined;
        data["jobStatus"] = this.jobStatus;
        data["postExtractionStatus"] = this.postExtractionStatus;
        data["postExtractionStart"] = this.postExtractionStart ? this.postExtractionStart.toISOString() : <any>undefined;
        data["postExtractionEnd"] = this.postExtractionEnd ? this.postExtractionEnd.toISOString() : <any>undefined;
        data["syndicationProof"] = this.syndicationProof;
        data["syndicationProofStart"] = this.syndicationProofStart ? this.syndicationProofStart.toISOString() : <any>undefined;
        data["syndicationProofEnd"] = this.syndicationProofEnd ? this.syndicationProofEnd.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IIssueWorkModel {
    slug: string | undefined;
    id: number | undefined;
    issueId: number | undefined;
    po: string | undefined;
    notes: string | undefined;
    requestedBy: string | undefined;
    qaStatus: IssueWorkModelQaStatus | undefined;
    qaStart: Date | undefined;
    qaEnd: Date | undefined;
    preExtractionStatus: IssueWorkModelPreExtractionStatus | undefined;
    preExtractionStart: Date | undefined;
    preExtractionEnd: Date | undefined;
    extractionStatus: IssueWorkModelExtractionStatus | undefined;
    extractionStart: Date | undefined;
    extractionEnd: Date | undefined;
    conversionStatus: IssueWorkModelConversionStatus | undefined;
    conversionEnd: Date | undefined;
    live: boolean | undefined;
    liveTime: Date | undefined;
    complete: boolean | undefined;
    completed: Date | undefined;
    created: Date | undefined;
    enhancementStatus: IssueWorkModelEnhancementStatus | undefined;
    enhancementStart: Date | undefined;
    enhancementEnd: Date | undefined;
    currentlyAssigned: string | undefined;
    customerReference: string | undefined;
    due: Date | undefined;
    jobStatus: IssueWorkModelJobStatus | undefined;
    postExtractionStatus: IssueWorkModelPostExtractionStatus | undefined;
    postExtractionStart: Date | undefined;
    postExtractionEnd: Date | undefined;
    syndicationProof: IssueWorkModelSyndicationProof | undefined;
    syndicationProofStart: Date | undefined;
    syndicationProofEnd: Date | undefined;
}

/** Log of Isue tracking items. */
export class IssueTrackingLogModel implements IIssueTrackingLogModel {
    /** the issue the folio is for. */
    issueid!: number | undefined;
    /** time action happened */
    time!: Date | undefined;
    /** message */
    message!: string | undefined;

    constructor(data?: IIssueTrackingLogModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueid = _data["issueid"];
            this.time = _data["time"] ? new Date(_data["time"].toString()) : <any>undefined;
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): IssueTrackingLogModel {
        data = typeof data === 'object' ? data : {};
        let result = new IssueTrackingLogModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueid"] = this.issueid;
        data["time"] = this.time ? this.time.toISOString() : <any>undefined;
        data["message"] = this.message;
        return data; 
    }
}

/** Log of Isue tracking items. */
export interface IIssueTrackingLogModel {
    /** the issue the folio is for. */
    issueid: number | undefined;
    /** time action happened */
    time: Date | undefined;
    /** message */
    message: string | undefined;
}

export class IssueWorkUpdateModel implements IIssueWorkUpdateModel {
    issueId!: number | undefined;
    po!: string | undefined;
    notes!: string | undefined;
    currentlyAssigned!: string | undefined;
    customerReference!: string | undefined;
    due!: Date | undefined;

    constructor(data?: IIssueWorkUpdateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueId = _data["issueId"];
            this.po = _data["po"];
            this.notes = _data["notes"];
            this.currentlyAssigned = _data["currentlyAssigned"];
            this.customerReference = _data["customerReference"];
            this.due = _data["due"] ? new Date(_data["due"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): IssueWorkUpdateModel {
        data = typeof data === 'object' ? data : {};
        let result = new IssueWorkUpdateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueId"] = this.issueId;
        data["po"] = this.po;
        data["notes"] = this.notes;
        data["currentlyAssigned"] = this.currentlyAssigned;
        data["customerReference"] = this.customerReference;
        data["due"] = this.due ? this.due.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IIssueWorkUpdateModel {
    issueId: number | undefined;
    po: string | undefined;
    notes: string | undefined;
    currentlyAssigned: string | undefined;
    customerReference: string | undefined;
    due: Date | undefined;
}

export class IssueViewerConfigDTO implements IIssueViewerConfigDTO {
    id!: number | undefined;
    issueId!: number | undefined;
    content!: string;

    constructor(data?: IIssueViewerConfigDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.issueId = _data["issueId"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): IssueViewerConfigDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IssueViewerConfigDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["issueId"] = this.issueId;
        data["content"] = this.content;
        return data; 
    }
}

export interface IIssueViewerConfigDTO {
    id: number | undefined;
    issueId: number | undefined;
    content: string;
}

export class MailchimpConfigurationModel implements IMailchimpConfigurationModel {
    id!: number | undefined;
    publicationId!: number | undefined;
    apiKey!: string | undefined;
    name!: string | undefined;
    fromName!: string | undefined;
    replyTo!: string | undefined;

    constructor(data?: IMailchimpConfigurationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.publicationId = _data["publicationId"];
            this.apiKey = _data["apiKey"];
            this.name = _data["name"];
            this.fromName = _data["fromName"];
            this.replyTo = _data["replyTo"];
        }
    }

    static fromJS(data: any): MailchimpConfigurationModel {
        data = typeof data === 'object' ? data : {};
        let result = new MailchimpConfigurationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["publicationId"] = this.publicationId;
        data["apiKey"] = this.apiKey;
        data["name"] = this.name;
        data["fromName"] = this.fromName;
        data["replyTo"] = this.replyTo;
        return data; 
    }
}

export interface IMailchimpConfigurationModel {
    id: number | undefined;
    publicationId: number | undefined;
    apiKey: string | undefined;
    name: string | undefined;
    fromName: string | undefined;
    replyTo: string | undefined;
}

export class MailchimpPublishOptions implements IMailchimpPublishOptions {
    templates!: TemplateModel[] | undefined;
    lists!: ListModel[] | undefined;
    fromName!: string | undefined;
    replyTo!: string | undefined;

    constructor(data?: IMailchimpPublishOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["templates"])) {
                this.templates = [] as any;
                for (let item of _data["templates"])
                    this.templates!.push(TemplateModel.fromJS(item));
            }
            if (Array.isArray(_data["lists"])) {
                this.lists = [] as any;
                for (let item of _data["lists"])
                    this.lists!.push(ListModel.fromJS(item));
            }
            this.fromName = _data["fromName"];
            this.replyTo = _data["replyTo"];
        }
    }

    static fromJS(data: any): MailchimpPublishOptions {
        data = typeof data === 'object' ? data : {};
        let result = new MailchimpPublishOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.templates)) {
            data["templates"] = [];
            for (let item of this.templates)
                data["templates"].push(item.toJSON());
        }
        if (Array.isArray(this.lists)) {
            data["lists"] = [];
            for (let item of this.lists)
                data["lists"].push(item.toJSON());
        }
        data["fromName"] = this.fromName;
        data["replyTo"] = this.replyTo;
        return data; 
    }
}

export interface IMailchimpPublishOptions {
    templates: TemplateModel[] | undefined;
    lists: ListModel[] | undefined;
    fromName: string | undefined;
    replyTo: string | undefined;
}

export class TemplateModel implements ITemplateModel {
    name!: string | undefined;
    id!: number | undefined;

    constructor(data?: ITemplateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TemplateModel {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITemplateModel {
    name: string | undefined;
    id: number | undefined;
}

export class ListModel implements IListModel {
    name!: string | undefined;
    id!: string | undefined;

    constructor(data?: IListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ListModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data; 
    }
}

export interface IListModel {
    name: string | undefined;
    id: string | undefined;
}

/** mailchimp campaign details. */
export class MailchimpPublishData implements IMailchimpPublishData {
    /** list to send campaign to */
    listId!: string | undefined;
    /** template to use in campaign */
    templateId!: number | undefined;
    /** reply to in email */
    replyTo!: string | undefined;
    /** friendly from in email */
    fromName!: string | undefined;
    /** issueId of newsletter */
    issueId!: number | undefined;
    /** subject of email - also campaign name */
    subject!: string | undefined;
    /** body of email */
    bodyhtml!: string | undefined;
    /** preheader of email - first thing mobil sees. */
    preheaderhtml!: string | undefined;

    constructor(data?: IMailchimpPublishData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.listId = _data["listId"];
            this.templateId = _data["templateId"];
            this.replyTo = _data["replyTo"];
            this.fromName = _data["fromName"];
            this.issueId = _data["issueId"];
            this.subject = _data["subject"];
            this.bodyhtml = _data["bodyhtml"];
            this.preheaderhtml = _data["preheaderhtml"];
        }
    }

    static fromJS(data: any): MailchimpPublishData {
        data = typeof data === 'object' ? data : {};
        let result = new MailchimpPublishData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listId"] = this.listId;
        data["templateId"] = this.templateId;
        data["replyTo"] = this.replyTo;
        data["fromName"] = this.fromName;
        data["issueId"] = this.issueId;
        data["subject"] = this.subject;
        data["bodyhtml"] = this.bodyhtml;
        data["preheaderhtml"] = this.preheaderhtml;
        return data; 
    }
}

/** mailchimp campaign details. */
export interface IMailchimpPublishData {
    /** list to send campaign to */
    listId: string | undefined;
    /** template to use in campaign */
    templateId: number | undefined;
    /** reply to in email */
    replyTo: string | undefined;
    /** friendly from in email */
    fromName: string | undefined;
    /** issueId of newsletter */
    issueId: number | undefined;
    /** subject of email - also campaign name */
    subject: string | undefined;
    /** body of email */
    bodyhtml: string | undefined;
    /** preheader of email - first thing mobil sees. */
    preheaderhtml: string | undefined;
}

export class InviteModel implements IInviteModel {
    to!: string | undefined;
    from!: string | undefined;
    newsletterServiceId!: number | undefined;
    note!: string | undefined;

    constructor(data?: IInviteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.to = _data["to"];
            this.from = _data["from"];
            this.newsletterServiceId = _data["newsletterServiceId"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): InviteModel {
        data = typeof data === 'object' ? data : {};
        let result = new InviteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["to"] = this.to;
        data["from"] = this.from;
        data["newsletterServiceId"] = this.newsletterServiceId;
        data["note"] = this.note;
        return data; 
    }
}

export interface IInviteModel {
    to: string | undefined;
    from: string | undefined;
    newsletterServiceId: number | undefined;
    note: string | undefined;
}

export class MyGroupingOfArticlePropDTO implements IMyGroupingOfArticlePropDTO {
    name!: string | undefined;
    id!: string | undefined;
    elements!: ArticlePropDTO[] | undefined;

    constructor(data?: IMyGroupingOfArticlePropDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(ArticlePropDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MyGroupingOfArticlePropDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MyGroupingOfArticlePropDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IMyGroupingOfArticlePropDTO {
    name: string | undefined;
    id: string | undefined;
    elements: ArticlePropDTO[] | undefined;
}

export class ArticlePropDTO implements IArticlePropDTO {
    title!: string | undefined;
    articleId!: string | undefined;
    parentName!: string | undefined;
    parentId!: number | undefined;
    syndicated!: boolean | undefined;
    streams!: number | undefined;

    constructor(data?: IArticlePropDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.articleId = _data["articleId"];
            this.parentName = _data["parentName"];
            this.parentId = _data["parentId"];
            this.syndicated = _data["syndicated"];
            this.streams = _data["streams"];
        }
    }

    static fromJS(data: any): ArticlePropDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ArticlePropDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["articleId"] = this.articleId;
        data["parentName"] = this.parentName;
        data["parentId"] = this.parentId;
        data["syndicated"] = this.syndicated;
        data["streams"] = this.streams;
        return data; 
    }
}

export interface IArticlePropDTO {
    title: string | undefined;
    articleId: string | undefined;
    parentName: string | undefined;
    parentId: number | undefined;
    syndicated: boolean | undefined;
    streams: number | undefined;
}

/** article viewer config */
export class MobileArticleViewerConfigModel implements IMobileArticleViewerConfigModel {
    /** publication this config is for. */
    publicationid!: number | undefined;
    /** config as json object */
    configJson!: string | undefined;

    constructor(data?: IMobileArticleViewerConfigModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.publicationid = _data["publicationid"];
            this.configJson = _data["configJson"];
        }
    }

    static fromJS(data: any): MobileArticleViewerConfigModel {
        data = typeof data === 'object' ? data : {};
        let result = new MobileArticleViewerConfigModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["publicationid"] = this.publicationid;
        data["configJson"] = this.configJson;
        return data; 
    }
}

/** article viewer config */
export interface IMobileArticleViewerConfigModel {
    /** publication this config is for. */
    publicationid: number | undefined;
    /** config as json object */
    configJson: string | undefined;
}

export class ArticleMoveDTO implements IArticleMoveDTO {
    articleGuids!: string[] | undefined;
    issueId!: number | undefined;
    sectionId!: number | undefined;
    publicationId!: number | undefined;

    constructor(data?: IArticleMoveDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["articleGuids"])) {
                this.articleGuids = [] as any;
                for (let item of _data["articleGuids"])
                    this.articleGuids!.push(item);
            }
            this.issueId = _data["issueId"];
            this.sectionId = _data["sectionId"];
            this.publicationId = _data["publicationId"];
        }
    }

    static fromJS(data: any): ArticleMoveDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleMoveDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.articleGuids)) {
            data["articleGuids"] = [];
            for (let item of this.articleGuids)
                data["articleGuids"].push(item);
        }
        data["issueId"] = this.issueId;
        data["sectionId"] = this.sectionId;
        data["publicationId"] = this.publicationId;
        return data; 
    }
}

export interface IArticleMoveDTO {
    articleGuids: string[] | undefined;
    issueId: number | undefined;
    sectionId: number | undefined;
    publicationId: number | undefined;
}

export class UserDTO implements IUserDTO {
    externalId!: string | undefined;
    secondaryId!: string | undefined;
    emailAddress!: string | undefined;
    firstname!: string | undefined;
    surname!: string | undefined;
    partnerId!: string | undefined;
    password!: string | undefined;

    constructor(data?: IUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"];
            this.secondaryId = _data["secondaryId"];
            this.emailAddress = _data["emailAddress"];
            this.firstname = _data["firstname"];
            this.surname = _data["surname"];
            this.partnerId = _data["partnerId"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): UserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId;
        data["secondaryId"] = this.secondaryId;
        data["emailAddress"] = this.emailAddress;
        data["firstname"] = this.firstname;
        data["surname"] = this.surname;
        data["partnerId"] = this.partnerId;
        data["password"] = this.password;
        return data; 
    }
}

export interface IUserDTO {
    externalId: string | undefined;
    secondaryId: string | undefined;
    emailAddress: string | undefined;
    firstname: string | undefined;
    surname: string | undefined;
    partnerId: string | undefined;
    password: string | undefined;
}

export class AccessDetailsDTO implements IAccessDetailsDTO {
    token!: string | undefined;
    accountId!: number | undefined;

    constructor(data?: IAccessDetailsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.accountId = _data["accountId"];
        }
    }

    static fromJS(data: any): AccessDetailsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AccessDetailsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["accountId"] = this.accountId;
        return data; 
    }
}

export interface IAccessDetailsDTO {
    token: string | undefined;
    accountId: number | undefined;
}

export class NewNewsletterData implements INewNewsletterData {
    newsletterServiceId!: number | undefined;
    newsletterName!: string | undefined;
    articles!: ArticleModel[] | undefined;

    constructor(data?: INewNewsletterData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newsletterServiceId = _data["newsletterServiceId"];
            this.newsletterName = _data["newsletterName"];
            if (Array.isArray(_data["articles"])) {
                this.articles = [] as any;
                for (let item of _data["articles"])
                    this.articles!.push(ArticleModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NewNewsletterData {
        data = typeof data === 'object' ? data : {};
        let result = new NewNewsletterData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newsletterServiceId"] = this.newsletterServiceId;
        data["newsletterName"] = this.newsletterName;
        if (Array.isArray(this.articles)) {
            data["articles"] = [];
            for (let item of this.articles)
                data["articles"].push(item.toJSON());
        }
        return data; 
    }
}

export interface INewNewsletterData {
    newsletterServiceId: number | undefined;
    newsletterName: string | undefined;
    articles: ArticleModel[] | undefined;
}

export class NewsletterUsageModel implements INewsletterUsageModel {
    account!: string | undefined;
    link!: string | undefined;

    constructor(data?: INewsletterUsageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.account = _data["account"];
            this.link = _data["link"];
        }
    }

    static fromJS(data: any): NewsletterUsageModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewsletterUsageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["account"] = this.account;
        data["link"] = this.link;
        return data; 
    }
}

export interface INewsletterUsageModel {
    account: string | undefined;
    link: string | undefined;
}

/** details for a newsletter subscription. */
export class NewsletterSubscriptionDetails implements INewsletterSubscriptionDetails {
    /** account of the subscriber */
    customerAccountId!: number | undefined;
    /** url requested */
    url!: string | undefined;
    /** title of newsletter */
    titleName!: string | undefined;
    /** slug for newsletter */
    slug!: string | undefined;
    /** newsletter service to subscribe to. */
    newsletterServiceId!: number | undefined;

    constructor(data?: INewsletterSubscriptionDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerAccountId = _data["customerAccountId"];
            this.url = _data["url"];
            this.titleName = _data["titleName"];
            this.slug = _data["slug"];
            this.newsletterServiceId = _data["newsletterServiceId"];
        }
    }

    static fromJS(data: any): NewsletterSubscriptionDetails {
        data = typeof data === 'object' ? data : {};
        let result = new NewsletterSubscriptionDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerAccountId"] = this.customerAccountId;
        data["url"] = this.url;
        data["titleName"] = this.titleName;
        data["slug"] = this.slug;
        data["newsletterServiceId"] = this.newsletterServiceId;
        return data; 
    }
}

/** details for a newsletter subscription. */
export interface INewsletterSubscriptionDetails {
    /** account of the subscriber */
    customerAccountId: number | undefined;
    /** url requested */
    url: string | undefined;
    /** title of newsletter */
    titleName: string | undefined;
    /** slug for newsletter */
    slug: string | undefined;
    /** newsletter service to subscribe to. */
    newsletterServiceId: number | undefined;
}

export class StoreArticleDTO implements IStoreArticleDTO {
    images!: StoreArticleImageDTO[] | undefined;
    id!: number | undefined;
    title!: string | undefined;
    abstract!: string | undefined;
    publication!: string | undefined;
    articleId!: string | undefined;
    publicationType!: StoreArticleDTOPublicationType | undefined;
    issueGuid!: string | undefined;
    articleType!: StoreArticleDTOArticleType | undefined;
    added!: Date | undefined;

    constructor(data?: IStoreArticleDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(StoreArticleImageDTO.fromJS(item));
            }
            this.id = _data["id"];
            this.title = _data["title"];
            this.abstract = _data["abstract"];
            this.publication = _data["publication"];
            this.articleId = _data["articleId"];
            this.publicationType = _data["publicationType"];
            this.issueGuid = _data["issueGuid"];
            this.articleType = _data["articleType"];
            this.added = _data["added"] ? new Date(_data["added"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): StoreArticleDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StoreArticleDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["title"] = this.title;
        data["abstract"] = this.abstract;
        data["publication"] = this.publication;
        data["articleId"] = this.articleId;
        data["publicationType"] = this.publicationType;
        data["issueGuid"] = this.issueGuid;
        data["articleType"] = this.articleType;
        data["added"] = this.added ? this.added.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IStoreArticleDTO {
    images: StoreArticleImageDTO[] | undefined;
    id: number | undefined;
    title: string | undefined;
    abstract: string | undefined;
    publication: string | undefined;
    articleId: string | undefined;
    publicationType: StoreArticleDTOPublicationType | undefined;
    issueGuid: string | undefined;
    articleType: StoreArticleDTOArticleType | undefined;
    added: Date | undefined;
}

export class StoreArticleImageDTO implements IStoreArticleImageDTO {
    src!: string | undefined;
    isFeatured!: boolean | undefined;

    constructor(data?: IStoreArticleImageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.src = _data["src"];
            this.isFeatured = _data["isFeatured"];
        }
    }

    static fromJS(data: any): StoreArticleImageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StoreArticleImageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["src"] = this.src;
        data["isFeatured"] = this.isFeatured;
        return data; 
    }
}

export interface IStoreArticleImageDTO {
    src: string | undefined;
    isFeatured: boolean | undefined;
}

export class CustomerInfo implements ICustomerInfo {
    promotionalCredit!: number | undefined;
    taxability!: string | undefined;
    billingCountry!: string | undefined;
    customerCardInfo!: CustomerCardInfo | undefined;
    discount!: number | undefined;

    constructor(data?: ICustomerInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.promotionalCredit = _data["promotionalCredit"];
            this.taxability = _data["taxability"];
            this.billingCountry = _data["billingCountry"];
            this.customerCardInfo = _data["customerCardInfo"] ? CustomerCardInfo.fromJS(_data["customerCardInfo"]) : <any>undefined;
            this.discount = _data["discount"];
        }
    }

    static fromJS(data: any): CustomerInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["promotionalCredit"] = this.promotionalCredit;
        data["taxability"] = this.taxability;
        data["billingCountry"] = this.billingCountry;
        data["customerCardInfo"] = this.customerCardInfo ? this.customerCardInfo.toJSON() : <any>undefined;
        data["discount"] = this.discount;
        return data; 
    }
}

export interface ICustomerInfo {
    promotionalCredit: number | undefined;
    taxability: string | undefined;
    billingCountry: string | undefined;
    customerCardInfo: CustomerCardInfo | undefined;
    discount: number | undefined;
}

export class CustomerCardInfo implements ICustomerCardInfo {
    last4!: string | undefined;
    cardType!: string | undefined;
    expiryYear!: number | undefined;
    expiryMonth!: number | undefined;

    constructor(data?: ICustomerCardInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.last4 = _data["last4"];
            this.cardType = _data["cardType"];
            this.expiryYear = _data["expiryYear"];
            this.expiryMonth = _data["expiryMonth"];
        }
    }

    static fromJS(data: any): CustomerCardInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerCardInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["last4"] = this.last4;
        data["cardType"] = this.cardType;
        data["expiryYear"] = this.expiryYear;
        data["expiryMonth"] = this.expiryMonth;
        return data; 
    }
}

export interface ICustomerCardInfo {
    last4: string | undefined;
    cardType: string | undefined;
    expiryYear: number | undefined;
    expiryMonth: number | undefined;
}

export class Pdfinfo implements IPdfinfo {
    pages!: Pdfpage[] | undefined;

    constructor(data?: IPdfinfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pages"])) {
                this.pages = [] as any;
                for (let item of _data["pages"])
                    this.pages!.push(Pdfpage.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Pdfinfo {
        data = typeof data === 'object' ? data : {};
        let result = new Pdfinfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pages)) {
            data["pages"] = [];
            for (let item of this.pages)
                data["pages"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPdfinfo {
    pages: Pdfpage[] | undefined;
}

export class Pdfpage implements IPdfpage {
    number!: number | undefined;
    width!: number | undefined;
    height!: number | undefined;

    constructor(data?: IPdfpage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.width = _data["width"];
            this.height = _data["height"];
        }
    }

    static fromJS(data: any): Pdfpage {
        data = typeof data === 'object' ? data : {};
        let result = new Pdfpage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["width"] = this.width;
        data["height"] = this.height;
        return data; 
    }
}

export interface IPdfpage {
    number: number | undefined;
    width: number | undefined;
    height: number | undefined;
}

export class PageContent implements IPageContent {
    pageNumber!: number | undefined;
    paras!: ParagraphContent[] | undefined;
    text!: string | undefined;
    height!: number | undefined;
    width!: number | undefined;
    images!: PdfImageInfo[] | undefined;
    id!: string | undefined;

    constructor(data?: IPageContent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            if (Array.isArray(_data["paras"])) {
                this.paras = [] as any;
                for (let item of _data["paras"])
                    this.paras!.push(ParagraphContent.fromJS(item));
            }
            this.text = _data["text"];
            this.height = _data["height"];
            this.width = _data["width"];
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(PdfImageInfo.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PageContent {
        data = typeof data === 'object' ? data : {};
        let result = new PageContent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        if (Array.isArray(this.paras)) {
            data["paras"] = [];
            for (let item of this.paras)
                data["paras"].push(item.toJSON());
        }
        data["text"] = this.text;
        data["height"] = this.height;
        data["width"] = this.width;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IPageContent {
    pageNumber: number | undefined;
    paras: ParagraphContent[] | undefined;
    text: string | undefined;
    height: number | undefined;
    width: number | undefined;
    images: PdfImageInfo[] | undefined;
    id: string | undefined;
}

export class ParagraphContent implements IParagraphContent {
    spaceBetweenLines!: number | undefined;
    box!: Rect | undefined;
    text!: string | undefined;
    id!: number | undefined;
    lines!: LineContent[] | undefined;
    html!: string | undefined;
    component!: ParagraphContentComponent | undefined;

    constructor(data?: IParagraphContent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.spaceBetweenLines = _data["spaceBetweenLines"];
            this.box = _data["box"] ? Rect.fromJS(_data["box"]) : <any>undefined;
            this.text = _data["text"];
            this.id = _data["id"];
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(LineContent.fromJS(item));
            }
            this.html = _data["html"];
            this.component = _data["component"];
        }
    }

    static fromJS(data: any): ParagraphContent {
        data = typeof data === 'object' ? data : {};
        let result = new ParagraphContent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["spaceBetweenLines"] = this.spaceBetweenLines;
        data["box"] = this.box ? this.box.toJSON() : <any>undefined;
        data["text"] = this.text;
        data["id"] = this.id;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        data["html"] = this.html;
        data["component"] = this.component;
        return data; 
    }
}

export interface IParagraphContent {
    spaceBetweenLines: number | undefined;
    box: Rect | undefined;
    text: string | undefined;
    id: number | undefined;
    lines: LineContent[] | undefined;
    html: string | undefined;
    component: ParagraphContentComponent | undefined;
}

export class PdfImageInfo implements IPdfImageInfo {
    pageNumber!: number | undefined;
    box!: Rect | undefined;
    imageUrl!: string | undefined;
    aspect!: number | undefined;
    width!: number | undefined;

    constructor(data?: IPdfImageInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.box = _data["box"] ? Rect.fromJS(_data["box"]) : <any>undefined;
            this.imageUrl = _data["imageUrl"];
            this.aspect = _data["aspect"];
            this.width = _data["width"];
        }
    }

    static fromJS(data: any): PdfImageInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PdfImageInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["box"] = this.box ? this.box.toJSON() : <any>undefined;
        data["imageUrl"] = this.imageUrl;
        data["aspect"] = this.aspect;
        data["width"] = this.width;
        return data; 
    }
}

export interface IPdfImageInfo {
    pageNumber: number | undefined;
    box: Rect | undefined;
    imageUrl: string | undefined;
    aspect: number | undefined;
    width: number | undefined;
}

export class Rect implements IRect {
    y2!: number | undefined;
    x2!: number | undefined;
    y1!: number | undefined;
    x1!: number | undefined;

    constructor(data?: IRect) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.y2 = _data["y2"];
            this.x2 = _data["x2"];
            this.y1 = _data["y1"];
            this.x1 = _data["x1"];
        }
    }

    static fromJS(data: any): Rect {
        data = typeof data === 'object' ? data : {};
        let result = new Rect();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["y2"] = this.y2;
        data["x2"] = this.x2;
        data["y1"] = this.y1;
        data["x1"] = this.x1;
        return data; 
    }
}

export interface IRect {
    y2: number | undefined;
    x2: number | undefined;
    y1: number | undefined;
    x1: number | undefined;
}

export class LineContent implements ILineContent {
    text!: string | undefined;
    words!: WordContent[] | undefined;
    box!: Rect | undefined;
    style!: TextStyle | undefined;
    isNewPara!: boolean | undefined;
    page_offset!: number | undefined;

    constructor(data?: ILineContent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            if (Array.isArray(_data["words"])) {
                this.words = [] as any;
                for (let item of _data["words"])
                    this.words!.push(WordContent.fromJS(item));
            }
            this.box = _data["box"] ? Rect.fromJS(_data["box"]) : <any>undefined;
            this.style = _data["style"] ? TextStyle.fromJS(_data["style"]) : <any>undefined;
            this.isNewPara = _data["isNewPara"];
            this.page_offset = _data["page_offset"];
        }
    }

    static fromJS(data: any): LineContent {
        data = typeof data === 'object' ? data : {};
        let result = new LineContent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        if (Array.isArray(this.words)) {
            data["words"] = [];
            for (let item of this.words)
                data["words"].push(item.toJSON());
        }
        data["box"] = this.box ? this.box.toJSON() : <any>undefined;
        data["style"] = this.style ? this.style.toJSON() : <any>undefined;
        data["isNewPara"] = this.isNewPara;
        data["page_offset"] = this.page_offset;
        return data; 
    }
}

export interface ILineContent {
    text: string | undefined;
    words: WordContent[] | undefined;
    box: Rect | undefined;
    style: TextStyle | undefined;
    isNewPara: boolean | undefined;
    page_offset: number | undefined;
}

export class WordContent implements IWordContent {
    text!: string | undefined;
    _box!: Rect | undefined;
    style!: TextStyle | undefined;

    constructor(data?: IWordContent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this._box = _data["_box"] ? Rect.fromJS(_data["_box"]) : <any>undefined;
            this.style = _data["style"] ? TextStyle.fromJS(_data["style"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WordContent {
        data = typeof data === 'object' ? data : {};
        let result = new WordContent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["_box"] = this._box ? this._box.toJSON() : <any>undefined;
        data["style"] = this.style ? this.style.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IWordContent {
    text: string | undefined;
    _box: Rect | undefined;
    style: TextStyle | undefined;
}

export class TextStyle implements ITextStyle {
    font!: string | undefined;
    size!: number | undefined;
    weight!: number | undefined;
    color!: string | undefined;
    isItalic!: boolean | undefined;
    isSerif!: boolean | undefined;
    fillColor!: string | undefined;

    constructor(data?: ITextStyle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.font = _data["font"];
            this.size = _data["size"];
            this.weight = _data["weight"];
            this.color = _data["color"];
            this.isItalic = _data["isItalic"];
            this.isSerif = _data["isSerif"];
            this.fillColor = _data["fillColor"];
        }
    }

    static fromJS(data: any): TextStyle {
        data = typeof data === 'object' ? data : {};
        let result = new TextStyle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["font"] = this.font;
        data["size"] = this.size;
        data["weight"] = this.weight;
        data["color"] = this.color;
        data["isItalic"] = this.isItalic;
        data["isSerif"] = this.isSerif;
        data["fillColor"] = this.fillColor;
        return data; 
    }
}

export interface ITextStyle {
    font: string | undefined;
    size: number | undefined;
    weight: number | undefined;
    color: string | undefined;
    isItalic: boolean | undefined;
    isSerif: boolean | undefined;
    fillColor: string | undefined;
}

export class DashboardPageSearchResults implements IDashboardPageSearchResults {
    hits!: DashboardPageTextSearchHit[] | undefined;
    total_hits!: number | undefined;

    constructor(data?: IDashboardPageSearchResults) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["hits"])) {
                this.hits = [] as any;
                for (let item of _data["hits"])
                    this.hits!.push(DashboardPageTextSearchHit.fromJS(item));
            }
            this.total_hits = _data["total_hits"];
        }
    }

    static fromJS(data: any): DashboardPageSearchResults {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardPageSearchResults();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.hits)) {
            data["hits"] = [];
            for (let item of this.hits)
                data["hits"].push(item.toJSON());
        }
        data["total_hits"] = this.total_hits;
        return data; 
    }
}

export interface IDashboardPageSearchResults {
    hits: DashboardPageTextSearchHit[] | undefined;
    total_hits: number | undefined;
}

export class DashboardPageTextSearchHit implements IDashboardPageTextSearchHit {
    issueName!: string | undefined;
    publicationName!: string | undefined;
    issueId!: number | undefined;
    pageNumber!: number | undefined;
    hits!: string[] | undefined;
    issueGuid!: string | undefined;

    constructor(data?: IDashboardPageTextSearchHit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueName = _data["issueName"];
            this.publicationName = _data["publicationName"];
            this.issueId = _data["issueId"];
            this.pageNumber = _data["pageNumber"];
            if (Array.isArray(_data["hits"])) {
                this.hits = [] as any;
                for (let item of _data["hits"])
                    this.hits!.push(item);
            }
            this.issueGuid = _data["issueGuid"];
        }
    }

    static fromJS(data: any): DashboardPageTextSearchHit {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardPageTextSearchHit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueName"] = this.issueName;
        data["publicationName"] = this.publicationName;
        data["issueId"] = this.issueId;
        data["pageNumber"] = this.pageNumber;
        if (Array.isArray(this.hits)) {
            data["hits"] = [];
            for (let item of this.hits)
                data["hits"].push(item);
        }
        data["issueGuid"] = this.issueGuid;
        return data; 
    }
}

export interface IDashboardPageTextSearchHit {
    issueName: string | undefined;
    publicationName: string | undefined;
    issueId: number | undefined;
    pageNumber: number | undefined;
    hits: string[] | undefined;
    issueGuid: string | undefined;
}

/** publication CSS. */
export class PublicationCSSModel implements IPublicationCSSModel {
    /** Publication identifier. */
    publicationId!: number | undefined;
    /** CSS for this publication */
    css!: string | undefined;

    constructor(data?: IPublicationCSSModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.publicationId = _data["publicationId"];
            this.css = _data["css"];
        }
    }

    static fromJS(data: any): PublicationCSSModel {
        data = typeof data === 'object' ? data : {};
        let result = new PublicationCSSModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["publicationId"] = this.publicationId;
        data["css"] = this.css;
        return data; 
    }
}

/** publication CSS. */
export interface IPublicationCSSModel {
    /** Publication identifier. */
    publicationId: number | undefined;
    /** CSS for this publication */
    css: string | undefined;
}

export class DropboxConfigurationModel implements IDropboxConfigurationModel {
    id!: number | undefined;
    publicationId!: number | undefined;
    path!: string | undefined;
    enabled!: boolean | undefined;

    constructor(data?: IDropboxConfigurationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.publicationId = _data["publicationId"];
            this.path = _data["path"];
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): DropboxConfigurationModel {
        data = typeof data === 'object' ? data : {};
        let result = new DropboxConfigurationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["publicationId"] = this.publicationId;
        data["path"] = this.path;
        data["enabled"] = this.enabled;
        return data; 
    }
}

export interface IDropboxConfigurationModel {
    id: number | undefined;
    publicationId: number | undefined;
    path: string | undefined;
    enabled: boolean | undefined;
}

/** publication notes. */
export class PublicationNotesModel implements IPublicationNotesModel {
    /** Publication identifier. */
    publicationId!: number | undefined;
    /** Notes for this publication */
    notes!: string | undefined;

    constructor(data?: IPublicationNotesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.publicationId = _data["publicationId"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): PublicationNotesModel {
        data = typeof data === 'object' ? data : {};
        let result = new PublicationNotesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["publicationId"] = this.publicationId;
        data["notes"] = this.notes;
        return data; 
    }
}

/** publication notes. */
export interface IPublicationNotesModel {
    /** Publication identifier. */
    publicationId: number | undefined;
    /** Notes for this publication */
    notes: string | undefined;
}

/** Settings for publications. */
export class PublicationOptionsModel implements IPublicationOptionsModel {
    /** Does publish to wordpress need to be performed. */
    wordpressPublishEnabled!: boolean | undefined;
    /** Publication identifier. */
    publicationId!: number | undefined;
    /** Link email|web|page jumps during conversion? */
    wordsmartBasicEnabled!: boolean | undefined;
    /** Will a custom folio need to be added, if not 1,2,3,4..... will be used. */
    customFolioEnabled!: boolean | undefined;
    /** Does article extraction need to be performed. */
    articleExtractionEnabled!: boolean | undefined;
    /** Does wordsmart proof need to be performed. */
    wordsmartProofEnabled!: boolean | undefined;

    constructor(data?: IPublicationOptionsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wordpressPublishEnabled = _data["wordpressPublishEnabled"];
            this.publicationId = _data["publicationId"];
            this.wordsmartBasicEnabled = _data["wordsmartBasicEnabled"];
            this.customFolioEnabled = _data["customFolioEnabled"];
            this.articleExtractionEnabled = _data["articleExtractionEnabled"];
            this.wordsmartProofEnabled = _data["wordsmartProofEnabled"];
        }
    }

    static fromJS(data: any): PublicationOptionsModel {
        data = typeof data === 'object' ? data : {};
        let result = new PublicationOptionsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wordpressPublishEnabled"] = this.wordpressPublishEnabled;
        data["publicationId"] = this.publicationId;
        data["wordsmartBasicEnabled"] = this.wordsmartBasicEnabled;
        data["customFolioEnabled"] = this.customFolioEnabled;
        data["articleExtractionEnabled"] = this.articleExtractionEnabled;
        data["wordsmartProofEnabled"] = this.wordsmartProofEnabled;
        return data; 
    }
}

/** Settings for publications. */
export interface IPublicationOptionsModel {
    /** Does publish to wordpress need to be performed. */
    wordpressPublishEnabled: boolean | undefined;
    /** Publication identifier. */
    publicationId: number | undefined;
    /** Link email|web|page jumps during conversion? */
    wordsmartBasicEnabled: boolean | undefined;
    /** Will a custom folio need to be added, if not 1,2,3,4..... will be used. */
    customFolioEnabled: boolean | undefined;
    /** Does article extraction need to be performed. */
    articleExtractionEnabled: boolean | undefined;
    /** Does wordsmart proof need to be performed. */
    wordsmartProofEnabled: boolean | undefined;
}

export class RedirectUrlModel implements IRedirectUrlModel {
    /** id */
    id!: number | undefined;
    /** the url to rediret to */
    customerUrlId!: number | undefined;
    /** old url we want to redirect */
    oldUrl!: string | undefined;
    /** reason for redirect */
    reason!: string | undefined;

    constructor(data?: IRedirectUrlModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerUrlId = _data["customerUrlId"];
            this.oldUrl = _data["oldUrl"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): RedirectUrlModel {
        data = typeof data === 'object' ? data : {};
        let result = new RedirectUrlModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerUrlId"] = this.customerUrlId;
        data["oldUrl"] = this.oldUrl;
        data["reason"] = this.reason;
        return data; 
    }
}

export interface IRedirectUrlModel {
    /** id */
    id: number | undefined;
    /** the url to rediret to */
    customerUrlId: number | undefined;
    /** old url we want to redirect */
    oldUrl: string | undefined;
    /** reason for redirect */
    reason: string | undefined;
}

export class ShoppingCartDTO implements IShoppingCartDTO {
    id!: number | undefined;
    name!: string | undefined;
    customerAccountId!: number | undefined;
    status!: ShoppingCartDTOStatus | undefined;
    purchasedDate!: Date | undefined;
    adminIdentityUserId!: string | undefined;
    shoppingCartItems!: ShoppingCartItemDTO[] | undefined;

    constructor(data?: IShoppingCartDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.customerAccountId = _data["customerAccountId"];
            this.status = _data["status"];
            this.purchasedDate = _data["purchasedDate"] ? new Date(_data["purchasedDate"].toString()) : <any>undefined;
            this.adminIdentityUserId = _data["adminIdentityUserId"];
            if (Array.isArray(_data["shoppingCartItems"])) {
                this.shoppingCartItems = [] as any;
                for (let item of _data["shoppingCartItems"])
                    this.shoppingCartItems!.push(ShoppingCartItemDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ShoppingCartDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ShoppingCartDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["customerAccountId"] = this.customerAccountId;
        data["status"] = this.status;
        data["purchasedDate"] = this.purchasedDate ? this.purchasedDate.toISOString() : <any>undefined;
        data["adminIdentityUserId"] = this.adminIdentityUserId;
        if (Array.isArray(this.shoppingCartItems)) {
            data["shoppingCartItems"] = [];
            for (let item of this.shoppingCartItems)
                data["shoppingCartItems"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IShoppingCartDTO {
    id: number | undefined;
    name: string | undefined;
    customerAccountId: number | undefined;
    status: ShoppingCartDTOStatus | undefined;
    purchasedDate: Date | undefined;
    adminIdentityUserId: string | undefined;
    shoppingCartItems: ShoppingCartItemDTO[] | undefined;
}

export class ShoppingCartItemDTO implements IShoppingCartItemDTO {
    id!: number | undefined;
    shoppingCartId!: number | undefined;
    articleId!: number | undefined;
    addedDate!: Date | undefined;
    article!: ArticleModel | undefined;

    constructor(data?: IShoppingCartItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.shoppingCartId = _data["shoppingCartId"];
            this.articleId = _data["articleId"];
            this.addedDate = _data["addedDate"] ? new Date(_data["addedDate"].toString()) : <any>undefined;
            this.article = _data["article"] ? ArticleModel.fromJS(_data["article"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ShoppingCartItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ShoppingCartItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["shoppingCartId"] = this.shoppingCartId;
        data["articleId"] = this.articleId;
        data["addedDate"] = this.addedDate ? this.addedDate.toISOString() : <any>undefined;
        data["article"] = this.article ? this.article.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IShoppingCartItemDTO {
    id: number | undefined;
    shoppingCartId: number | undefined;
    articleId: number | undefined;
    addedDate: Date | undefined;
    article: ArticleModel | undefined;
}

export class ChargebeePaymentDTO implements IChargebeePaymentDTO {
    id!: number | undefined;
    adminIdentityUserId!: string | undefined;
    customerAccountId!: number | undefined;
    amount!: number | undefined;
    purchaseDate!: Date | undefined;
    invoiceId!: string | undefined;
    currency!: ChargebeePaymentDTOCurrency | undefined;
    status!: ChargebeePaymentDTOStatus | undefined;
    notes!: string | undefined;
    chargebeePaymentItems!: ChargebeePaymentItemDTO[] | undefined;

    constructor(data?: IChargebeePaymentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.adminIdentityUserId = _data["adminIdentityUserId"];
            this.customerAccountId = _data["customerAccountId"];
            this.amount = _data["amount"];
            this.purchaseDate = _data["purchaseDate"] ? new Date(_data["purchaseDate"].toString()) : <any>undefined;
            this.invoiceId = _data["invoiceId"];
            this.currency = _data["currency"];
            this.status = _data["status"];
            this.notes = _data["notes"];
            if (Array.isArray(_data["chargebeePaymentItems"])) {
                this.chargebeePaymentItems = [] as any;
                for (let item of _data["chargebeePaymentItems"])
                    this.chargebeePaymentItems!.push(ChargebeePaymentItemDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChargebeePaymentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ChargebeePaymentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["adminIdentityUserId"] = this.adminIdentityUserId;
        data["customerAccountId"] = this.customerAccountId;
        data["amount"] = this.amount;
        data["purchaseDate"] = this.purchaseDate ? this.purchaseDate.toISOString() : <any>undefined;
        data["invoiceId"] = this.invoiceId;
        data["currency"] = this.currency;
        data["status"] = this.status;
        data["notes"] = this.notes;
        if (Array.isArray(this.chargebeePaymentItems)) {
            data["chargebeePaymentItems"] = [];
            for (let item of this.chargebeePaymentItems)
                data["chargebeePaymentItems"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IChargebeePaymentDTO {
    id: number | undefined;
    adminIdentityUserId: string | undefined;
    customerAccountId: number | undefined;
    amount: number | undefined;
    purchaseDate: Date | undefined;
    invoiceId: string | undefined;
    currency: ChargebeePaymentDTOCurrency | undefined;
    status: ChargebeePaymentDTOStatus | undefined;
    notes: string | undefined;
    chargebeePaymentItems: ChargebeePaymentItemDTO[] | undefined;
}

export class ChargebeePaymentItemDTO implements IChargebeePaymentItemDTO {
    id!: number | undefined;
    chargebeePaymentId!: number | undefined;
    articleId!: number | undefined;
    amount!: number | undefined;
    status!: ChargebeePaymentItemDTOStatus | undefined;

    constructor(data?: IChargebeePaymentItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.chargebeePaymentId = _data["chargebeePaymentId"];
            this.articleId = _data["articleId"];
            this.amount = _data["amount"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ChargebeePaymentItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ChargebeePaymentItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["chargebeePaymentId"] = this.chargebeePaymentId;
        data["articleId"] = this.articleId;
        data["amount"] = this.amount;
        data["status"] = this.status;
        return data; 
    }
}

export interface IChargebeePaymentItemDTO {
    id: number | undefined;
    chargebeePaymentId: number | undefined;
    articleId: number | undefined;
    amount: number | undefined;
    status: ChargebeePaymentItemDTOStatus | undefined;
}

export class SocialConfigurationModel implements ISocialConfigurationModel {
    id!: number | undefined;
    publicationId!: number | undefined;
    facebookAppId!: string | undefined;
    twitterSiteId!: string | undefined;

    constructor(data?: ISocialConfigurationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.publicationId = _data["publicationId"];
            this.facebookAppId = _data["facebookAppId"];
            this.twitterSiteId = _data["twitterSiteId"];
        }
    }

    static fromJS(data: any): SocialConfigurationModel {
        data = typeof data === 'object' ? data : {};
        let result = new SocialConfigurationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["publicationId"] = this.publicationId;
        data["facebookAppId"] = this.facebookAppId;
        data["twitterSiteId"] = this.twitterSiteId;
        return data; 
    }
}

export interface ISocialConfigurationModel {
    id: number | undefined;
    publicationId: number | undefined;
    facebookAppId: string | undefined;
    twitterSiteId: string | undefined;
}

export class StartPageData implements IStartPageData {
    websites!: UrlPubDTO[] | undefined;
    publicationGroups!: PublicationData[] | undefined;
    articleGroups!: ArticleTypeData[] | undefined;
    affiliatePrograms!: AffiliateConfigurationDTO[] | undefined;
    contentStreams!: NewsletterserviceModel[] | undefined;

    constructor(data?: IStartPageData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["websites"])) {
                this.websites = [] as any;
                for (let item of _data["websites"])
                    this.websites!.push(UrlPubDTO.fromJS(item));
            }
            if (Array.isArray(_data["publicationGroups"])) {
                this.publicationGroups = [] as any;
                for (let item of _data["publicationGroups"])
                    this.publicationGroups!.push(PublicationData.fromJS(item));
            }
            if (Array.isArray(_data["articleGroups"])) {
                this.articleGroups = [] as any;
                for (let item of _data["articleGroups"])
                    this.articleGroups!.push(ArticleTypeData.fromJS(item));
            }
            if (Array.isArray(_data["affiliatePrograms"])) {
                this.affiliatePrograms = [] as any;
                for (let item of _data["affiliatePrograms"])
                    this.affiliatePrograms!.push(AffiliateConfigurationDTO.fromJS(item));
            }
            if (Array.isArray(_data["contentStreams"])) {
                this.contentStreams = [] as any;
                for (let item of _data["contentStreams"])
                    this.contentStreams!.push(NewsletterserviceModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StartPageData {
        data = typeof data === 'object' ? data : {};
        let result = new StartPageData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.websites)) {
            data["websites"] = [];
            for (let item of this.websites)
                data["websites"].push(item.toJSON());
        }
        if (Array.isArray(this.publicationGroups)) {
            data["publicationGroups"] = [];
            for (let item of this.publicationGroups)
                data["publicationGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.articleGroups)) {
            data["articleGroups"] = [];
            for (let item of this.articleGroups)
                data["articleGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.affiliatePrograms)) {
            data["affiliatePrograms"] = [];
            for (let item of this.affiliatePrograms)
                data["affiliatePrograms"].push(item.toJSON());
        }
        if (Array.isArray(this.contentStreams)) {
            data["contentStreams"] = [];
            for (let item of this.contentStreams)
                data["contentStreams"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IStartPageData {
    websites: UrlPubDTO[] | undefined;
    publicationGroups: PublicationData[] | undefined;
    articleGroups: ArticleTypeData[] | undefined;
    affiliatePrograms: AffiliateConfigurationDTO[] | undefined;
    contentStreams: NewsletterserviceModel[] | undefined;
}

export class UrlPubDTO implements IUrlPubDTO {
    /** Url identifier. */
    id!: number | undefined;
    /** custom url for this customer. */
    url!: string | undefined;
    pid!: number | undefined;
    name!: string | undefined;

    constructor(data?: IUrlPubDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.url = _data["url"];
            this.pid = _data["pid"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UrlPubDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UrlPubDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["url"] = this.url;
        data["pid"] = this.pid;
        data["name"] = this.name;
        return data; 
    }
}

export interface IUrlPubDTO {
    /** Url identifier. */
    id: number | undefined;
    /** custom url for this customer. */
    url: string | undefined;
    pid: number | undefined;
    name: string | undefined;
}

export class PublicationData implements IPublicationData {
    type!: PublicationDataType | undefined;
    publications!: PublicationModel[] | undefined;

    constructor(data?: IPublicationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            if (Array.isArray(_data["publications"])) {
                this.publications = [] as any;
                for (let item of _data["publications"])
                    this.publications!.push(PublicationModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PublicationData {
        data = typeof data === 'object' ? data : {};
        let result = new PublicationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (Array.isArray(this.publications)) {
            data["publications"] = [];
            for (let item of this.publications)
                data["publications"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPublicationData {
    type: PublicationDataType | undefined;
    publications: PublicationModel[] | undefined;
}

export class ArticleTypeData implements IArticleTypeData {
    articleType!: ArticleTypeDataArticleType | undefined;
    count!: number | undefined;

    constructor(data?: IArticleTypeData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleType = _data["articleType"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): ArticleTypeData {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleTypeData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleType"] = this.articleType;
        data["count"] = this.count;
        return data; 
    }
}

export interface IArticleTypeData {
    articleType: ArticleTypeDataArticleType | undefined;
    count: number | undefined;
}

export class ArticleOwnerPaymentDTO implements IArticleOwnerPaymentDTO {
    title!: string | undefined;
    owner!: string | undefined;
    stream!: string | undefined;
    subscriber!: string | undefined;
    created!: Date | undefined;
    streamId!: number | undefined;
    articleId!: number | undefined;
    ownerId!: number | undefined;
    subscriberId!: number | undefined;
    paymentId!: number | undefined;

    constructor(data?: IArticleOwnerPaymentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.owner = _data["owner"];
            this.stream = _data["stream"];
            this.subscriber = _data["subscriber"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.streamId = _data["streamId"];
            this.articleId = _data["articleId"];
            this.ownerId = _data["ownerId"];
            this.subscriberId = _data["subscriberId"];
            this.paymentId = _data["paymentId"];
        }
    }

    static fromJS(data: any): ArticleOwnerPaymentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleOwnerPaymentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["owner"] = this.owner;
        data["stream"] = this.stream;
        data["subscriber"] = this.subscriber;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["streamId"] = this.streamId;
        data["articleId"] = this.articleId;
        data["ownerId"] = this.ownerId;
        data["subscriberId"] = this.subscriberId;
        data["paymentId"] = this.paymentId;
        return data; 
    }
}

export interface IArticleOwnerPaymentDTO {
    title: string | undefined;
    owner: string | undefined;
    stream: string | undefined;
    subscriber: string | undefined;
    created: Date | undefined;
    streamId: number | undefined;
    articleId: number | undefined;
    ownerId: number | undefined;
    subscriberId: number | undefined;
    paymentId: number | undefined;
}

export class ContentStreamArticleOwnerBatchDTO implements IContentStreamArticleOwnerBatchDTO {
    id!: number | undefined;
    name!: string | undefined;
    created!: Date | undefined;
    status!: ContentStreamArticleOwnerBatchDTOStatus | undefined;

    constructor(data?: IContentStreamArticleOwnerBatchDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ContentStreamArticleOwnerBatchDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ContentStreamArticleOwnerBatchDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["status"] = this.status;
        return data; 
    }
}

export interface IContentStreamArticleOwnerBatchDTO {
    id: number | undefined;
    name: string | undefined;
    created: Date | undefined;
    status: ContentStreamArticleOwnerBatchDTOStatus | undefined;
}

export class ContentStreamArticleOwnerBatchItemDTO implements IContentStreamArticleOwnerBatchItemDTO {
    status!: ContentStreamArticleOwnerBatchItemDTOStatus | undefined;
    paymentToken!: string | undefined;
    owner!: string | undefined;
    amount!: number | undefined;
    paid!: Date | undefined;
    customerId!: number | undefined;

    constructor(data?: IContentStreamArticleOwnerBatchItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.paymentToken = _data["paymentToken"];
            this.owner = _data["owner"];
            this.amount = _data["amount"];
            this.paid = _data["paid"] ? new Date(_data["paid"].toString()) : <any>undefined;
            this.customerId = _data["customerId"];
        }
    }

    static fromJS(data: any): ContentStreamArticleOwnerBatchItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ContentStreamArticleOwnerBatchItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["paymentToken"] = this.paymentToken;
        data["owner"] = this.owner;
        data["amount"] = this.amount;
        data["paid"] = this.paid ? this.paid.toISOString() : <any>undefined;
        data["customerId"] = this.customerId;
        return data; 
    }
}

export interface IContentStreamArticleOwnerBatchItemDTO {
    status: ContentStreamArticleOwnerBatchItemDTOStatus | undefined;
    paymentToken: string | undefined;
    owner: string | undefined;
    amount: number | undefined;
    paid: Date | undefined;
    customerId: number | undefined;
}

export class OwnerPaymentDTO implements IOwnerPaymentDTO {
    batch!: string | undefined;
    batchId!: number | undefined;
    amount!: number | undefined;
    status!: number | undefined;
    articles!: OwnerPaymentArticleDTO[] | undefined;

    constructor(data?: IOwnerPaymentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batch = _data["batch"];
            this.batchId = _data["batchId"];
            this.amount = _data["amount"];
            this.status = _data["status"];
            if (Array.isArray(_data["articles"])) {
                this.articles = [] as any;
                for (let item of _data["articles"])
                    this.articles!.push(OwnerPaymentArticleDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OwnerPaymentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OwnerPaymentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batch"] = this.batch;
        data["batchId"] = this.batchId;
        data["amount"] = this.amount;
        data["status"] = this.status;
        if (Array.isArray(this.articles)) {
            data["articles"] = [];
            for (let item of this.articles)
                data["articles"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IOwnerPaymentDTO {
    batch: string | undefined;
    batchId: number | undefined;
    amount: number | undefined;
    status: number | undefined;
    articles: OwnerPaymentArticleDTO[] | undefined;
}

export class OwnerPaymentArticleDTO implements IOwnerPaymentArticleDTO {
    article!: string | undefined;
    publication!: string | undefined;
    used!: Date | undefined;

    constructor(data?: IOwnerPaymentArticleDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.article = _data["article"];
            this.publication = _data["publication"];
            this.used = _data["used"] ? new Date(_data["used"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OwnerPaymentArticleDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OwnerPaymentArticleDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["article"] = this.article;
        data["publication"] = this.publication;
        data["used"] = this.used ? this.used.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IOwnerPaymentArticleDTO {
    article: string | undefined;
    publication: string | undefined;
    used: Date | undefined;
}

export class StreamIssuePaymentDTO implements IStreamIssuePaymentDTO {
    issueId!: number | undefined;
    issueName!: string | undefined;
    streamName!: string | undefined;
    issueDate!: Date | undefined;
    numberSubscriptions!: number | undefined;
    contentCharge!: number | undefined;
    curatorCharge!: number | undefined;
    curator!: string | undefined;
    issuePaymentId!: number | undefined;
    streamId!: number | undefined;
    writerCharge!: number | undefined;
    writers!: any[] | undefined;

    constructor(data?: IStreamIssuePaymentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueId = _data["issueId"];
            this.issueName = _data["issueName"];
            this.streamName = _data["streamName"];
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : <any>undefined;
            this.numberSubscriptions = _data["numberSubscriptions"];
            this.contentCharge = _data["contentCharge"];
            this.curatorCharge = _data["curatorCharge"];
            this.curator = _data["curator"];
            this.issuePaymentId = _data["issuePaymentId"];
            this.streamId = _data["streamId"];
            this.writerCharge = _data["writerCharge"];
            if (Array.isArray(_data["writers"])) {
                this.writers = [] as any;
                for (let item of _data["writers"])
                    this.writers!.push(item);
            }
        }
    }

    static fromJS(data: any): StreamIssuePaymentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StreamIssuePaymentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueId"] = this.issueId;
        data["issueName"] = this.issueName;
        data["streamName"] = this.streamName;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>undefined;
        data["numberSubscriptions"] = this.numberSubscriptions;
        data["contentCharge"] = this.contentCharge;
        data["curatorCharge"] = this.curatorCharge;
        data["curator"] = this.curator;
        data["issuePaymentId"] = this.issuePaymentId;
        data["streamId"] = this.streamId;
        data["writerCharge"] = this.writerCharge;
        if (Array.isArray(this.writers)) {
            data["writers"] = [];
            for (let item of this.writers)
                data["writers"].push(item);
        }
        return data; 
    }
}

export interface IStreamIssuePaymentDTO {
    issueId: number | undefined;
    issueName: string | undefined;
    streamName: string | undefined;
    issueDate: Date | undefined;
    numberSubscriptions: number | undefined;
    contentCharge: number | undefined;
    curatorCharge: number | undefined;
    curator: string | undefined;
    issuePaymentId: number | undefined;
    streamId: number | undefined;
    writerCharge: number | undefined;
    writers: any[] | undefined;
}

/** payment info for curator of article. */
export class StreamCuratorPaymentDTO implements IStreamCuratorPaymentDTO {
    stream!: string | undefined;
    curator!: string | undefined;
    amount!: number | undefined;
    curatorUserId!: string | undefined;
    paymentId!: number | undefined;
    title!: string | undefined;
    curatorAccountId!: number | undefined;

    constructor(data?: IStreamCuratorPaymentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stream = _data["stream"];
            this.curator = _data["curator"];
            this.amount = _data["amount"];
            this.curatorUserId = _data["curatorUserId"];
            this.paymentId = _data["paymentId"];
            this.title = _data["title"];
            this.curatorAccountId = _data["curatorAccountId"];
        }
    }

    static fromJS(data: any): StreamCuratorPaymentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StreamCuratorPaymentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stream"] = this.stream;
        data["curator"] = this.curator;
        data["amount"] = this.amount;
        data["curatorUserId"] = this.curatorUserId;
        data["paymentId"] = this.paymentId;
        data["title"] = this.title;
        data["curatorAccountId"] = this.curatorAccountId;
        return data; 
    }
}

/** payment info for curator of article. */
export interface IStreamCuratorPaymentDTO {
    stream: string | undefined;
    curator: string | undefined;
    amount: number | undefined;
    curatorUserId: string | undefined;
    paymentId: number | undefined;
    title: string | undefined;
    curatorAccountId: number | undefined;
}

/** payment info for stream article owner. */
export class StreamOwnerPaymentDTO implements IStreamOwnerPaymentDTO {
    stream!: string | undefined;
    owner!: string | undefined;
    title!: string | undefined;
    amount!: number | undefined;
    ownerUserId!: string | undefined;
    ownerAccountId!: number | undefined;
    writerPaymentId!: number | undefined;

    constructor(data?: IStreamOwnerPaymentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stream = _data["stream"];
            this.owner = _data["owner"];
            this.title = _data["title"];
            this.amount = _data["amount"];
            this.ownerUserId = _data["ownerUserId"];
            this.ownerAccountId = _data["ownerAccountId"];
            this.writerPaymentId = _data["writerPaymentId"];
        }
    }

    static fromJS(data: any): StreamOwnerPaymentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StreamOwnerPaymentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stream"] = this.stream;
        data["owner"] = this.owner;
        data["title"] = this.title;
        data["amount"] = this.amount;
        data["ownerUserId"] = this.ownerUserId;
        data["ownerAccountId"] = this.ownerAccountId;
        data["writerPaymentId"] = this.writerPaymentId;
        return data; 
    }
}

/** payment info for stream article owner. */
export interface IStreamOwnerPaymentDTO {
    stream: string | undefined;
    owner: string | undefined;
    title: string | undefined;
    amount: number | undefined;
    ownerUserId: string | undefined;
    ownerAccountId: number | undefined;
    writerPaymentId: number | undefined;
}

export class StreamPaymentCompleteDTO implements IStreamPaymentCompleteDTO {
    stream!: string | undefined;
    user!: string | undefined;
    amount!: number | undefined;
    token!: string | undefined;
    paid!: Date | undefined;

    constructor(data?: IStreamPaymentCompleteDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stream = _data["stream"];
            this.user = _data["user"];
            this.amount = _data["amount"];
            this.token = _data["token"];
            this.paid = _data["paid"] ? new Date(_data["paid"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): StreamPaymentCompleteDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StreamPaymentCompleteDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stream"] = this.stream;
        data["user"] = this.user;
        data["amount"] = this.amount;
        data["token"] = this.token;
        data["paid"] = this.paid ? this.paid.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IStreamPaymentCompleteDTO {
    stream: string | undefined;
    user: string | undefined;
    amount: number | undefined;
    token: string | undefined;
    paid: Date | undefined;
}

export class IssueTailorPaymentDTO implements IIssueTailorPaymentDTO {
    id!: number | undefined;
    stream!: string | undefined;
    tailor!: string | undefined;
    created!: Date | undefined;
    issue!: string | undefined;
    tailoringType!: IssueTailorPaymentDTOTailoringType | undefined;
    subscriber!: string | undefined;
    userId!: string | undefined;
    amount!: number | undefined;

    constructor(data?: IIssueTailorPaymentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.stream = _data["stream"];
            this.tailor = _data["tailor"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.issue = _data["issue"];
            this.tailoringType = _data["tailoringType"];
            this.subscriber = _data["subscriber"];
            this.userId = _data["userId"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): IssueTailorPaymentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IssueTailorPaymentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stream"] = this.stream;
        data["tailor"] = this.tailor;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["issue"] = this.issue;
        data["tailoringType"] = this.tailoringType;
        data["subscriber"] = this.subscriber;
        data["userId"] = this.userId;
        data["amount"] = this.amount;
        return data; 
    }
}

export interface IIssueTailorPaymentDTO {
    id: number | undefined;
    stream: string | undefined;
    tailor: string | undefined;
    created: Date | undefined;
    issue: string | undefined;
    tailoringType: IssueTailorPaymentDTOTailoringType | undefined;
    subscriber: string | undefined;
    userId: string | undefined;
    amount: number | undefined;
}

export class ContentStreamIssueTailoringBatchDTO implements IContentStreamIssueTailoringBatchDTO {
    id!: number | undefined;
    name!: string | undefined;
    created!: Date | undefined;
    status!: ContentStreamIssueTailoringBatchDTOStatus | undefined;

    constructor(data?: IContentStreamIssueTailoringBatchDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ContentStreamIssueTailoringBatchDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ContentStreamIssueTailoringBatchDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["status"] = this.status;
        return data; 
    }
}

export interface IContentStreamIssueTailoringBatchDTO {
    id: number | undefined;
    name: string | undefined;
    created: Date | undefined;
    status: ContentStreamIssueTailoringBatchDTOStatus | undefined;
}

export class ContentStreamIssueTailoringBatchItemDTO implements IContentStreamIssueTailoringBatchItemDTO {
    status!: ContentStreamIssueTailoringBatchItemDTOStatus | undefined;
    paymentToken!: string | undefined;
    tailor!: string | undefined;
    amount!: number | undefined;
    paid!: Date | undefined;

    constructor(data?: IContentStreamIssueTailoringBatchItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.paymentToken = _data["paymentToken"];
            this.tailor = _data["tailor"];
            this.amount = _data["amount"];
            this.paid = _data["paid"] ? new Date(_data["paid"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ContentStreamIssueTailoringBatchItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ContentStreamIssueTailoringBatchItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["paymentToken"] = this.paymentToken;
        data["tailor"] = this.tailor;
        data["amount"] = this.amount;
        data["paid"] = this.paid ? this.paid.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IContentStreamIssueTailoringBatchItemDTO {
    status: ContentStreamIssueTailoringBatchItemDTOStatus | undefined;
    paymentToken: string | undefined;
    tailor: string | undefined;
    amount: number | undefined;
    paid: Date | undefined;
}

export class TailoringPaymentDTO implements ITailoringPaymentDTO {
    batch!: string | undefined;
    batchId!: number | undefined;
    amount!: number | undefined;
    status!: number | undefined;
    issues!: TailoringPaymentIssueDTO[] | undefined;

    constructor(data?: ITailoringPaymentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batch = _data["batch"];
            this.batchId = _data["batchId"];
            this.amount = _data["amount"];
            this.status = _data["status"];
            if (Array.isArray(_data["issues"])) {
                this.issues = [] as any;
                for (let item of _data["issues"])
                    this.issues!.push(TailoringPaymentIssueDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TailoringPaymentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TailoringPaymentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batch"] = this.batch;
        data["batchId"] = this.batchId;
        data["amount"] = this.amount;
        data["status"] = this.status;
        if (Array.isArray(this.issues)) {
            data["issues"] = [];
            for (let item of this.issues)
                data["issues"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITailoringPaymentDTO {
    batch: string | undefined;
    batchId: number | undefined;
    amount: number | undefined;
    status: number | undefined;
    issues: TailoringPaymentIssueDTO[] | undefined;
}

export class TailoringPaymentIssueDTO implements ITailoringPaymentIssueDTO {
    issue!: string | undefined;
    stream!: string | undefined;
    amount!: number | undefined;
    created!: Date | undefined;
    tailoringType!: TailoringPaymentIssueDTOTailoringType | undefined;

    constructor(data?: ITailoringPaymentIssueDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issue = _data["issue"];
            this.stream = _data["stream"];
            this.amount = _data["amount"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.tailoringType = _data["tailoringType"];
        }
    }

    static fromJS(data: any): TailoringPaymentIssueDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TailoringPaymentIssueDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issue"] = this.issue;
        data["stream"] = this.stream;
        data["amount"] = this.amount;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["tailoringType"] = this.tailoringType;
        return data; 
    }
}

export interface ITailoringPaymentIssueDTO {
    issue: string | undefined;
    stream: string | undefined;
    amount: number | undefined;
    created: Date | undefined;
    tailoringType: TailoringPaymentIssueDTOTailoringType | undefined;
}

export class SyndicationArticleDto implements ISyndicationArticleDto {
    articleId!: string | undefined;
    issueId!: number | undefined;

    constructor(data?: ISyndicationArticleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"];
            this.issueId = _data["issueId"];
        }
    }

    static fromJS(data: any): SyndicationArticleDto {
        data = typeof data === 'object' ? data : {};
        let result = new SyndicationArticleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId;
        data["issueId"] = this.issueId;
        return data; 
    }
}

export interface ISyndicationArticleDto {
    articleId: string | undefined;
    issueId: number | undefined;
}

export class SyndicationAccountConfigModel implements ISyndicationAccountConfigModel {
    id!: number | undefined;
    customerAccountId!: number | undefined;
    syndicationAccountCategories!: SyndicationAccountCategoryModel[] | undefined;
    customerAccount!: CustomerAccountModel | undefined;

    constructor(data?: ISyndicationAccountConfigModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerAccountId = _data["customerAccountId"];
            if (Array.isArray(_data["syndicationAccountCategories"])) {
                this.syndicationAccountCategories = [] as any;
                for (let item of _data["syndicationAccountCategories"])
                    this.syndicationAccountCategories!.push(SyndicationAccountCategoryModel.fromJS(item));
            }
            this.customerAccount = _data["customerAccount"] ? CustomerAccountModel.fromJS(_data["customerAccount"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SyndicationAccountConfigModel {
        data = typeof data === 'object' ? data : {};
        let result = new SyndicationAccountConfigModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerAccountId"] = this.customerAccountId;
        if (Array.isArray(this.syndicationAccountCategories)) {
            data["syndicationAccountCategories"] = [];
            for (let item of this.syndicationAccountCategories)
                data["syndicationAccountCategories"].push(item.toJSON());
        }
        data["customerAccount"] = this.customerAccount ? this.customerAccount.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ISyndicationAccountConfigModel {
    id: number | undefined;
    customerAccountId: number | undefined;
    syndicationAccountCategories: SyndicationAccountCategoryModel[] | undefined;
    customerAccount: CustomerAccountModel | undefined;
}

export class SyndicationAccountCategoryModel implements ISyndicationAccountCategoryModel {
    id!: number | undefined;
    syndicationAccountConfigId!: number | undefined;
    category!: string | undefined;

    constructor(data?: ISyndicationAccountCategoryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.syndicationAccountConfigId = _data["syndicationAccountConfigId"];
            this.category = _data["category"];
        }
    }

    static fromJS(data: any): SyndicationAccountCategoryModel {
        data = typeof data === 'object' ? data : {};
        let result = new SyndicationAccountCategoryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["syndicationAccountConfigId"] = this.syndicationAccountConfigId;
        data["category"] = this.category;
        return data; 
    }
}

export interface ISyndicationAccountCategoryModel {
    id: number | undefined;
    syndicationAccountConfigId: number | undefined;
    category: string | undefined;
}

export class SyndicationTitleConfigModel implements ISyndicationTitleConfigModel {
    id!: number | undefined;
    publicationId!: number | undefined;
    syndicationTitleCategories!: SyndicationTitleCategoryModel[] | undefined;
    publication!: PublicationModel | undefined;

    constructor(data?: ISyndicationTitleConfigModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.publicationId = _data["publicationId"];
            if (Array.isArray(_data["syndicationTitleCategories"])) {
                this.syndicationTitleCategories = [] as any;
                for (let item of _data["syndicationTitleCategories"])
                    this.syndicationTitleCategories!.push(SyndicationTitleCategoryModel.fromJS(item));
            }
            this.publication = _data["publication"] ? PublicationModel.fromJS(_data["publication"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SyndicationTitleConfigModel {
        data = typeof data === 'object' ? data : {};
        let result = new SyndicationTitleConfigModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["publicationId"] = this.publicationId;
        if (Array.isArray(this.syndicationTitleCategories)) {
            data["syndicationTitleCategories"] = [];
            for (let item of this.syndicationTitleCategories)
                data["syndicationTitleCategories"].push(item.toJSON());
        }
        data["publication"] = this.publication ? this.publication.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ISyndicationTitleConfigModel {
    id: number | undefined;
    publicationId: number | undefined;
    syndicationTitleCategories: SyndicationTitleCategoryModel[] | undefined;
    publication: PublicationModel | undefined;
}

export class SyndicationTitleCategoryModel implements ISyndicationTitleCategoryModel {
    id!: number | undefined;
    syndicationTitleConfigId!: number | undefined;
    category!: string | undefined;

    constructor(data?: ISyndicationTitleCategoryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.syndicationTitleConfigId = _data["syndicationTitleConfigId"];
            this.category = _data["category"];
        }
    }

    static fromJS(data: any): SyndicationTitleCategoryModel {
        data = typeof data === 'object' ? data : {};
        let result = new SyndicationTitleCategoryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["syndicationTitleConfigId"] = this.syndicationTitleConfigId;
        data["category"] = this.category;
        return data; 
    }
}

export interface ISyndicationTitleCategoryModel {
    id: number | undefined;
    syndicationTitleConfigId: number | undefined;
    category: string | undefined;
}

export class PoisonSummary implements IPoisonSummary {
    queueName!: string | undefined;
    messages!: number | undefined;

    constructor(data?: IPoisonSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.queueName = _data["queueName"];
            this.messages = _data["messages"];
        }
    }

    static fromJS(data: any): PoisonSummary {
        data = typeof data === 'object' ? data : {};
        let result = new PoisonSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["queueName"] = this.queueName;
        data["messages"] = this.messages;
        return data; 
    }
}

export interface IPoisonSummary {
    queueName: string | undefined;
    messages: number | undefined;
}

/** audit log for API calls. query usign sys. */
export class ApiAuditModel implements IApiAuditModel {
    /** request execution time. */
    ms!: number | undefined;
    /** http method - GET|POST|etc.. */
    httpmethod!: string | undefined;
    /** Api method called */
    method!: string | undefined;
    /** issueid if any passed to api */
    issueid!: number | undefined;
    /** publicationid if any passed to api */
    publicationid!: number | undefined;
    /** parameteres passed to api on quert string */
    parameters!: string | undefined;
    /** data posted in body */
    body!: string | undefined;
    /** call successful? */
    success!: boolean | undefined;
    /** http code returned */
    httpCode!: number | undefined;
    /** user who made the request */
    user!: string | undefined;
    /** userid fo the caller. */
    userid!: string | undefined;
    /** response sent back to client. */
    response!: string | undefined;
    /** time of last update. */
    logtime!: Date | undefined;

    constructor(data?: IApiAuditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ms = _data["ms"];
            this.httpmethod = _data["httpmethod"];
            this.method = _data["method"];
            this.issueid = _data["issueid"];
            this.publicationid = _data["publicationid"];
            this.parameters = _data["parameters"];
            this.body = _data["body"];
            this.success = _data["success"];
            this.httpCode = _data["httpCode"];
            this.user = _data["user"];
            this.userid = _data["userid"];
            this.response = _data["response"];
            this.logtime = _data["logtime"] ? new Date(_data["logtime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ApiAuditModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApiAuditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ms"] = this.ms;
        data["httpmethod"] = this.httpmethod;
        data["method"] = this.method;
        data["issueid"] = this.issueid;
        data["publicationid"] = this.publicationid;
        data["parameters"] = this.parameters;
        data["body"] = this.body;
        data["success"] = this.success;
        data["httpCode"] = this.httpCode;
        data["user"] = this.user;
        data["userid"] = this.userid;
        data["response"] = this.response;
        data["logtime"] = this.logtime ? this.logtime.toISOString() : <any>undefined;
        return data; 
    }
}

/** audit log for API calls. query usign sys. */
export interface IApiAuditModel {
    /** request execution time. */
    ms: number | undefined;
    /** http method - GET|POST|etc.. */
    httpmethod: string | undefined;
    /** Api method called */
    method: string | undefined;
    /** issueid if any passed to api */
    issueid: number | undefined;
    /** publicationid if any passed to api */
    publicationid: number | undefined;
    /** parameteres passed to api on quert string */
    parameters: string | undefined;
    /** data posted in body */
    body: string | undefined;
    /** call successful? */
    success: boolean | undefined;
    /** http code returned */
    httpCode: number | undefined;
    /** user who made the request */
    user: string | undefined;
    /** userid fo the caller. */
    userid: string | undefined;
    /** response sent back to client. */
    response: string | undefined;
    /** time of last update. */
    logtime: Date | undefined;
}

export class ActionHistoryModel implements IActionHistoryModel {
    created!: Date | undefined;
    path!: string | undefined;
    message!: string | undefined;

    constructor(data?: IActionHistoryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.path = _data["path"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ActionHistoryModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActionHistoryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["path"] = this.path;
        data["message"] = this.message;
        return data; 
    }
}

export interface IActionHistoryModel {
    created: Date | undefined;
    path: string | undefined;
    message: string | undefined;
}

export class TenantModel implements ITenantModel {
    tenantId!: number | undefined;
    domain!: string | undefined;

    constructor(data?: ITenantModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.domain = _data["domain"];
        }
    }

    static fromJS(data: any): TenantModel {
        data = typeof data === 'object' ? data : {};
        let result = new TenantModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["domain"] = this.domain;
        return data; 
    }
}

export interface ITenantModel {
    tenantId: number | undefined;
    domain: string | undefined;
}

export class TenantOwnerModel implements ITenantOwnerModel {
    id!: number | undefined;
    tenantId!: number | undefined;
    adminIdentityUserId!: string | undefined;
    adminIdentityUser!: AdminIdentityUserModel | undefined;

    constructor(data?: ITenantOwnerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.adminIdentityUserId = _data["adminIdentityUserId"];
            this.adminIdentityUser = _data["adminIdentityUser"] ? AdminIdentityUserModel.fromJS(_data["adminIdentityUser"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TenantOwnerModel {
        data = typeof data === 'object' ? data : {};
        let result = new TenantOwnerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["adminIdentityUserId"] = this.adminIdentityUserId;
        data["adminIdentityUser"] = this.adminIdentityUser ? this.adminIdentityUser.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ITenantOwnerModel {
    id: number | undefined;
    tenantId: number | undefined;
    adminIdentityUserId: string | undefined;
    adminIdentityUser: AdminIdentityUserModel | undefined;
}

export class NewWebsiteDTO implements INewWebsiteDTO {
    customerAccountId!: number;
    url!: string;
    titleName!: string;
    slug!: string;

    constructor(data?: INewWebsiteDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerAccountId = _data["customerAccountId"];
            this.url = _data["url"];
            this.titleName = _data["titleName"];
            this.slug = _data["slug"];
        }
    }

    static fromJS(data: any): NewWebsiteDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NewWebsiteDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerAccountId"] = this.customerAccountId;
        data["url"] = this.url;
        data["titleName"] = this.titleName;
        data["slug"] = this.slug;
        return data; 
    }
}

export interface INewWebsiteDTO {
    customerAccountId: number;
    url: string;
    titleName: string;
    slug: string;
}

/** issue publish data */
export class IssuePublishDataModel implements IIssuePublishDataModel {
    /** the issue the data is for. */
    issueid!: number | undefined;
    /** publication of issue. */
    publicationid!: number | undefined;
    /** last published for the issue */
    lastPublished!: Date | undefined;
    /** last time an article was updated for this issue. */
    articleUpdated!: Date | undefined;
    /** FOR FUTURE USE. last time pdf links were updated for this issue. */
    linksUpdated!: Date | undefined;
    /** FOR FUTURE USE. last time interactivity was updated for this issue. */
    interactivityUpdated!: Date | undefined;

    constructor(data?: IIssuePublishDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueid = _data["issueid"];
            this.publicationid = _data["publicationid"];
            this.lastPublished = _data["lastPublished"] ? new Date(_data["lastPublished"].toString()) : <any>undefined;
            this.articleUpdated = _data["articleUpdated"] ? new Date(_data["articleUpdated"].toString()) : <any>undefined;
            this.linksUpdated = _data["linksUpdated"] ? new Date(_data["linksUpdated"].toString()) : <any>undefined;
            this.interactivityUpdated = _data["interactivityUpdated"] ? new Date(_data["interactivityUpdated"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): IssuePublishDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new IssuePublishDataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueid"] = this.issueid;
        data["publicationid"] = this.publicationid;
        data["lastPublished"] = this.lastPublished ? this.lastPublished.toISOString() : <any>undefined;
        data["articleUpdated"] = this.articleUpdated ? this.articleUpdated.toISOString() : <any>undefined;
        data["linksUpdated"] = this.linksUpdated ? this.linksUpdated.toISOString() : <any>undefined;
        data["interactivityUpdated"] = this.interactivityUpdated ? this.interactivityUpdated.toISOString() : <any>undefined;
        return data; 
    }
}

/** issue publish data */
export interface IIssuePublishDataModel {
    /** the issue the data is for. */
    issueid: number | undefined;
    /** publication of issue. */
    publicationid: number | undefined;
    /** last published for the issue */
    lastPublished: Date | undefined;
    /** last time an article was updated for this issue. */
    articleUpdated: Date | undefined;
    /** FOR FUTURE USE. last time pdf links were updated for this issue. */
    linksUpdated: Date | undefined;
    /** FOR FUTURE USE. last time interactivity was updated for this issue. */
    interactivityUpdated: Date | undefined;
}

export class CustomAuthConfigDTO implements ICustomAuthConfigDTO {
    customerUrlId!: number;
    secret!: string;
    jwtExpirySeconds!: number;
    callbackUrl!: string | undefined;
    autoRefreshJWT!: boolean;
    maxStaleRefresh!: number;
    useIncomingJWTExpiry!: boolean;

    constructor(data?: ICustomAuthConfigDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerUrlId = _data["customerUrlId"];
            this.secret = _data["secret"];
            this.jwtExpirySeconds = _data["jwtExpirySeconds"];
            this.callbackUrl = _data["callbackUrl"];
            this.autoRefreshJWT = _data["autoRefreshJWT"];
            this.maxStaleRefresh = _data["maxStaleRefresh"];
            this.useIncomingJWTExpiry = _data["useIncomingJWTExpiry"];
        }
    }

    static fromJS(data: any): CustomAuthConfigDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAuthConfigDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerUrlId"] = this.customerUrlId;
        data["secret"] = this.secret;
        data["jwtExpirySeconds"] = this.jwtExpirySeconds;
        data["callbackUrl"] = this.callbackUrl;
        data["autoRefreshJWT"] = this.autoRefreshJWT;
        data["maxStaleRefresh"] = this.maxStaleRefresh;
        data["useIncomingJWTExpiry"] = this.useIncomingJWTExpiry;
        return data; 
    }
}

export interface ICustomAuthConfigDTO {
    customerUrlId: number;
    secret: string;
    jwtExpirySeconds: number;
    callbackUrl: string | undefined;
    autoRefreshJWT: boolean;
    maxStaleRefresh: number;
    useIncomingJWTExpiry: boolean;
}

export class UserDetails implements IUserDetails {
    authLogs!: AuthLogModel[] | undefined;
    subscriptionLogs!: SubscriptionNotification[] | undefined;

    constructor(data?: IUserDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["authLogs"])) {
                this.authLogs = [] as any;
                for (let item of _data["authLogs"])
                    this.authLogs!.push(AuthLogModel.fromJS(item));
            }
            if (Array.isArray(_data["subscriptionLogs"])) {
                this.subscriptionLogs = [] as any;
                for (let item of _data["subscriptionLogs"])
                    this.subscriptionLogs!.push(SubscriptionNotification.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserDetails {
        data = typeof data === 'object' ? data : {};
        let result = new UserDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.authLogs)) {
            data["authLogs"] = [];
            for (let item of this.authLogs)
                data["authLogs"].push(item.toJSON());
        }
        if (Array.isArray(this.subscriptionLogs)) {
            data["subscriptionLogs"] = [];
            for (let item of this.subscriptionLogs)
                data["subscriptionLogs"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUserDetails {
    authLogs: AuthLogModel[] | undefined;
    subscriptionLogs: SubscriptionNotification[] | undefined;
}

export class AuthLogModel implements IAuthLogModel {
    customerId!: string | undefined;
    actionTime!: Date | undefined;
    action!: string | undefined;
    clientId!: string | undefined;

    constructor(data?: IAuthLogModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.actionTime = _data["actionTime"] ? new Date(_data["actionTime"].toString()) : <any>undefined;
            this.action = _data["action"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): AuthLogModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthLogModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["actionTime"] = this.actionTime ? this.actionTime.toISOString() : <any>undefined;
        data["action"] = this.action;
        data["clientId"] = this.clientId;
        return data; 
    }
}

export interface IAuthLogModel {
    customerId: string | undefined;
    actionTime: Date | undefined;
    action: string | undefined;
    clientId: string | undefined;
}

export class SubscriptionNotification implements ISubscriptionNotification {
    customerId!: string | undefined;
    subscriptionId!: string | undefined;
    status!: string | undefined;
    actionTime!: Date | undefined;
    amount!: number | undefined;
    action!: string | undefined;
    merchantId!: string | undefined;

    constructor(data?: ISubscriptionNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.subscriptionId = _data["subscriptionId"];
            this.status = _data["status"];
            this.actionTime = _data["actionTime"] ? new Date(_data["actionTime"].toString()) : <any>undefined;
            this.amount = _data["amount"];
            this.action = _data["action"];
            this.merchantId = _data["merchantId"];
        }
    }

    static fromJS(data: any): SubscriptionNotification {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["subscriptionId"] = this.subscriptionId;
        data["status"] = this.status;
        data["actionTime"] = this.actionTime ? this.actionTime.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        data["action"] = this.action;
        data["merchantId"] = this.merchantId;
        return data; 
    }
}

export interface ISubscriptionNotification {
    customerId: string | undefined;
    subscriptionId: string | undefined;
    status: string | undefined;
    actionTime: Date | undefined;
    amount: number | undefined;
    action: string | undefined;
    merchantId: string | undefined;
}

export class AuthUser implements IAuthUser {
    password!: string | undefined;
    email!: string | undefined;
    domainId!: number;
    userId!: string | undefined;
    access!: Access | undefined;

    constructor(data?: IAuthUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.password = _data["password"];
            this.email = _data["email"];
            this.domainId = _data["domainId"];
            this.userId = _data["userId"];
            this.access = _data["access"] ? Access.fromJS(_data["access"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AuthUser {
        data = typeof data === 'object' ? data : {};
        let result = new AuthUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password;
        data["email"] = this.email;
        data["domainId"] = this.domainId;
        data["userId"] = this.userId;
        data["access"] = this.access ? this.access.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAuthUser {
    password: string | undefined;
    email: string | undefined;
    domainId: number;
    userId: string | undefined;
    access: Access | undefined;
}

export class Access implements IAccess {
    access_items!: Access_item[] | undefined;
    expiry!: string | undefined;

    constructor(data?: IAccess) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["access_items"])) {
                this.access_items = [] as any;
                for (let item of _data["access_items"])
                    this.access_items!.push(Access_item.fromJS(item));
            }
            this.expiry = _data["expiry"];
        }
    }

    static fromJS(data: any): Access {
        data = typeof data === 'object' ? data : {};
        let result = new Access();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.access_items)) {
            data["access_items"] = [];
            for (let item of this.access_items)
                data["access_items"].push(item.toJSON());
        }
        data["expiry"] = this.expiry;
        return data; 
    }
}

export interface IAccess {
    access_items: Access_item[] | undefined;
    expiry: string | undefined;
}

export class Access_item implements IAccess_item {
    d!: string | undefined;
    a!: Access_itemA | undefined;

    constructor(data?: IAccess_item) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.d = _data["d"];
            this.a = _data["a"];
        }
    }

    static fromJS(data: any): Access_item {
        data = typeof data === 'object' ? data : {};
        let result = new Access_item();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["d"] = this.d;
        data["a"] = this.a;
        return data; 
    }
}

export interface IAccess_item {
    d: string | undefined;
    a: Access_itemA | undefined;
}

export class SubscriberDetailsDTO implements ISubscriberDetailsDTO {
    domainId!: number;
    id!: string;
    email!: string;
    expiry!: Date;

    constructor(data?: ISubscriberDetailsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.domainId = _data["domainId"];
            this.id = _data["id"];
            this.email = _data["email"];
            this.expiry = _data["expiry"] ? new Date(_data["expiry"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SubscriberDetailsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriberDetailsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["domainId"] = this.domainId;
        data["id"] = this.id;
        data["email"] = this.email;
        data["expiry"] = this.expiry ? this.expiry.toISOString() : <any>undefined;
        return data; 
    }
}

export interface ISubscriberDetailsDTO {
    domainId: number;
    id: string;
    email: string;
    expiry: Date;
}

export class SearchSubscriberDTO implements ISearchSubscriberDTO {
    domainId!: number;
    email!: string;

    constructor(data?: ISearchSubscriberDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.domainId = _data["domainId"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): SearchSubscriberDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SearchSubscriberDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["domainId"] = this.domainId;
        data["email"] = this.email;
        return data; 
    }
}

export interface ISearchSubscriberDTO {
    domainId: number;
    email: string;
}

export class Auth0UserDTO implements IAuth0UserDTO {
    domainId!: number | undefined;
    userName!: string | undefined;
    email!: string | undefined;
    password!: string | undefined;
    connection!: string | undefined;

    constructor(data?: IAuth0UserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.domainId = _data["domainId"];
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.password = _data["password"];
            this.connection = _data["connection"];
        }
    }

    static fromJS(data: any): Auth0UserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new Auth0UserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["domainId"] = this.domainId;
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["password"] = this.password;
        data["connection"] = this.connection;
        return data; 
    }
}

export interface IAuth0UserDTO {
    domainId: number | undefined;
    userName: string | undefined;
    email: string | undefined;
    password: string | undefined;
    connection: string | undefined;
}

export class ViewerContentDTO implements IViewerContentDTO {
    id!: number | undefined;
    customerUrlId!: number;
    viewerContentType!: ViewerContentDTOViewerContentType;
    content!: string | undefined;
    version!: ViewerContentDTOVersion;
    customerUrl!: CustomerUrlModel | undefined;

    constructor(data?: IViewerContentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerUrlId = _data["customerUrlId"];
            this.viewerContentType = _data["viewerContentType"];
            this.content = _data["content"];
            this.version = _data["version"];
            this.customerUrl = _data["customerUrl"] ? CustomerUrlModel.fromJS(_data["customerUrl"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ViewerContentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ViewerContentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerUrlId"] = this.customerUrlId;
        data["viewerContentType"] = this.viewerContentType;
        data["content"] = this.content;
        data["version"] = this.version;
        data["customerUrl"] = this.customerUrl ? this.customerUrl.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IViewerContentDTO {
    id: number | undefined;
    customerUrlId: number;
    viewerContentType: ViewerContentDTOViewerContentType;
    content: string | undefined;
    version: ViewerContentDTOVersion;
    customerUrl: CustomerUrlModel | undefined;
}

/** viewer options for a publication */
export class ViewerOptionsModel implements IViewerOptionsModel {
    /** the page layout to launch the viewer with. */
    pageLayout!: number | undefined;
    /** A link to the logo for this publication. */
    logoUrl!: string | undefined;
    /** A Url to hyperlink the logo to. */
    logoLink!: string | undefined;
    /** Initial zoom level for publication. */
    zoomLevel!: number | undefined;
    /** Initial zoom factor for publication. */
    zoomFactor!: number | undefined;
    /** Set the spine style for the publication. */
    spineStyle!: ViewerOptionsModelSpineStyle | undefined;
    /** Sets the spine gap if a gap is selected in SpineStyle. */
    spineGap!: number | undefined;
    /** Enables printing in the viewer. */
    enablePrint!: boolean | undefined;
    /** Sets the background in the viewer. */
    backgroundOptions!: string | undefined;
    /** Color of toolbar in viewer */
    toolbarColor!: string | undefined;
    /** ? */
    toolColor!: string | undefined;
    /** ? */
    toolHoverColor!: string | undefined;
    /** Url to request secure content. */
    secureContentUrl!: string | undefined;

    constructor(data?: IViewerOptionsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageLayout = _data["pageLayout"];
            this.logoUrl = _data["logoUrl"];
            this.logoLink = _data["logoLink"];
            this.zoomLevel = _data["zoomLevel"];
            this.zoomFactor = _data["zoomFactor"];
            this.spineStyle = _data["spineStyle"];
            this.spineGap = _data["spineGap"];
            this.enablePrint = _data["enablePrint"];
            this.backgroundOptions = _data["backgroundOptions"];
            this.toolbarColor = _data["toolbarColor"];
            this.toolColor = _data["toolColor"];
            this.toolHoverColor = _data["toolHoverColor"];
            this.secureContentUrl = _data["secureContentUrl"];
        }
    }

    static fromJS(data: any): ViewerOptionsModel {
        data = typeof data === 'object' ? data : {};
        let result = new ViewerOptionsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageLayout"] = this.pageLayout;
        data["logoUrl"] = this.logoUrl;
        data["logoLink"] = this.logoLink;
        data["zoomLevel"] = this.zoomLevel;
        data["zoomFactor"] = this.zoomFactor;
        data["spineStyle"] = this.spineStyle;
        data["spineGap"] = this.spineGap;
        data["enablePrint"] = this.enablePrint;
        data["backgroundOptions"] = this.backgroundOptions;
        data["toolbarColor"] = this.toolbarColor;
        data["toolColor"] = this.toolColor;
        data["toolHoverColor"] = this.toolHoverColor;
        data["secureContentUrl"] = this.secureContentUrl;
        return data; 
    }
}

/** viewer options for a publication */
export interface IViewerOptionsModel {
    /** the page layout to launch the viewer with. */
    pageLayout: number | undefined;
    /** A link to the logo for this publication. */
    logoUrl: string | undefined;
    /** A Url to hyperlink the logo to. */
    logoLink: string | undefined;
    /** Initial zoom level for publication. */
    zoomLevel: number | undefined;
    /** Initial zoom factor for publication. */
    zoomFactor: number | undefined;
    /** Set the spine style for the publication. */
    spineStyle: ViewerOptionsModelSpineStyle | undefined;
    /** Sets the spine gap if a gap is selected in SpineStyle. */
    spineGap: number | undefined;
    /** Enables printing in the viewer. */
    enablePrint: boolean | undefined;
    /** Sets the background in the viewer. */
    backgroundOptions: string | undefined;
    /** Color of toolbar in viewer */
    toolbarColor: string | undefined;
    /** ? */
    toolColor: string | undefined;
    /** ? */
    toolHoverColor: string | undefined;
    /** Url to request secure content. */
    secureContentUrl: string | undefined;
}

/** publication notes. */
export class WordpressConfigurationModel implements IWordpressConfigurationModel {
    /** Publication identifier. */
    publicationId!: number | undefined;
    /** Wordpress user */
    user!: string | undefined;
    /** Wordpress password */
    password!: string | undefined;
    /** Wordpress website */
    url!: string | undefined;
    /** Wordpress status (Draft | Published) */
    status!: string | undefined;

    constructor(data?: IWordpressConfigurationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.publicationId = _data["publicationId"];
            this.user = _data["user"];
            this.password = _data["password"];
            this.url = _data["url"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): WordpressConfigurationModel {
        data = typeof data === 'object' ? data : {};
        let result = new WordpressConfigurationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["publicationId"] = this.publicationId;
        data["user"] = this.user;
        data["password"] = this.password;
        data["url"] = this.url;
        data["status"] = this.status;
        return data; 
    }
}

/** publication notes. */
export interface IWordpressConfigurationModel {
    /** Publication identifier. */
    publicationId: number | undefined;
    /** Wordpress user */
    user: string | undefined;
    /** Wordpress password */
    password: string | undefined;
    /** Wordpress website */
    url: string | undefined;
    /** Wordpress status (Draft | Published) */
    status: string | undefined;
}

export class WordpressPluginDTO implements IWordpressPluginDTO {
    id!: number | undefined;
    customerAccountId!: number;
    user!: string;
    password!: string;
    url!: string;
    status!: WordpressPluginDTOStatus;

    constructor(data?: IWordpressPluginDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerAccountId = _data["customerAccountId"];
            this.user = _data["user"];
            this.password = _data["password"];
            this.url = _data["url"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): WordpressPluginDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WordpressPluginDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerAccountId"] = this.customerAccountId;
        data["user"] = this.user;
        data["password"] = this.password;
        data["url"] = this.url;
        data["status"] = this.status;
        return data; 
    }
}

export interface IWordpressPluginDTO {
    id: number | undefined;
    customerAccountId: number;
    user: string;
    password: string;
    url: string;
    status: WordpressPluginDTOStatus;
}

export class WordpressPublishDTO implements IWordpressPublishDTO {
    articleId!: number | undefined;
    wordpressPluginId!: number | undefined;

    constructor(data?: IWordpressPublishDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"];
            this.wordpressPluginId = _data["wordpressPluginId"];
        }
    }

    static fromJS(data: any): WordpressPublishDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WordpressPublishDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId;
        data["wordpressPluginId"] = this.wordpressPluginId;
        return data; 
    }
}

export interface IWordpressPublishDTO {
    articleId: number | undefined;
    wordpressPluginId: number | undefined;
}

/** model for to create link on a page */
export class IssueLinkModel implements IIssueLinkModel {
    /** the publication */
    publicationid!: number | undefined;
    /** the issue the link is on. */
    issueid!: number | undefined;
    /** the page offset the link is on. */
    pageNumber!: number | undefined;
    /** the link action (href: / jump: / email: ) */
    link!: string | undefined;
    /** where to draw the link on the page. */
    coordinates!: string | undefined;
    /** what created this link (wordsmart|manual|...) */
    createdBy!: IssueLinkModelCreatedBy | undefined;
    /** context of the hit. */
    snippet!: string | undefined;
    check!: number | undefined;
    /** row id */
    rowKey!: string | undefined;

    constructor(data?: IIssueLinkModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.publicationid = _data["publicationid"];
            this.issueid = _data["issueid"];
            this.pageNumber = _data["pageNumber"];
            this.link = _data["link"];
            this.coordinates = _data["coordinates"];
            this.createdBy = _data["createdBy"];
            this.snippet = _data["snippet"];
            this.check = _data["check"];
            this.rowKey = _data["rowKey"];
        }
    }

    static fromJS(data: any): IssueLinkModel {
        data = typeof data === 'object' ? data : {};
        let result = new IssueLinkModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["publicationid"] = this.publicationid;
        data["issueid"] = this.issueid;
        data["pageNumber"] = this.pageNumber;
        data["link"] = this.link;
        data["coordinates"] = this.coordinates;
        data["createdBy"] = this.createdBy;
        data["snippet"] = this.snippet;
        data["check"] = this.check;
        data["rowKey"] = this.rowKey;
        return data; 
    }
}

/** model for to create link on a page */
export interface IIssueLinkModel {
    /** the publication */
    publicationid: number | undefined;
    /** the issue the link is on. */
    issueid: number | undefined;
    /** the page offset the link is on. */
    pageNumber: number | undefined;
    /** the link action (href: / jump: / email: ) */
    link: string | undefined;
    /** where to draw the link on the page. */
    coordinates: string | undefined;
    /** what created this link (wordsmart|manual|...) */
    createdBy: IssueLinkModelCreatedBy | undefined;
    /** context of the hit. */
    snippet: string | undefined;
    check: number | undefined;
    /** row id */
    rowKey: string | undefined;
}

export class WordsmartCustomRegexDTO implements IWordsmartCustomRegexDTO {
    regex!: string;
    regexType!: WordsmartCustomRegexDTORegexType;
    issueId!: number;
    pageNumber!: number;

    constructor(data?: IWordsmartCustomRegexDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.regex = _data["regex"];
            this.regexType = _data["regexType"];
            this.issueId = _data["issueId"];
            this.pageNumber = _data["pageNumber"];
        }
    }

    static fromJS(data: any): WordsmartCustomRegexDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WordsmartCustomRegexDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regex"] = this.regex;
        data["regexType"] = this.regexType;
        data["issueId"] = this.issueId;
        data["pageNumber"] = this.pageNumber;
        return data; 
    }
}

export interface IWordsmartCustomRegexDTO {
    regex: string;
    regexType: WordsmartCustomRegexDTORegexType;
    issueId: number;
    pageNumber: number;
}

export enum ArticleType {
    Extracted = "extracted",
    Metadata = "metadata",
    Newsletter = "newsletter",
    Newslettersubscription = "newslettersubscription",
    Copied = "copied",
    Syndication = "syndication",
    Syndicationproof = "syndicationproof",
    All = "all",
    Syndicationrejected = "syndicationrejected",
    Imported = "imported",
    Syndicationremoved = "syndicationremoved",
    Purchased = "purchased",
    Written = "written",
    ContentStreamSource = "contentStreamSource",
    ReadyForCuration = "readyForCuration",
    Curated = "curated",
}

/** new status of account */
export enum Status {
    Deleted = "deleted",
    PendingTC = "pendingTC",
    New = "new",
    Demo = "demo",
    Approved = "approved",
    Inactive = "inactive",
    Suspended = "suspended",
    Cancelled = "cancelled",
}

/** the image type */
export enum ImageType {
    Welcomebanner = "welcomebanner",
    Welcomebannermobile = "welcomebannermobile",
    Bannerad = "bannerad",
    Banneradmobile = "banneradmobile",
    Coverimage = "coverimage",
    Coverimagemobile = "coverimagemobile",
}

export enum Task {
    QA = "qA",
    ArticleExtraction = "articleExtraction",
    PreExtraction = "preExtraction",
    Live = "live",
    Conversion = "conversion",
    Enhancement = "enhancement",
    PostExtraction = "postExtraction",
    SyndicationProof = "syndicationProof",
}

export enum Status2 {
    NotApplicable = "notApplicable",
    NotStarted = "notStarted",
    Started = "started",
    Finished = "finished",
}

export enum Status3 {
    New = "new",
    InProgress = "inProgress",
    WithClient = "withClient",
    Finished = "finished",
    Cancelled = "cancelled",
    Suspended = "suspended",
    Reopened = "reopened",
}

export enum Language {
    English = "english",
    German = "german",
    Swedish = "swedish",
    Spanish = "spanish",
}

export enum PublicationType {
    Title = "title",
    Newsletterservice = "newsletterservice",
    Newslettersubscription = "newslettersubscription",
    Myarticles = "myarticles",
    Written = "written",
    Contentstream = "contentstream",
    ContentStreamSubscription = "contentStreamSubscription",
}

/** The feature group to change to. */
export enum FeatureGroup {
    Premium = "premium",
    Plus = "plus",
    Replica = "replica",
}

/** the icon type */
export enum PublicationIcon {
    Icon = "icon",
}

/** the image type */
export enum ImageType2 {
    Welcomebanner = "welcomebanner",
    Welcomebannermobile = "welcomebannermobile",
    Bannerad = "bannerad",
    Banneradmobile = "banneradmobile",
    Coverimage = "coverimage",
    Coverimagemobile = "coverimagemobile",
}

export enum LiveStatus {
    Notlive = "notlive",
    Live = "live",
}

export enum Language2 {
    English = "english",
    German = "german",
    Swedish = "swedish",
    Spanish = "spanish",
}

export enum Language3 {
    English = "english",
    German = "german",
    Swedish = "swedish",
    Spanish = "spanish",
}

export enum Language4 {
    English = "english",
    German = "german",
    Swedish = "swedish",
    Spanish = "spanish",
}

export enum PosionQueue {
    ProcessInputUrl = "processInputUrl",
    Pdf2xod = "pdf2xod",
    Finish = "finish",
    ExtractPdfContent = "extractPdfContent",
    CreateThumbnails = "createThumbnails",
    Preflight = "preflight",
    MergePdf = "mergePdf",
    Wordsmart = "wordsmart",
    Testing = "testing",
    PublishParticaAI = "publishParticaAI",
    Contentupdate = "contentupdate",
    Moveembedimages = "moveembedimages",
    Moveissueembedimages = "moveissueembedimages",
    Removeembedimages = "removeembedimages",
    Removeissueembedimages = "removeissueembedimages",
    DownloadImageArticleImport = "downloadImageArticleImport",
    Publishissues = "publishissues",
    Republishissues = "republishissues",
}

/** how the title will display on this url */
export enum DisplayPreference {
    ArticleReplica = "articleReplica",
    ReplicaArticle = "replicaArticle",
    ReplicaOnly = "replicaOnly",
    ArticleOnly = "articleOnly",
}

export enum Secure {
    Free = "free",
    Secure = "secure",
    Register = "register",
    Maillist = "maillist",
    Custom = "custom",
}

export enum SecurityType {
    Unknown = "unknown",
    NoSecurity = "noSecurity",
    CompulsoryRegistration = "compulsoryRegistration",
    Subscription = "subscription",
    TokenIntegration = "tokenIntegration",
    Crm = "crm",
    CustomAPI = "customAPI",
}

export enum DisplayPreference2 {
    ArticleReplica = "articleReplica",
    ReplicaArticle = "replicaArticle",
    ReplicaOnly = "replicaOnly",
    ArticleOnly = "articleOnly",
}

/** the icon type */
export enum UrlIcon {
    Shortcut_icon = "shortcut_icon",
    Apple_touchicon_60x60 = "apple_touchicon_60x60",
    Apple_touchicon_76x76 = "apple_touchicon_76x76",
    Apple_touchicon_120x120 = "apple_touchicon_120x120",
    Apple_touchicon_152x152 = "apple_touchicon_152x152",
    Apple_touchicon_57x57 = "apple_touchicon_57x57",
    Apple_touchicon_72x72 = "apple_touchicon_72x72",
    Apple_touchicon_144x144 = "apple_touchicon_144x144",
}

/** type of content to load */
export enum ViewerContentType {
    Template = "template",
    Zeropage = "zeropage",
    Search = "search",
    Tableofcontents = "tableofcontents",
    Authentication = "authentication",
    Classic = "classic",
}

/** version of content to load */
export enum ViewerContentVersion {
    Live = "live",
    Preview = "preview",
    Blank = "blank",
}

export enum ViewerContentType2 {
    Template = "template",
    Zeropage = "zeropage",
    Search = "search",
    Tableofcontents = "tableofcontents",
    Authentication = "authentication",
    Classic = "classic",
}

/** What links to copy */
export enum InteractivitySource {
    Pdf = "pdf",
    Wordsmart = "wordsmart",
    Manual = "manual",
    All = "all",
}

export enum AffiliateConfigurationDTOStatus {
    Active = "active",
    Inactive = "inactive",
}

export enum ArticleModelArticleType {
    Extracted = "extracted",
    Metadata = "metadata",
    Newsletter = "newsletter",
    Newslettersubscription = "newslettersubscription",
    Copied = "copied",
    Syndication = "syndication",
    Syndicationproof = "syndicationproof",
    All = "all",
    Syndicationrejected = "syndicationrejected",
    Imported = "imported",
    Syndicationremoved = "syndicationremoved",
    Purchased = "purchased",
    Written = "written",
    ContentStreamSource = "contentStreamSource",
    ReadyForCuration = "readyForCuration",
    Curated = "curated",
}

export enum IssueModelIssueType {
    Issue = "issue",
    NewsletterSource = "newsletterSource",
    Newsletter = "newsletter",
    Importcontainer = "importcontainer",
    Myarticles = "myarticles",
    Written = "written",
    Contentstreamissue = "contentstreamissue",
    Contentstreamsubissue = "contentstreamsubissue",
}

export enum StreamStatsDTOStatus {
    Active = "active",
    Inactive = "inactive",
    Removed = "removed",
}

export enum StreamStatsDTOVisibility {
    PrivateChargebeeBilledStream = "privateChargebeeBilledStream",
    NonChargebeeBilledStream = "nonChargebeeBilledStream",
}

export enum ContentStreamDTOStatus {
    Active = "active",
    Inactive = "inactive",
    Removed = "removed",
}

export enum ContentStreamDTOVisibility {
    PrivateChargebeeBilledStream = "privateChargebeeBilledStream",
    NonChargebeeBilledStream = "nonChargebeeBilledStream",
}

export enum ContentStreamDTOOwner {
    Partica = "partica",
    MyDesign = "myDesign",
    Corelogic = "corelogic",
    ActivePipe = "activePipe",
    Spare = "spare",
}

export enum ContentStreamDTOCategory {
    RealEstate = "realEstate",
    Finance = "finance",
}

export enum ContentStreamDTOCopyIssueOnSubscribe {
    None = "none",
    First = "first",
    Last = "last",
    All = "all",
}

export enum PublicationModelLanguage {
    English = "english",
    German = "german",
    Swedish = "swedish",
    Spanish = "spanish",
}

export enum PublicationModelPublicationType {
    Title = "title",
    Newsletterservice = "newsletterservice",
    Newslettersubscription = "newslettersubscription",
    Myarticles = "myarticles",
    Written = "written",
    Contentstream = "contentstream",
    ContentStreamSubscription = "contentStreamSubscription",
}

export enum ContentStreamLevelDTORequiresCuration {
    Required = "required",
    Notrequired = "notrequired",
}

export enum ContentStreamSubscriberDTORequiresCuration {
    Required = "required",
    Notrequired = "notrequired",
}

export enum ContentStreamSubscriberDTOStatus {
    Created = "created",
    Active = "active",
    Inactive = "inactive",
}

export enum ContentStreamLevelStoreDTORequiresCuration {
    Required = "required",
    Notrequired = "notrequired",
}

export enum ContentStreamStoreDTOCopyIssueOnSubscribe {
    None = "none",
    First = "first",
    Last = "last",
    All = "all",
}

export enum ContentStreamStoreLevelDTORequiresCuration {
    Required = "required",
    Notrequired = "notrequired",
}

export enum ConversionOptionsModelFlattenThresholdFlag {
    E_very_strict = "e_very_strict",
    E_strict = "e_strict",
    E_default = "e_default",
    E_keep_most = "e_keep_most",
    E_keep_all = "e_keep_all",
}

export enum ConversionOptionsModelFlatten {
    E_off = "e_off",
    E_simple = "e_simple",
    E_fast = "e_fast",
}

export enum AccountDetailsUpdateDTOCountry {
    Afghanistan = "Afghanistan",
    Albania = "Albania",
    Algeria = "Algeria",
    Andorra = "Andorra",
    Angola = "Angola",
    Antarctica = "Antarctica",
    Argentina = "Argentina",
    Armenia = "Armenia",
    Aruba = "Aruba",
    Australia = "Australia",
    Austria = "Austria",
    Azerbaijan = "Azerbaijan",
    Bahrain = "Bahrain",
    Bangladesh = "Bangladesh",
    Belarus = "Belarus",
    Belgium = "Belgium",
    Belize = "Belize",
    Benin = "Benin",
    Bhutan = "Bhutan",
    Bolivia = "Bolivia",
    BosniaHerzegovina = "BosniaHerzegovina",
    Botswana = "Botswana",
    Brazil = "Brazil",
    BruneiDarussalam = "BruneiDarussalam",
    Bulgaria = "Bulgaria",
    BurkinaFaso = "BurkinaFaso",
    Myanmar = "Myanmar",
    Burundi = "Burundi",
    Cambodia = "Cambodia",
    Cameroon = "Cameroon",
    Canada = "Canada",
    CapeVerde = "CapeVerde",
    CentralAfricanRepublic = "CentralAfricanRepublic",
    Chad = "Chad",
    Chile = "Chile",
    China = "China",
    ChristmasIsland = "ChristmasIsland",
    CocosIslands = "CocosIslands",
    Colombia = "Colombia",
    Comoros = "Comoros",
    Congo = "Congo",
    DemocraticRepublicCongo = "DemocraticRepublicCongo",
    CookIslands = "CookIslands",
    CostaRica = "CostaRica",
    Croatia = "Croatia",
    Cuba = "Cuba",
    Cyprus = "Cyprus",
    CzechRepublic = "CzechRepublic",
    Denmark = "Denmark",
    Djibouti = "Djibouti",
    Timorleste = "Timorleste",
    Ecuador = "Ecuador",
    Egypt = "Egypt",
    ElSalvador = "ElSalvador",
    EquatorialGuinea = "EquatorialGuinea",
    Eritrea = "Eritrea",
    Estonia = "Estonia",
    Ethiopia = "Ethiopia",
    FalklandIslands = "FalklandIslands",
    FaroeIslands = "FaroeIslands",
    Fiji = "Fiji",
    Finland = "Finland",
    France = "France",
    FrenchPolynesia = "FrenchPolynesia",
    Gabon = "Gabon",
    Gambia = "Gambia",
    Georgia = "Georgia",
    Germany = "Germany",
    Ghana = "Ghana",
    Gibraltar = "Gibraltar",
    Greece = "Greece",
    Greenland = "Greenland",
    Guatemala = "Guatemala",
    Guinea = "Guinea",
    Guineabissau = "Guineabissau",
    Guyana = "Guyana",
    Haiti = "Haiti",
    Honduras = "Honduras",
    HongKong = "HongKong",
    Hungary = "Hungary",
    India = "India",
    Indonesia = "Indonesia",
    Iran = "Iran",
    Iraq = "Iraq",
    Ireland = "Ireland",
    IsleOfMan = "IsleOfMan",
    Israel = "Israel",
    Italy = "Italy",
    CoteDivoire = "CoteDivoire",
    Japan = "Japan",
    Jordan = "Jordan",
    Kazakhstan = "Kazakhstan",
    Kenya = "Kenya",
    Kiribati = "Kiribati",
    Kuwait = "Kuwait",
    Kyrgyzstan = "Kyrgyzstan",
    LaoPeoplesDR = "LaoPeoplesDR",
    Latvia = "Latvia",
    Lebanon = "Lebanon",
    Lesotho = "Lesotho",
    Liberia = "Liberia",
    Libya = "Libya",
    Liechtenstein = "Liechtenstein",
    Lithuania = "Lithuania",
    Luxembourg = "Luxembourg",
    Macao = "Macao",
    Macedonia = "Macedonia",
    Madagascar = "Madagascar",
    Malawi = "Malawi",
    Malaysia = "Malaysia",
    Maldives = "Maldives",
    Mali = "Mali",
    Malta = "Malta",
    Mauritania = "Mauritania",
    Mauritius = "Mauritius",
    Mayotte = "Mayotte",
    Mexico = "Mexico",
    Micronesia = "Micronesia",
    Moldova = "Moldova",
    Monaco = "Monaco",
    Mongolia = "Mongolia",
    Montenegro = "Montenegro",
    Morocco = "Morocco",
    Mozambique = "Mozambique",
    Namibia = "Namibia",
    Nauru = "Nauru",
    Nepal = "Nepal",
    Netherlands = "Netherlands",
    NewCaledonia = "NewCaledonia",
    NewZealand = "NewZealand",
    Nicaragua = "Nicaragua",
    Niger = "Niger",
    Nigeria = "Nigeria",
    Niue = "Niue",
    NorthKorea = "NorthKorea",
    Norway = "Norway",
    Oman = "Oman",
    Pakistan = "Pakistan",
    Palau = "Palau",
    Panama = "Panama",
    PapuaNewGuinea = "PapuaNewGuinea",
    Paraguay = "Paraguay",
    Peru = "Peru",
    Philippines = "Philippines",
    Poland = "Poland",
    Portugal = "Portugal",
    PuertoRico = "PuertoRico",
    Qatar = "Qatar",
    Romania = "Romania",
    RussianFederation = "RussianFederation",
    Rwanda = "Rwanda",
    SaintBarthélemy = "SaintBarthélemy",
    Samoa = "Samoa",
    SanMarino = "SanMarino",
    SaoTomeAndPrincipe = "SaoTomeAndPrincipe",
    SaudiArabia = "SaudiArabia",
    Senegal = "Senegal",
    Serbia = "Serbia",
    Seychelles = "Seychelles",
    SierraLeone = "SierraLeone",
    Singapore = "Singapore",
    Slovakia = "Slovakia",
    Slovenia = "Slovenia",
    SolomonIslands = "SolomonIslands",
    Somalia = "Somalia",
    SouthAfrica = "SouthAfrica",
    SouthKorea = "SouthKorea",
    Spain = "Spain",
    SriLanka = "SriLanka",
    SaintHelena = "SaintHelena",
    SaintPierreMiquelon = "SaintPierreMiquelon",
    Sudan = "Sudan",
    Suriname = "Suriname",
    Swaziland = "Swaziland",
    Sweden = "Sweden",
    Switzerland = "Switzerland",
    SyrianArabRepublic = "SyrianArabRepublic",
    Taiwan = "Taiwan",
    Tajikistan = "Tajikistan",
    Tanzania = "Tanzania",
    Thailand = "Thailand",
    Togo = "Togo",
    Tokelau = "Tokelau",
    Tonga = "Tonga",
    Tunisia = "Tunisia",
    Turkey = "Turkey",
    Turkmenistan = "Turkmenistan",
    Tuvalu = "Tuvalu",
    UnitedArabEmirates = "UnitedArabEmirates",
    Uganda = "Uganda",
    UnitedKingdom = "UnitedKingdom",
    Ukraine = "Ukraine",
    Uruguay = "Uruguay",
    UnitedStates = "UnitedStates",
    Uzbekistan = "Uzbekistan",
    Vanuatu = "Vanuatu",
    VaticanCity = "vaticanCity",
    HolySee = "HolySee",
    Venezuela = "Venezuela",
    VietNam = "VietNam",
    WallisFutuna = "WallisFutuna",
    Yemen = "Yemen",
    Zambia = "Zambia",
    Zimbabwe = "Zimbabwe",
    MarshallIslands = "MarshallIslands",
    Pitcairn = "Pitcairn",
}

export enum CustomerAccountModelCountry {
    Afghanistan = "Afghanistan",
    Albania = "Albania",
    Algeria = "Algeria",
    Andorra = "Andorra",
    Angola = "Angola",
    Antarctica = "Antarctica",
    Argentina = "Argentina",
    Armenia = "Armenia",
    Aruba = "Aruba",
    Australia = "Australia",
    Austria = "Austria",
    Azerbaijan = "Azerbaijan",
    Bahrain = "Bahrain",
    Bangladesh = "Bangladesh",
    Belarus = "Belarus",
    Belgium = "Belgium",
    Belize = "Belize",
    Benin = "Benin",
    Bhutan = "Bhutan",
    Bolivia = "Bolivia",
    BosniaHerzegovina = "BosniaHerzegovina",
    Botswana = "Botswana",
    Brazil = "Brazil",
    BruneiDarussalam = "BruneiDarussalam",
    Bulgaria = "Bulgaria",
    BurkinaFaso = "BurkinaFaso",
    Myanmar = "Myanmar",
    Burundi = "Burundi",
    Cambodia = "Cambodia",
    Cameroon = "Cameroon",
    Canada = "Canada",
    CapeVerde = "CapeVerde",
    CentralAfricanRepublic = "CentralAfricanRepublic",
    Chad = "Chad",
    Chile = "Chile",
    China = "China",
    ChristmasIsland = "ChristmasIsland",
    CocosIslands = "CocosIslands",
    Colombia = "Colombia",
    Comoros = "Comoros",
    Congo = "Congo",
    DemocraticRepublicCongo = "DemocraticRepublicCongo",
    CookIslands = "CookIslands",
    CostaRica = "CostaRica",
    Croatia = "Croatia",
    Cuba = "Cuba",
    Cyprus = "Cyprus",
    CzechRepublic = "CzechRepublic",
    Denmark = "Denmark",
    Djibouti = "Djibouti",
    Timorleste = "Timorleste",
    Ecuador = "Ecuador",
    Egypt = "Egypt",
    ElSalvador = "ElSalvador",
    EquatorialGuinea = "EquatorialGuinea",
    Eritrea = "Eritrea",
    Estonia = "Estonia",
    Ethiopia = "Ethiopia",
    FalklandIslands = "FalklandIslands",
    FaroeIslands = "FaroeIslands",
    Fiji = "Fiji",
    Finland = "Finland",
    France = "France",
    FrenchPolynesia = "FrenchPolynesia",
    Gabon = "Gabon",
    Gambia = "Gambia",
    Georgia = "Georgia",
    Germany = "Germany",
    Ghana = "Ghana",
    Gibraltar = "Gibraltar",
    Greece = "Greece",
    Greenland = "Greenland",
    Guatemala = "Guatemala",
    Guinea = "Guinea",
    Guineabissau = "Guineabissau",
    Guyana = "Guyana",
    Haiti = "Haiti",
    Honduras = "Honduras",
    HongKong = "HongKong",
    Hungary = "Hungary",
    India = "India",
    Indonesia = "Indonesia",
    Iran = "Iran",
    Iraq = "Iraq",
    Ireland = "Ireland",
    IsleOfMan = "IsleOfMan",
    Israel = "Israel",
    Italy = "Italy",
    CoteDivoire = "CoteDivoire",
    Japan = "Japan",
    Jordan = "Jordan",
    Kazakhstan = "Kazakhstan",
    Kenya = "Kenya",
    Kiribati = "Kiribati",
    Kuwait = "Kuwait",
    Kyrgyzstan = "Kyrgyzstan",
    LaoPeoplesDR = "LaoPeoplesDR",
    Latvia = "Latvia",
    Lebanon = "Lebanon",
    Lesotho = "Lesotho",
    Liberia = "Liberia",
    Libya = "Libya",
    Liechtenstein = "Liechtenstein",
    Lithuania = "Lithuania",
    Luxembourg = "Luxembourg",
    Macao = "Macao",
    Macedonia = "Macedonia",
    Madagascar = "Madagascar",
    Malawi = "Malawi",
    Malaysia = "Malaysia",
    Maldives = "Maldives",
    Mali = "Mali",
    Malta = "Malta",
    Mauritania = "Mauritania",
    Mauritius = "Mauritius",
    Mayotte = "Mayotte",
    Mexico = "Mexico",
    Micronesia = "Micronesia",
    Moldova = "Moldova",
    Monaco = "Monaco",
    Mongolia = "Mongolia",
    Montenegro = "Montenegro",
    Morocco = "Morocco",
    Mozambique = "Mozambique",
    Namibia = "Namibia",
    Nauru = "Nauru",
    Nepal = "Nepal",
    Netherlands = "Netherlands",
    NewCaledonia = "NewCaledonia",
    NewZealand = "NewZealand",
    Nicaragua = "Nicaragua",
    Niger = "Niger",
    Nigeria = "Nigeria",
    Niue = "Niue",
    NorthKorea = "NorthKorea",
    Norway = "Norway",
    Oman = "Oman",
    Pakistan = "Pakistan",
    Palau = "Palau",
    Panama = "Panama",
    PapuaNewGuinea = "PapuaNewGuinea",
    Paraguay = "Paraguay",
    Peru = "Peru",
    Philippines = "Philippines",
    Poland = "Poland",
    Portugal = "Portugal",
    PuertoRico = "PuertoRico",
    Qatar = "Qatar",
    Romania = "Romania",
    RussianFederation = "RussianFederation",
    Rwanda = "Rwanda",
    SaintBarthélemy = "SaintBarthélemy",
    Samoa = "Samoa",
    SanMarino = "SanMarino",
    SaoTomeAndPrincipe = "SaoTomeAndPrincipe",
    SaudiArabia = "SaudiArabia",
    Senegal = "Senegal",
    Serbia = "Serbia",
    Seychelles = "Seychelles",
    SierraLeone = "SierraLeone",
    Singapore = "Singapore",
    Slovakia = "Slovakia",
    Slovenia = "Slovenia",
    SolomonIslands = "SolomonIslands",
    Somalia = "Somalia",
    SouthAfrica = "SouthAfrica",
    SouthKorea = "SouthKorea",
    Spain = "Spain",
    SriLanka = "SriLanka",
    SaintHelena = "SaintHelena",
    SaintPierreMiquelon = "SaintPierreMiquelon",
    Sudan = "Sudan",
    Suriname = "Suriname",
    Swaziland = "Swaziland",
    Sweden = "Sweden",
    Switzerland = "Switzerland",
    SyrianArabRepublic = "SyrianArabRepublic",
    Taiwan = "Taiwan",
    Tajikistan = "Tajikistan",
    Tanzania = "Tanzania",
    Thailand = "Thailand",
    Togo = "Togo",
    Tokelau = "Tokelau",
    Tonga = "Tonga",
    Tunisia = "Tunisia",
    Turkey = "Turkey",
    Turkmenistan = "Turkmenistan",
    Tuvalu = "Tuvalu",
    UnitedArabEmirates = "UnitedArabEmirates",
    Uganda = "Uganda",
    UnitedKingdom = "UnitedKingdom",
    Ukraine = "Ukraine",
    Uruguay = "Uruguay",
    UnitedStates = "UnitedStates",
    Uzbekistan = "Uzbekistan",
    Vanuatu = "Vanuatu",
    VaticanCity = "vaticanCity",
    HolySee = "HolySee",
    Venezuela = "Venezuela",
    VietNam = "VietNam",
    WallisFutuna = "WallisFutuna",
    Yemen = "Yemen",
    Zambia = "Zambia",
    Zimbabwe = "Zimbabwe",
    MarshallIslands = "MarshallIslands",
    Pitcairn = "Pitcairn",
}

export enum CustomerUrlModelSecure {
    Free = "free",
    Secure = "secure",
    Register = "register",
    Maillist = "maillist",
    Custom = "custom",
}

export enum CustomerUrlModelSecurityType {
    Unknown = "unknown",
    NoSecurity = "noSecurity",
    CompulsoryRegistration = "compulsoryRegistration",
    Subscription = "subscription",
    TokenIntegration = "tokenIntegration",
    Crm = "crm",
    CustomAPI = "customAPI",
}

export enum MessageModelMessageType {
    Invite = "invite",
    Info = "info",
}

export enum CustomerUrlPublicationModelDisplayConfiguration {
    ArticleReplica = "articleReplica",
    ReplicaArticle = "replicaArticle",
    ReplicaOnly = "replicaOnly",
    ArticleOnly = "articleOnly",
}

export enum LicenceDTOType {
    TermsConditions = "termsConditions",
    ParticaOpenContentLicence = "particaOpenContentLicence",
}

export enum LicenceDTOStatus {
    Active = "active",
    Inactive = "inactive",
}

export enum IssuePropertiesDTOVisibility {
    NotVisible = "notVisible",
    Visible = "visible",
}

export enum IssuePropertiesDTOSecure {
    NotSecure = "notSecure",
    Secure = "secure",
}

export enum IssuePropertiesDTOStatus {
    Processing = "processing",
    Processed = "processed",
    Deleted = "deleted",
    Conversionfailed = "conversionfailed",
}

export enum IssueStorageDTOStatus {
    Created = "created",
    Processing = "processing",
    Processed = "processed",
    Live = "live",
    BackedUp = "backedUp",
    Deleted = "deleted",
    Removed = "removed",
    ArticleOnly = "articleOnly",
    Unlive = "unlive",
    CleanedUp = "cleanedUp",
}

export enum IssueStorageHistoryDTOStatus {
    Created = "created",
    Processing = "processing",
    Processed = "processed",
    Live = "live",
    BackedUp = "backedUp",
    Deleted = "deleted",
    Removed = "removed",
    ArticleOnly = "articleOnly",
    Unlive = "unlive",
    CleanedUp = "cleanedUp",
}

export enum IssueWorkModelQaStatus {
    NotApplicable = "notApplicable",
    NotStarted = "notStarted",
    Started = "started",
    Finished = "finished",
}

export enum IssueWorkModelPreExtractionStatus {
    NotApplicable = "notApplicable",
    NotStarted = "notStarted",
    Started = "started",
    Finished = "finished",
}

export enum IssueWorkModelExtractionStatus {
    NotApplicable = "notApplicable",
    NotStarted = "notStarted",
    Started = "started",
    Finished = "finished",
}

export enum IssueWorkModelConversionStatus {
    NotApplicable = "notApplicable",
    NotStarted = "notStarted",
    Started = "started",
    Finished = "finished",
}

export enum IssueWorkModelEnhancementStatus {
    NotApplicable = "notApplicable",
    NotStarted = "notStarted",
    Started = "started",
    Finished = "finished",
}

export enum IssueWorkModelJobStatus {
    New = "new",
    InProgress = "inProgress",
    WithClient = "withClient",
    Finished = "finished",
    Cancelled = "cancelled",
    Suspended = "suspended",
    Reopened = "reopened",
}

export enum IssueWorkModelPostExtractionStatus {
    NotApplicable = "notApplicable",
    NotStarted = "notStarted",
    Started = "started",
    Finished = "finished",
}

export enum IssueWorkModelSyndicationProof {
    NotApplicable = "notApplicable",
    NotStarted = "notStarted",
    Started = "started",
    Finished = "finished",
}

export enum StoreArticleDTOPublicationType {
    Title = "title",
    Newsletterservice = "newsletterservice",
    Newslettersubscription = "newslettersubscription",
    Myarticles = "myarticles",
    Written = "written",
    Contentstream = "contentstream",
    ContentStreamSubscription = "contentStreamSubscription",
}

export enum StoreArticleDTOArticleType {
    Extracted = "extracted",
    Metadata = "metadata",
    Newsletter = "newsletter",
    Newslettersubscription = "newslettersubscription",
    Copied = "copied",
    Syndication = "syndication",
    Syndicationproof = "syndicationproof",
    All = "all",
    Syndicationrejected = "syndicationrejected",
    Imported = "imported",
    Syndicationremoved = "syndicationremoved",
    Purchased = "purchased",
    Written = "written",
    ContentStreamSource = "contentStreamSource",
    ReadyForCuration = "readyForCuration",
    Curated = "curated",
}

export enum ParagraphContentComponent {
    Body = "body",
    Subtitle = "subtitle",
    Image = "image",
    Quote = "quote",
}

export enum ShoppingCartDTOStatus {
    Open = "open",
    Paid = "paid",
    Pending = "pending",
}

export enum ChargebeePaymentDTOCurrency {
    AUD = "aUD",
}

export enum ChargebeePaymentDTOStatus {
    Created = "created",
    FundsReceived = "fundsReceived",
    Success = "success",
    PaymentFailed = "paymentFailed",
}

export enum ChargebeePaymentItemDTOStatus {
    Created = "created",
    Complete = "complete",
}

export enum PublicationDataType {
    Title = "title",
    Newsletterservice = "newsletterservice",
    Newslettersubscription = "newslettersubscription",
    Myarticles = "myarticles",
    Written = "written",
    Contentstream = "contentstream",
    ContentStreamSubscription = "contentStreamSubscription",
}

export enum ArticleTypeDataArticleType {
    Extracted = "extracted",
    Metadata = "metadata",
    Newsletter = "newsletter",
    Newslettersubscription = "newslettersubscription",
    Copied = "copied",
    Syndication = "syndication",
    Syndicationproof = "syndicationproof",
    All = "all",
    Syndicationrejected = "syndicationrejected",
    Imported = "imported",
    Syndicationremoved = "syndicationremoved",
    Purchased = "purchased",
    Written = "written",
    ContentStreamSource = "contentStreamSource",
    ReadyForCuration = "readyForCuration",
    Curated = "curated",
}

export enum ContentStreamArticleOwnerBatchDTOStatus {
    Created = "created",
    FundsDeposited = "fundsDeposited",
}

export enum ContentStreamArticleOwnerBatchItemDTOStatus {
    Created = "created",
    FundsDeposited = "fundsDeposited",
}

export enum IssueTailorPaymentDTOTailoringType {
    PostFinalize = "postFinalize",
    PreFinalize = "preFinalize",
}

export enum ContentStreamIssueTailoringBatchDTOStatus {
    Created = "created",
    FundsDeposited = "fundsDeposited",
}

export enum ContentStreamIssueTailoringBatchItemDTOStatus {
    Created = "created",
    FundsDeposited = "fundsDeposited",
}

export enum TailoringPaymentIssueDTOTailoringType {
    PostFinalize = "postFinalize",
    PreFinalize = "preFinalize",
}

export enum Access_itemA {
    All = "all",
}

export enum ViewerContentDTOViewerContentType {
    Template = "template",
    Zeropage = "zeropage",
    Search = "search",
    Tableofcontents = "tableofcontents",
    Authentication = "authentication",
    Classic = "classic",
}

export enum ViewerContentDTOVersion {
    Live = "live",
    Preview = "preview",
    Blank = "blank",
}

export enum ViewerOptionsModelSpineStyle {
    NoSpine = "noSpine",
    DropShadow = "dropShadow",
    Gap = "gap",
    GapDropShadow = "gapDropShadow",
}

export enum WordpressPluginDTOStatus {
    Draft = "draft",
    Publish = "publish",
}

export enum IssueLinkModelCreatedBy {
    Pdf = "pdf",
    Wordsmart = "wordsmart",
    Manual = "manual",
    All = "all",
}

export enum WordsmartCustomRegexDTORegexType {
    Page = "page",
    Web = "web",
    Email = "email",
    Pageindex = "pageindex",
    Webself = "webself",
}

export class SwaggerException extends Error {
    message: string;
    status: number; 
    response: string; 
    headers: { [key: string]: any; };
    result: any; 

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

export function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}